import {AppBar, FormGroup, IconButton, InputLabel, List, ListItem, ListItemButton, ListItemText, ListSubheader, Paper, Box, Stack, Divider, FormControl, FormLabel,
   Button, Chip, CircularProgress, Popover, Select, MenuItem, RadioGroup, Radio, FormControlLabel,
  ToggleButtonGroup, ToggleButton, Typography, Tooltip, CardActionArea, Card, CardContent, Switch, 
  duration,
  formLabelClasses} from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';


// import { fabric } from "fabric";
import Konva from 'konva';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { red, pink, indigo, green, blue, teal, grey } from '@mui/material/colors';

import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';


import { useState, useEffect, useRef, useCallback, useContext } from 'react';

import { JsonViewer, undefinedType } from '@textea/json-viewer'

import { Icon as Iconify } from '@iconify/react';

import axios from 'axios';

import {ccColorDarkTeal, ccColorLightTeal, ccColorOrange, ccColorSecondaryPink, ccColorSecondaryPurple, ccColorTeal, lionObjectsColors}  from './helpersStyles';
import {lionIcons}  from './helpersIcons';
import {LionColorPicker, LionLinearGradientPicker, LionRadialGradientPicker}  from './lionColorPicker';
import {TryParseIntDefault, TryParseFloatDefault, RandomId, CheckImageUrlExists}  from './helpers';
import {getRatingsBlockSize} from  './helpersBlock';
import {ParseSvg, EditSvg, DeleteSegment, ChangeEndPointSvg, GetSegmentEndXY}  from './helpersSvg';
import ImageLibraryPicker from './imageLibrary';
import {DatafeedPicker} from './datafeedGrid';
import {ConditionsManager, FilterViewer, FilterTextViewer} from "./filtersManager";

// the combos in the grid header are dynamic and their state is managed with redux
import {store} from '../redux/store'
import dataConnections, {setColumsSettings} from '../redux/slices/dataConnections' // columnsSettings[colName] = {dataType: '', isKey: bool, visible: bool, textLength: 'string', datetimeInputFormat: 'string' }
import {LionNumberInput} from './lionNumberInput';

import {SettingsContext} from '../components/userSettingsContext'

import { ImageUploader, InputNumber, LionListbox, Toggle } from '../commonComponents/inputFields';
import { CcActionButtonOutlined, CcActionButton } from '../commonComponents/styledTexts';
import { InfoToolTip, TabSelector } from '../commonComponents/generalComponents';

import { object as yupObject, string, number, date, InferType, object } from 'yup';
import { getErrorListFromYupError, getErrorMessage } from './helperErrors';
import { InputText } from '../commonComponents/inputFields';


import { CcFontLoader, FontStyleMenu } from './helperFonts';
import { getForecastsDescription } from '../commonComponents/helperWeather';

import { getDayOfWeek } from '../commonComponents/helperDateTime';

import { createSweepGradient } from '../commonComponents/helperKonvaGradient';

const getBounds = require('svg-path-bounds'); // https://www.npmjs.com/package/svg-path-bounds
const svgpath = require('svgpath'); // https://www.npmjs.com/package/svgpath


// fabric js values:
// fontStyle: we use values 'normal' or 'italic'
// textAlign: we use values "left", "center", "right"
// underline: we use values true or false
// fontWeight: we use values 'normal' or 'bold'

const  MenuAddMappedBlocks = (props) => {
  // props.mappings: {prop1: value1, prop2: value2 } where propX are prettyname and valueX are real names
  // props.allNames: array of prettyNames

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuItems, setMenuItems] = useState([]);

useEffect(() => {
  if (props.allNames && props.allNames.length > 0) {
    const updatedMenuItems = props.allNames.map(n => ({prettyName: n.colName, name:'', active: false}));
    let mappingPrettyNames = []
    if (props.mappings !== undefined) mappingPrettyNames = Object.keys(props.mappings);
    mappingPrettyNames.forEach(mpn => {
      const currentMenuItem = updatedMenuItems.find(i => i.prettyName === mpn);
      if (currentMenuItem) {
        currentMenuItem.name = props.mappings[mpn];
        currentMenuItem.active = true;  
      }
    })
    setMenuItems(updatedMenuItems);  
  }
}, [props.allNames, props.mappings])

  const openMenu = Boolean(anchorEl);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick  = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleMappedBlockClick = (bindValue, prettyName) => {
    //console.log(bindValue)
    //console.log(prettyName)
    if (props.onClick !== undefined) props.onClick(bindValue, prettyName);
    handleCloseMenu();
  }

  return <>
          {/*<Button sx={{minWidth: 40, maxWidth:40}} color='inherit' onClick={handleClick}><Iconify icon='material-symbols:add-circle-outline' width={24} /></Button>*/}
          <button onClick={handleClick} type="button" className={`px-2 py-1 text-xs focus:outline-none text-ccColorSecondaryPurple hover:text-white border border-ccColorSecondaryPurple hover:bg-ccColorSecondaryPurple font-medium rounded-lg dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className === undefined ? '' : props.className}`}>
            <div className='flex flex-row gap-2 items-center font-poppins'>
              <Iconify icon='material-symbols:add-circle-outline' width={24} />
              <div>quick add blocks</div>
            </div>
          </button>
          <Popover      open={openMenu}
                      anchorEl={anchorEl}
                      onClose={handleCloseMenu}
                      anchorOrigin={{
                        vertical: 'bottom',
                      }}
            >
            <Paper sx={{ padding: '10px'}} elevation={4}>
              <Stack spacing={1}>
            {!props.feedConnected && 
                        <Alert sx={{width: 300}} severity="info">No data connection selected</Alert>
                        }
              <Grid2 container spacing={0.5}>
                {        
                  menuItems.map(i =>  
                    <Grid2 xs={4} key={i.name}>
                        <Button onClick={() => handleMappedBlockClick(i.name, i.prettyName)}
                                disabled={!i.active}
                                startIcon={<Iconify icon={i.prettyName === 'Image' ? lionIcons.Icon_ImageInsert : lionIcons.Icon_TextInsert} />} 
                                variant="outlined"  >{i.prettyName}</Button>
                    </Grid2>       
                  )

                }
              </Grid2>
              </Stack>
            </Paper>                    
          </Popover>
      </>
}
const  MenuQuickAddWeatherBlocks = (props) => {

  const [currentTab, setCurrentTab] = useState('metric')
  const [anchorEl, setAnchorEl] = useState(null);

useEffect(() => {

}, [props.allNames, props.mappings])

  const openMenu = Boolean(anchorEl);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick  = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleMappedBlockClick = (codeName) => {
    //console.log(codeName)
    if (props.onClick !== undefined) props.onClick(codeName);
    handleCloseMenu();
  }
  const  renderButton = (codeName, example, desc) => {
    return <div className='border p-1 rounded w-[280px] h-20 flex flex-row items-center gap-x-4 hover:cursor-pointer hover:bg-slate-100'
              onClick={() => handleMappedBlockClick(codeName)}>
            <div className='font-semibold text-3xl min-w-[90px]'>{example}</div>
            <div><div className='text-sm'>{desc}</div></div>
          </div>

  }

  return <>
          <button onClick={handleClick} type="button" className="w-14 px-2 py-1 text-xs focus:outline-none text-ccColorSecondaryPurple hover:text-white border border-ccColorSecondaryPurple hover:bg-ccColorSecondaryPurple font-medium rounded-lg dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900">
            <div className='flex flex-row gap-2 items-center justify-center font-poppins'>
              <Iconify icon='material-symbols:add-circle-outline' width={24} />
            </div>
          </button>
          <Popover      open={openMenu}
                      anchorEl={anchorEl}
                      onClose={handleCloseMenu}
                      anchorOrigin={{
                        vertical: 'bottom',
                      }}
            >
              <div className='p-2'>
                <div className='mb-4'>
                  <TabSelector 
                      items={[{id: 'metric', name:'Metric'}, {id: 'imperial', name: 'Imperial'}]}
                      selectedItemId={currentTab}
                      onChange={setCurrentTab}
                    />
                </div>
                {currentTab === 'metric' &&
                  <div className='grid grid-cols-3 gap-4 text-ccColorDarkTeal font-poppins'>
                        <div className='border p-1 rounded w-[280px] h-20 flex flex-row items-center gap-x-4 hover:cursor-pointer hover:bg-slate-100'
                          onClick={() => handleMappedBlockClick('weatherIcon')}>
                          <Iconify icon={lionIcons.Icon_Sun} width={64} />
                          <div className='text-sm'>Weather icon</div>
                        </div>
                        {renderButton('minTemp', '19° C', 'Min temperature')}
                        {renderButton('maxTemp', '24° C', 'Max temperature')}
                        {renderButton('dayTemp', '21° C', 'Day temperature')}
                        {renderButton('dayFeelsLike', '22° C', 'Day feels-like temperature')}
                        {renderButton('dayOfWeek', getDayOfWeek(), 'Day of the week')}
                  </div>
                }
                {currentTab === 'imperial' &&
                  <div className='grid grid-cols-3 gap-4 text-ccColorDarkTeal font-poppins'>
                        <div className='border p-1 rounded w-[280px] h-20 flex flex-row items-center gap-x-4 hover:cursor-pointer hover:bg-slate-100'
                          onClick={() => handleMappedBlockClick('weatherIcon')}>
                          <Iconify icon={lionIcons.Icon_Sun} width={64} />
                          <div className='text-sm'>Weather icon</div>
                        </div>
                        {renderButton('minTemp-imperial', '66° F', 'Min temperature')}
                        {renderButton('maxTemp-imperial', '75° F', 'Max temperature')}
                        {renderButton('dayTemp-imperial', '70° F', 'Day temperature')}
                        {renderButton('dayFeelsLike-imperial', '71° F', 'Day feels-like temperature')}
                        {renderButton('dayOfWeek', getDayOfWeek(), 'Day of the week')}
                  </div>
                }
              </div>
          </Popover>
      </>
}

const  MenuUrlBoundBlocks = (props) => {

  const [anchorEl, setAnchorEl] = useState(null);


  const openMenu = Boolean(anchorEl);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick  = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleMappedBlockClick = (prettyName) => {
    if (props.onClick !== undefined) props.onClick(prettyName);
    handleCloseMenu()
  }

  return <>
          <Button sx={{minWidth: 40, maxWidth:40}} color='inherit' onClick={handleClick}><Iconify icon='material-symbols:add-circle-outline' width={24} /></Button>
          <Popover      open={openMenu}
                              anchorEl={anchorEl}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                              }}
                    >
            <Paper sx={{ padding: '10px'}} elevation={4}>
              <Stack spacing={1}>

                <Grid2 container columnSpacing={0.5} rowSpacing={1}>
                  <Grid2 xs={4} >
                      <Button onClick={() => handleMappedBlockClick('firstname')}
                              startIcon={<Iconify icon={lionIcons.Icon_Databind_url} />} 
                              sx={{textTransform: 'lowercase !important;'}}
                              variant="outlined"  >firstname</Button>
                  </Grid2>       
                  <Grid2 xs={4} >
                      <Button onClick={() => handleMappedBlockClick('surname')}
                              startIcon={<Iconify icon={lionIcons.Icon_Databind_url} />} 
                              sx={{textTransform: 'lowercase !important;'}}
                              variant="outlined"  >surname</Button>
                  </Grid2>       
                  <Grid2 xs={4} >
                      <Button onClick={() => handleMappedBlockClick('lastname')}
                              startIcon={<Iconify icon={lionIcons.Icon_Databind_url} />} 
                              sx={{textTransform: 'lowercase !important;'}}
                              variant="outlined"  >lastname</Button>
                  </Grid2>       
                  <Grid2 xs={4} >
                      <Button onClick={() => handleMappedBlockClick('salutation')}
                              startIcon={<Iconify icon={lionIcons.Icon_Databind_url} />} 
                              sx={{textTransform: 'lowercase !important;'}}
                              variant="outlined"  >salutation</Button>
                  </Grid2>       
                </Grid2>
                </Stack>
            </Paper>                    
          </Popover>
      </>
}

const  MenuAddShapes = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick  = (event) => {
    setAnchorEl(event.currentTarget);
  }
  
const handleShapeClick = (shape) => {
  props.onClick(shape);
  handleCloseMenu();
}

  return <>
          <Button sx={{minWidth: 40, maxWidth:40}} color='inherit' onClick={handleClick}><Iconify icon='mdi:shape-outline' width={24} /></Button>
          <Popover      open={openMenu}
                              anchorEl={anchorEl}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                              }}
                    >
            <Paper sx={{ padding: '10px'}} elevation={4}>
              <Stack>
                <Stack direction='row'>
                <Button onClick={() => handleShapeClick('circle')}><Iconify icon={lionIcons.Icon_Shapes_Circle} width={42} color={grey[500]} /></Button>
                <Button color='secondary' onClick={() => handleShapeClick('rect')}><Iconify icon={lionIcons.Icon_Shapes_Rectangle} width={42} color={grey[500]} /></Button>
                <Button color='secondary' onClick={() => handleShapeClick('triangle')}><Iconify icon={lionIcons.Icon_Shapes_Triangle} width={42} color={grey[500]} /></Button>
                </Stack>
                <Stack direction='row'>
                <Button color='secondary' onClick={() => handleShapeClick('square')}><Iconify icon={lionIcons.Icon_Shapes_Square} width={42} color={grey[500]} /></Button>
                <Button color='secondary' onClick={() => handleShapeClick('ellipse')}><Iconify icon={lionIcons.Icon_Shapes_Ellipse} width={42}color={grey[500]} /></Button>
                <Button color='secondary' onClick={() => handleShapeClick('polygon')}><Iconify icon={lionIcons.Icon_Shapes_Polygon} width={42} color={grey[500]} /></Button>
                </Stack>
              </Stack>
            </Paper>                    
          </Popover>
      </>
}

const  MenuAddRatings = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick  = (event) => {
    setAnchorEl(event.currentTarget);
  }
  
const handleButtonClick = (shape) => {
  switch (shape) {
  case "star":
    props.onClick('M11.2691 4.41115C11.5006 3.89177 11.6164 3.63208 11.7776 3.55211C11.9176 3.48263 12.082 3.48263 12.222 3.55211C12.3832 3.63208 12.499 3.89177 12.7305 4.41115L14.5745 8.54808C14.643 8.70162 14.6772 8.77839 14.7302 8.83718C14.777 8.8892 14.8343 8.93081 14.8982 8.95929C14.9705 8.99149 15.0541 9.00031 15.2213 9.01795L19.7256 9.49336C20.2911 9.55304 20.5738 9.58288 20.6997 9.71147C20.809 9.82316 20.8598 9.97956 20.837 10.1342C20.8108 10.3122 20.5996 10.5025 20.1772 10.8832L16.8125 13.9154C16.6877 14.0279 16.6252 14.0842 16.5857 14.1527C16.5507 14.2134 16.5288 14.2807 16.5215 14.3503C16.5132 14.429 16.5306 14.5112 16.5655 14.6757L17.5053 19.1064C17.6233 19.6627 17.6823 19.9408 17.5989 20.1002C17.5264 20.2388 17.3934 20.3354 17.2393 20.3615C17.0619 20.3915 16.8156 20.2495 16.323 19.9654L12.3995 17.7024C12.2539 17.6184 12.1811 17.5765 12.1037 17.56C12.0352 17.5455 11.9644 17.5455 11.8959 17.56C11.8185 17.5765 11.7457 17.6184 11.6001 17.7024L7.67662 19.9654C7.18404 20.2495 6.93775 20.3915 6.76034 20.3615C6.60623 20.3354 6.47319 20.2388 6.40075 20.1002C6.31736 19.9408 6.37635 19.6627 6.49434 19.1064L7.4341 14.6757C7.46898 14.5112 7.48642 14.429 7.47814 14.3503C7.47081 14.2807 7.44894 14.2134 7.41394 14.1527C7.37439 14.0842 7.31195 14.0279 7.18708 13.9154L3.82246 10.8832C3.40005 10.5025 3.18884 10.3122 3.16258 10.1342C3.13978 9.97956 3.19059 9.82316 3.29993 9.71147C3.42581 9.58288 3.70856 9.55304 4.27406 9.49336L8.77835 9.01795C8.94553 9.00031 9.02911 8.99149 9.10139 8.95929C9.16534 8.93081 9.2226 8.8892 9.26946 8.83718C9.32241 8.77839 9.35663 8.70162 9.42508 8.54808L11.2691 4.41115Z');
    break; 
  case "heart":
    props.onClick('M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z');
    break;
  case "thumbUp":
    props.onClick('M 8.85 19 H 6 C 5.4477 19 5 18.5523 5 18 V 12 C 5 11.4477 5.4477 11 6 11 H 8.85 C 8.9328 11 9 11.0672 9 11.15 V 18.85 C 9 18.9328 8.9328 19 8.85 19 Z M 9 11 L 10.8321 8.2519 C 10.9416 8.0877 11 7.8947 11 7.6972 V 5 C 11 4.4477 11.4477 4 12 4 H 13 C 14.1046 4 15 4.8954 15 6 V 11M13 11H17.7655C18.9575 11 19.8849 12.0361 19.7532 13.2209L19.1977 18.2209C19.0851 19.2337 18.229 20 17.2099 20H13.4142C13.149 20 12.8946 19.8946 12.7071 19.7071L12.2929 19.2929C12.1054 19.1054 11.851 19 11.5858 19H9');
    break;
  case "sun":
    props.onClick('M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5001M17.6859 17.69L18.5 18.5001M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z');
    break;
  case "lightning":
    props.onClick('M 8.0064 10.1088 l -5.472 9.792 l 1.728 -7.488 l -2.304 -0.288 l 5.184 -10.08 l -1.728 7.776 z');
    break;
  case "water-drop":
    props.onClick('M 9.8 19 C 7.4804 19 5.6 17.1448 5.6 14.8564 C 5.6 12.5674 8.2232 10.3774 9.8 8.8 C 11.4398 10.4182 14 12.5674 14 14.8564 C 14 17.1448 12.1196 19 9.8 19 L 9.8 19 Z M 9.8 2.8 C 6.872 5.7694 2 9.892 2 14.2 C 2 18.508 5.492 22 9.8 22 C 14.108 22 17.6 18.508 17.6 14.2 C 17.6 9.892 12.8462 5.8462 9.8 2.8 L 9.8 2.8 Z M 9.7802 10.303 C 8.6564 11.5096 6.8072 12.8812 6.8072 14.6314 C 6.8072 16.3816 8.147 17.8 9.8 17.8 C 11.453 17.8 12.7928 16.3816 12.7928 14.6314 C 12.7928 12.8812 10.9484 11.5402 9.7802 10.303 L 9.7802 10.303 Z');
    break;
  case "spades":
    props.onClick('M 20.2673 8.9951 C 17.8686 5.8583 13.9982 2.4621 12.9644 0.1885 c -0.0672 -0.1482 -0.1161 -0.1885 -0.1645 -0.1885 c -0.0407 0.0033 -0.0973 0.0403 -0.1645 0.1885 c -1.0334 2.2736 -4.9043 5.6698 -7.3025 8.8065 c -2.2015 2.8782 -3.0459 6.8778 -0.2952 9.2356 c 1.8408 1.5778 4.9532 1.4463 6.7268 -0.2325 c -0.1547 2.7484 -0.5484 5.3835 -1.3534 7.6018 h 4.7777 c -0.8054 -2.2183 -1.1983 -4.8534 -1.353 -7.6018 c 1.7728 1.6788 4.886 1.8102 6.7264 0.2325 C 23.3133 15.8728 22.4684 11.8733 20.2673 8.9951 z');
    break;
  default:
    break;   
  }
  handleCloseMenu();
}

  return <>
          <Button sx={{minWidth: 40, maxWidth:40}} color='inherit' onClick={handleClick}><Iconify icon={lionIcons.Icon_Ratings} width={24} /></Button>
          <Popover      open={openMenu}
                              anchorEl={anchorEl}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                              }}
                    >
            <Paper sx={{ padding: '10px'}} elevation={4}>
              <Stack>
                <Stack direction='row'>
                <Button onClick={() => handleButtonClick('star')}><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <path d="M11.2691 4.41115C11.5006 3.89177 11.6164 3.63208 11.7776 3.55211C11.9176 3.48263 12.082 3.48263 12.222 3.55211C12.3832 3.63208 12.499 3.89177 12.7305 4.41115L14.5745 8.54808C14.643 8.70162 14.6772 8.77839 14.7302 8.83718C14.777 8.8892 14.8343 8.93081 14.8982 8.95929C14.9705 8.99149 15.0541 9.00031 15.2213 9.01795L19.7256 9.49336C20.2911 9.55304 20.5738 9.58288 20.6997 9.71147C20.809 9.82316 20.8598 9.97956 20.837 10.1342C20.8108 10.3122 20.5996 10.5025 20.1772 10.8832L16.8125 13.9154C16.6877 14.0279 16.6252 14.0842 16.5857 14.1527C16.5507 14.2134 16.5288 14.2807 16.5215 14.3503C16.5132 14.429 16.5306 14.5112 16.5655 14.6757L17.5053 19.1064C17.6233 19.6627 17.6823 19.9408 17.5989 20.1002C17.5264 20.2388 17.3934 20.3354 17.2393 20.3615C17.0619 20.3915 16.8156 20.2495 16.323 19.9654L12.3995 17.7024C12.2539 17.6184 12.1811 17.5765 12.1037 17.56C12.0352 17.5455 11.9644 17.5455 11.8959 17.56C11.8185 17.5765 11.7457 17.6184 11.6001 17.7024L7.67662 19.9654C7.18404 20.2495 6.93775 20.3915 6.76034 20.3615C6.60623 20.3354 6.47319 20.2388 6.40075 20.1002C6.31736 19.9408 6.37635 19.6627 6.49434 19.1064L7.4341 14.6757C7.46898 14.5112 7.48642 14.429 7.47814 14.3503C7.47081 14.2807 7.44894 14.2134 7.41394 14.1527C7.37439 14.0842 7.31195 14.0279 7.18708 13.9154L3.82246 10.8832C3.40005 10.5025 3.18884 10.3122 3.16258 10.1342C3.13978 9.97956 3.19059 9.82316 3.29993 9.71147C3.42581 9.58288 3.70856 9.55304 4.27406 9.49336L8.77835 9.01795C8.94553 9.00031 9.02911 8.99149 9.10139 8.95929C9.16534 8.93081 9.2226 8.8892 9.26946 8.83718C9.32241 8.77839 9.35663 8.70162 9.42508 8.54808L11.2691 4.41115Z" stroke={grey[500]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </g></svg></Button>
                <Button onClick={() => handleButtonClick('heart')}><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <path d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke={grey[500]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </g></svg></Button>
                <Button onClick={() => handleButtonClick('thumbUp')}><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <path d="M 8.85 19 H 6 C 5.4477 19 5 18.5523 5 18 V 12 C 5 11.4477 5.4477 11 6 11 H 8.85 C 8.9328 11 9 11.0672 9 11.15 V 18.85 C 9 18.9328 8.9328 19 8.85 19 Z M 9 11 L 10.8321 8.2519 C 10.9416 8.0877 11 7.8947 11 7.6972 V 5 C 11 4.4477 11.4477 4 12 4 H 13 C 14.1046 4 15 4.8954 15 6 V 11M13 11H17.7655C18.9575 11 19.8849 12.0361 19.7532 13.2209L19.1977 18.2209C19.0851 19.2337 18.229 20 17.2099 20H13.4142C13.149 20 12.8946 19.8946 12.7071 19.7071L12.2929 19.2929C12.1054 19.1054 11.851 19 11.5858 19H9" stroke={grey[500]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </g></svg></Button>
                </Stack>
                <Stack direction='row'>
                <Button onClick={() => handleButtonClick('sun')}><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <path d="M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5001M17.6859 17.69L18.5 18.5001M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke={grey[500]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </g></svg></Button>
                <Button onClick={() => handleButtonClick('lightning')}><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <path d="M 13.0064 10.1088 l -5.472 9.792 l 1.728 -7.488 l -2.304 -0.288 l 5.184 -10.08 l -1.728 7.776 z" stroke={grey[500]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </g></svg></Button>
                <Button onClick={() => handleButtonClick('water-drop')}><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <path d="M 9.8 19 C 7.4804 19 5.6 17.1448 5.6 14.8564 C 5.6 12.5674 8.2232 10.3774 9.8 8.8 C 11.4398 10.4182 14 12.5674 14 14.8564 C 14 17.1448 12.1196 19 9.8 19 L 9.8 19 Z M 9.8 2.8 C 6.872 5.7694 2 9.892 2 14.2 C 2 18.508 5.492 22 9.8 22 C 14.108 22 17.6 18.508 17.6 14.2 C 17.6 9.892 12.8462 5.8462 9.8 2.8 L 9.8 2.8 Z M 9.7802 10.303 C 8.6564 11.5096 6.8072 12.8812 6.8072 14.6314 C 6.8072 16.3816 8.147 17.8 9.8 17.8 C 11.453 17.8 12.7928 16.3816 12.7928 14.6314 C 12.7928 12.8812 10.9484 11.5402 9.7802 10.303 L 9.7802 10.303 Z" stroke={grey[500]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </g></svg></Button>
                </Stack>
                <Stack direction='row'>
                <Button onClick={() => handleButtonClick('spades')}><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <path d="M 20.2673 8.9951 C 17.8686 5.8583 13.9982 2.4621 12.9644 0.1885 c -0.0672 -0.1482 -0.1161 -0.1885 -0.1645 -0.1885 c -0.0407 0.0033 -0.0973 0.0403 -0.1645 0.1885 c -1.0334 2.2736 -4.9043 5.6698 -7.3025 8.8065 c -2.2015 2.8782 -3.0459 6.8778 -0.2952 9.2356 c 1.8408 1.5778 4.9532 1.4463 6.7268 -0.2325 c -0.1547 2.7484 -0.5484 5.3835 -1.3534 7.6018 h 4.7777 c -0.8054 -2.2183 -1.1983 -4.8534 -1.353 -7.6018 c 1.7728 1.6788 4.886 1.8102 6.7264 0.2325 C 23.3133 15.8728 22.4684 11.8733 20.2673 8.9951 z" stroke={grey[500]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </g></svg></Button>
                </Stack>
              </Stack>
            </Paper>                    
          </Popover>
      </>
}

const  MenuAddTimerBlocks = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick  = (event) => {
    setAnchorEl(event.currentTarget);
  }
  
const handleTimerClick = (blockTypes) => {
  props.onClick(blockTypes);
  handleCloseMenu();
}

  return <>
          <Button sx={{minWidth: 40, maxWidth:40}} color='inherit' onClick={handleClick}><Iconify icon={lionIcons.Icon_TimerInsert} width={24} /></Button>
          <Popover      open={openMenu}
                              anchorEl={anchorEl}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                              }}
                    >
            <Paper sx={{ padding: '10px'}} elevation={4}>
              <Stack>
                <Button onClick={() => handleTimerClick('dd:hh:mm:ss')}><span className=' text-gray-500'>dd:hh:mm:ss</span></Button>
                <Button onClick={() => handleTimerClick('hh:mm:ss')}><span className=' text-gray-500'>hh:mm:ss</span></Button>
                <Button onClick={() => handleTimerClick('hh:mm')}><span className=' text-gray-500'>hh:mm</span></Button>
                <Button onClick={() => handleTimerClick('sentence')}><span className=' text-gray-500'>1 day, 1 hour, 1 minute, 1 second</span></Button>
                <Button onClick={() => handleTimerClick('singleBlock')}><span className=' text-gray-500'>single block</span></Button>
                <Button onClick={() => handleTimerClick('separatorBlock')}><span className=' text-gray-500'>Separator</span></Button>
              </Stack>
            </Paper>                    
          </Popover>
      </>
}

const MenuZoom = (props) => {
  const handleZoomLevelChange = (val) => {
    if (props.onChange) props.onChange(val.id)
  }

  return <div className='flex flex-row items-center gap-x-1 px-2'>
            <Iconify icon="gravity-ui:magnifier" width={24} />
            <LionListbox 
              selectedItemId={props.zoomLevel}
              onChange={handleZoomLevelChange}
              items={[{id: 1, name: '100%'}, {id: 0.5, name: '50%'}, {id: 0.25, name: '25%'}, ]}
              zIndex={100}
            />
          
  </div>
}

const FontSelector = (props) => {
  const [currentFont, setCurrentFont] = useState('');

  const [currentFontStyles, setCurrentFontStyles] = useState([]); // contains styles that need to be converted in a format for fabricjs
  const [currentFontDecorations, setCurrentFontDecorations] = useState([]); // contains styles that need to be converted in a format for fabricjs
  const [currentUseAutoSize, setCurrentUseAutoSize] = useState(false);
  const [availableFonts, setAvailableFonts] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);


  useEffect(() => {
    if (props.currentFont.style === null) props.currentFont.style = 'normal'
    setCurrentFont(props.currentFont)
    const newStyles = [];
    if (props.currentFont.style.includes('italic')) newStyles.push('italic');
    if (props.currentFont.style.includes('bold')) newStyles.push('bold');
    if (props.currentFont.textDecoration !== '') setCurrentFontDecorations([props.currentFont.textDecoration]);
    else setCurrentFontDecorations([]);

    setCurrentFontStyles(newStyles);

    if (props.currentFont.fontIsAutoSize !==  undefined) setCurrentUseAutoSize(props.currentFont.fontIsAutoSize);

  }, [props.currentFont])

  useEffect(() => {
    getAvailableFonts();
  }, [])

  const getAvailableFonts = useCallback(async () => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Templates/fonts`;
      const response = await axios.get(url);
      const data = response.data;
      // const url = `api/Templates/fonts`;
      // const response = await fetch(url, { method: "GET", });
  
      //const data = await response.json();

      setAvailableFonts(data);
    } catch (error) {
      console.log(error);
    }
  }
  ,[])

  const handleOpenFontSettings = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeFont = (propName, propValue) => {
    const newFont = {...currentFont, [propName]: propValue};
    setCurrentFont(newFont);
    bubbleUpFontSettings(newFont, currentFontStyles, currentFontDecorations);
  }

  const handleFontStyles = (e, styles) => {
    setCurrentFontStyles(styles);
    bubbleUpFontSettings(currentFont, styles, currentFontDecorations);
  }
  const handleFontTextDecoration = (e, decoration) => {
    setCurrentFontDecorations(decoration);
    bubbleUpFontSettings(currentFont, currentFontStyles, decoration);
  }
  const handleCloseFontSettings = () => {
    setAnchorEl(null);
    let fStyle = 'normal';
    if (currentFontStyles.length === 1) fStyle = currentFontStyles[0];
    if (currentFontStyles.length === 2) fStyle = 'italic bold';

    props.returnCurrentFont(currentFont.fontId, currentFont.fontName, currentFont.size, fStyle, currentFont.align, currentFontDecorations[0], currentUseAutoSize);
  };

  const bubbleUpFontSettings = (font, styles, decorations) => {
    let fStyle = 'normal';
    if (styles.length === 1) fStyle = styles[0];
    if (styles.length === 2) fStyle = 'italic bold';

    props.returnCurrentFont(font.fontId, font.fontName, font.size, fStyle, font.align, decorations[0], currentUseAutoSize);
  };

  const openFontSettings = Boolean(anchorEl);


  return <>
      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
        <Typography>Font:</Typography>
        <Chip sx={{width: '100%'}} label={currentFont == null ? '' : `${currentFont.fontName}, ${currentUseAutoSize ? 'auto-size' : currentFont.size}, ${currentFont.style}`} variant="outlined" onClick={handleOpenFontSettings} />
      
      </Stack>
      <Popover      open={openFontSettings}
                    anchorEl={anchorEl}
                    onClose={handleCloseFontSettings}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <Paper sx={{ padding: '10px'}} elevation={4}>
          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
            <Select
              labelId="select-fontname"
              id="select-fontname"
              value={currentFont.fontName}
              label="Font"
              onChange={(e) => handleChangeFont('fontName', e.target.value)}
            >
              {availableFonts.map(f => <MenuItem key={f} value={f}>{f}</MenuItem>)}
              
            </Select>
            {props.showAutoSize &&
                    <div className='flex flex-row items-center gap-1 px-1 py-2 border border-gray-200 rounded-md'>
                      <div className={currentUseAutoSize ? ' text-gray-400' : ''}>Size:</div>
                      <TextField sx={{width: '80px'}}
                                value={currentFont.size}
                                disabled={currentUseAutoSize}
                                onChange={(e) => handleChangeFont('size', TryParseIntDefault(e.target.value, ''))}
                                size="small"
                              />
                      <div className="ml-2"><Toggle
                                        checked={currentUseAutoSize}
                                        onChange={(chk) => setCurrentUseAutoSize(chk)}
                                        displayName="Auto Size"/>
                      </div>
                    </div>
          
            }
            {!props.showAutoSize && <>
                      <div>Size:</div>
                      <TextField sx={{width: '80px'}}
                                value={currentFont.size}
                                disabled={currentUseAutoSize}
                                onChange={(e) => handleChangeFont('size', TryParseIntDefault(e.target.value, ''))}
                                size="small"
                              />
                      </>
          
            }


            <ToggleButtonGroup size='small'
                  value={currentFontStyles}
                  onChange={handleFontStyles}

                  aria-label="text formatting"
                >
                <ToggleButton value="bold" aria-label="bold">
                  <Iconify icon={lionIcons.Icon_bold}  />
                </ToggleButton>
                <ToggleButton value="italic" aria-label="italic">
                  <Iconify icon={lionIcons.Icon_italics} />
                </ToggleButton>
            </ToggleButtonGroup>

            <ToggleButtonGroup size='small'
                  value={currentFontDecorations}
                  onChange={handleFontTextDecoration}
                  aria-label="text formatting"
                >
                <ToggleButton value="underline" aria-label="underlined">
                  <Iconify icon={lionIcons.Icon_underlined} />
                </ToggleButton>
            </ToggleButtonGroup>

            <ToggleButtonGroup size='small'
                  value={currentFont.align}
                  exclusive
                  onChange={(e, style) => handleChangeFont('align', style)}
                  aria-label="text alignment"
            >
              <ToggleButton value="left" aria-label="left aligned">
                <Iconify icon={lionIcons.Icon_TextAlignLeft}  />
              </ToggleButton>
              <ToggleButton value="center" aria-label="centered">
                <Iconify icon={lionIcons.Icon_TextAlignCenter}  />
              </ToggleButton>
              <ToggleButton value="right" aria-label="right aligned">
                <Iconify icon={lionIcons.Icon_TextAlignRight}  />
              </ToggleButton>
            </ToggleButtonGroup>

          </Stack>

        </Paper>
    </Popover>
  </>
}
export const FontSelectorNew = (props) => {
  //props:
  // noPopup: if true the popup content is always visible instead of being in a popup


  const [currentFont, setCurrentFont] = useState('');
  const [currentFontAllStyles, setCurrentFontAllStyles] = useState([]); //contains all the possible weights and italics styles 

  const [currentFontStyles, setCurrentFontStyles] = useState([]); // contains styles that need to be converted in a format for fabricjs
  const [currentFontDecorations, setCurrentFontDecorations] = useState([]); // contains styles that need to be converted in a format for fabricjs
  const [currentUseAutoSize, setCurrentUseAutoSize] = useState(false);
  const [availableFonts, setAvailableFonts] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);



  useEffect(() => {
    if (availableFonts.length === 0) return;

    // props.currentFont.style should be of the form: ['weight', 'optionalItalic']

    //if (props.currentFont.style === null) props.currentFont.style = 'normal'
    if (props.currentFont.style === null) props.currentFont.style = '' //this will  kick the fallback method

    const f = props.currentFont
    //it seems konvajs defaults to size=12 and it will remove from the definition
    //so if size is undefined then we set it to 12
    if (f.size === undefined) f.size = 12
    setCurrentFont(f)

    //const newStyles = [];
    //if (props.currentFont.style.includes('italic')) newStyles.push('italic');
    //if (props.currentFont.style.includes('bold')) newStyles.push('bold');
    //setCurrentFontStyles(newStyles);
    //legacy: props.currentFont.style could be either a string or an array
    let stylesParts = props.currentFont.style;
    if (!Array.isArray(props.currentFont.style)) stylesParts = props.currentFont.style.split(' ');

    setCurrentFontStyles(stylesParts);
    getCurrentFontAllStyles(props.currentFont)

    if (props.currentFont.textDecoration !== '') setCurrentFontDecorations([props.currentFont.textDecoration]);
    else setCurrentFontDecorations([]);


    if (props.currentFont.fontIsAutoSize !==  undefined) setCurrentUseAutoSize(props.currentFont.fontIsAutoSize);

  }, [props.currentFont, availableFonts])

  useEffect(() => {
    getAvailableFonts();
  }, [])

  const getAvailableFonts = useCallback(async () => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Templates/fontsWithStyles?all=true`;
      const response = await axios.get(url);
      const data = response.data;
      // const url = `api/Templates/fonts`;
      // const response = await fetch(url, { method: "GET", });
  
      //const data = await response.json();
      setAvailableFonts(data);
    } catch (error) {
      console.log(error);
    }
  }
  ,[])

  const handleOpenFontSettings = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeFont = (propName, propValue) => {
    const newFont = {...currentFont, [propName]: propValue};
    setCurrentFont(newFont);
    setCurrentFontStyles('')
    bubbleUpFontSettings(newFont, '', currentFontDecorations);
  }
  const handleChangeFontNameAndId = (fNameAndId) => {
    const fontParts = fNameAndId.split('|||')
    console.log(fNameAndId)
    const newFont = {...currentFont, fontId: fontParts[0], fontName: fontParts[1]};
    setCurrentFont(newFont)
    setCurrentFontStyles('')
    bubbleUpFontSettings(newFont, '', currentFontDecorations);
  }

  const handleFontStyles = (e, styles) => {
    console.log(styles)
    //setCurrentFontStyles(styles);
    //bubbleUpFontSettings(currentFont, styles, currentFontDecorations);
  }
  const handleFontStylesNew = (style) => {
    //legacy: styles needs to an array of 1 or 2 strings like ['weight', 'optionally-italic']
    const styles = [style.weight.toString()]
    if (style.italics) styles.push('italic')

    setCurrentFontStyles(styles);
    //console.log(styles)
    bubbleUpFontSettings(currentFont, styles, currentFontDecorations);
  }
  const handleFontTextDecoration = (e, decoration) => {
    setCurrentFontDecorations(decoration);
    bubbleUpFontSettings(currentFont, currentFontStyles, decoration);
  }
  const handleCloseFontSettings = () => {
    setAnchorEl(null);
    //let fStyle = '';
    //if (currentFontStyles.length === 1) fStyle = currentFontStyles[0];
    //if (currentFontStyles.length === 2) fStyle = 'italic bold';
    //props.returnCurrentFont(currentFont.fontName, currentFont.size, fStyle, currentFont.align, currentFontDecorations[0], currentUseAutoSize);
    props.returnCurrentFont(currentFont.fontId, currentFont.fontName, currentFont.size, currentFontStyles, currentFont.align, currentFontDecorations[0], currentUseAutoSize);
  };

  const bubbleUpFontSettings = (font, styles, decorations) => {
    //let fStyle = '';
    //if (styles.length === 1) fStyle = styles[0];
    //if (styles.length === 2) fStyle = 'italic bold';
    //console.log(font)
    const fStyle = `${styles[0]}${styles.length > 1 ? " italic":""}`
    props.returnCurrentFont(font.fontId, font.fontName, font.size, fStyle, font.align, decorations[0], currentUseAutoSize);
  };

  const openFontSettings = Boolean(anchorEl);

  const getCurrentFontAllStyles = (currentFont) => {
    const currentMatch = availableFonts.find(f => f.familyName === currentFont.fontName)
    if (currentMatch) {
      setCurrentFontAllStyles(currentMatch.styles)
    }
    else setCurrentFontAllStyles(undefined)
  }

  const output = (<Paper sx={{ padding: '10px'}} elevation={4}>
    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
      <Select
        labelId="select-fontname"
        id="select-fontname"
        //value={currentFont.fontName}
        value={`${currentFont.fontId}|||${currentFont.fontName}`}
        label="Font"
        //onChange={(e) => handleChangeFont('fontName', e.target.value)}
        onChange={(e) => handleChangeFontNameAndId(e.target.value)}
      >
        {availableFonts.map(f => <MenuItem key={f.fontId} value={`${f.fontId}|||${f.familyName}`}>{f.prettyName}</MenuItem>)}
        
      </Select>
      {props.showAutoSize &&
              <div className='flex flex-row items-center gap-1 px-1 py-2 border border-gray-200 rounded-md'>
                <div className={currentUseAutoSize ? ' text-gray-400' : ''}>Size:</div>
                <TextField sx={{width: '80px'}}
                          value={currentFont.size}
                          disabled={currentUseAutoSize}
                          onChange={(e) => handleChangeFont('size', TryParseIntDefault(e.target.value, ''))}
                          size="small"
                        />
                <div className="ml-2"><Toggle
                                  checked={currentUseAutoSize}
                                  onChange={(chk) => setCurrentUseAutoSize(chk)}
                                  displayName="Auto Size"/>
                </div>
              </div>
    
      }
      {!props.showAutoSize && <>
                <div>Size:</div>
                <TextField sx={{width: '80px'}}
                          value={currentFont.size}
                          disabled={currentUseAutoSize}
                          onChange={(e) => handleChangeFont('size', TryParseIntDefault(e.target.value, ''))}
                          size="small"
                        />
                </>
    
      }
      


      <FontStyleMenu styles={currentFontAllStyles} 
      onChange={handleFontStylesNew}
      selectedStyle={currentFontStyles}
      />



      <ToggleButtonGroup size='small'
            value={currentFontDecorations}
            onChange={handleFontTextDecoration}
            aria-label="text formatting"
          >
          <ToggleButton value="underline" aria-label="underlined">
            <Iconify icon={lionIcons.Icon_underlined} />
          </ToggleButton>
      </ToggleButtonGroup>

      <ToggleButtonGroup size='small'
            value={currentFont.align}
            exclusive
            onChange={(e, style) => handleChangeFont('align', style)}
            aria-label="text alignment"
      >
        <ToggleButton value="left" aria-label="left aligned">
          <Iconify icon={lionIcons.Icon_TextAlignLeft}  />
        </ToggleButton>
        <ToggleButton value="center" aria-label="centered">
          <Iconify icon={lionIcons.Icon_TextAlignCenter}  />
        </ToggleButton>
        <ToggleButton value="right" aria-label="right aligned">
          <Iconify icon={lionIcons.Icon_TextAlignRight}  />
        </ToggleButton>
      </ToggleButtonGroup>

    </Stack>

  </Paper>
)

  return props.noPopup ? <>{output}</> 
  
    : <>
      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
        <Typography>Font:</Typography>
        <Chip sx={{width: '100%'}} label={currentFont == null ? '' : `${currentFont.fontName}, ${currentUseAutoSize ? 'auto-size' : currentFont.size}, ${currentFont.style}`} variant="outlined" onClick={handleOpenFontSettings} />
      
      </Stack>
      <Popover      open={openFontSettings}
                    anchorEl={anchorEl}
                    onClose={handleCloseFontSettings}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
            {output}
    </Popover>
  </>
}

export const DatabindingSelector = (props) => {
  const allTypes = ['none', 'designTimeValues', 'databind', 'url', 'urlChartSeries', 'imgLibrary'];
  const [currentSrc, setCurrentSrc] = useState('');
  const [dataBindType, setDataBindType] = useState('');
  const [availableDataBindTypes, setAvailableDataBindTypes] = useState(allTypes);
  const [designTimeValue, setDesignTimeValue] = useState(undefined);
  const [weatherIconsCollectionId, setWeatherIconsCollectionId] = useState(1);

  const [anchorEl, setAnchorEl] = useState(null);
  const [showOnlyArraysWarning, setShowOnlyArraysWarning] = useState(false);

  //valueTypes are not used in the Generator. So far they are used only for the charts
  const defaultValueTypes = [
                              {
                                is: (value) => typeof value === 'string' || typeof value === 'number',
                                Component: (props) => <Button variant={props.path.join('.') === currentSrc ? 'outlined' : 'text'} sx={{maxWidth: '450px', textTransform: 'none'}} onClick={() => setCurrentSrc(props.path.join('.'))}><Typography sx={{fontFamily: 'monospace'}} noWrap>{props.value}</Typography></Button>,
                              },
                            ]
  const defaultValueTypesWithArray = [
                                      {
                                        is: (value) => typeof value === 'string' || typeof value === 'number',
                                        Component: (props) => <Button variant={props.path.join('.') === currentSrc ? 'outlined' : 'text'} sx={{maxWidth: '450px', textTransform: 'none'}} onClick={() => {setCurrentSrc(props.path.join('.')); setShowOnlyArraysWarning(true)}}><Typography sx={{fontFamily: 'monospace'}} noWrap>{props.value}</Typography></Button>,
                                      },
                                      {
                                        is: (value) => typeof value === 'object' && Array.isArray(value),
                                        Component: (props) => <Button variant={props.path.join('.') === currentSrc ? 'outlined' : 'text'} sx={{maxWidth: '450px', textTransform: 'none'}} onClick={() => {setCurrentSrc(props.path.join('.')); setShowOnlyArraysWarning(false)}}><Typography sx={{fontFamily: 'monospace'}} noWrap>{JSON.stringify(props.value)}</Typography></Button>,
                                      },
                                    ]
  const [valueTypes, setValueTypes] = useState(defaultValueTypes)
  useEffect(() => {
      if (props.allowArraysSelection) setValueTypes(defaultValueTypesWithArray)
      else setValueTypes(defaultValueTypes)
  }, [props.allowArraysSelection])

  // props.dataBindTypes is an array of strings whose values can be: none, databind, url, imgLibrary
  // props.dataBindType is the currently selected type
  // props.dataBindValue for url-bound blocks it contains the url param name

  useEffect(() => {
    //console.log(props.dataBindValue)
    //console.log(props.dataBindType)
    //console.log(props.designTimeValue)

    setCurrentSrc(props.dataBindValue)
    setDataBindType(props.dataBindType)
    setDesignTimeValue(props.designTimeValue)
  }, [props.dataBindValue, props.dataBindType, props.designTimeValue])

  useEffect(() => {
    if (props.dataBindTypes === undefined || props.dataBindTypes === undefined) setAvailableDataBindTypes(allTypes);
    if (Array.isArray(props.dataBindTypes)) {
      if (props.dataBindTypes.length === 0) setAvailableDataBindTypes(allTypes);
      else setAvailableDataBindTypes(props.dataBindTypes)
    }
  }, [props.dataBindTypes])

  useEffect(() => {
    //console.log(props.weatherIconsCollectionId)
    if (props.weatherIconsCollectionId) setWeatherIconsCollectionId(props.weatherIconsCollectionId)
  }, [props.weatherIconsCollectionId])

  const handleOpenSrcSettings = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSrcSettings = () => {
    setAnchorEl(null);
    let dataBindValue = currentSrc;
    let dbType = dataBindType;
    if (currentSrc === '') dbType = null;
    if (dbType === 'weatherIcon') {
      const col = props.weatherIconsCollections.find(c => c.weatherCollectionId === weatherIconsCollectionId)
      dataBindValue = col.collection[0].iconDayDataURL
    }
    //if (dataBindType === 'url' && !dataBindValue.startsWith('param(')) dataBindValue = `param(${currentSrc})`;
    props.onChange(dbType, dataBindValue, dbType === 'url' ? designTimeValue : undefined, weatherIconsCollectionId);
  };
  const openFontSettings = Boolean(anchorEl);

  const handleFileChange = (fileInfo) => {
    // this can only be 1 file for the canvas background
    const filenames = fileInfo.fileMappings;
    //const fileSizes = fileInfo.fileSizes;
  
    const fn = Object.keys(filenames);
    //console.log(filenames[fn[0]]);

    props.onChange('none', filenames[fn[0]]);
    setAnchorEl(null);

  }

  const handleDeleteFile = () => {
    setCurrentSrc('')
  }
  const handleForecastsSelected = (section, newValue) => {
    setAnchorEl(null);
    let dataBindValue = section + '||' + newValue;
    props.onChange('forecasts', dataBindValue, undefined);
  };

  /*
  const getFirstAvailablePrimitiveProp = (obj) => {
    let result = '';
    const objProps = Object.keys(obj);
    objProps.forEach(o => {      
      if (!Array.isArray(obj[o]) && typeof(obj[o]) !== "object") result = o;
      
    })
    return result;
  }
  */

  function isPrimitive(value) {
    return value === null || (typeof value !== "object" && typeof value !== "function");
  }
  const forecastsGetValuesForSections = (section) => {

    const allKeys = Object.keys(props.sampleData[props.weatherUnits].daily[0])
    const temperatureKeys = Object.keys(props.sampleData[props.weatherUnits].daily[0].temp)
    const feelsLikeKeys = Object.keys(props.sampleData[props.weatherUnits].daily[0].feels_like)
    const weatherKeys = Object.keys(props.sampleData[props.weatherUnits].daily[0].weather[0]).filter(k => k !== 'id' && k !== 'icon')
    const result = []

    switch (section) {
      case "general":
        allKeys.forEach(k => {if (isPrimitive(props.sampleData[props.weatherUnits].daily[0][k])) result.push({name: k, prettyname: k, description: getForecastsDescription(section, k)})})
      break;
      case "temperature":
        temperatureKeys.forEach(k => {if (isPrimitive(props.sampleData[props.weatherUnits].daily[0].temp[k])) result.push({name: k, prettyname: k, description: getForecastsDescription(section, k)})})
      break;
      case "feelsLike":
        feelsLikeKeys.forEach(k => {if (isPrimitive(props.sampleData[props.weatherUnits].daily[0].feels_like[k])) result.push({name: k, prettyname: k, description: getForecastsDescription(section, k)})})
      break;
      case "weather":
        weatherKeys.forEach(k => {if (isPrimitive(props.sampleData[props.weatherUnits].daily[0].weather[k])) result.push({name: k, prettyname: k, description: getForecastsDescription(section, k)})})
      break;
      default:
      break;
    }

    return result.sort((a, b) => a.prettyname.localeCompare(b.prettyname));
  }
  const renderWeatherCollectionIconsPreview = () => {
    const col = props.weatherIconsCollections.find(c => c.weatherCollectionId === weatherIconsCollectionId)
    if (col) {
      const first3 = col.collection.slice(0,3)
      return first3.map(g => <img src={g.iconDayDataURL} className='w-[60px] h-[60px]' />)

    }
    else return <></>

  }

  return <>
        {!props.noPreview && 
          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
            <Typography>{props.label === undefined ? 'Src:' : props.label}</Typography>
            {props.dataBindType === 'weatherIcon' ? <Chip sx={{maxWidth: '200px'}} label={(currentSrc == null || currentSrc === '') ? 'Select...' : 'Weather Icon'} variant="outlined" onClick={handleOpenSrcSettings} />        
            :
            <Chip sx={{maxWidth: '200px'}} label={(currentSrc == null || currentSrc === '') ? 'Select...' : `${currentSrc}`} variant="outlined" onClick={handleOpenSrcSettings} />
        }        
          </Stack>
        }
        {props.noPreview && <>
          {props.noPreviewCustomMsg ? <><CcActionButton onClick={handleOpenSrcSettings}>{props.noPreviewCustomMsg}</CcActionButton></>
          :
          <Button sx={{minWidth: '40px'}} color='secondary' onClick={handleOpenSrcSettings} >
              <Iconify icon={lionIcons.Icon_Databind_databound} />
          </Button>        
          }
        </>
        }
      
      <Popover      open={openFontSettings}
                    anchorEl={anchorEl}
                    onClose={handleCloseSrcSettings}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <div className='w-[800px] max-h-[600px] p-3'>
          {props.uploaderMode ?  
            <div>
              <ImageUploader onChange={handleFileChange}
                                        //uploadedFiles={canvasUploadedFiles}
                                        endpoint="utils/unmanaged/uploadImage"
                                         />
            </div>
            :
            <Stack spacing={2}>
            <Typography>Data connection type</Typography>
            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
              <RadioGroup
                row
                name="radio-buttons-databindType"
                value={dataBindType}
                onChange={(e) => {setDataBindType(e.target.value);}}
              >
                {availableDataBindTypes.includes('none') && <FormControlLabel value="none" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_none, color:'#fff', cursor:'pointer'}} label="Text block" icon={<Iconify icon={lionIcons.Icon_Databind_fixed} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('designTimeValues') && <FormControlLabel value="designTimeValues" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_none, color:'#fff', cursor:'pointer'}} label="Design Time Values" icon={<Iconify icon={lionIcons.Icon_Databind_fixed} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('databind') && <FormControlLabel value="databind" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_databound, color:'#fff', cursor:'pointer'}} label="Connect to feed" icon={<Iconify icon={lionIcons.Icon_Databind_databound} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('url') && <FormControlLabel value="url" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_url, color:'#fff', cursor:'pointer'}} label="URL Parameter" icon={<Iconify icon={lionIcons.Icon_Databind_url} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('urlChartSeries') && <FormControlLabel value="urlChartSeries" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_url, color:'#fff', cursor:'pointer'}} label="URL Parameter" icon={<Iconify icon={lionIcons.Icon_Databind_url} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('imgLibrary') && <FormControlLabel value="imgLibrary" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_imgLibrary, color:'#fff', cursor:'pointer'}} label="Image Library" icon={<Iconify icon={lionIcons.Icon_Databind_imgLibrary} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('s3') && <FormControlLabel value="s3" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_imgLibrary, color:'#fff', cursor:'pointer'}} label="Uploaded Image" icon={<Iconify icon={lionIcons.Icon_Databind_imgLibrary} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('forecasts') && <FormControlLabel value="forecasts" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_databound, color:'#fff', cursor:'pointer'}} label="Connect to weather forecasts" icon={<Iconify icon={lionIcons.Icon_Databind_Weather} style={{color: 'white'}} />} />} /> }
                {availableDataBindTypes.includes('weatherIcon') && <FormControlLabel value="weatherIcon" control={<Radio />} label={<Chip sx={{backgroundColor: lionObjectsColors.Color_Databind_databound, color:'#fff', cursor:'pointer'}} label="Connect to weather icon" icon={<Iconify icon={lionIcons.Icon_Databind_Weather} style={{color: 'white'}} />} />} /> }
              </RadioGroup>
            </Stack>
            {dataBindType === 'none' && <>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Fixed:</Typography>
                <TextField sx={{width: '95%'}}
                      value={currentSrc}
                      onChange={(e) => setCurrentSrc(e.target.value)}
                      size="small"
                    />

              </Stack>            
            </>}
            {dataBindType === 'designTimeValues' && <>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>

              </Stack>            
            </>}
            {dataBindType === 'url' && <>
                <div className='flex flex-col gap-2 border p-2 bg-slate-100 border-gray-200 rounded-lg shadow'>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <div className='font-semibold text-ccColorTeal'>Parameter:</div>
                      <TextField sx={{width: 200}}
                          value={currentSrc}
                          onChange={(e) => setCurrentSrc(e.target.value)}
                          size="small"
                        />
                      <InfoToolTip 
                        placement='left'
                        headLine='URL parameter value'
                        message="Define the name of the URL parameter which contains the data for this block"
                      />

                  </Stack>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <div className='font-semibold text-ccColorTeal'>Preview content:</div>
                      <TextField sx={{width: 200}}
                          value={designTimeValue}
                          onChange={(e) => setDesignTimeValue(e.target.value)}
                          size="small"
                        />
                      <InfoToolTip 
                        placement='left'
                        headLine='Preview content'
                        message="This value is to be used in the design lab ONLY. It won't affect live tags"
                      />
                  </Stack>
                </div>
            </>}
            {dataBindType === 'urlChartSeries' && <>
                <div className='flex flex-col gap-2 border p-2 bg-slate-100 border-gray-200 rounded-lg shadow'>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <div className='font-semibold text-ccColorTeal'>Parameter:</div>
                      <div className='w-48 h-10 p-2 border border-gray-400 rounded font-poppins font-semibold text-ccColorDarkTeal cursor-not-allowed'>{currentSrc}</div>
                  </Stack>
                  <div className='text-sm text-ccColorDarkTeal font-poppins'>Our tag will contain a parameter named <span className='font-semibold'>{currentSrc}</span>. Merge your data in there</div>
                </div>
            </>}

            {dataBindType === 'imgLibrary' && <>
              <ImageLibraryPicker               
                      onChange={(url) => setCurrentSrc(url)} />
            </>}
            {dataBindType === 'databind' && <>
                      {showOnlyArraysWarning && <div className='font-poppins font-semibold text-red-500'>Please make sure to select an array</div>}
                      <Grid2 container>
                        <Grid2 xs={12}>
                          <div className='h-96 overflow-auto'>
                            <JsonViewer value={props.sampleData}
                                      rootName={false}
                                    enableClipboard={false}
                                    onSelect={(path, value) => {
                                                                  setCurrentSrc(path.join('.'))
                                                                }
                                                }
                                    /* keyRenderer={{when: (props) => props.path[0] === 'id', 
                                      Component: (props) => {console.log(props); return <div>ciao</div>}}} 
                                      */
                                    valueTypes={valueTypes} 
                            />
                          </div>
                        </Grid2>
                      </Grid2>
                      </>
            }
            {dataBindType === 's3' && <div className='flex flex-col gap-y-2'>
              {(currentSrc === '') &&
                    <div>No image uploaded</div>
              }
              {(currentSrc !== '') && <div className='flex flex-row items-start'>
                                <div className='bg-slate-200 rounded p-4 mt-2 w-[350px] h-[260px] flex justify-center'>
                                  <div className='relative h-full' >                  
                                      <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${currentSrc}`} />     
                                  </div>
                                </div>
                                <IconButton onClick={handleDeleteFile} ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                            </div>              
              }
                  <ImageUploader onChange={handleFileChange}
                      //uploadedFiles={canvasUploadedFiles}
                      endpoint="utils/unmanaged/uploadImage"
                      />
                      </div>
            }
            {dataBindType === 'forecasts' && <div className='text-ccColorDarkTeal font-poppins'>
              <div className='h-[300px] mt-2 overflow-auto'>
                <div className='bg-slate-50 py-1 font-semibold italic text-lg'>General</div>
                {forecastsGetValuesForSections('general').map(weatherKey => <div className={`flex flex-row gap-x-2 items-center border-b py-5 hover:bg-slate-100 ${'general||' + weatherKey.name === props.dataBindValue ? 'bg-ccColorLightTeal' : ''}`}>
                    <div className='flex flex-col w-96'>
                      <div className='font-semibold'>{weatherKey.prettyname}</div>
                      <div className='text-gray-500 text-sm'>{weatherKey.description}</div>
                    </div>
                    <div className='text-xl'>{props.sampleData[props.weatherUnits].daily[0][weatherKey.name]}</div>
                    <div className='flex grow'></div>
                    <div className='mr-4'><CcActionButtonOutlined onClick={() => handleForecastsSelected('general', weatherKey.name)}>Select</CcActionButtonOutlined></div>
                  </div>)              
                }
                <div className='bg-slate-50 py-1 font-semibold italic text-lg'>Temperature</div>
                {forecastsGetValuesForSections('temperature').map(weatherKey => <div className={`flex flex-row items-center border-b py-5 hover:bg-slate-100 ${'temperature||' + weatherKey.name === props.dataBindValue ? 'bg-ccColorLightTeal' : ''}`}>
                    <div className='flex flex-col w-96'>
                      <div className='font-semibold'>{weatherKey.prettyname}</div>
                      <div className='text-gray-500 text-sm'>{weatherKey.description}</div>
                    </div>
                    <div className='text-xl'>{props.sampleData[props.weatherUnits].daily[0].temp[weatherKey.name]}</div>
                    <div className='flex grow'></div>
                    <div className='mr-4'><CcActionButtonOutlined onClick={() => handleForecastsSelected('temperature', weatherKey.name)}>Select</CcActionButtonOutlined></div>
                  </div>)              
                }
                <div className='bg-slate-50 py-1 font-semibold italic text-lg'>Feels Like</div>
                {forecastsGetValuesForSections('feelsLike').map(weatherKey => <div className={`flex flex-row items-center border-b py-5 hover:bg-slate-100 ${'feelsLike||' + weatherKey.name === props.dataBindValue ? 'bg-ccColorLightTeal' : ''}`}>
                    <div className='flex flex-col w-96'>
                      <div className='font-semibold'>{weatherKey.prettyname}</div>
                      <div className='text-gray-500 text-sm'>{weatherKey.description}</div>
                    </div>
                    <div className='text-xl'>{props.sampleData[props.weatherUnits].daily[0].feels_like[weatherKey.name]}</div>
                    <div className='flex grow'></div>
                    <div className='mr-4'><CcActionButtonOutlined onClick={() => handleForecastsSelected('feelsLike', weatherKey.name)}>Select</CcActionButtonOutlined></div>
                  </div>)              
                }
                <div className='bg-slate-50 py-1 font-semibold italic text-lg'>Weather</div>
                {forecastsGetValuesForSections('weather').map(weatherKey => <div className={`flex flex-row items-center border-b py-5 hover:bg-slate-100 ${'weather||' + weatherKey.name === props.dataBindValue ? 'bg-ccColorLightTeal' : ''}`}>
                    <div className='flex flex-col w-96'>
                      <div className='font-semibold'>{weatherKey.prettyname}</div>
                      <div className='text-gray-500 text-sm'>{weatherKey.description}</div>
                    </div>
                    <div className='text-xl'>{props.sampleData[props.weatherUnits].daily[0].weather[0][weatherKey.name]}</div>
                    <div className='flex grow'></div>
                    <div className='mr-4'><CcActionButtonOutlined onClick={() => handleForecastsSelected('weather', weatherKey.name)}>Select</CcActionButtonOutlined></div>
                  </div>)              
                }
              </div>
            </div>
            }
            {dataBindType === 'weatherIcon' && <div className='text-ccColorDarkTeal font-poppins flex flex-row gap-x-4'>
                <div className='flex flex-col w-64 min-h-52'>
                    <div className='block text-sm font-medium leading-6 text-gray-900'>Icons collections</div>
                    <LionListbox items={props.weatherIconsCollections.map(c => {return {id: c.weatherCollectionId, name: c.collectionName}})}
                      zIndex={10}
                      selectedItemId={weatherIconsCollectionId}
                      onChange={(val) => setWeatherIconsCollectionId(val.id)}
                    />
                </div>
                <div className='flex flex-col'>
                  <div>Icon preview</div>
                  <div className='flex flex-row'>
                  {renderWeatherCollectionIconsPreview()}
                  </div>
                </div>
            </div>
            }
            <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
              <Button variant='outlined' color='secondary'  sx={{mr:1}} onClick={handleCloseSrcSettings}>Save</Button>
            </Box>

            </Stack>
          }

        </div>
    </Popover>
  </>
}

const TextFunctionBuilder = (props) => {
  const [functionNameBrowsed, setFunctionNameBrowsed] = useState('');
  const [labelTitle, setLabelTitle] = useState('Select a function')
  const [selectedFunctionIndex, setSelectedFunctionIndex] = useState(-1)
  const [anchorEl, setAnchorEl] = useState(null);
  const [allFunctionParameters, setAllFunctionParameters] = useState({replace: ['',''], // array of parameter values (we don't use names)
                                                                      truncate: ['',''],
                                                                      replaceEmpty: ['',''],
                                                                      replaceLonger: ['',''],
                                                                      replaceShorter: ['',''],
                                                                      formatNumber: ['D','',''],
                                                                      formatDatetime: ['yyyy-MM-dd HH:mm:ss','',''],
                                                                      ordinalize: [''],
                                                                      numberToWords: [''],
                                                                      numberToOrdinalWords: [''],
                                                                      romanNumeralsTo: [''],
                                                                      romanNumeralsFrom: [''],
                                                                      celsiusToFahrenheit: [''],
                                                                     });
  const [cultures, setCultures] = useState([]);
  const {settings, setSettings} = useContext(SettingsContext);
                                                                  
  useEffect(() => {
    if (props.functionParameters !== undefined) {
      const newAllFunctionParameters = {...allFunctionParameters, [props.functionParameters.functionName]: props.functionParameters.parameters}
      setAllFunctionParameters(newAllFunctionParameters);
      setLabelTitle(getLabelTitle());

      // we want the editor to show highlight the first function by default
      // first function currently is "replace"
      setFunctionNameBrowsed(props.functionParameters.functionName === '' ? 'replace' : props.functionParameters.functionName)
      setSelectedFunctionIndex(getSelectedFunctionIndex(props.functionParameters.functionName));

    }
    
  }, [props.functionParameters])

  /*
  useEffect(() =>{
    async function getDataFromStore() {
      const supportedCultures = await store.getState().userSettings.supportedCultures;
      setCultures(supportedCultures);
      const favCulture = supportedCultures.find(c => c.isFavourite);

      // we wanto to use the fav culture as the default
      const newAllFunctionParameters = {...allFunctionParameters};
      if (newAllFunctionParameters.formatNumber[2] === '') newAllFunctionParameters.formatNumber[2] = favCulture.id;
      if (newAllFunctionParameters.formatDatetime[2] === '') newAllFunctionParameters.formatDatetime[2] = favCulture.id;
      if (newAllFunctionParameters.ordinalize[0] === '') newAllFunctionParameters.ordinalize[0] = favCulture.id;
      if (newAllFunctionParameters.numberToWords[0] === '') newAllFunctionParameters.numberToWords[0] = favCulture.id;
      if (newAllFunctionParameters.numberToOrdinalWords[0] === '') newAllFunctionParameters.numberToOrdinalWords[0] = favCulture.id;
    };
    getDataFromStore();
  }, [])
*/

  useEffect(() => {
    if (settings.cultures === undefined) return;

    const supportedCultures = settings.cultures;
    setCultures(supportedCultures);
    const favCulture = supportedCultures.find(c => c.isFavourite);

    // we wanto to use the fav culture as the default
    const newAllFunctionParameters = {...allFunctionParameters};
    if (newAllFunctionParameters.formatNumber[2] === '') newAllFunctionParameters.formatNumber[2] = favCulture.id;
    if (newAllFunctionParameters.formatDatetime[2] === '') newAllFunctionParameters.formatDatetime[2] = favCulture.id;
    if (newAllFunctionParameters.ordinalize[0] === '') newAllFunctionParameters.ordinalize[0] = favCulture.id;
    if (newAllFunctionParameters.numberToWords[0] === '') newAllFunctionParameters.numberToWords[0] = favCulture.id;
    if (newAllFunctionParameters.numberToOrdinalWords[0] === '') newAllFunctionParameters.numberToOrdinalWords[0] = favCulture.id;

  }, [settings]);


  const getLabelTitle = () => {
    if (props.functionParameters === undefined || props.functionParameters.functionName === '') return "Select a function";
    switch (props.functionParameters.functionName) {
      case "replace":
        return `Replace ${props.functionParameters.parameters[0]} with ${props.functionParameters.parameters[1]}`;
      case "replaceEmpty":
        return `Replace empty text with ${props.functionParameters.parameters[0]}`;
      case "replaceLonger":
        return `Replace text longer than ${props.functionParameters.parameters[0]} with ${props.functionParameters.parameters[1]}`;
      case "replaceShorter":
        return `Replace text shorter than ${props.functionParameters.parameters[0]} with ${props.functionParameters.parameters[1]}`;
      case "truncate":
        return `Truncate at char ${props.functionParameters.parameters[0]}`;
      case "formatNumber":
        return `Format number as ${props.functionParameters.parameters[0]}`;
      case "formatDatetime":
        return `Format date and time as ${props.functionParameters.parameters[1]}`;
      case "ordinalize":
        return `Ordinalize a number`;
      case "numberToWords":
        return `Number to words`;
      case "numberToOrdinalWords":
        return `Number to ordinal words`;
      case "romanNumeralsTo":
        return `Number to roman numerals`;
      case "romanNumeralsFrom":
        return `Number from roman numerals`;
      case 'celsiusToFahrenheit':
        return 'Celsius To Fahrenheit'
      default:
        return props.functionParameters.functionName;
    }
  }
  const getSelectedFunctionIndex = (functionName) => {
    switch (functionName) {
      case 'replace':
        return 0;
      case 'truncate':
        return 1;
      case 'replaceEmpty':
        return 2;
      case 'replaceLonger':
        return 3;
      case 'replaceShorter':
        return 4;
      case 'formatNumber':
        return 5;
      case 'formatDatetime':
        return 6;
      case 'ordinalize':
        return 7;
      case 'numberToWords':
        return 8;
      case 'numberToOrdinalWords':
        return 9;
      case 'romanNumeralsTo':
        return 10;
      case 'romanNumeralsFrom':
        return 11;
      case 'celsiusToFahrenheit':
        return 12;
      default:
        return 0;
    }
  }


  const openBuilder = Boolean(anchorEl);
  const handleOpenFunctionSelector = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseFunctionSelector = () => {
    // if (props.onTextFunctionsChange !== undefined) props.onTextFunctionsChange(textTransforms);

    setAnchorEl(null);
    
  };

  const renderExample = (functionName) => {
    switch (functionName) {
        case "replace":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                    String Replace
                  </Typography>
                  <Typography color="text.secondary">
                    replaces a <span style={{fontStyle: 'italic'}}>word</span> with <span style={{fontStyle: 'italic'}}>another word</span>
                  </Typography>                
                  <Typography variant="h6" component="div">
                    Example:
                  </Typography>
                  <Typography color="text.secondary">
                    replace <span style={{fontWeight: 'bold'}}>apples</span> with <span style={{fontWeight: 'bold'}}>bananas</span>
                  </Typography>                
                  <Typography color="text.secondary">
                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                      <div>I like apples</div>
                      <Iconify icon='material-symbols:arrow-forward-rounded' />
                      <div>I like bananas</div>
                    </Stack>
                  </Typography>                
            </Stack>
        case "replaceEmpty":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                      String Replace when empty
                    </Typography>
                    <Typography color="text.secondary">
                      replaces <span style={{fontStyle: 'italic'}}>empty block text</span> with the <span style={{fontStyle: 'italic'}}>provided text</span>
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      replace <span style={{fontWeight: 'bold'}}>empty text</span> with <span style={{fontWeight: 'bold'}}>Customer</span>
                    </Typography>                
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>""</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>Customer</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>"Dear customer"</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>Dear customer</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "replaceLonger":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                      String Replace when longer
                    </Typography>
                    <Typography color="text.secondary">
                      replaces the <span style={{fontStyle: 'italic'}}>block text</span> when its length is bigger than <span style={{fontStyle: 'italic'}}>maxLength</span> with the <span style={{fontStyle: 'italic'}}>provided text</span>
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      replace the <span style={{fontWeight: 'bold'}}>block text</span> when its length is bigger than <span style={{fontStyle: 'italic'}}>8</span> with <span style={{fontWeight: 'bold'}}>Customer</span>
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>a very long name</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>Customer</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>John</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>John</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "replaceShorter":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                      String Replace when shorter
                    </Typography>
                    <Typography color="text.secondary">
                      replaces the <span style={{fontStyle: 'italic'}}>block text</span> when its length is lower than <span style={{fontStyle: 'italic'}}>minLength</span> with the <span style={{fontStyle: 'italic'}}>provided text</span>
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      replace the <span style={{fontWeight: 'bold'}}>block text</span> when its length is lower than <span style={{fontStyle: 'italic'}}>4</span> with <span style={{fontWeight: 'bold'}}>Customer</span>
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>abc</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>Customer</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>John</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>John</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "truncate":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                      String Truncate
                    </Typography>
                    <Typography color="text.secondary">
                      truncate <span style={{fontStyle: 'italic'}}>text</span> when longer than a certain length with <span style={{fontStyle: 'italic'}}>... (or a specified symbol)</span>
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      truncate <span style={{fontWeight: 'bold'}}>I like apples</span> when longer than 5 characters
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>I like apples</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>I lik...</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "formatNumber":
          return <Stack sx={{maxHeight: 300, overflow: 'auto'}} spacing={1}>
                    <Typography variant="h4" component="div">
                      Format a number
                    </Typography>
                    <Typography color="text.secondary">
                      control how <span style={{fontStyle: 'italic'}}>leading zeros, decimal digits and group separators</span> should be formatted using a <span style={{fontStyle: 'italic'}}>format string</span> and <span style={{fontStyle: 'italic'}}>culture</span> information
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Format String List:
                    </Typography>
                    <Typography color="text.secondary">
                      <span style={{fontWeight: 'bold'}}>D - Integer only with no decimals.</span>  Optionally specifiy the minimun number of digits
                    </Typography>                
                    <Typography color="text.secondary">
                      <span style={{fontWeight: 'bold'}}>F - Integral and Decimal parts.</span>  Optionally append how many decimal digits you wish to show
                    </Typography>                
                    <Typography color="text.secondary">
                      <span style={{fontWeight: 'bold'}}>N - Integral and Decimal parts and Group separators</span>  Optionally append how many decimal digits you wish to show
                    </Typography>
                    <Typography variant="h6" component="div">
                      Examples:
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: D</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1234</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: D6</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>001234</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: F (US culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1234.56</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: F (FR culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1234,56</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: F4 (US culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1234.5670</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: F4 (FR culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1234,5670</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: N (US culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1234.5670</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: N (SE culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1 234,56</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: N4 (US culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1,234.5670</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1234.567</div>
                        <span style={{fontWeight: 'bold'}}> format: N4 (SE culture)</span>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1 234,5670</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "formatDatetime":
          return <Stack sx={{maxHeight: 300, overflow: 'auto'}} spacing={1}>
                    <Typography variant="h4" component="div">
                      Format a date and time
                    </Typography>
                    <Typography color="text.secondary">
                      format a datetime using a <span style={{fontStyle: 'italic'}}>format string</span>  and <span style={{fontStyle: 'italic'}}>culture</span> information
                    </Typography>                
                    <Typography color="text.secondary">
                      A format string is created by combining one or more specifiers. See below all the available specifiers with examples
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Format String specifiers:
                    </Typography>
                    <Typography color="text.secondary">
                      <Grid2 container spacing={1} sx={{width: '95%'}}>
                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>d</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The day of the month from 1 to 31</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                            <span>2009-06-01T13:45:30</span>
                            <Iconify icon='material-symbols:arrow-forward-rounded' />
                            <div>1</div>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>dd</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The day of the month, from 01 through 31</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                            <span>2009-06-01T13:45:30</span>
                            <Iconify icon='material-symbols:arrow-forward-rounded' />
                            <div>01</div>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>ddd</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The abbreviated name of the day of the week.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-01T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>Mon (en-US)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-01T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>Пн (ru-RU)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-01T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>lun. (fr-FR)</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>dddd</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The full name of the day of the week.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-01T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>Monday (en-US)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-01T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>понедельник (ru-RU)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-01T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>lundi (fr-FR)</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>f</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The tenths of a second in a date and time value.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.6170000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>6</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.05</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>0</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>ff</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The hundredths of a second in a date and time value.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.6170000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>61</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.05</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>00</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>fff</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The milliseconds in a date and time value.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.6170000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>617</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.05</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>000</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>F</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>If non-zero, the tenths of a second in a date and time value..</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.6170000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>6</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.0500000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>no output</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>FF</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The hundredths of a second in a date and time value.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.6170000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>61</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.0050000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>no output</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>FFF</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The milliseconds in a date and time value.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.0005000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>617</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.05</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>no output</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>"g" or "gg"</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The period or era.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30.0005000</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>A.D.</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>h</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The hour, using a 12-hour clock from 1 to 12.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>1</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>1</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>hh</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The hour, using a 12-hour clock from 01 to 12.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>01</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>01</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>H</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The hour, using a 24-hour clock from 0 to 23.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>1</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>13</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>HH</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The hour, using a 24-hour clock from 00 to 23.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>01</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>13</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>m</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The minute, from 0 through 59.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:09:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>9</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:29:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>29</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>mm</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The minute, from 00 through 59.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:09:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>09</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T01:29:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>29</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>M</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The month, from 1 through 12.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>6</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>MM</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The month, from 01 through 12.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>06</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>MMM</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The abbreviated name of the month.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>Jun (en-US)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>juin (fr-FR)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>Jun (zu-ZA)</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>MMMM</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}> The full name of the month.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>June (en-US)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>juni (da-DK)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>uJuni (zu-ZA)</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>s</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The second, from 0 through 59.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>9</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>ss</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The second, from 00 through 59.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>09</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>t</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The first character of the AM/PM designator.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>P (en-US)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>午 (ja-JP)</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>tt</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The AM/PM designator.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>PM (en-US)</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>午後 (ja-JP)</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>y</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The year, from 0 to 99.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>9</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2019-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>19</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>yy</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The year, from 00 to 99.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>09</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2019-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>19</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>yyy</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The year, with a minimum of three digits.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>0900-01-01T00:00:00</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>900</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>1900-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>1900</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2019-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>2019</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>yyyy</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>The year as a four-digit number.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>0900-01-01T00:00:00</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>0900</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>1900-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>1900</div>
                            </Stack>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2019-06-15T13:45:09</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>2019</div>
                            </Stack>
                          </Stack>
                        </Grid2>

                        <Grid2 xs={1}>
                          <Typography><span style={{fontWeight: 'bold'}}>"string"</span></Typography>
                        </Grid2>
                        <Grid2 xs={4}>
                          <Typography sx={{maxWidth:300}}>  Literal string delimiter.</Typography>
                        </Grid2>
                        <Grid2 xs={7}>
                          <Stack spacing={1}>
                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                              <span>2009-06-15T13:45:30 <br />("arr:" h:m t)</span>
                              <Iconify icon='material-symbols:arrow-forward-rounded' />
                              <div>arr: 1:45 P</div>
                            </Stack>
                          </Stack>
                        </Grid2>


                      </Grid2>                        
                    </Typography>
              </Stack>
        case "ordinalize":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                      Ordinalize number
                    </Typography>
                    <Typography color="text.secondary">
                      turns a <span style={{fontStyle: 'italic'}}>number</span> into an ordinal string used to denote the position in an ordered sequence such as 1st, 2nd, 3rd, 4th
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1st (English)</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>1º (Portuguese)</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "numberToWords":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                      Number to words
                    </Typography>
                    <Typography color="text.secondary">
                      translate a <span style={{fontStyle: 'italic'}}>number</span> into words
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>one (English)</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>122</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>one hundred and twenty-two (English)</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "numberToOrdinalWords":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                    Number to ordinal words
                    </Typography>
                    <Typography color="text.secondary">
                      takes the ordinal representation of a <span style={{fontStyle: 'italic'}}>number</span> and translates it into words
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>first (English)</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>8</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>eighth (English)</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "romanNumeralsTo":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                    Number to roman numerals
                    </Typography>
                    <Typography color="text.secondary">
                      takes a <span style={{fontStyle: 'italic'}}>number</span> and translates it into roman numerals
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>1</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>I</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>8</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>VIII</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "romanNumeralsFrom":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                    Number from roman numerals
                    </Typography>
                    <Typography color="text.secondary">
                      takes a <span style={{fontStyle: 'italic'}}>roman numeral</span> and converts it into a number
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>II</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>two (English)</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>IV</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>four (English)</div>
                      </Stack>
                    </Typography>                
              </Stack>
        case "celsiusToFahrenheit":
          return <Stack spacing={1}>
                    <Typography variant="h4" component="div">
                    Celsius To Fahrenheit temperature
                    </Typography>
                    <Typography color="text.secondary">
                      takes <span style={{fontStyle: 'italic'}}>celsius</span> degrees and converts them in fahrenheit
                    </Typography>                
                    <Typography variant="h6" component="div">
                      Example:
                    </Typography>
                    <Typography color="text.secondary">
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>20°C</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>68°F</div>
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', fontFamily:'monospace'}}>
                        <div>35°C</div>
                        <Iconify icon='material-symbols:arrow-forward-rounded' />
                        <div>95°F</div>
                      </Stack>
                    </Typography>                
              </Stack>
        default:
      break;
    }
    return <>
    Example for {functionName}
    </>
  }
const handleFunctionEdit = (fName, paramIndex, paramValue) => {

  const newFunctionParams = [...allFunctionParameters[fName]]
  newFunctionParams[paramIndex] = paramValue;

  const newAllFunctionParameters = {...allFunctionParameters, [fName]: newFunctionParams}
  setAllFunctionParameters(newAllFunctionParameters);
}


  const renderFunctionEditor = (functionName) => {
    switch (functionName) {
      case "replace":
      return  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>
                  Replace
                </Typography>
                <TextField sx={{width: '120px'}}
                      value={allFunctionParameters.replace[0]}
                      onChange={(e) => handleFunctionEdit('replace', 0, e.target.value)}
                      size="small"
                    />
                <Typography>
                  with
                </Typography>
                <TextField sx={{width: '120px'}}
                      value={allFunctionParameters.replace[1]}
                      onChange={(e) => handleFunctionEdit('replace', 1, e.target.value)}
                      size="small"
                    />
          </Stack>
      case "replaceEmpty":
        return  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>
                    Replace empty text with
                  </Typography>
                  <TextField sx={{width: '120px'}}
                        value={allFunctionParameters.replaceEmpty[0]}
                        onChange={(e) => handleFunctionEdit('replaceEmpty', 0, e.target.value)}
                        size="small"
                      />
            </Stack>
      case "replaceLonger":
        return <Stack>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography>
                          Replace block text when longer than
                        </Typography>
                        <TextField sx={{width: '120px'}}
                              value={allFunctionParameters.replaceLonger[0]}
                              onChange={(e) => handleFunctionEdit('replaceLonger', 0, e.target.value)}
                              size="small"
                            />
                  </Stack>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography>
                          with
                        </Typography>
                        <TextField sx={{width: '200px'}}
                              value={allFunctionParameters.replaceLonger[1]}
                              onChange={(e) => handleFunctionEdit('replaceLonger', 1, e.target.value)}
                              size="small"
                            />
                  </Stack>
                </Stack>
      case "replaceShorter":
        return <Stack>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography>
                          Replace block text when shorter than
                        </Typography>
                        <TextField sx={{width: '120px'}}
                              value={allFunctionParameters.replaceShorter[0]}
                              onChange={(e) => handleFunctionEdit('replaceShorter', 0, e.target.value)}
                              size="small"
                            />
                  </Stack>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography>
                          with
                        </Typography>
                        <TextField sx={{width: '200px'}}
                              value={allFunctionParameters.replaceShorter[1]}
                              onChange={(e) => handleFunctionEdit('replaceShorter', 1, e.target.value)}
                              size="small"
                            />
                  </Stack>
                </Stack>
        case "truncate":
          return <Stack>
                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography>
                      Truncate after
                    </Typography>
                    <TextField sx={{width: '120px'}}
                          value={allFunctionParameters.truncate[0]}
                          onChange={(e) => handleFunctionEdit('truncate', 0, e.target.value)}
                          size="small"
                        />
                    <Typography>
                      characters
                    </Typography>
                    </Stack>
                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography>
                      (Optionally) provide a truncation character 
                    </Typography>
                    <TextField sx={{width: '120px'}}
                          value={allFunctionParameters.truncate[1]}
                          onChange={(e) => handleFunctionEdit('truncate', 1, e.target.value)}
                          size="small"
                        />
                    </Stack>
                </Stack>
        case "formatNumber":
          return <Stack spacing={1}>
                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography>
                      Format String
                    </Typography>
                    <FormControl size="small">
                      <Select
                        // id="select-fontname"
                        value={allFunctionParameters.formatNumber[0]}
                        onChange={(e) => handleFunctionEdit('formatNumber', 0, e.target.value)}
                        >
                        <MenuItem value='D'>D</MenuItem>
                        <MenuItem value='F'>F</MenuItem>
                        <MenuItem value='N'>N</MenuItem>                      
                      </Select>
                    </FormControl>
                    <Typography>
                      Optional specifier
                    </Typography>
                    <TextField sx={{width: '120px'}}
                          value={allFunctionParameters.formatNumber[1]}
                          onChange={(e) => handleFunctionEdit('formatNumber', 1, e.target.value)}
                          size="small"
                        />
                    </Stack>
                    {allFunctionParameters.formatNumber[0] !== 'D' &&
                                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                          <Typography>
                                            Culture 
                                          </Typography>
                                            <FormControl size="small">
                                              <Select
                                                  value={allFunctionParameters.formatNumber[2]}
                                                  onChange={(e) => handleFunctionEdit('formatNumber', 2, e.target.value)}
                                                >
                                                  {cultures.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                                                
                                              </Select>
                                            </FormControl>
                                          </Stack>

                    }
                </Stack>
        case "formatDatetime":
          return <Stack spacing={1}>
                    <Stack direction='row' spacing={3} sx={{display: 'flex', alignItems: 'center'}}>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography>
                        Input
                      </Typography>
                      <TextField sx={{width: '220px'}}
                            label='Format'
                            value={allFunctionParameters.formatDatetime[0]}
                            onChange={(e) => handleFunctionEdit('formatDatetime', 0, e.target.value)}
                            size="small"
                          />
                      <InfoToolTip 
                        placement='top'
                        headLine='Input format'
                        message={<div className='font-poppins text-ccColorDarkTeal'>
                                  <div>Write your format using any of the allowed specifiers</div>
                                  <div className='mt-2'>Type <span className='bg-slate-200 rounded font-bold text-lg px-1'>unix</span> if your input is a Unix timestamp</div>
                        </div>}
                        />
                        
                      </Stack>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography>
                        Output
                      </Typography>
                      <TextField sx={{width: '220px'}}
                            label='Format'
                            value={allFunctionParameters.formatDatetime[1]}
                            onChange={(e) => handleFunctionEdit('formatDatetime', 1, e.target.value)}
                            size="small"
                          />
                      </Stack>
                    </Stack>
                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography>
                      Culture 
                    </Typography>
                      <FormControl size="small">
                        <Select
                          value={allFunctionParameters.formatDatetime[2]}
                          onChange={(e) => handleFunctionEdit('formatDatetime', 2, e.target.value)}
                          >
                            {cultures.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}                          
                        </Select>
                      </FormControl>
                    </Stack>

                </Stack>
        case "ordinalize":
          return <Stack spacing={1}>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography>
                        Culture 
                      </Typography>
                        <FormControl size="small">
                          <Select
                              value={allFunctionParameters.ordinalize[0]}
                              onChange={(e) => handleFunctionEdit('ordinalize', 0, e.target.value)}
                            >
                              {cultures.filter(c => c.hasHumanizerSupport).map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                            
                          </Select>
                        </FormControl>
                      </Stack>
                </Stack>
        case "numberToWords":
          return <Stack spacing={1}>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography>
                        Culture 
                      </Typography>
                        <FormControl size="small">
                          <Select
                              value={allFunctionParameters.numberToWords[0]}
                              onChange={(e) => handleFunctionEdit('numberToWords', 0, e.target.value)}
                            >
                              {cultures.filter(c => c.hasHumanizerSupport).map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                            
                          </Select>
                        </FormControl>
                      </Stack>
                </Stack>
        case "numberToOrdinalWords":
          return <Stack spacing={1}>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography>
                        Culture 
                      </Typography>
                        <FormControl size="small">
                          <Select
                              value={allFunctionParameters.numberToOrdinalWords[0]}
                              onChange={(e) => handleFunctionEdit('numberToOrdinalWords', 0, e.target.value)}
                            >
                              {cultures.filter(c => c.hasHumanizerSupport).map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                            
                          </Select>
                        </FormControl>
                      </Stack>
                </Stack>
        case "romanNumeralsTo":
        case "romanNumeralsFrom":
        case "celsiusToFahrenheit":
            return <Stack spacing={1}>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                      <Typography>
                        No parameters required 
                      </Typography>
                      </Stack>
                </Stack>
        default:
        break;
    }
    return <>
    Example for {functionName}
    </>
  }
const handleSubmit = () => {
  if (props.onChange !== undefined) props.onChange({functionName: functionNameBrowsed, 
                                                    id: props.functionParameters.id,
                                                    parameters: allFunctionParameters[functionNameBrowsed]});  
   handleCloseFunctionSelector();
}

  return <>
    <Chip sx={{width: '85%'}} label={labelTitle} variant="outlined"
        onClick={handleOpenFunctionSelector} 
        />
  
  <Popover      open={openBuilder}
                anchorEl={anchorEl}
                onClose={handleCloseFunctionSelector}
                anchorOrigin={{
                  vertical: 'top',
                }}
      >
    <Paper sx={{ padding: '10px', width:900}} elevation={4}>
      <Stack>
        <Grid2 container sx={{height:600}}>
          <Grid2 xs={3}>
            <List dense sx={{overflow: 'auto', maxHeight: 650,}}>
              <ListSubheader>String</ListSubheader>
              <ListItem>
                <ListItemButton selected={selectedFunctionIndex === 0}
                                 onMouseEnter={() => {setFunctionNameBrowsed('replace'); setSelectedFunctionIndex(0);}}>
                  <ListItemText primary="Replace" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton selected={selectedFunctionIndex === 1}
                               onMouseEnter={() => {setFunctionNameBrowsed('truncate'); setSelectedFunctionIndex(1);}}>
                  <ListItemText primary="Truncate" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 2}
                               onMouseEnter={() => {setFunctionNameBrowsed('replaceEmpty'); setSelectedFunctionIndex(2);}}>
                  <ListItemText primary="Replace when empty" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 3}
                               onMouseEnter={() => {setFunctionNameBrowsed('replaceLonger'); setSelectedFunctionIndex(3);}}>
                  <ListItemText primary="Replace when longer" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 4}
                               onMouseEnter={() => {setFunctionNameBrowsed('replaceShorter'); setSelectedFunctionIndex(4);}}>
                  <ListItemText primary="Replace when shorter" />
                </ListItemButton>
              </ListItem>
              <ListSubheader>Number</ListSubheader>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 5}
                               onMouseEnter={() => {setFunctionNameBrowsed('formatNumber'); setSelectedFunctionIndex(5);}}>
                  <ListItemText primary="Format number" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 7}
                               onMouseEnter={() => {setFunctionNameBrowsed('ordinalize'); setSelectedFunctionIndex(7);}}>
                  <ListItemText primary="Ordinalize number" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 8}
                               onMouseEnter={() => {setFunctionNameBrowsed('numberToWords'); setSelectedFunctionIndex(8);}}>
                  <ListItemText primary="Number to words" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 9}
                               onMouseEnter={() => {setFunctionNameBrowsed('numberToOrdinalWords'); setSelectedFunctionIndex(9);}}>
                  <ListItemText primary="Number to ordinal words" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 10}
                               onMouseEnter={() => {setFunctionNameBrowsed('romanNumeralsTo'); setSelectedFunctionIndex(10);}}>
                  <ListItemText primary="Number to roman numeral" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 11}
                               onMouseEnter={() => {setFunctionNameBrowsed('romanNumeralsFrom'); setSelectedFunctionIndex(11);}}>
                  <ListItemText primary="Number from roman numerals" />
                </ListItemButton>
              </ListItem>
              <ListSubheader>Date time</ListSubheader>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 6}
                               onMouseEnter={() => {setFunctionNameBrowsed('formatDatetime'); setSelectedFunctionIndex(6);}}>
                  <ListItemText primary="Format date time" />
                </ListItemButton>
              </ListItem>
              <ListSubheader>Conversions</ListSubheader>
              <ListItem>
              <ListItemButton selected={selectedFunctionIndex === 12}
                               onMouseEnter={() => {setFunctionNameBrowsed('celsiusToFahrenheit'); setSelectedFunctionIndex(12);}}>
                  <ListItemText primary="Celsius to Fahrenheit" />
                </ListItemButton>
              </ListItem>
            </List>
          </Grid2>
          <Grid2 xs={9}>
            <Stack spacing={6}>
              {renderExample(functionNameBrowsed)}
              <Stack spacing={1}>
                <Typography variant='h4'>Your parameters:</Typography>
                {renderFunctionEditor(functionNameBrowsed)}
              </Stack>
            </Stack>
          </Grid2>
        </Grid2>
        <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
            <Button variant='outlined' color='secondary'  sx={{mr:1}} onClick={handleCloseFunctionSelector} >Cancel</Button>
            <Button variant='outlined' color='secondary'  sx={{mr:1}} onClick={handleSubmit} >Confirm</Button>
        </Box>
      </Stack>
    </Paper>
</Popover>
</>



}

const TextFunctionsManager = (props) => {

  useEffect(() => {
    if (props.currentTransforms !== undefined) setTextTransforms(props.currentTransforms)
  }, [props.currentTransforms])


  const [textTransforms, setTextTransforms] = useState({prefix: '', suffix:'', functions:[]});
  const [anchorEl, setAnchorEl] = useState(null);

  const openBuilder = Boolean(anchorEl);
  const handleOpenBuilder = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseBuilder = () => {
    if (props.onTextFunctionsChange !== undefined) props.onTextFunctionsChange(textTransforms);

    setAnchorEl(null);
    
  };

  const handleTextTransformPropChange = (propName, propValue) => {
    const newTransforms = {...textTransforms, [propName]: propValue}

    setTextTransforms(newTransforms);

    if (props.onTextFunctionsChange !== undefined) props.onTextFunctionsChange(newTransforms);
  }

  const getLabelTitle = () => {
    const titleParts = [];
    if (textTransforms.prefix !== '') titleParts.push(`prefix = ${textTransforms.prefix}`)
    if (textTransforms.suffix !== '') titleParts.push(`suffix = ${textTransforms.suffix}`)
    if (textTransforms.functions.length === 1) titleParts.push(`added 1 function`)
    if (textTransforms.functions.length > 1) titleParts.push(`added ${textTransforms.functions.length} functions`)

    if (titleParts.length === 0) return `prefix, suffix, magic`
    return titleParts.join(', ');
  }

  const addTransformFunction = () => {
    const newTransformsFunctions = [...textTransforms.functions, {
      id: RandomId(10),
      functionName: '',
      // when: 'always',
      parameters: [] // array of parameter values (we don't use names)
    }] 
    const newTransforms = {...textTransforms, functions: newTransformsFunctions}

    setTextTransforms(newTransforms)
  }
  const removeTransformFunction = (id) => {
    const newTransformsFunctions = [...textTransforms.functions]
    const removeIndex = newTransformsFunctions.findIndex(f => f.id === id);
    if (removeIndex !== -1) {
      newTransformsFunctions.splice(removeIndex, 1);
      const newTransforms = {...textTransforms, functions: newTransformsFunctions}
  
      setTextTransforms(newTransforms)
    }
  }
  const getTransformFunctionByid = (id) => {
    const matchedFunction = textTransforms.functions.find(f => f.id === id);

    return matchedFunction;
  }

  const handleTextFunctionChange = (functionSettings) => {
    const newFunctionArr = textTransforms.functions.map(f => f.id === functionSettings.id ? functionSettings : f);
    const newTextTransforms = {...textTransforms, functions: newFunctionArr};
    setTextTransforms(newTextTransforms);

    if (props.onTextFunctionsChange !== undefined) props.onTextFunctionsChange(newTextTransforms);
  }


  return <>
  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
    <Typography noWrap>Text functions:</Typography>
    <Chip sx={{width: '60%'}} label={getLabelTitle()} variant="outlined" 
        onClick={handleOpenBuilder} 
        />
  
  </Stack>
  <Popover      open={openBuilder}
                anchorEl={anchorEl}
                onClose={handleCloseBuilder}
                anchorOrigin={{
                  vertical: 'top',
                }}
      >
    <Paper sx={{ padding: '10px', width: 400}} elevation={4}>
      <Stack spacing={1}>
        <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
          <Typography>Prefix</Typography>
          <TextField sx={{width: '120px'}}
                value={textTransforms.prefix}
                onChange={(e) => handleTextTransformPropChange('prefix', e.target.value)}
                size="small"
              />
          <Typography sx={{ml:'20px !important'}}>Suffix</Typography>
          <TextField sx={{width: '120px'}}
                value={textTransforms.suffix}
                onChange={(e) => handleTextTransformPropChange('suffix', e.target.value)}
                size="small"
              />
        </Stack>
        <Button variant='outlined' sx={{width: 150}} onClick={addTransformFunction}>Add a function</Button>
        {textTransforms.functions.map((t, index) =>  <>                      
                      <Stack key={t.id} direction='row' sx={{display: 'flex', alignItems: 'center'}} spacing={1} >
                        <TextFunctionBuilder onChange={handleTextFunctionChange}
                                            functionParameters={t} />
                        <IconButton onClick={() => removeTransformFunction(t.id)} ><Iconify icon={lionIcons.Icon_Actions_Minus} /></IconButton>
                      </Stack>
                      {index < textTransforms.functions.length -1 &&
                      <Box sx={{display:'flex', justifyContent:'center'}}>
                        <Iconify icon='material-symbols:arrow-downward-rounded' />
                      </Box>
                      }
                      </>
                      )

}
        {/*
        textTransforms.functions.map((t, index) => <>
                      <Stack direction='row' sx={{display: 'flex', alignItems: 'center'}} spacing={1} key={t.id}>
                        <Typography>When</Typography>
                        <FormControl size="small">
                          <Select
                            value={t.when}
                            onChange={(e) => handleTransformFunctionChange(t.id, 'when', e.target.value)}
                            >
                              <MenuItem value='always'>Always</MenuItem>
                              <MenuItem value='hasValue'>Text has a value</MenuItem>                                
                              <MenuItem value='isEmpty'>Text is empty</MenuItem>
                          </Select>
                        </FormControl>
                        <Typography>Action</Typography>
                        <FunctionSelector />
                      </Stack>
                      {index < textTransforms.functions.length -1 &&
                      <Box sx={{display:'flex', justifyContent:'center'}}>
                        <Iconify icon='material-symbols:arrow-downward-rounded' />
                      </Box>
                      }
                      </>)
                    */}
      </Stack>
    </Paper>
</Popover>
</>

}

const ConditionalPropertiesViewer = (props) => {
// takes 2 object properties and show the differencies

const [differentPropsNames, setDifferentPropsNames] = useState([])
const [objectClassName, setObjectClassName] = useState('')

useEffect(() => {
  if (props.modifiedProps === undefined || props.originalProps === undefined) {
    setDifferentPropsNames([]);
    return;
  }

  let originalPropNames = Object.keys(props.originalProps.attrs);
  // remove the prop conditionalProperties if present - this prop can be different
  originalPropNames = removeStringsFromArray(originalPropNames, ['conditionalProperties', 'id', 'draggable'])

  if (!originalPropNames.includes('textTransforms')) {
    originalPropNames.push('textTransforms');
    props.originalProps.attrs.textTransforms = { prefix: "", suffix: "", functions: [] }
  }
  const modifiedPropNames = Object.keys(props.modifiedProps.attrs);
  if (!modifiedPropNames.includes('textTransforms')) {
    props.modifiedProps.attrs.textTransforms = { prefix: "", suffix: "", functions: [] }
  }

  if (!originalPropNames.includes('fontStyle')) {
    originalPropNames.push('fontStyle');
    props.originalProps.attrs.fontStyle = 'normal'
  }
  if (!modifiedPropNames.includes('fontStyle')) {
    props.modifiedProps.attrs.fontStyle = 'normal'
  }

  if (!originalPropNames.includes('textDecoration')) {
    originalPropNames.push('textDecoration');
    props.originalProps.attrs.textDecoration = ''
  }
  if (!modifiedPropNames.includes('textDecoration')) {
    props.modifiedProps.attrs.textDecoration = ''
  }
  if (modifiedPropNames.includes('textDecoration') && props.modifiedProps.attrs.textDecoration === undefined) {
    props.modifiedProps.attrs.textDecoration = ''
  }
  

  if (!originalPropNames.includes('align')) {
    originalPropNames.push('align');
    props.originalProps.attrs.align = 'left'
  }
  if (!modifiedPropNames.includes('align')) {
    props.modifiedProps.attrs.align = 'left'
  }

  const different = [];
  
  originalPropNames.forEach(pName => {
    if (pName === 'textTransforms') {
      if (props.originalProps.attrs.textTransforms.prefix !== props.modifiedProps.attrs.textTransforms.prefix) different.push(pName);
      if (props.originalProps.attrs.textTransforms.suffix !== props.modifiedProps.attrs.textTransforms.suffix) different.push(pName);
      if (props.originalProps.attrs.textTransforms.functions.length !== props.modifiedProps.attrs.textTransforms.functions.length) different.push(pName);
    }
    else if (pName === 'fillLinearGradientColorStops' || pName === 'fillRadialGradientColorStops') {
      if (props.originalProps.attrs[pName].length !== props.modifiedProps.attrs[pName].length) different.push(pName);
      for (let i = 0; i < props.originalProps.attrs[pName].length; i += 1) {
        if (props.originalProps.attrs[pName][i] !== props.modifiedProps.attrs[pName][i]) different.push(pName);
      }
    }
    else if (pName === 'animation') {
      if (props.originalProps.attrs.animation.totalSeconds != props.modifiedProps.attrs.animation.totalSeconds) different.push(pName);
    }
    else if (props.originalProps.attrs[pName] !== props.modifiedProps.attrs[pName]) different.push(pName);
  })

  // console.log(different)
  setDifferentPropsNames(different.sort());
  setObjectClassName(props.originalProps.className)

}, [props.originalProps, props.modifiedProps])

const removeStringsFromArray = (srcArray, strToRemove) => {
  let result = srcArray;
  strToRemove.forEach(str => {
    result = result.filter(item => item !== str)
  })
  return result;
}

const getTextTransformsLabel = (textTransforms) => {
  const titleParts = [];
  if (textTransforms.prefix !== '') titleParts.push(`prefix = ${textTransforms.prefix}`)
  if (textTransforms.suffix !== '') titleParts.push(`suffix = ${textTransforms.suffix}`)
  if (textTransforms.functions.length === 1) titleParts.push(`1 function`)
  if (textTransforms.functions.length > 1) titleParts.push(`${textTransforms.functions.length} functions`)

  if (titleParts.length === 0) return `none`
  return titleParts.join(', ');
}

const getPropPrettyName = (pName) => {
  switch (pName) {
    case "y":
      if (objectClassName === 'Circle') return "Center Y";
      return "Top";
    case "x":
      if (objectClassName === 'Circle') return "Center X";
      return "Left";
    case "fill":
      return "Fill color";
    case "stroke":
      return "Stroke color";
    case "strokeWidth":
      return "Stroke width";
        default:
    return pName[0].toUpperCase() + pName.substring(1);
  }
}
const getValuePretty = (pName, origOrModified) => {
  const attrs = origOrModified === 'modified' ? props.modifiedProps.attrs : props.originalProps.attrs;
  if (pName === 'textTransforms') {
    return getTextTransformsLabel(attrs[pName])
  }
  if (pName === 'textDecoration' && attrs[pName] === '') {
    return 'none';
  }

  if (pName === 'dataBindType') {
    switch (attrs[pName]) {
      case "none":
        return "Fixed";
      case "url":
        return "Url Parameter";
      case "imgLibrary":
        return "Image Library";
      default:
        return attrs[pName][0].toUpperCase() + attrs[pName].substring(1);
      }
  }
  return attrs[pName];
}


return <>
  {differentPropsNames.length === 0 && <>
    No changes  
    </>}

<ul>
{differentPropsNames.map(pName => <li key={pName} >Change <span style={{fontWeight: 'bold'}}>{getPropPrettyName(pName)}</span> (from: {getValuePretty(pName)}) to: <span style={{fontWeight: 'bold'}}>{getValuePretty(pName, 'modified')}</span></li>)}
</ul>
</>

} 

const ConditionalPropertiesBuilder = (props) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const [allRules, setAllRules] = useState([]); // each rule is like {id:'', conditions:[], model:{}}
  const [tempRule, setTempRule] = useState(null); // used during editing. If editing confimed then it goes to allRules
  const [editingRule, setEditingRule] = useState(false);
  const [currentRuleId, setCurrentRuleId] = useState('');
  const [blockOriginalProps, setBlockOriginalProps] = useState({});
  const [currentRuleProps, setCurrentRuleProps] = useState(undefined);

  useEffect(() => {
    // props.objects is an array because object inspector support multi-object-selection but here it will always be a single object
    // if (props.objects !== undefined) setOriginalProps(props.objects[0]);
// console.log(props.objects[0])
    setBlockOriginalProps(props.objects[0]);
    if (props.objects[0].attrs !== undefined && props.objects[0].attrs.conditionalProperties !== undefined) setAllRules(props.objects[0].attrs.conditionalProperties);
    else setAllRules([])
  }, [props.objects])


  const handleOpenBuilder = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseBuilder = () => {
    setAnchorEl(null);
  };
  const openBuilderSettings = Boolean(anchorEl);

const renderTitleHeader = () => 
      <Stack spacing={1}>
      <Typography variant="h4" component="div">
        Dynamic Properties builder
      </Typography>
      <Typography color="text.secondary">
        Define conditions that can change this block's properties
      </Typography> 
      <Typography color="text.secondary">
        <span style={{fontStyle: 'italic'}}>Examples: change the text color based on the properties in your feed (e.g. price, item on sale etc). You can also hide the block completely</span>
      </Typography> 
    </Stack>
const addRule = () => {
  const initialProps = JSON.parse(JSON.stringify(blockOriginalProps)) // we need a deep-copy

  const newRule = {id: RandomId(20), model: initialProps}
  setTempRule(newRule);

  setEditingRule(true);
  setCurrentRuleId(newRule.id);
}
const editRule = (ruleId) => {

  const ruleToEdit = allRules.find(r => r.id === ruleId);

  setTempRule(ruleToEdit);

  setEditingRule(true);
  setCurrentRuleId(ruleId);
}

const mergeTempRuleInAllRules = () => {

  const tempRuleIndex = allRules.findIndex(r => r.id === tempRule.id);
  let newAllRules = null;
  if (tempRuleIndex === -1) {
    // new rule, we add it to allRules
    newAllRules = [...allRules, tempRule];
  }
  else {
    // existing rule, we replace it in allRules
    newAllRules = allRules.map(r => r.id === tempRule.id ? tempRule : r);
  }

  setAllRules(newAllRules);
  cancelEditingChanges();

  if (props.onConditionalPropertiesChange !== undefined) props.onConditionalPropertiesChange(newAllRules)
}
const cancelEditingChanges = () => {
  setEditingRule(false);
  setCurrentRuleId('');
  setTempRule(null);
}

const getCurrentRule = () => 
  allRules.find(r => r.id === currentRuleId);


const handleConditionsInRuleChange = (condition) => {

  const newRule = {...tempRule, conditions: condition}
  console.log(condition)
  console.log(tempRule)
  if (condition.length > 0) setTempRule(newRule);


/* OLD CODE
  const currentRule = getCurrentRule();
  const newRule = {...currentRule, conditions: condition}
  const newAllRules = allRules.map(r => r.id === currentRule.id ? newRule : r)
  setAllRules(newAllRules);
*/
}

const updateSingleProp = (propName, propValue) => {
  const tempRuleProperties = {...tempRule.model};
  
  tempRuleProperties.attrs[propName] = propValue;


  if (tempRuleProperties.className === 'Image') {
    if (propName === 'width') tempRuleProperties.attrs.imageWidth = propValue;
    if (propName === 'height') tempRuleProperties.attrs.imageHeight = propValue;
  }

  setCurrentRuleProps(tempRuleProperties);
  
  const newRule = {...tempRule, model: tempRuleProperties}
  setTempRule(newRule);

  /* OLD CODE
  const currentRule = getCurrentRule();
  const currentRuleProperties = {...currentRule.model};
  
  currentRuleProperties.attrs[propName] = propValue;


  if (currentRuleProperties.className === 'Image') {
    if (propName === 'width') currentRuleProperties.attrs.imageWidth = propValue;
    if (propName === 'height') currentRuleProperties.attrs.imageHeight = propValue;
  }

  setCurrentRuleProps(currentRuleProperties);
  
  const newRule = {...currentRule, model: currentRuleProperties}
  const newAllRules = allRules.map(r => r.id === currentRule.id ? newRule : r)
  setAllRules(newAllRules);
*/
}

const renderConditionalPropSummary = (conditionalProp, index) => {
  if (conditionalProp === undefined) return <></>
  return (
  <Paper key={conditionalProp.id} elevation={4} sx={{p:1}}>
    <Grid2 container spacing={1}>
      <Grid2 xs={1} display="flex" justifyContent="center" alignItems="center">
        <Typography variant='h4'>Rule {index +1}</Typography>
      </Grid2>
      <Grid2 xs={5} display="flex" justifyContent="center" alignItems="center">
        <Stack spacing={1} sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          <Typography variant='h5'>IF</Typography>
          <FilterTextViewer items={conditionalProp.conditions} />
        </Stack>
      </Grid2>
      <Grid2 xs={5} display="flex" justifyContent="center" alignItems="center">
        <Stack spacing={1} sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          <Typography variant='h5'>THEN</Typography>
          <ConditionalPropertiesViewer originalProps={props.objects[0]}
                                            modifiedProps={conditionalProp.model}
                                  /> 
        </Stack>
      </Grid2>
      <Grid2 xs={1} display="flex" justifyContent="center" alignItems="center">
        <IconButton onClick={() => editRule(conditionalProp.id)} >
          <Iconify icon={lionIcons.Icon_Actions_Edit} />
        </IconButton>
      </Grid2>
    </Grid2>
  </Paper>
  )
}

const getLabelTitle = () => {
  if (allRules === undefined) return `No rules defined`;
  if (allRules.length === 0) return `No rules defined`;
  if (allRules.length === 1) return `1 rule defined`;
  return `${allRules.length} rules defined`
}


  return <>
      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
        <Typography>Dynamic properties:</Typography>
        <Chip sx={{minWidth: '50%'}} label={getLabelTitle()} variant="outlined" onClick={handleOpenBuilder} />
      
      </Stack>
      <Popover      open={openBuilderSettings}
                    anchorEl={anchorEl}
                    onClose={handleCloseBuilder}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <Paper sx={{ padding: '10px', width:1100, height: 750}} elevation={4}>
          <Stack spacing={3} sx={{display: 'flex'}} >
            {renderTitleHeader()}
            {!editingRule && <Button sx={{width: 200}} variant='outlined'
                              onClick={addRule} >Create new rule</Button>}

            {editingRule &&  <Stack spacing={1}>
                              <Grid2 container>
                                <Grid2 xs={6} display="flex" justifyContent="center" alignItems="center"><Box sx={{height:50}}>Conditions</Box></Grid2>
                                <Grid2 xs={6} display="flex" justifyContent="center" alignItems="center">
                                  <ConditionalPropertiesViewer originalProps={props.objects[0]}
                                            modifiedProps={tempRule.model}
                                  /> 
                                </Grid2>
                                <Grid2 xs={8} >
                                <ConditionsManager availableConditions={props.availableConditions}
                                      onConditionChange={handleConditionsInRuleChange}
                                      initialConditions={tempRule.conditions}
                                      // clearFilter={undefined}
                                  />
                                </Grid2>
                                <Grid2 xs={4} >
                                <ObjectInspector 
                                        // objects={props.objects}
                                        objects={[tempRule.model]}
                                        noDynamicProps
                                    returnUpdateSingle={updateSingleProp}
                                    // sampleData={sampleData}
                                    // returnUpdateCanvas={updateCanvas}
                                    // returnUpdateTextPath={updateTextPath}
                                    // returnUpdateImageBindings={updateImageBindings}
                                />

                                </Grid2>
                              </Grid2>
                              <Box display="flex" justifyContent="flex-end" p={0.5} >
                                <Button sx={{mr:1}} variant='outlined' color='secondary' onClick={() => cancelEditingChanges()} >Cancel</Button>
                                <Button variant='outlined' color='secondary' onClick={mergeTempRuleInAllRules} >Confirm</Button>
                              </Box>
                            </Stack>            
            }
            {!editingRule && <Stack spacing={2}>
                    {allRules.map((rule, index) => renderConditionalPropSummary(rule, index))}
                  </Stack>
            }

          </Stack>
            {allRules.length === 0 && <Box sx={{display: 'flex', alignItems: 'center', justifyContent:'center', height:400}}>
                    <Typography variant='h4' color="text.secondary">
                      No rules defined
                    </Typography> 
            </Box>
            }
        </Paper>
    </Popover>
  </>

}

const BlockVisibilityManager = (props) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const [visibilityConditions, setVisibilityConditions] = useState([]);
  const [originalVisibilityConditions, setOriginalVisibilityConditions] = useState([]);

  useEffect(() => {
    //console.log(props.visibilityConditions)
    if (props.visibilityConditions) {
      setVisibilityConditions(props.visibilityConditions)
      setOriginalVisibilityConditions(props.visibilityConditions)
    } else {
      setVisibilityConditions([])
      setOriginalVisibilityConditions([])
    }
  }, [props.visibilityConditions])


  const handleOpenBuilder = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseBuilder = () => {
    setVisibilityConditions(originalVisibilityConditions)
    setAnchorEl(null);
  };
  const openBuilderSettings = Boolean(anchorEl);

const renderTitleHeader = () => 
      <Stack spacing={1}>
      <Typography variant="h4" component="div">
      Magic Layers
      </Typography>
      <Typography color="text.secondary">
      Define conditions for when you'd like to hide or show this block.<span className='italic'> To use Magic Layers the relevant information must be contained in your Content Connection.</span>
      </Typography> 
      <Typography color="text.secondary">
        An example use case is to <span className='italic'>show this block when the item is on sale or it is a new arrival.</span>
      </Typography> 
    </Stack>

const cancelEditingChanges = () => {
  handleCloseBuilder()
}


const handleConditionsInRuleChange = (condition) => {
  if (condition.length === 0) return;
  console.log(condition)
  setVisibilityConditions(condition);

}

const closeAndSendChanges = () => {
  if (props.onConditionalPropertiesChange) props.onConditionalPropertiesChange(visibilityConditions)
  
    setAnchorEl(null);
}



const getLabelTitle = () => {
  if (visibilityConditions === undefined) return `Always`;
  if (visibilityConditions.length === 0) return `Always`;
  if (visibilityConditions.length >= 1) return `On conditions matched`;
}


  return <>
      <div className='flex flex-row items-center gap-x-2'>
        <div>Magic Layers:</div>
        <Chip label={getLabelTitle()} variant="outlined" onClick={handleOpenBuilder} />
      
      </div>
      <Popover      open={openBuilderSettings}
                    anchorEl={anchorEl}
                    onClose={handleCloseBuilder}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <Paper sx={{ padding: '10px', width:1100, height: 750}} elevation={4}>
          <Stack spacing={3} sx={{display: 'flex'}} className='text-ccColorDarkTeal' >
            {renderTitleHeader()}
            <div className='flex flex-row items-center gap-x-4'>
              <div className='border rounded p-2 w-[450px]'>
                  <div className='font-semibold'>Status</div>
                  {visibilityConditions.length === 0 && <div>
                    <div className=''>This block is ALWAYS visible</div>
                  </div>}
                  {visibilityConditions.length >= 1 && <div>
                    <div className=''>This block is visible when the conditions below are met</div>
                  </div>}
              </div>
              {visibilityConditions.length >= 1 && <div>
                  <CcActionButton
                  onClick={() => setVisibilityConditions([])}
                  >Reset conditions</CcActionButton>
                </div>

                }
            </div>

            <Stack spacing={1}>
            <ConditionsManager availableConditions={props.availableConditions}
                        onConditionChange={handleConditionsInRuleChange}
                        initialConditions={visibilityConditions}
                        // clearFilter={undefined}
                    />
                <Box display="flex" justifyContent="flex-end" p={0.5} >
                  <Button sx={{mr:1, color: ccColorSecondaryPurple, borderColor: ccColorSecondaryPurple, ":hover":{borderColor: ccColorSecondaryPink, backgroundColor: ccColorSecondaryPink}}} variant='outlined' onClick={handleCloseBuilder} >Cancel</Button>
                  <Button sx={{color: ccColorSecondaryPurple, borderColor: ccColorSecondaryPurple, ":hover":{borderColor: ccColorSecondaryPink, backgroundColor: ccColorSecondaryPink}}} variant='outlined' onClick={closeAndSendChanges} >Confirm</Button>
                </Box>
            </Stack>            
            

          </Stack>
        </Paper>
    </Popover>
  </>

}

const AnswersManager = (props) => {
const [templateNames, setTemplateNames] = useState(['Template 1']);

  useEffect(() => {
    // allTemplates
    // currentTemplateNum
    // numTemplates
    if (props.numTemplates !== undefined) {
      const names = [];
      for (let i = 0; i < props.numTemplates; i +=1) {
        names.push(`Template ${i + 1}`);
      }
      setTemplateNames(names);
    }
  }, [props.currentTemplateNum, props.numTemplates])

  return <>
          <Stack direction='row' spacing={0} sx={{display: 'flex', alignItems: 'center'}}>
            <Select size='small'
              value={props.currentTemplateNum}
              onChange={(e) => {if (props.onTemplateChange !== undefined) props.onTemplateChange(e.target.value)}}
            >
              {templateNames.map((t, index) => <MenuItem key={t} value={index}>{t}</MenuItem>)}
              
            </Select>
            <IconButton onClick={() => {if (props.onTemplateAdded !== undefined) props.onTemplateAdded()}}>
              <Iconify icon={lionIcons.Icon_Actions_Add} /></IconButton>
            <IconButton onClick={() => {if (props.onTemplateRemoved !== undefined) props.onTemplateRemoved(props.currentTemplateNum)}}>
              <Iconify icon={lionIcons.Icon_Actions_Minus} />
            </IconButton>
          </Stack>
  </>
}

const AnimationTitle = (props) => {

  return     <Card sx={{...props.sx, width: 250 }}>
    <CardContent>
      <Typography gutterBottom variant="h5" component="div" color="#222b5c">
        {props.title}
      </Typography>
      <Typography variant="body2" color="#222b5c">
        {props.description}
      </Typography>
    </CardContent>
  </Card>
  }

const AnimationEffectGallery = (props) => {
  //used to pick a new effect when within the AnimationManager
  //props: every time you open this gallery you want to choose a new effect 
  // so in principle there is no need handle a "selected" case here
  //however we want tto know the selected effects so that we can show only the effects that are compatible with the ones tthat have been already selected
  //props:
  //      effect: all the effects
  //      selected: array of alredy selected effects

  const [highlightedEffectId, setHighlightedEffectId] = useState(0)
  const [effects, setEffects] = useState([])

  function mergeUniqueArraysFromArray(arrays) {
    // Flatten the array of arrays and remove duplicates
    return [...new Set(arrays.flat())];
  }

  useEffect(() => {
    //we find all the effect ids to exclude
    //we read the "notTogetherIds" prop of every selected effect
    //and we create an array with those notTogetherIds
    
    if (props.selected && props.effects) {
      const allIdsToExcludeDuplicates = []
      props.selected.forEach(s => {
        const matched = props.effects.find(e => e.id === s)
        allIdsToExcludeDuplicates.push(matched.notTogetherIds)
      })
      allIdsToExcludeDuplicates.push(props.selected)
      const allIdsToExclude = mergeUniqueArraysFromArray(allIdsToExcludeDuplicates)
      let newEffects = [...props.effects]
      allIdsToExclude.forEach(id => {
        newEffects = newEffects.filter(e => e.id !== id)
      })
      //console.log(newEffects)
      setEffects(newEffects)
    }
  }, [props.selected, props.effects])

  const handleClick = (functionName) => {
    if (props.onSelect) props.onSelect(functionName)
  }
  
  const renderExample = (functionName) => {
    switch (functionName) {
      case "moveToX":
      return <Stack spacing={1}>
                <Typography variant="h4" component="div">
                  Move horizontally to 
                </Typography>
                <Typography color="text.secondary">
                  translates a block from the current horizontal position to <span style={{fontStyle: 'italic'}}>a new position</span>
                </Typography>                
                <Typography color="text.secondary">
                  The position is defined by the  <span style={{fontStyle: 'italic'}}>Left</span> property
                </Typography>
          </Stack>
      case "moveToY":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                    Move vertically to 
                  </Typography>
                  <Typography color="text.secondary">
                    translates a block from the current vertical position to <span style={{fontStyle: 'italic'}}>a new position</span>
                  </Typography>                
                  <Typography color="text.secondary">
                    The position is defined by the  <span style={{fontStyle: 'italic'}}>Top</span> property
                  </Typography>
          </Stack>
      case "lineHeight":
        return <Stack spacing={1}>
        <Typography variant="h4" component="div">
          Line Height
        </Typography>
        <Typography color="text.secondary">
          changes the  <span style={{fontStyle: 'italic'}}>line height</span> of a text block
        </Typography>
        </Stack>
      case "strokeWidth":
        return <Stack spacing={1}>
        <Typography variant="h4" component="div">
        Stroke Width
        </Typography>
        <Typography color="text.secondary">
          changes the  <span style={{fontStyle: 'italic'}}>stroke width</span> of the text
        </Typography>
        </Stack>
      case "fill":
        return <Stack spacing={1}>
        <Typography variant="h4" component="div">
          Color
        </Typography>
        <Typography color="text.secondary">
          changes the  <span style={{fontStyle: 'italic'}}>color</span> of the text
        </Typography>
        </Stack>
      case "fillLinearGradientColorStops":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                  Linear Gradient Colors
                  </Typography>
                  <Typography color="text.secondary">
                    changes the <span style={{fontStyle: 'italic'}}>colors</span> of a linear gradient
                  </Typography>
        </Stack>
      case "fillRadialGradientEndRadius":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                    Gradient Radius
                  </Typography>
                  <Typography color="text.secondary">
                    changes the <span style={{fontStyle: 'italic'}}>radius</span> of a gradial gradient
                  </Typography>
        </Stack>
      case "textTyping":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                    Text typing
                  </Typography>
                  <Typography color="text.secondary">
                    add a  <span style={{fontStyle: 'italic'}}>typing</span> effect where letters appear one at a time
                  </Typography>
        </Stack>
      default:
      break;
    }
    return <>
    Example for {functionName}
    </>
  }


  return <> {effects.length === 0 ?
                <div className='text-ccColorTeal font-semibold text-xl p-5 text-center'>
                      There are no more effects to add
                  </div>
            :
            <div className='grid grid-cols-3 gap-x-2 gap-y-5 h-96 overflow-auto'>
            {effects.map(eff => <div className='flex flex-col gap-0'>
                        <div className='flex flex-row justify-center font-poppins font-semibold'>{eff.name}</div>

                        <div className={`relative w-full h-[280px] flex flex-row items-center justify-center ${highlightedEffectId === eff.id ? "bg-ccColorLightTeal" : "bg-gray-200"} p-2 rounded-md cursor-pointer`}
                            onMouseEnter={() => setHighlightedEffectId(eff.id)}
                            onMouseLeave={() => setHighlightedEffectId(0)}
                            onClick={() => handleClick(eff.functionName)}
                    >
                        <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={eff.imageURL} />
                        </div>
                    </div>
            )}

  </div>
  }

</>
} 

const AnimationManagerOLD = (props) => {
  // TO DO IMPORTANT:
  // so far the AnimationManager only handles properties that are common among all blocks
  // we should enhance the AnimationManager so that also block-specific properties are handled
  // e.g. rating block: the color "fill" prop has not effect, there should be a "ratedColor" and "unratedColor" props
  //  also for the rating block it is possible to change the "text" prop with a manipulation function to treat that text as a number

  const [animations, setAnimations] = useState({totalSeconds: 0}) // main object - contains all possible animations

  // const [selectedFunctionIndex, setSelectedFunctionIndex] = useState(-1)
  const [functionNameBrowsed, setFunctionNameBrowsed] = useState('');

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElEffectManager, setAnchorElEffectManager] = useState(null);
  const openAnimationManager = Boolean(anchorEl);

  const handleOpenAnimationManager = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAnimationManager = () => {
    setAnchorEl(null);
  };

  const openEffectManager = Boolean(anchorElEffectManager);
  const handleOpenEffectManager = (event, effectName) => {
    setAnchorElEffectManager(event.currentTarget);
    if (effectName !== undefined) setFunctionNameBrowsed(effectName);
  };
  const handleCloseEffectManager = () => {
    // if (props.onTextFunctionsChange !== undefined) props.onTextFunctionsChange(textTransforms);

    setAnchorElEffectManager(null);
    
  };

  useEffect(() => {
    if (props.animations !== undefined) setAnimations(props.animations)
    console.log(props.animations)
  }, [props.animations])

  const updateAnimationProp = (propName, propValue) => {
    const newAnimations = {...animations, [propName]: propValue}

    setAnimations(newAnimations);
    if (props.onAnimationChange !== undefined) props.onAnimationChange(newAnimations) 
  }

  const getLabelTitle = () => {
    const allKeys = Object.keys(animations);
    //there is always at leat one key: totalSeconds
    if (allKeys.length <= 1) return `No animation defined`
    if (allKeys.length === 2) {
      const animationName = allKeys.find(k => k !== "totalSeconds")
      return animationName
    }
    //if we are here there are multiple effects
    return `Multiple effects defined`;
  }
  const addEffectStep = (effectName, value) => {
    // check if effectName is undefined 
    let newSteps = null;
    if (animations[effectName] === undefined) {
      newSteps = [];
    }
    else  newSteps = [...animations[effectName]]

    newSteps.push(value);

    updateAnimationProp(effectName, newSteps);
  }
  const removeEffectStep = (effectName, index) => {
    const newSteps = [...animations[effectName]]
    newSteps.splice(index, 1)
    if (newSteps.length === 0) {
      // the effect has been completely removed. We want to remove its key from the animation dictionary
      const newAnimations = {...animations}
      delete newAnimations[effectName];
      setAnimations(newAnimations);
      if (props.onAnimationChange !== undefined) props.onAnimationChange(newAnimations) 
    }
    else updateAnimationProp(effectName, newSteps);

  }
  const editEffectStep = (effectName, index, value) => {
    const newSteps = [...animations[effectName]]
    newSteps.splice(index, 1, value)

    updateAnimationProp(effectName, newSteps);
  }
  const editLinearGradientChange = (gradientProps, index) => {
    const colorsStops = [];
    const delta = 1 / (gradientProps.colors.length - 1);
   
    gradientProps.colors.forEach((c, index) => {colorsStops.push(index * delta); colorsStops.push(c)});
    editEffectStep('fillLinearGradientColorStops', index, colorsStops)
  }

  const renderExample = (functionName) => {
    switch (functionName) {
      case "moveToX":
      return <Stack spacing={1}>
                <Typography variant="h4" component="div">
                  Move horizontally to 
                </Typography>
                <Typography color="text.secondary">
                  translates a block from the current horizontal position to <span style={{fontStyle: 'italic'}}>a new position</span>
                </Typography>                
                <Typography color="text.secondary">
                  The position is defined by the  <span style={{fontStyle: 'italic'}}>Left</span> property
                </Typography>
          </Stack>
      case "moveToY":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                    Move vertically to 
                  </Typography>
                  <Typography color="text.secondary">
                    translates a block from the current vertical position to <span style={{fontStyle: 'italic'}}>a new position</span>
                  </Typography>                
                  <Typography color="text.secondary">
                    The position is defined by the  <span style={{fontStyle: 'italic'}}>Top</span> property
                  </Typography>
          </Stack>
      case "lineHeight":
        return <Stack spacing={1}>
        <Typography variant="h4" component="div">
          Line Height
        </Typography>
        <Typography color="text.secondary">
          changes the  <span style={{fontStyle: 'italic'}}>line height</span> of a text block
        </Typography>
        </Stack>
      case "strokeWidth":
        return <Stack spacing={1}>
        <Typography variant="h4" component="div">
        Stroke Width
        </Typography>
        <Typography color="text.secondary">
          changes the  <span style={{fontStyle: 'italic'}}>stroke width</span> of the text
        </Typography>
        </Stack>
      case "fill":
        return <Stack spacing={1}>
        <Typography variant="h4" component="div">
          Color
        </Typography>
        <Typography color="text.secondary">
          changes the  <span style={{fontStyle: 'italic'}}>color</span> of the text
        </Typography>
        </Stack>
      case "fillLinearGradientColorStops":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                  Linear Gradient Colors
                  </Typography>
                  <Typography color="text.secondary">
                    changes the <span style={{fontStyle: 'italic'}}>colors</span> of a linear gradient
                  </Typography>
        </Stack>
      case "fillRadialGradientEndRadius":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                    Gradient Radius
                  </Typography>
                  <Typography color="text.secondary">
                    changes the <span style={{fontStyle: 'italic'}}>radius</span> of a gradial gradient
                  </Typography>
        </Stack>
      case "textTyping":
        return <Stack spacing={1}>
                  <Typography variant="h4" component="div">
                    Text typing
                  </Typography>
                  <Typography color="text.secondary">
                    add a  <span style={{fontStyle: 'italic'}}>typing</span> effect where letters appear one at a time
                  </Typography>
        </Stack>
      default:
      break;
    }
    return <>
    Example for {functionName}
    </>
  }
  const renderEffectSettings = (functionName) => {
    switch (functionName) {
      case "moveToX":
        if (animations.x === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('x', 50)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.x.map((left, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change left position to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={left}
                                        onChange={(e) => editEffectStep('x', index, TryParseIntDefault(e.target.value, ''))}
                                        size="small"
                                      />
                                      {animations.x.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('x', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('x', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.x.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "moveToY":
        if (animations.y === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('y', 10)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.y.map((top, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change top position to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={top}
                                        onChange={(e) => editEffectStep('y', index, TryParseIntDefault(e.target.value, ''))}
                                        size="small"
                                      />
                                      {animations.y.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('y', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('y', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.y.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "fillRadialGradientEndRadius":
        if (animations.fillRadialGradientEndRadius === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('fillRadialGradientEndRadius', 50)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.fillRadialGradientEndRadius.map((radius, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change radius to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={radius}
                                        onChange={(e) => editEffectStep('fillRadialGradientEndRadius', index, TryParseIntDefault(e.target.value, ''))}
                                        size="small"
                                      />
                                      {animations.fillRadialGradientEndRadius.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('fillRadialGradientEndRadius', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('fillRadialGradientEndRadius', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.fillRadialGradientEndRadius.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "lineHeight":
        if (animations.lineHeight === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('lineHeight', 1)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.lineHeight.map((lHeight, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change line height to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={lHeight}
                                        onChange={(e) => editEffectStep('lineHeight', index, TryParseFloatDefault(e.target.value, 1))}
                                        size="small"
                                      />
                                      {animations.lineHeight.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('lineHeight', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('lineHeight', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.lineHeight.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "strokeWidth":
        if (animations.strokeWidth === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('strokeWidth', 1)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.strokeWidth.map((sWidth, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change line height to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={sWidth}
                                        onChange={(e) => editEffectStep('strokeWidth', index, TryParseFloatDefault(e.target.value, 1))}
                                        size="small"
                                      />
                                      {animations.strokeWidth.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('strokeWidth', 1)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('strokeWidth', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.strokeWidth.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "fill":
        if (animations.fill === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('fill', '#000')}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.fill.map((fill, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change the text color to
                                  </Typography>
                                  <LionColorPicker color={fill}      
                                              // onChange={(color) => handlePropChange('fill', color)}
                                              onChange={(color) => editEffectStep('fill', index, color)}
                                              />
                                      {animations.fill.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('fill', '#000')} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('fill', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.fill.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "fillLinearGradientColorStops":
        if (animations.fillLinearGradientColorStops === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('fillLinearGradientColorStops', [0, "#000000", 1, "#54d925"])}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.fillLinearGradientColorStops.map((gradientValues, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change gradient color to
                                  </Typography>
                                  <Paper elevation={2} sx={{p:1}}>
                                    <LionLinearGradientPicker
                                          // onChange={(colors) => editEffectStep('fillLinearGradientColorStops', index, colors)}
                                          onChange={(colors) => editLinearGradientChange(colors, index)}
                                          // direction={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.gradientDirection}
                                          colorsStops={gradientValues} 
                                          />                                    
                                  </Paper>
                                      {animations.fillLinearGradientColorStops.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('fillLinearGradientColorStops', [0, "#000000", 1, "#54d925"])} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('fillLinearGradientColorStops', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.fillLinearGradientColorStops.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "textTyping":
        if (animations.textTyping === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('textTyping', 'leftToRight')}>
            Add Effect
          </Button>
        }
        return <div>
              <div>Enabled</div>
              <div>Direction {animations.textTyping[0] === 'leftToRight' ? 'Left to Right' : 'Right to Left'}</div>
        </div>          
      default:
      break;
    }
    return <>
    Example for {functionName}
    </>
  }
  const renderAnimationSummary = (effectName, effectValues) => {
    let effectNamePretty = effectName;
    switch (effectName) {
      case "fillRadialGradientEndRadius":
        effectNamePretty = "Gradient Radius";
        break;
      case "x":
        effectNamePretty = "Move Horizontally";
        break;
      case "y":
        effectNamePretty = "Move Vertically";
        break;
      case "lineHeight":
        effectNamePretty = "Line Height";
        break;
      case "strokeWidth":
        effectNamePretty = "Stroke Width";
        break;
      case "fill":
        effectNamePretty = "Text Color";
        break;
      case "textTyping":
        effectNamePretty = "Text Typing";
        break;
      default:
        effectNamePretty = effectName;
        break;
    }

    let result = null;
    switch (effectName) {
      case "fillRadialGradientEndRadius":
        result = effectValues.map((val, index) => 
           <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Change radius to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'fillRadialGradientEndRadius')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "x":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Move horizontally to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'moveToX')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "y":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Move vertically to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'moveToY')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "lineHeight":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Change line height to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'lineHeight')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "fill":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Change text color to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'fill')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
      break;
      case "textTyping":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Add typing effect</Typography>
            <Typography>{val === 'leftToRight' ? "(Left to right)" : "(Right to left)"}</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'fill')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
      break;
      case "scrolling":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Add scrolling effect</Typography>
            <Typography>{console.log(val)}</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'fill')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
      break;
      case "flashing":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Add flashing effect</Typography>
            <Typography>{console.log(val)}</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'fill')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
      break;
        
      default:
        result = effectValues.map((val, index) => 
        <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
        <Card  sx={{...props.sx, width: 250 }}>
        <CardContent>
        <Typography>Change to {val} px</Typography>
        </CardContent>
        </Card>
        {index < effectValues.length - 1 &&
        <Iconify icon='maki:arrow' />
        }
        </Stack>
        )
        break;

  }



    return <Stack direction='row' spacing={1} display='flex' alignItems='center'>
      <AnimationTitle title={effectNamePretty}
      />
      <Iconify icon='fad:digital-colon' />
      {result}
    </Stack>
  }

return <>
      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
        <Typography>Animate:</Typography>
        <Chip sx={{minWidth: '50%'}} label={getLabelTitle()} variant="outlined" onClick={handleOpenAnimationManager} />
      
      </Stack>
      <Popover      open={openAnimationManager}
                    anchorEl={anchorEl}
                    onClose={handleCloseAnimationManager}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <Paper sx={{ padding: '10px', width:1100, height: 750}} elevation={4}>
        <Stack spacing={1}>
          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
            <Typography>Animation Duration</Typography>
            <TextField sx={{width: '120px'}}
                  value={animations.totalSeconds}
                  onChange={(e) => updateAnimationProp('totalSeconds', TryParseIntDefault(e.target.value, ''))}
                  size="small"
                />
          </Stack>
          <Button variant='outlined' sx={{width: 150}} onClick={handleOpenEffectManager}>Add an effect</Button>
          <Stack direction='row' display='flex' alignItems='center'>
            <Box sx={{border:'1px solid #333', width:'70%', height:'2px'}} />
            <Iconify icon='maki:arrow'  />
          </Stack>
          {Object.keys(animations).filter(k => k !== "totalSeconds" && k !== "textTransitionFunction").map(animationName => 
             renderAnimationSummary(animationName, animations[animationName])

          )}
        </Stack>
        </Paper>
    </Popover>

    <Popover      open={openEffectManager}
                anchorEl={anchorElEffectManager}
                onClose={handleCloseEffectManager}
                anchorOrigin={{
                  vertical: 'top',
                }}
      >
    <Paper sx={{ padding: '10px', width:900}} elevation={4}>
      <Stack>
        <Grid2 container sx={{height:600}}>
          <Grid2 xs={3}>
            <List dense sx={{overflow: 'auto', maxHeight: 650,}}>
              <ListSubheader>General</ListSubheader>
              <ListItem>
                <ListItemButton selected={functionNameBrowsed === 'moveToX'}
                                 onMouseEnter={() => {setFunctionNameBrowsed('moveToX');}}>
                  <ListItemText primary="Move horizontally to" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton selected={functionNameBrowsed === 'moveToY'}
                                 onMouseEnter={() => {setFunctionNameBrowsed('moveToY');}}>
                  <ListItemText primary="Move vertically to" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton selected={functionNameBrowsed === 'lineHeight'}
                               onMouseEnter={() => {setFunctionNameBrowsed('lineHeight');}}>
                  <ListItemText primary="Line Height" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton selected={functionNameBrowsed === 'strokeWidth'}
                               onMouseEnter={() => {setFunctionNameBrowsed('strokeWidth');}}>
                  <ListItemText primary="Stroke Width" />
                </ListItemButton>
              </ListItem>
              <ListSubheader>Colors</ListSubheader>
              <ListItem>
              <ListItemButton selected={functionNameBrowsed === 'fill'}
                               onMouseEnter={() => {setFunctionNameBrowsed('fill');}}>
                  <ListItemText primary="Solid color change" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={functionNameBrowsed === 'fillLinearGradientColorStops'}
                               onMouseEnter={() => {setFunctionNameBrowsed('fillLinearGradientColorStops');}}>
                  <ListItemText primary="Linear gradient color change" />
                </ListItemButton>
              </ListItem>
              <ListItem>
              <ListItemButton selected={functionNameBrowsed === 'fillRadialGradientEndRadius'}
                               onMouseEnter={() => {setFunctionNameBrowsed('fillRadialGradientEndRadius');}}>
                  <ListItemText primary="Gradient radius change" />
                </ListItemButton>
              </ListItem>
              <ListSubheader>Text</ListSubheader>
              <ListItem>
                <ListItemButton selected={functionNameBrowsed === 'textTyping'}
                               onMouseEnter={() => {setFunctionNameBrowsed('textTyping');}}>
                  <ListItemText primary="Text typing" />
                </ListItemButton>
              </ListItem>
            </List>
          </Grid2>
          <Grid2 xs={9}>
            <Stack spacing={6}>
              {renderExample(functionNameBrowsed)}
              <Stack spacing={1}>
                <Typography variant='h4'>Your parameters:</Typography>
                {renderEffectSettings(functionNameBrowsed)}
              </Stack>
            </Stack>
          </Grid2>
        </Grid2>
        <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
            <Button variant='outlined' color='secondary'  sx={{mr:1}} onClick={handleCloseEffectManager} >Close</Button>
        </Box>
      </Stack>
    </Paper>
    </Popover>
  </>
}

const AnimationManager = (props) => {
  // TO DO IMPORTANT:
  // so far the AnimationManager only handles properties that are common among all blocks
  // we should enhance the AnimationManager so that also block-specific properties are handled
  // e.g. rating block: the color "fill" prop has not effect, there should be a "ratedColor" and "unratedColor" props
  //  also for the rating block it is possible to change the "text" prop with a manipulation function to treat that text as a number

  const effects = [{id: 1, name: "Typing effect", imageURL: `/assets/effects/typing.gif`, functionName: "textTyping", notTogetherIds: [2,3,4]},
    {id: 2, name: "Flashing effect", imageURL: `/assets/effects/flashing.gif`, functionName: "textFlashing", notTogetherIds: [1,3,4]},
    {id: 3, name: "Scrolling effect", imageURL: `/assets/effects/scrolling.gif`, functionName: "textScrolling", notTogetherIds: [1,2,4]},
    {id: 4, name: "Tumble effect", imageURL: `/assets/effects/tumble.gif`, functionName: "textTumble", notTogetherIds: [1,2,3]},
  ]
  const effectsImages = [{id: 100, name: "Flip", imageURL: `/assets/effects/typing.gif`, functionName: "imgFlip", notTogetherIds: [2,3,4]},
  ]
  const [extraImages, setExtraImages] = useState([''])
  const [animations, setAnimations] = useState({totalSeconds: 0}) // main object - contains all possible animations
  const [extraImagesErrMsg, setExtraImagesErrMsg] = useState(false)

  // const [selectedFunctionIndex, setSelectedFunctionIndex] = useState(-1)
  const [functionNameBrowsed, setFunctionNameBrowsed] = useState('');

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElEffectManager, setAnchorElEffectManager] = useState(null);
  const openAnimationManager = Boolean(anchorEl);

  const handleOpenAnimationManager = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAnimationManager = () => {
    setAnchorEl(null);
  };

  const openEffectManager = Boolean(anchorElEffectManager);
  const handleOpenEffectManager = (event, effectName) => {
    setAnchorElEffectManager(event.currentTarget);
    
    if (effectName !== undefined) {
      setFunctionNameBrowsed(effectName);
      setExtraImages([''])
    }
    else {
      setExtraImages([''])
    }
  };
  const handleCloseEffectManager = () => {
    // if (props.onTextFunctionsChange !== undefined) props.onTextFunctionsChange(textTransforms);

    setAnchorElEffectManager(null);
    
  };

  useEffect(() => {
    console.log(props.animations)
    if (props.animations !== undefined) {
      setAnimations(props.animations)
      if (props.animations.imgFlip) setExtraImages(props.animations.imgFlip[0].split("||"))
    }
  }, [props.animations])

  useEffect(() => {
  }, [props.blockType])

  const updateAnimationProp = (propName, propValue) => {
    const newAnimations = {...animations, [propName]: propValue}
    //console.log(newAnimations)
    setAnimations(newAnimations);
    if (props.onAnimationChange !== undefined) props.onAnimationChange(newAnimations) 
  }

  const getLabelTitle = () => {
    const allKeys = Object.keys(animations);
    //there is always at leat one key: totalSeconds
    if (allKeys.length <= 1) return `No animation defined`
    if (allKeys.length === 2) {
      const animationName = allKeys.find(k => k !== "totalSeconds")
      return animationName
    }
    //if we are here there are multiple effects
    return `Multiple effects defined`;
  }
  const addEffectStep = (effectName) => {
    let value = getEffectDefaultValues(effectName)
    if (props.blockType === "Image") value = extraImages.join("||"); 

    // check if effectName is undefined 
    let newSteps = null;
    if (animations[effectName] === undefined) {
      newSteps = [];
    }
    else  newSteps = [...animations[effectName]]

    newSteps.push(value);

    updateAnimationProp(effectName, newSteps);
  }
  const removeEffectStep = (effectName, index) => {
    const newSteps = [...animations[effectName]]
    newSteps.splice(index, 1)
    if (newSteps.length === 0) {
      // the effect has been completely removed. We want to remove its key from the animation dictionary
      const newAnimations = {...animations}
      delete newAnimations[effectName];
      setAnimations(newAnimations);
      if (props.onAnimationChange !== undefined) props.onAnimationChange(newAnimations) 
    }
    else updateAnimationProp(effectName, newSteps);

  }
  const removeEffectAllSteps = (effectName) => {
    const newAnimations = {...animations}
    delete newAnimations[effectName];
    setAnimations(newAnimations);
    if (props.onAnimationChange !== undefined) props.onAnimationChange(newAnimations) 

  }
  const editEffectStep = (effectName, index, value) => {
    const newSteps = [...animations[effectName]]
    newSteps.splice(index, 1, value)

    updateAnimationProp(effectName, newSteps);
  }
  const editLinearGradientChange = (gradientProps, index) => {
    const colorsStops = [];
    const delta = 1 / (gradientProps.colors.length - 1);
   
    gradientProps.colors.forEach((c, index) => {colorsStops.push(index * delta); colorsStops.push(c)});
    editEffectStep('fillLinearGradientColorStops', index, colorsStops)
  }

  const renderEffectSettings = (functionName) => {
    switch (functionName) {
      case "moveToX":
        if (animations.x === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('x', 50)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.x.map((left, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change left position to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={left}
                                        onChange={(e) => editEffectStep('x', index, TryParseIntDefault(e.target.value, ''))}
                                        size="small"
                                      />
                                      {animations.x.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('x', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('x', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.x.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "moveToY":
        if (animations.y === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('y', 10)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.y.map((top, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change top position to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={top}
                                        onChange={(e) => editEffectStep('y', index, TryParseIntDefault(e.target.value, ''))}
                                        size="small"
                                      />
                                      {animations.y.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('y', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('y', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.y.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "fillRadialGradientEndRadius":
        if (animations.fillRadialGradientEndRadius === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('fillRadialGradientEndRadius', 50)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.fillRadialGradientEndRadius.map((radius, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change radius to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={radius}
                                        onChange={(e) => editEffectStep('fillRadialGradientEndRadius', index, TryParseIntDefault(e.target.value, ''))}
                                        size="small"
                                      />
                                      {animations.fillRadialGradientEndRadius.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('fillRadialGradientEndRadius', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('fillRadialGradientEndRadius', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.fillRadialGradientEndRadius.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "lineHeight":
        if (animations.lineHeight === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('lineHeight', 1)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.lineHeight.map((lHeight, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change line height to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={lHeight}
                                        onChange={(e) => editEffectStep('lineHeight', index, TryParseFloatDefault(e.target.value, 1))}
                                        size="small"
                                      />
                                      {animations.lineHeight.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('lineHeight', 50)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('lineHeight', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.lineHeight.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "strokeWidth":
        if (animations.strokeWidth === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('strokeWidth', 1)}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.strokeWidth.map((sWidth, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change line height to
                                  </Typography>
                                  <TextField sx={{width: '120px'}}
                                        value={sWidth}
                                        onChange={(e) => editEffectStep('strokeWidth', index, TryParseFloatDefault(e.target.value, 1))}
                                        size="small"
                                      />
                                      {animations.strokeWidth.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('strokeWidth', 1)} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('strokeWidth', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.strokeWidth.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "fill":
        if (animations.fill === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('fill', '#000')}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.fill.map((fill, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change the text color to
                                  </Typography>
                                  <LionColorPicker color={fill}      
                                              // onChange={(color) => handlePropChange('fill', color)}
                                              onChange={(color) => editEffectStep('fill', index, color)}
                                              />
                                      {animations.fill.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('fill', '#000')} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('fill', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.fill.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "fillLinearGradientColorStops":
        if (animations.fillLinearGradientColorStops === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('fillLinearGradientColorStops', [0, "#000000", 1, "#54d925"])}>
            Add Effect
          </Button>
        }
        return <Stack spacing={1}>
                { animations.fillLinearGradientColorStops.map((gradientValues, index) =>
                        <Stack key={index} spacing={1} >
                          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                  <Typography>
                                    Change gradient color to
                                  </Typography>
                                  <Paper elevation={2} sx={{p:1}}>
                                    <LionLinearGradientPicker
                                          // onChange={(colors) => editEffectStep('fillLinearGradientColorStops', index, colors)}
                                          onChange={(colors) => editLinearGradientChange(colors, index)}
                                          // direction={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.gradientDirection}
                                          colorsStops={gradientValues} 
                                          />                                    
                                  </Paper>
                                      {animations.fillLinearGradientColorStops.length < 4 &&
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Add} onClick={() => addEffectStep('fillLinearGradientColorStops', [0, "#000000", 1, "#54d925"])} />
                                        </IconButton>
                                      }
                                          <IconButton>
                                          <Iconify icon={lionIcons.Icon_Actions_Delete} onClick={() => removeEffectStep('fillLinearGradientColorStops', index)} />
                                        </IconButton>
                            </Stack>
                            {index < animations.fillLinearGradientColorStops.length -1 &&
                            <Stack direction='row' spacing={1}>
                                <Typography>then</Typography>
                                <Iconify icon='maki:arrow' rotate={1} />
                              </Stack>
                            }
                          </Stack>
                          )
                }
        </Stack>
      case "textTyping":
        if (animations.textTyping === undefined) {
          return <Button sx={{width: 100}} onClick={() => addEffectStep('textTyping', 'leftToRight')}>
            Add Effect
          </Button>
        }
        return <div>
              <div>Enabled</div>
              <div>Direction {animations.textTyping[0] === 'leftToRight' ? 'Left to Right' : 'Right to Left'}</div>
        </div>          
      default:
      break;
    }
    return <>
    Example for {functionName}
    </>
  }
  const renderAnimationSummary = (effectName, effectValues) => {
    let effectNamePretty = effectName;
    switch (effectName) {
      case "fillRadialGradientEndRadius":
        effectNamePretty = "Gradient Radius";
        break;
      case "x":
        effectNamePretty = "Move Horizontally";
        break;
      case "y":
        effectNamePretty = "Move Vertically";
        break;
      case "lineHeight":
        effectNamePretty = "Line Height";
        break;
      case "strokeWidth":
        effectNamePretty = "Stroke Width";
        break;
      case "fill":
        effectNamePretty = "Text Color";
        break;
      case "textTyping":
        effectNamePretty = "Text Typing";
        break;
      case "textScrolling":
        effectNamePretty = "Text Scrolling";
        break;
      case "textFlashing":
        effectNamePretty = "Text Flashing";
        break;
      case "textTumble":
        effectNamePretty = "Text Tumble";
        break;
      case "imgFlip":
        effectNamePretty = "Image Flip";
        break;
      default:
        effectNamePretty = effectName;
        break;
    }

    let result = null;
    switch (effectName) {
      case "fillRadialGradientEndRadius":
        result = effectValues.map((val, index) => 
           <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Change radius to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'fillRadialGradientEndRadius')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "x":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Move horizontally to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'moveToX')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "y":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Move vertically to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'moveToY')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "lineHeight":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Change line height to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'lineHeight')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
              break;
      case "fill":
        result = effectValues.map((val, index) => 
            <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
          <Card  sx={{...props.sx, width: 225 }}>
          <CardContent>
            <Typography>Change text color to</Typography>
            <Typography>{val} px</Typography>
            </CardContent>
            </Card>
          {index < effectValues.length - 1 &&
          <Iconify icon='maki:arrow' />
          }
          {index === effectValues.length - 1 &&
            <IconButton onClick={(e) => handleOpenEffectManager(e, 'fill')}>
              <Iconify icon={lionIcons.Icon_Actions_Edit} />
            </IconButton>
          }
        </Stack>
          )
      break;
      case "textTyping":
        result = effectValues.map((val, index) => 
            <div className='flex flex-row'>
              <div>{val === 'leftToRight' ? "(Left to right)" : "(Right to left)"}</div>
            </div>
          )
      break;
      case "textScrolling":
        result = effectValues.map((val, index) => 
            <div className='flex flex-row'>
                <div className='text-sm text-gray-400'>No parameters to define</div>
            </div>
          )
      break;
      case "textFlashing":
      case "imgFlip":
        result = effectValues.map((val, index) => 
            <div className='flex flex-row items-center'>
              <div>Flip to these images:</div>
              {val.split("||").map(v => <div className='flex flex-col justify-center items-center'>
                                            {getImageSrc(v) && getImageSrc(v).length > 0 &&
                                                    <div className={`w-[200px] h-[220px] flex flex-row items-center justify-center p-2 rounded-md`}>
                                                      <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={getImageSrc(extraImages[index])} />
                                                    </div>
                                            }
                                          <div className='w-fit text-sm bg-gray-200 text-ccColorDarkTeal ml-2 p-1 rounded'>{v}</div>
              </div>)}
              
            </div>
          )
      break;
      case "textTumble":
        result = effectValues.map((val, index) => 
            <div className='flex flex-row'>
              <div className='text-sm text-gray-400'>No parameters to define</div>
            </div>
          )
      break;
        
      default:
        result = effectValues.map((val, index) => 
        <Stack key={index} direction='row' spacing={1} display='flex' alignItems='center'>
        <Card  sx={{...props.sx, width: 250 }}>
        <CardContent>
        <Typography>Change to {val} px</Typography>
        </CardContent>
        </Card>
        {index < effectValues.length - 1 &&
        <Iconify icon='maki:arrow' />
        }
        </Stack>
        )
        break;

  }

    return <div className='flex flex-rox gap-x-2 items-center mt-2'>
      <div className='flex flex-row grow gap-x-2 items-center px-2 border rounded min-h-12'>
        <div className='text-center font-poppins font-semibold bg-ccColorOrange text-white text-sm rounded p-1'>Added</div>
        <div className='w-56 text-center font-poppins font-semibold'>{effectNamePretty}</div>
        <div className='flex grow'>
          {result}
        </div>
      </div>
        <IconButton onClick={() => {removeEffectAllSteps(effectName)}}>
          <Iconify icon={lionIcons.Icon_Actions_Delete} />
        </IconButton>
    </div>
  }
  const getAnimationNames = () => {
    //check the animations object and return all the animation names found
    if (animations === undefined || animations === null) return [];

    return Object.keys(animations).filter(k => k !== "totalSeconds" && k !== "textTransitionFunction");

  }
const handleSelectEffect = (functionName) => {
  setExtraImagesErrMsg(false)
  if (props.blockType === "Image") {
    //if it's a flip animation we need to run some validation first
    if (extraImages.length === 1 && extraImages[0] === '') {
      setExtraImagesErrMsg(true)
      return
    }
  }

  addEffectStep(functionName)
  handleCloseEffectManager()
}
const getImageSrc = (dataBindValue) => {

  if (dataBindValue === undefined) return ""
  //used with flip image animation to show thumbnails
  let value = ""
  if (props.sampleData !== undefined && Object.keys(props.sampleData).length > 0) {
      
    if (dataBindValue.includes('.')) {
      const parts = dataBindValue.split('.')
      value = props.sampleData
      for (const p of parts) {
        value = value[p]
      }
    }
    else value = props.sampleData[dataBindValue]
  }
  return value
}

const getEffectDefaultValues = (functionName) => {
  //all effect values are a single string (legacy)
  switch (functionName) {
    case "textTyping":
      return "leftToRight"
    case "textTumble":
      return "downUp"
    default:
      return ""
  }
}
const getSelectedEffectIds = () => {
  const allKeys = Object.keys(animations).filter(k => k !== "totalSeconds")
  const allIds = []
  const allEffects =[...effects, ...effectsImages]
  allKeys.forEach(k => {
    const matched = allEffects.find(e => e.functionName === k)
    allIds.push(matched.id)
  })
  return allIds
}

const handleExtraImagesDatabindChange = (dataBindType, databind, _, index) => {
  setExtraImagesErrMsg(false)
  const newImages = [...extraImages]
  newImages.splice(index, 1, databind);
  //console.log(newImages)
  setExtraImages(newImages)
}
const handleExtraImageRemove = (index) => {
  const newImages = [...extraImages]
  newImages.splice(index, 1);
  //console.log(newImages)
  setExtraImages(newImages)
}

return <>
      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
        <Typography>Animate:</Typography>
        <Chip sx={{minWidth: '50%'}} label={getLabelTitle()} variant="outlined" onClick={handleOpenAnimationManager} />
      
      </Stack>
      <Popover      open={openAnimationManager}
                    anchorEl={anchorEl}
                    onClose={handleCloseAnimationManager}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <Paper sx={{ padding: '10px', width:1000, height: 650}} elevation={4}>
        <div>
          <div className=' p-2 gap-x-2 border rounded items-center mb-4'>
            <div className='w-48 font-poppins'>
              <InputNumber displayName="Animation Duration (ms)"
                min={1000} max={8000} incr={500}
                onChange={(val) => updateAnimationProp("totalSeconds", val)}
                value={animations.totalSeconds}
              />
            </div>

          </div>
          {getAnimationNames().length === 0 && <div className='flex flex-col items-center gap-y-6 p-6 font-poppins font-semibold text-2xl text-gray-400'>
            <div>No Animation effects defined</div>
            <CcActionButtonOutlined  onClick={handleOpenEffectManager} >Add an effect</CcActionButtonOutlined>
            </div>}
          {getAnimationNames().map(animationName => 
             renderAnimationSummary(animationName, animations[animationName])

          )}
          {getAnimationNames().length > 0 && <div className='mt-4'>
              <CcActionButtonOutlined  onClick={handleOpenEffectManager} >Add an effect</CcActionButtonOutlined>
          </div>
          }
        </div>
        </Paper>
    </Popover>

    <Popover      open={openEffectManager}
                anchorEl={anchorElEffectManager}
                onClose={handleCloseEffectManager}
                anchorOrigin={{
                  vertical: 'top',
                }}
      >
    <Paper sx={{ padding: '10px', width:900}} elevation={4}>
      <Stack>
        {props.blockType === "Image" && <div className='text-ccColorDarkTeal mb-2'>
          <div>Select one or more extra images</div>
            {extraImages.map((img, index) => <div className='flex flex-row items-center mt-2 gap-x-4'>
              <DatabindingSelector 
                      dataBindValue={extraImages[index]}
                      sampleData={props.sampleData}
                      dataBindType={'databind'}
                    dataBindTypes={['databind']}
                    onChange={(p1, p2, p3) => handleExtraImagesDatabindChange(p1, p2, p3, index)} 
                    />
                {getImageSrc(extraImages[index]) && getImageSrc(extraImages[index]).length > 0 &&
                        <div className={`w-[200px] h-[220px] flex flex-row items-center justify-center p-2 rounded-md`}>
                          <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={getImageSrc(extraImages[index])} />
                        </div>
                }
                {index > 0 && <IconButton variant="contained" sx={{color: ccColorDarkTeal}} onClick={() => handleExtraImageRemove(index)} >
                      <Iconify icon={lionIcons.Icon_Actions_Delete} width="28px" />
                  </IconButton>


                }
            </div>)}
            {extraImages[0].length >0 &&
             <DatabindingSelector 
                      //dataBindValue={activeSelection.attrs.imageUrl}
                      sampleData={props.sampleData}
                      dataBindType={'databind'}
                    dataBindTypes={['databind']}
                    onChange={(p1, p2, p3) => handleExtraImagesDatabindChange(p1, p2, p3, extraImages.length)} 
                    noPreview
                    noPreviewCustomMsg="Add image"
                    />
            }
          {extraImagesErrMsg && <div className='text-red-400'>Please select at least one image</div>}
        </div>
        }
        <AnimationEffectGallery effects={props.blockType === "Image" ? effectsImages : effects} 
            selected={getSelectedEffectIds()}
            onSelect={handleSelectEffect} />
        <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
            <Button variant='outlined' color='secondary'  sx={{mr:1}} onClick={handleCloseEffectManager} >Close</Button>
        </Box>
      </Stack>
    </Paper>
    </Popover>
  </>
}

const AnimationLoopSelector = (props) => {
  const [animationSettings, setAnimationSettings] = useState({isLoop: false, pauseBetweenLoops: 0})

  useEffect(() => {
    //console.log(props.settings)
    if (props.settings) setAnimationSettings(props.settings)

  }, [props.settings])

  const handleUpdateAnimationSettings = (propName, propValue) => {
    const newAnimationSettings = {...animationSettings, [propName]: propValue}
    //console.log(newAnimationSettings)

    setAnimationSettings(newAnimationSettings)

    if (props.onChange !== undefined) props.onChange(newAnimationSettings)
  }


  return <div>
    <div className='flex flex-row'>
      <div className='text-xs font-poppins'>Animation loop settings</div>
    </div>
    <div className='flex flex-row gap-x-2'>
            <Toggle displayName="Loop"
                  checked={animationSettings.isLoop}
                  onChange={(val) => handleUpdateAnimationSettings("isLoop", val)}
          />
        {animationSettings.isLoop && <div className='flex flex-row items-center gap-x-1'>
              <div className=" w-[160px]">
                <InputNumber
                            incr={500}
                            value={animationSettings.pauseBetweenLoops} 
                            onChange={(val) => handleUpdateAnimationSettings("pauseBetweenLoops", val)}
                />
              </div>
              <InfoToolTip 
                        placement='top-end'
                        headLine='Pause between loops'
                        message="When loop is active, it allows to set a pause in milliseconds between loops"
                      />
          </div>
        }

  </div>
  </div>
}

const TwoDSelector = (props) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const [effects, setEffects] = useState({rotation: 0, skewX: 0, skewY: 0});

  useEffect(() => {
    let propRotation = 0;
    let propSkewX = 0;
    let propSkewY = 0;
    if (props.effects.rotation !== undefined) propRotation = TryParseIntDefault(props.effects.rotation, '');
    if (props.effects.skewX !== undefined) propSkewX = props.effects.skewX;
    if (props.effects.skewY !== undefined) propSkewY = props.effects.skewY;
    setEffects({rotation: propRotation, skewX: propSkewX, skewY: propSkewY});

  }, [props.effects])

  const handleOpen2DSettings = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose2DSettings = () => {
    setAnchorEl(null);
  };
  const openFontSettings = Boolean(anchorEl);

  const handleChangeProp = (propName, propValue) => {
    const newEffects = {...effects, [propName]: propValue}

    setEffects(newEffects);
    console.log(newEffects)
    if (props.onChange !== undefined) props.onChange(newEffects)
  }
  

  return <>
      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
        <Chip sx={{width: '100%'}} label={`2D Effects`} variant="outlined" onClick={handleOpen2DSettings} />
      
      </Stack>
      <Popover      open={openFontSettings}
                    anchorEl={anchorEl}
                    onClose={handleClose2DSettings}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <Paper sx={{ padding: '10px'}} elevation={4}>
          <Stack direction='row' spacing={2} sx={{display: 'flex', alignItems: 'center'}}>
            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}} >
                <Typography>Rotation</Typography>
                <LionNumberInput sx={{width: '80px'}}
                      value={effects.rotation}
                      onChange={(num) => handleChangeProp('rotation', TryParseIntDefault(num, ''))}
                      size="small"
                    />
                    {false &&
                <Tooltip title='Change rotation origin' placement='right' >                    
                  <IconButton onClick={() => {if (props.onAddRotationViewFinder !== undefined) props.onAddRotationViewFinder()}}>
                    <Iconify icon='tabler:viewfinder' />
                  </IconButton>
                  </Tooltip>
                  }
            </Stack>
            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}} >
                <Typography>Skew X</Typography>
                <LionNumberInput sx={{width: '80px'}}
                      value={effects.skewX}
                      onChange={(num) => handleChangeProp('skewX', num)}
                      size="small"
                      increment={0.1}
                    />
            </Stack>              
            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}} >
                <Typography>Skew Y</Typography>
                <LionNumberInput sx={{width: '80px'}}
                      value={effects.skewY}
                      onChange={(num) => handleChangeProp('skewY', num)}
                      increment={0.1}
                      size="small"
                    />
            </Stack>              
          </Stack>

        </Paper>
    </Popover>
  </>
}

const LayersManager = (props) => {
  const [nodes, setNodes] = useState([])
  const [activeBlockId, setActiveBlockId] = useState('')
  const [editPrettyNameBlockId, setEditPrettyNameBlockId] = useState('')
  const [tmpPrettyName, setTmpPrettyName] = useState('')

  useEffect(() => {
    //extracting user-added blocks from konva
    if (props.konvaLayer) {
      var userNodes = props.konvaLayer.find(node => {
        return node.attrs.id !== undefined && !node.attrs.id.includes("_delete") && !node.attrs.id.includes("timerLabel");
       });
       setNodes(userNodes.reverse())
       //console.log(userNodes)
    }
    else {
      setNodes([])
      setActiveBlockId('');
    }

  }, [props.konvaLayer])

  useEffect(() => {
    if (props.selectedObjects && props.selectedObjects !== null) {
      if (props.selectedObjects.length === 1 && props.selectedObjects[0].attrs) {
        setActiveBlockId(props.selectedObjects[0].attrs.id)
      }
      else setActiveBlockId('')
    }
    else setActiveBlockId('')

  }, [props.selectedObjects])

  const getNodePrettyName = (node) => {
    if (node.attrs.layerName && node.attrs.layerName !== '') return node.attrs.layerName;

    if (node.getType() === "Shape" && node.getClassName() !== "Text" && node.getClassName() !== "Image") {
      //this is shape like circle, rect, etc..
      return "Shape - " + node.getClassName();
    }

    if (node.attrs.timePart && node.attrs.timePart !== '') return node.attrs.timePart;

    if (node.attrs.dataBindValue && node.attrs.dataBindValue !== '') return node.attrs.dataBindValue;

    //image without databind
    if (node.attrs.image) return "Image"

    return node.attrs.text ?? node.attrs.textRaw;
  }
  const handleClickNode = (node) => {
    node.fire('click');
  }
  const handleEditPrettyName = (e, node) => {
    setEditPrettyNameBlockId(node.attrs.id)
    setTmpPrettyName(getNodePrettyName(node))
    e.stopPropagation()
  }
  const handleConfirmPrettyName = (e, node) => {
    node.setAttr('layerName', tmpPrettyName);
    setEditPrettyNameBlockId('')
    e.stopPropagation()
  }
  const handleHideNode = (e, node) => {
    const newNodes = [...nodes]
    const matchedNode = newNodes.find(n => n.attrs.id === node.attrs.id)
    matchedNode.hide();
    setNodes(newNodes)

    e.stopPropagation()
  }
  const handleShowNode = (e, node) => {
    const newNodes = [...nodes]
    const matchedNode = newNodes.find(n => n.attrs.id === node.attrs.id)
    matchedNode.show();
    setNodes(newNodes)

    e.stopPropagation()
  }

  return <div className='flex flex-col gap-y-2 text-ccColorDarkTeal'>
        {nodes.map(n => <div className={`flex flex-row border rounded p-2 mr-4 cursor-pointer hover:bg-ccColorLightTeal ${n.attrs.id === activeBlockId ? 'bg-ccColorTeal text-white' : ''}`}
                          onClick={() => handleClickNode(n)}>
          {n.attrs.id === editPrettyNameBlockId && <div className='flex flex-row'>
                <InputText value={tmpPrettyName} onChange={setTmpPrettyName}  />
                <button className='p-1 rounded-full hover:text-white hover:bg-opacity-20 hover:bg-gray-500'
                              onClick={(e) => handleConfirmPrettyName(e, n)}><Iconify  icon={lionIcons.Icon_Actions_TickOutlined}  /></button>
            </div>
          }
          {n.attrs.id !== editPrettyNameBlockId && <>
              <div className='flex grow'>{getNodePrettyName(n)}</div>
              <button className='p-1 rounded-full hover:bg-ccColorDarkTeal hover:text-white'
                              onClick={(e) => handleEditPrettyName(e, n)}><Iconify  icon={lionIcons.Icon_Actions_Edit}  /></button>
              {(n.attrs.visible === undefined || n.attrs.visible === true) &&
                <button className='p-1 rounded-full hover:bg-ccColorDarkTeal hover:text-white'
                  onClick={(e) => handleHideNode(e, n)}><Iconify  icon="mdi:hide-outline"  /></button>
              }
              {(n.attrs.visible === false) &&
                <button className='p-1 rounded-full hover:bg-ccColorDarkTeal hover:text-white'
                  onClick={(e) => handleShowNode(e, n)}><Iconify  icon="mdi:show-outline"  /></button>
              }
            </>
          }
        </div>)}
  </div>
}

const ObjectInspector = (props) => {

  const [activeSelection, setActiveSelection] = useState({}); // this can contain 1 object or the commom props of multi-object-selection that we want to view/edit
  const [activeSelectionType, setActiveSelectionType] = useState('single'); // values can be 'single' or 'multi'
  const [timerLabelBlock, setTimerLabelBlock] = useState(undefined);
  const [timerRingBlock, setTimerRingBlock] = useState(undefined);

  const [radioCanvasBackground, setRadioCanvasBackground] = useState("Color") // This is a UI ONLY flag - not passed to the server at any point.

  const gradientPreviewCanvasRef = useRef(null);

  // props.snippetTypeId : it is used to turn on/off certain features of the editor depending on the kind of snippet this template refers to
  // backward compatibility: when props.snippetTypeId is not defined, it is a "Generator" type (snippetTypeId = 1)
  // we need to use a state variable instead of the prop to set it to 1 when props is undefined
  const [snippetTypeId, setSnippetTypeId] = useState(0);
  useEffect(() => {
    if (props.snippetTypeId === undefined) setSnippetTypeId(1);
    else setSnippetTypeId(props.snippetTypeId);
    
    switch(props.snippetTypeId) {
      case 9:
      break;
      case 1:
      default:
        // it's a Generator
      break;
    }
  }, [props.snippetTypeId])

  useEffect(() => {
    setTimerLabelBlock(props.timerLabelBlock)
  }, [props.timerLabelBlock])
  useEffect(() => {
    setTimerRingBlock(props.timerRingBlock)
    //ugly code: for some reason sometimes the container div is not rendered
    //when we call initPreviewKonva ==> so we do a polling and call it only
    //when the div has been rendered
    const intervalId = setInterval(() => {
      if (document.getElementById('gradient-preview-container') !== null && props.timerRingBlock && props.timerRingBlock.attrs.ccFillColors.length > 0) {
        clearInterval(intervalId)
        initPreviewKonva()
      }
    }, 100)

  }, [props.timerRingBlock])

  const initPreviewKonva = () => {
    //if (!document.getElementById('gradient-preview-container')) return

    //init gradientPreview Konva
    const stage = new Konva.Stage({
      container: 'gradient-preview-container',
      width: 150,
      height: 150
    });
    const layer = new Konva.Layer();
    stage.add(layer);

    if (props.timerRingBlock.attrs.ccFillColors === undefined) return
    if (props.timerRingBlock.attrs.ccFillColors.length === 0) return

    const colors = props.timerRingBlock.attrs.ccFillColors
    const deltaStop = 1 / (props.timerRingBlock.attrs.ccFillColors.length-1)
    const colorsSteps = colors.map((c,index) => {return {stop: deltaStop*index, color: c}})
    /*
    const gradientCanvas = createSweepGradient(300, [
      { stop: 0, color: "#17425d" },
      { stop: 0.25, color: "#fbbc3d" },
      { stop: 0.5, color: "#ff8095" },
      { stop: 0.75, color: "#a274a3" },
      { stop: 1, color: "#17425d" },
    ]);
    */
    const gradientCanvas = createSweepGradient(300, colorsSteps);

    const ring = new Konva.Ring({
      x: stage.width() / 2,
      y: stage.height() / 2,
      innerRadius: 50,
      outerRadius: 60,
      fillPatternImage: gradientCanvas,
      fillPatternOffset: { x: 150, y: 150 }, // half the gradient size
    });

    layer.add(ring);
    layer.draw();    
    gradientPreviewCanvasRef.current = stage

  }

  const getStartSentence = () => {
    const sentences = ["Click a block to kick things off",
                        "Clickety-click on a block to get the party started",
                        "Ready to unleash your inner Picasso? Click on a block and let's design",
                        "Designers, start your engines! Click a block to get started",
                    ]

    const randomIndex = Math.floor(Math.random() * sentences.length);
    return sentences[randomIndex]
  }
  const findConditionalPropChanges = (condProp) => {

  }

  const handlePropChange = (propName, propValue) => {
    if (activeSelectionType === 'single') {
      const currentObj = activeSelection;

      // if below is to manage conditionalProperties
      // when there is a prop change in the main object then we need to change all the conditional properties and apply the same change
      if (currentObj.attrs.conditionalProperties !== undefined && currentObj.attrs.conditionalProperties.length > 0) {
        for (let i = 0; i<currentObj.attrs.conditionalProperties.length; i+=1) {
          const currentModelAttrs =  currentObj.attrs.conditionalProperties[i].model.attrs;
          if (currentModelAttrs[propName] === currentObj.attrs[propName]) {
            currentModelAttrs[propName] = propValue;
          }
        }
      }

      const currentAttrs = {...currentObj.attrs, [propName]: propValue};
      setActiveSelection({...currentObj, attrs: currentAttrs});
      props.returnUpdateSingle(propName, propValue)
    }
  }

  const handlePropChangeRatingBlock = (path, gapIcon, numIcons, svgScale, propName, propValue) => {
    if (propName === 'numIcons' || propName === 'gapIcon') {
      const blockSize = getRatingsBlockSize(path, gapIcon, numIcons);
      handlePropChange('width', Math.round(blockSize.width * svgScale) + 2);
      handlePropChange(propName, propValue);
    }    
    if (propName === 'svgScale') {
      const blockSize = getRatingsBlockSize(path, gapIcon, numIcons);
      handlePropChange('width', Math.round(blockSize.width * propValue) + 2);
      handlePropChange('height', Math.round(blockSize.height * propValue) + 2);
      handlePropChange(propName, propValue);
    }    
  }


  const handleCanvasPropChange = (propName, propValue) => {
    let updatedSelection = {...activeSelection, [propName]: propValue};

    if (propName === 'backgroundColor') updatedSelection = {...updatedSelection, dataBindType: '', imageUrl: ''}; // if the background colour is changed we want to reset any background image

    setActiveSelection(updatedSelection);

    if ((propName === 'width' || propName === 'height') && propValue === '') return;

    props.returnUpdateCanvas(updatedSelection)
}


  useEffect(() => {
    if (props.objects == null) setActiveSelection({attr: {}});
    else if (props.objects.length === 0) setActiveSelection({attr: {}});
    else if (props.objects.length === 1) {
      //console.log(props.objects[0])
      setActiveSelection(props.objects[0]);
      setActiveSelectionType('single');
      if (props.objects[0].imageUrl && props.objects[0].imageUrl.length > 0) setRadioCanvasBackground('Image')
      else setRadioCanvasBackground('Color')
    }
    else if (props.objects.length > 1) {
      // to do - decide which props to work with in case of multi-select
      setActiveSelection({}); // for now
      setActiveSelectionType('multi');
    }
  }, [props.objects])


  const updateActiveSelectionWithCurrentFontInfo = (fontId, fontName, size, style, tAlign, tDecoration, isAutoSize) => {
    const updatedAttrs = {...activeSelection.attrs, fontId: fontId, fontFamily: fontName,
                            fontSize: size, fontStyle: style, align: tAlign,
                            textDecoration: tDecoration, fontIsAutoSize: isAutoSize
                              };
    setActiveSelection({...activeSelection, attrs: updatedAttrs});
    //console.log(updatedAttrs)
    //legacy if style is an array we need to flatten it to a string
    if (Array.isArray(style)) style = style.join(' ')

    props.returnUpdateSingle('fontFamily', fontName);
    props.returnUpdateSingle('fontId', fontId);
    props.returnUpdateSingle('fontSize', size);
    props.returnUpdateSingle('fontIsAutoSize', isAutoSize);
    props.returnUpdateSingle('fontStyle', style);
    props.returnUpdateSingle('textDecoration', tDecoration);
    props.returnUpdateSingle('align', tAlign);
    // props.returnUpdateSingle('fontWeight', fWeight);
  }
  const updateTimerLabelWithCurrentFontInfo = (fontId, fontName, size, style, tAlign, tDecoration) => {
    const updatedAttrs = {...timerLabelBlock.attrs, fontId: fontId, fontFamily: fontName,
                            fontSize: size, fontStyle: style, align: tAlign,
                            textDecoration: tDecoration
                              };

    setTimerLabelBlock({...timerLabelBlock, attrs: updatedAttrs});

    //legacy if style is an array we need to flatten it to a string
    if (Array.isArray(style)) style = style.join(' ')

    if (props.timerLabelChange !== undefined) {
      props.timerLabelChange(activeSelection.attrs.id, 'fontFamily', fontName)  
      props.timerLabelChange(activeSelection.attrs.id, 'fontId', fontId);
      props.timerLabelChange(activeSelection.attrs.id, 'fontSize', size)  
      props.timerLabelChange(activeSelection.attrs.id, 'fontStyle', style)  
      props.timerLabelChange(activeSelection.attrs.id, 'textDecoration', tDecoration)  
      props.timerLabelChange(activeSelection.attrs.id, 'align', tAlign)  
    // props.returnUpdateSingle('fontWeight', fWeight);
  }
  
  }

const handleSegmentChange = (svg, pos, propName, value) => {
  const newData = EditSvg(svg, pos, propName, value);
  const mainId = activeSelection.attrs.id;

  handlePropChange('data', newData);
  props.returnUpdateTextPath(mainId, newData)

}

const handleDeleteSegment = (svg, pos) => {
  // console.log(svg);
  // console.log(DeleteSegment(svg, pos));

  const newData = DeleteSegment(svg, pos);
  const mainId = activeSelection.attrs.id;

  handlePropChange('data', newData);
  props.returnUpdateTextPath(mainId, newData)
}
const handleAddSegment = (svg) => {
  // we insert a simple line. User can change it later
  const newData = `${svg}l 100 0 `;
  const mainId = activeSelection.attrs.id;

  handlePropChange('data', newData);
  props.returnUpdateTextPath(mainId, newData)
}

const handleImageDatabindChange = (bindType, dataBindValue, _, weatherCollectionId) => {
  //weatherCollectionId can only have a value when binding an icon of the weather api

  handlePropChange('dataBindType', bindType);

  const updatedAttrs = {...activeSelection.attrs, dataBindType:bindType, imageUrl: dataBindValue};
  setActiveSelection({...activeSelection, attrs: updatedAttrs});

  if (bindType === 'databind') {
    //handlePropChange('dataBindValue', dataBindValue);
    if (props.sampleData !== undefined && Object.keys(props.sampleData).length > 0) {
        
      let value = ""
      if (dataBindValue.includes('.')) {
        const parts = dataBindValue.split('.')
        value = props.sampleData
        for (const p of parts) {
          value = value[p]
        }
      }
      else value = props.sampleData[dataBindValue]

      props.returnUpdateImageBindings(bindType, value, dataBindValue);
      //props.returnUpdateImageBindings(bindType, props.sampleData[dataBindValue], dataBindValue);
    }
  }
else if (bindType === 'weatherIcon') {
  props.returnUpdateImageBindings(bindType, dataBindValue, weatherCollectionId.toString());
  }
else 
  props.returnUpdateImageBindings(bindType, dataBindValue);

  //console.log(updatedAttrs);
}
const handleImageCanvasDatabindChange = (bindType, dataBindValue) => {

  //console.log(bindType, dataBindValue)
  const updatedSelection = {...activeSelection, dataBindType: bindType, imageUrl: dataBindValue };
  setActiveSelection(updatedSelection);

  if (dataBindValue && dataBindValue.length > 0) setRadioCanvasBackground('Image')
  else setRadioCanvasBackground('Color')



  props.returnUpdateCanvas(updatedSelection)

}

const handleTextDatabindChange = (bindType, dataBindValue, designTimeValue) => {
  handlePropChange('dataBindType', bindType);
  console.log(dataBindValue)


  let updatedAttrs = {...activeSelection.attrs, dataBindType:bindType, text: dataBindValue};
  if (bindType === 'url') {
    updatedAttrs = {...activeSelection.attrs, dataBindType:bindType, text: designTimeValue, 'dataBindValue': dataBindValue};
  }
  //console.log(updatedAttrs)
  setActiveSelection({...activeSelection, attrs: updatedAttrs});
  props.returnUpdateSingle('designTimeValue', '')


  if (bindType === 'databind') { 
    handlePropChange('dataBindValue', dataBindValue);
    if (props.sampleData !== undefined && Object.keys(props.sampleData).length > 0) {
      if (dataBindValue.includes('.')) {
        const parts = dataBindValue.split('.')
        let value = props.sampleData
        for (const p of parts) {
          value = value[p]
        }
        handlePropChange('textRaw', value)
      }
      else handlePropChange('textRaw', props.sampleData[dataBindValue]);
    }
  }
  else if (bindType === 'forecasts') {
    if (dataBindValue === undefined) {handlePropChange('dataBindType', 'none'); return;}

    const [section, forecastsDatabindValue] = dataBindValue.split('||')
    //console.log(props.sampleData)
    let txt = ''
    if (section === 'general') {
      txt = props.sampleData[props.weatherUnits].daily[0][forecastsDatabindValue]
    }
    if (section === 'temperature') {
      txt = props.sampleData[props.weatherUnits].daily[0].temp[forecastsDatabindValue]
    }
    if (section === 'feelsLike') {
      txt = props.sampleData[props.weatherUnits].daily[0].feels_like[forecastsDatabindValue]
    }
    if (section === 'weather') {
      txt = props.sampleData[props.weatherUnits].daily[0].weather[0][forecastsDatabindValue]
    }
    handlePropChange('dataBindValue', dataBindValue);
    handlePropChange('textRaw', txt.toString());
  }
  else if (bindType === 'url') { 
    //console.log('entrato')
    props.returnUpdateSingle('dataBindValue', dataBindValue)
    props.returnUpdateSingle('text', designTimeValue)
    props.returnUpdateSingle('designTimeValue', designTimeValue)

    //handlePropChange('dataBindValue', dataBindValue);
    //handlePropChange('textRaw', designTimeValue);
  }
  else if (bindType === 'none') { 
    //console.log('entrato')
    handlePropChange('dataBindValue', dataBindValue);
    handlePropChange('textRaw', dataBindValue);
  }
  else handlePropChange('textRaw', dataBindValue);
}

const handleTextFunctionsChange = (transforms) => {
  //let updatedAttrs = {...activeSelection.attrs, text: `${transforms.prefix}${activeSelection.attrs.textRaw}${transforms.suffix}` };
  //const updatedText = designTimeApplyFunctions(activeSelection.attrs.textRaw, transforms.functions);

  let workingText = activeSelection.attrs.textRaw;
  if (activeSelection.attrs.designTimeValue && activeSelection.attrs.designTimeValue.length > 0) workingText = activeSelection.attrs.designTimeValue
  const updatedText = designTimeApplyFunctions(workingText, transforms.functions);

  handlePropChange('textTransforms', transforms);
  handlePropChange('text', `${transforms.prefix}${updatedText}${transforms.suffix}`)
}
const designTimeApplyFunctions = (txt, functions) => {
  let result = txt
  let newText = txt
  for (const f of functions) {
    switch (f.functionName) {
      case "celsiusToFahrenheit":
        try {
          newText = (result * 9/5 + 32).toString()
          if (!isNaN(newText)) result = newText
        }
        catch(e) {}
      break;
      default:
      break;
    }
  }
  return result;
}


const handleConditionalPropertiesChange = (conditions) => {
  console.log(conditions)
  handlePropChange('visibilityConditions', conditions);
}
const handleAnimationChange = (animations) => {
  //console.log(animations)
  handlePropChange('animation', animations);
}

const handleGradientChange = (gradientProps) => {
 const colorsStops = [];
 const delta = 1 / (gradientProps.colors.length - 1);
 let currentWidth = activeSelection.attrs.width;
 let currentHeight = activeSelection.attrs.height;

 if (currentWidth === undefined) {
  // console.log(activeSelection.attrs.lionBoundWidth);
  // const [left, top, right, bottom] = getBounds(activeSelection.attrs.data);
  currentWidth = activeSelection.attrs.lionBoundWidth;
  currentHeight = activeSelection.attrs.lionBoundHeight;
 
 }

 gradientProps.colors.forEach((c, index) => {colorsStops.push(index * delta); colorsStops.push(c)});

    // handlePropChange('fill', '');
    
  if (gradientProps.gradientType === 'linear') {
    handlePropChange('fillLinearGradientStartPoint', { x: 0, y: 0 });
    switch(gradientProps.direction) {
      case "horizontal":
        handlePropChange('fillLinearGradientEndPoint', { x: currentWidth, y: 0 });
        break;
      case "vertical":
        handlePropChange('fillLinearGradientEndPoint', { x: 0, y: currentHeight });
        break;
      case "diagonal":
        handlePropChange('fillLinearGradientEndPoint', { x: currentWidth, y: currentHeight });
        break;
      default:
        handlePropChange('fillLinearGradientEndPoint', { x: 0, y: 0 });
        break;
    }
    // handlePropChange('fillLinearGradientColorStops', [0, '#f0f', 0.5, 'yellow', 1, '#00f']);
    handlePropChange('fillLinearGradientColorStops', colorsStops);
    handlePropChange('gradientDirection', gradientProps.direction);

  }
  else {
    handlePropChange('fillRadialGradientStartPoint', { x: gradientProps.startX, y: gradientProps.startY });
    handlePropChange('fillRadialGradientStartRadius', 0);
    handlePropChange('fillRadialGradientEndPoint', { x: gradientProps.startX, y: gradientProps.startY });
    handlePropChange('fillRadialGradientEndRadius', gradientProps.radius);
    handlePropChange('fillRadialGradientColorStops', colorsStops);
  }

    
// console.log(colorsStops)
}
const updateGradientStartEndPoints = () => {
  console.log('entrato')
  if (activeSelection.attrs.fillMode === 'gradient') {
    if (activeSelection.attrs.gradientType === 'linear') {
      const currentWidth = activeSelection.attrs.width;
      const currentHeight = activeSelection.attrs.height;
      switch(activeSelection.gradientDirection) {
        case "horizontal":
          handlePropChange('fillLinearGradientEndPoint', { x: currentWidth, y: 0 });
          break;
        case "vertical":
          handlePropChange('fillLinearGradientEndPoint', { x: 0, y: currentHeight });
          break;
        case "diagonal":
          handlePropChange('fillLinearGradientEndPoint', { x: currentWidth, y: currentHeight });
          break;
        default:
          handlePropChange('fillLinearGradientEndPoint', { x: 0, y: 0 });
          break;
      }
    }
  }

}


const handleMoveBox = (direction) => {
  if (activeSelectionType === 'single') {
    if (props.onBlockPositionChange !== undefined) props.onBlockPositionChange(direction);
  }
}
const handle2dEffectsChange = (effects) => {
  /*
  let updatedAttrs = {...activeSelection.attrs, rotation: effects.rotation, skewX: effects.skewX, skewY: effects.skewY};
  console.log(updatedAttrs)
  setActiveSelection({...activeSelection, attrs: updatedAttrs});
*/
  props.returnUpdateMultipleProps({rotation: effects.rotation, skewX: effects.skewX, skewY: effects.skewY})
  //handlePropChange('rotation', effects.rotation);
  //handlePropChange('skewX', effects.skewX);
  //handlePropChange('skewY', effects.skewY);
  
  // CODE BELOW IS TO ALLOW ROTATION AROUND ANY POINT
  // this is useful for animations only, not for edits
  // therefore this is not active here.
  // TODO: if we wanted to allow this here there is an issue when de-selecting and re-selecting back a block
  // we should resent the rotationOrigin back to the Konva default (top,left) otherwise Konva will "move" the object
 
  /*
  const rotationOrigin = {x: activeSelection.attrs.rotationOriginX === undefined ? activeSelection.attrs.x : activeSelection.attrs.rotationOriginX, y:activeSelection.attrs.rotationOriginY === undefined ? activeSelection.attrs.y : activeSelection.attrs.rotationOriginY}
  const newRotationPos = rotateAroundPoint(activeSelection.attrs.x, activeSelection.attrs.y, effects.rotation, rotationOrigin)
  console.log(newRotationPos)
  handlePropChange('x', newRotationPos.left);
  handlePropChange('y', newRotationPos.top);
  handlePropChange('rotation', newRotationPos.deltaDegrees);
  */
}

const handleAddRotationViewFinder = () => {
  if (props.onAddRotationViewFinder !== undefined) {
    props.onAddRotationViewFinder(activeSelection.attrs.x, activeSelection.attrs.y)
  }
}
const rotateAroundPoint = (shapeX, shapeY, angleDegrees, point) => {
  // sin + cos require radians
  const angleRadians = angleDegrees * Math.PI / 180; 
   console.log(shapeX)
  const x =
    point.x +
    (shapeX - point.x) * Math.cos(angleRadians) -
    (shapeY - point.y) * Math.sin(angleRadians);
  const y =
    point.y +
    (shapeX - point.x) * Math.sin(angleRadians) +
    (shapeY - point.y) * Math.cos(angleRadians);
    
  return {left: x, top: y, deltaDegrees: angleDegrees};
 
  // rotate the shape in place around its natural rotation point 
  // shape.rotation(shape.rotation() + angleDegrees); 
}
const handleTimerLabelChange = (e) => {
  if (props.timerLabelChange !== undefined) {
    props.timerLabelChange(activeSelection.attrs.id, 'show', e.target.checked)  
  }
  handlePropChange('showLabel', e.target.checked);
}
const handleTimerRingChange = (e) => {
  if (props.timerLabelChange !== undefined) {
    props.timerRingChange(activeSelection.attrs.id, 'show', e.target.checked)  
  }
  handlePropChange('showRing', e.target.checked);

}
const handleAllTimerLabelsChange = (val) => {
  if (props.timerLabelChange !== undefined) {
    props.timerLabelChange(activeSelection.attrs.id, 'showAll', val)  
  }
  handlePropChange('showLabel', val);
}
const handleAllTimerRingsChange = (val) => {
  if (props.timerLabelChange !== undefined) {
    props.timerRingChange(activeSelection.attrs.id, 'showAll', val)  
  }
  handlePropChange('showRing', val);
}
const handleTimePartChange = (e) => {
  handlePropChange('timePart', e.target.value)
  if (props.timerLabelChange !== undefined) {
    props.timerLabelChange(activeSelection.attrs.id, 'timePart', e.target.value)  
    props.timerLabelChange(activeSelection.attrs.id, 'dataBindValue', `label${e.target.value[0].toUpperCase() + e.target.value.slice(1)}`)  
  }
}
const handleMinMaxTimePartChange = (propName, e) => {
  handlePropChange(propName, e.target.value)
  /*
  if (props.timerLabelChange !== undefined) {
    props.timerLabelChange(activeSelection.attrs.id, 'timePart', e.target.value)  
    props.timerLabelChange(activeSelection.attrs.id, 'dataBindValue', `label${e.target.value[0].toUpperCase() + e.target.value.slice(1)}`)  
  }
  */
}

const handleTimeBlockChange = (propName, propValue) => {
  handlePropChange(propName, propValue)
  if (props.timerLabelChange !== undefined) {
    props.timerLabelChange(activeSelection.attrs.id, propName, propValue)  
  }
}
const handleCanvasBackgroundChange = (e) => {
  const val = e.target.value;
  console.log(val)
  setRadioCanvasBackground(val)
  if (val === 'Color') {
    //we need to force a color selection (for compatibility with the old UI without the radio component)
    //bad practice - we need to change the colkor twice to make sure to have a refresh on the screen (it is important that #010101 is different than activeSelection.backgroundColor)
    handleCanvasPropChange('backgroundColor', '#010101')
    handleCanvasPropChange('backgroundColor', activeSelection.backgroundColor)
  }
}

const getDatabindNames = () => {
  // function to use with DatabindingSelector
  // it calculates the right values to pass to the dataBindTypes prop of DatabindingSelector
  if (snippetTypeId === 9 || snippetTypeId === 12 || snippetTypeId === 14) return ['none', 'url']
  if (snippetTypeId === 18) return ['none', 'url', 'forecasts']
  return ['none', 'url', 'databind']


}
const getDatabindNamesImageBlock = () => {
  // function to use with DatabindingSelector
  // it calculates the right values to pass to the dataBindTypes prop of DatabindingSelector

  //dataBindTypes={snippetTypeId === 12 ? ['none'] : ['none', 'databind']}

  if (snippetTypeId === 9 || snippetTypeId === 12 || snippetTypeId === 14) return ['none']
  if (snippetTypeId === 18) return ['none', 'weatherIcon']

  return ['none', 'databind']


}
const canSeeAnimationManager = () => {
  // first checks..
  if (activeSelection.attrs === undefined) return false;
  if (props.numDefinedAnimations && props.numDefinedAnimations.isOneToOne) return false;

  let canSee = activeSelection.attrs.subType !== 'Timer' && activeSelection.attrs.subType !== 'TimerSeparator'

  if (canSee) { //if first checks are passed, we have other checks
    if (activeSelection.className === "Image") {
      if (activeSelection.attrs.dataBindType !== "databind") canSee = false;

      //if there are other blocks with animations
      if (props.numDefinedAnimations.Others > 0) canSee = false;
      if (props.numDefinedAnimations.Image > 0) {
        //it means that there is 1 block with an animation applied
        //if that block is the current block then ok we can see the animation, otherwise we can't
  
        //console.log(activeSelection.attrs.animation)
        if (activeSelection.attrs.animation === undefined || Object.keys(activeSelection.attrs.animation).length < 2) canSee = false
        
      }
    }
    else {
      //if this is not an image block we need to check if there are image blocks with animations
      if (props.numDefinedAnimations.Image > 0) canSee = false;
    }
  }

  return canSee;
}

  return <>
  <Stack>
  { /* 0 objects selected */ 
    props.objects.length === 0 && <> 
      <div className='flex flex-col items-center justify-center'>
        <div className='mt-16 text-center font-medium font-poppins'>{getStartSentence()}</div>
      </div>
                </>
    }

  { /* canvas selected */ 
    props.objects.length === 1 && props.objects[0].className === 'Canvas' && <>
      <Chip sx={{backgroundColor: teal[500], color:'#fff', width: 80, mb:1}} label={activeSelection.className} /> 
          <Grid2 container spacing={2} sx={{width: '100%'}} >
            <Grid2 xs={6}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Width:</Typography>
                <TextField sx={{width: '120px'}}
                      value={activeSelection.width}
                      onChange={(e) => handleCanvasPropChange('width', TryParseIntDefault(e.target.value, ''))}
                      size="small"
                    />
              </Stack>

            </Grid2>
            <Grid2 xs={6}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Height:</Typography>
                <TextField sx={{width: '120px'}}
                      value={activeSelection.height}
                      onChange={(e) => handleCanvasPropChange('height', TryParseIntDefault(e.target.value, ''))}
                      size="small"
                    />
              </Stack>
              
            </Grid2>
            <Grid2 xs={12}>
              <RadioGroup
                        row
                        value={radioCanvasBackground}
                        onChange={handleCanvasBackgroundChange}
                      >
                        <FormControlLabel value="Color" control={<Radio sx={{'&.Mui-checked': {color: ccColorTeal} }} />} label="Background color" />
                        <FormControlLabel value="Image" control={<Radio sx={{'&.Mui-checked': {color: ccColorTeal} }} />} label="Background image" />
              </RadioGroup>

            </Grid2>
            {radioCanvasBackground === 'Color' &&
            <Grid2 xs={12}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Background color:</Typography>
                  <LionColorPicker color={activeSelection.backgroundColor} onChange={(color) => handleCanvasPropChange('backgroundColor', color)} />
              </Stack>
            </Grid2>
            }
            {radioCanvasBackground === 'Image' &&
            <Grid2 xs={12}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', width:'100%'}}>
                  <Typography>Background Image:</Typography>
                  <DatabindingSelector dataBindValue={activeSelection.imageUrl === undefined ? '' : activeSelection.imageUrl}
                              sampleData={props.sampleData}
                              label=''
                              uploaderMode={props.snippetTypeId === 12}
                              dataBindType={(activeSelection.dataBindType === undefined && activeSelection.databindType === undefined) ? '' : activeSelection.dataBindType ?? activeSelection.databindType}
                              dataBindTypes={props.snippetTypeId === 14 ? ['none', 'databind', 's3'] : ['none', 'databind']}
                            onChange={handleImageCanvasDatabindChange} />
              </Stack>
            </Grid2>
            }
            {props.canvasBackgroundImageShowAnimationSelector !== undefined &&
            props.canvasBackgroundImageShowAnimationSelector &&
            <Grid2 xs={12}>
              <Stack>
                <Alert severity="info">
                  <AlertTitle>Found animated image</AlertTitle>
                  <Stack>
                    <Typography>Would you like to render an animation?</Typography>
                    <FormControl>
                      <RadioGroup row
                        name="radio-backgroundImage-animation"
                        value={activeSelection.isImageAnimated === undefined ? 0 : (activeSelection.isImageAnimated ? 1 : 0)}
                        onChange={(e) => handleCanvasPropChange('isImageAnimated', e.target.value === '1')}
                        >
                        <FormControlLabel value={1} control={<Radio />} label="Yes" />
                        <FormControlLabel value={0} control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Stack>
                  
                </Alert>
              </Stack>
            </Grid2>            
            }
          </Grid2>


          </>
    }
    

    { /* 1 object selected */ 
    props.objects.length === 1 && props.objects[0].className !== 'Canvas' && <>
    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center', mb:1}}>
      <Typography>Type:</Typography>
      <Chip sx={{backgroundColor: teal[500], color:'#fff'}} label={(activeSelection.attrs === undefined || activeSelection.attrs.subType === undefined) ? activeSelection.className : activeSelection.attrs.subType} />
      <Stack direction='row' spacing={0} divider={<Divider orientation="vertical" flexItem />}>
        <Tooltip title='Move to top' placement='top'>
          <IconButton variant="contained" onClick={() => handleMoveBox('top')} >
            <Iconify  icon={lionIcons.Icon_Actions_MoveTop}  />
          </IconButton>
        </Tooltip>
        <Tooltip title='Move up' placement='top'>
          <IconButton variant="contained" onClick={() => handleMoveBox('up')} >
              <Iconify  icon={lionIcons.Icon_Actions_MoveUp}  />
          </IconButton>
        </Tooltip>
        <Tooltip title='Move to bottom' placement='top'>
          <IconButton variant="contained" onClick={() => handleMoveBox('bottom')} >
              <Iconify  icon={lionIcons.Icon_Actions_MoveBottom}  />
          </IconButton>
        </Tooltip>
        <Tooltip title='Move down' placement='top'>
          <IconButton variant="contained" onClick={() => handleMoveBox('down')} >
              <Iconify  icon={lionIcons.Icon_Actions_MoveDown}  />
          </IconButton>
        </Tooltip>
      </Stack>
    </Stack>

    {activeSelection.attrs !== undefined && activeSelection.attrs.subType === 'Timer' && activeSelection.attrs.timePart !== 'sentence' && <div className=' flex flex-col mt-1 mb-1 pr-3'>
      <FormControl sx={{width: '100%'}}>
        <InputLabel id="time-part-label">Time Part</InputLabel>
            <Select size='small' 
                    labelId='time-part-label'
                    label='Time Part'
                    value={activeSelection.attrs === undefined || activeSelection.attrs.timePart === undefined ? 'seconds' : activeSelection.attrs.timePart}
                    onChange={handleTimePartChange}
                    >
                      <MenuItem value={'days'}>Days</MenuItem>
                      <MenuItem value={'hours'}>Hours</MenuItem>                                
                      <MenuItem value={'minutes'}>Minutes</MenuItem>
                      <MenuItem value={'seconds'}>Seconds</MenuItem>
                  </Select>
        </FormControl>
        <div className='flex flex-row mt-2 items-center gap-x-1'>
          <FormGroup>
            <FormControlLabel control={<Switch checked={activeSelection.attrs.showLabel} onChange={handleTimerLabelChange}  />} label="Show Label" />
          </FormGroup>
          <CcActionButtonOutlined size="small" onClick={() => handleAllTimerLabelsChange(true)} >Show all labels</CcActionButtonOutlined>
          <CcActionButtonOutlined size="small" onClick={() => handleAllTimerLabelsChange(false)} >Hide all labels</CcActionButtonOutlined>
        </div>
        <div className='flex flex-row mt-2 items-center gap-x-1'>
          <FormGroup>
            <FormControlLabel control={<Switch checked={activeSelection.attrs.showRing} onChange={handleTimerRingChange}  />} label="Show Ring" />
          </FormGroup>
          <CcActionButtonOutlined size="small" onClick={() => handleAllTimerRingsChange(true)} >Show all rings</CcActionButtonOutlined>
          <CcActionButtonOutlined size="small" onClick={() => handleAllTimerRingsChange(false)} >Hide all rings</CcActionButtonOutlined>
        </div>
    </div>
    }

{activeSelection.attrs !== undefined && activeSelection.attrs.subType === 'Timer' && activeSelection.attrs.timePart === 'sentence' && <div className=' flex flex-col gap-3 mt-1 mb-1 pr-3'>
      <FormControl sx={{width: '100%'}}>
        <InputLabel sx={{background: 'white', pr:1}} id="time-part-label">Max time part</InputLabel>
            <Select size='small' 
                    labelId='time-part-label'
                    label='Time Part'
                    value={activeSelection.attrs === undefined || activeSelection.attrs.maxTimePart === undefined ? 'weeks' : activeSelection.attrs.maxTimePart}
                    onChange={(e) => handleMinMaxTimePartChange('maxTimePart', e)}
                    >
                      <MenuItem value={'years'}>Years</MenuItem>
                      <MenuItem value={'months'}>Months</MenuItem>
                      <MenuItem value={'weeks'}>Weeks</MenuItem>
                      <MenuItem value={'days'}>Days</MenuItem>
                      <MenuItem value={'hours'}>Hours</MenuItem>                                
                      <MenuItem value={'minutes'}>Minutes</MenuItem>
                      <MenuItem value={'seconds'}>Seconds</MenuItem>
                  </Select>
        </FormControl>
        <FormControl sx={{width: '100%'}}>
        <InputLabel sx={{background: 'white', pr:1}} id="time-part-label">Min time part</InputLabel>
            <Select size='small' 
                    labelId='time-part-label'
                    label='Time Part'
                    value={activeSelection.attrs === undefined || activeSelection.attrs.minTimePart === undefined ? 'seconds' : activeSelection.attrs.minTimePart}
                    onChange={(e) => handleMinMaxTimePartChange('minTimePart', e)}
                    >
                      <MenuItem value={'years'}>Years</MenuItem>
                      <MenuItem value={'months'}>Months</MenuItem>
                      <MenuItem value={'weeks'}>Weeks</MenuItem>
                      <MenuItem value={'days'}>Days</MenuItem>
                      <MenuItem value={'hours'}>Hours</MenuItem>                                
                      <MenuItem value={'minutes'}>Minutes</MenuItem>
                      <MenuItem value={'seconds'}>Seconds</MenuItem>
                  </Select>
        </FormControl>
        <div className='flex flex-row gap-1 items-center'>
          <Typography>Separator:</Typography>
          <TextField sx={{width: '80px'}}
                value={(activeSelection.attrs === undefined || activeSelection.attrs.timePartSeparator === undefined) ? ', ' : activeSelection.attrs.timePartSeparator}
                onChange={(e) => handlePropChange('timePartSeparator', e.target.value)}
                size="small"
              />
          <div className=' grow'></div>
          <FormGroup>
            <FormControlLabel control={<Switch checked={(activeSelection.attrs === undefined || activeSelection.attrs.digitsToWord === undefined) ? false : activeSelection.attrs.digitsToWord} 
                              onChange={(e) => handlePropChange('digitsToWord', e.target.checked)}  />} label="Digits to words" />
          </FormGroup>
         </div>

    </div>
    }


        <Grid2 container spacing={2} sx={{width: '100%'}}>
            <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>{(activeSelection.className === 'Circle' || activeSelection.className === 'Ellipse') ? 'CenterY' : 'Top'}:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.y}
                      onChange={(e) => handlePropChange('y', TryParseIntDefault(e.target.value, 0))}
                      size="small"
                    />
              </Stack>

            </Grid2>
            <Grid2 xs={2} />
            <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>{(activeSelection.className === 'Circle' || activeSelection.className === 'Ellipse') ? 'CenterX' : 'Left'}:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.x}
                      onChange={(e) => handlePropChange('x', TryParseIntDefault(e.target.value, 0))}
                      size="small"
                    />
              </Stack>
              
            </Grid2>

            {activeSelection.attrs !== undefined && activeSelection.attrs.subType === 'Timer' && <>
                <Grid2 xs={5}>
                      <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography>Width:</Typography>
                        <TextField sx={{width: '80px'}}
                              value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.width}
                              onChange={(e) => handleTimeBlockChange('width', TryParseIntDefault(e.target.value, 0))}
                              //onChange={(e) => handleTimeBlockChange('width', parseInt(e.target.value, 10))}
                              size="small"
                            />
                      </Stack>

                </Grid2>
                <Grid2 xs={2} />
                <Grid2 xs={5}>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography>Height:</Typography>
                    <TextField sx={{width: '80px'}}
                          value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.height}
                          onChange={(e) => handleTimeBlockChange('height', TryParseIntDefault(e.target.value, 0))}
                          size="small"
                        />
                  </Stack>        
                </Grid2>

                <Grid2 xs={12}>
              <FontSelectorNew returnCurrentFont={updateActiveSelectionWithCurrentFontInfo}
               currentFont={{ fontName: activeSelection.attrs.fontFamily,
                            fontId: activeSelection.attrs.fontId,
                             size: activeSelection.attrs.fontSize, 
                             style: activeSelection.attrs.fontStyle === undefined ? '' : activeSelection.attrs.fontStyle,
                             align: activeSelection.attrs.align === undefined ? 'left' : activeSelection.attrs.align,
                             textDecoration: activeSelection.attrs.textDecoration === undefined  ? '' : activeSelection.attrs.textDecoration,
                             }} />
                </Grid2>

            </>
            }


            {activeSelection.className === 'Circle' && <> 
            <Grid2 container spacing={2} sx={{width: '100%'}}>
              <Grid2 xs={5}>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Radius:</Typography>
                  <TextField sx={{width: '80px'}}
                        value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.radius}
                        onChange={(e) => handlePropChange('radius', TryParseIntDefault(e.target.value, 0))}
                        size="small"
                      />
                </Stack>

              </Grid2>
              <Grid2 xs={7} />
            </Grid2>
            </>            
            }

            {activeSelection.className === 'RegularPolygon' && <> 
            <Grid2 container spacing={2} sx={{width: '100%'}}>
              <Grid2 xs={5}>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Radius:</Typography>
                  <TextField sx={{width: '80px'}}
                        value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.radius}
                        onChange={(e) => handlePropChange('radius', TryParseIntDefault(e.target.value, 0))}
                        size="small"
                      />
                </Stack>
              </Grid2>
              <Grid2 xs={2} />
              <Grid2 xs={5}>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Num sides:</Typography>
                  <TextField sx={{width: '80px'}}
                        value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.sides}
                        onChange={(e) => handlePropChange('sides', TryParseIntDefault(e.target.value, 1))}
                        size="small"
                      />
                </Stack>
              </Grid2>
            </Grid2>
            </>            
            }

            {activeSelection.className === 'Ellipse' && <> 
            <Grid2 container spacing={2} sx={{width: '100%'}}>
              <Grid2 xs={5}>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Rx:</Typography>
                  <TextField sx={{width: '80px'}}
                        value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.radiusX}
                        onChange={(e) => handlePropChange('radiusX', TryParseIntDefault(e.target.value, 0))}
                        size="small"
                      />
                </Stack>
              </Grid2>
              <Grid2 xs={2} />
              <Grid2 xs={5}>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Ry:</Typography>
                  <TextField sx={{width: '80px'}}
                        value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.radiusY}
                        onChange={(e) => handlePropChange('radiusY', TryParseIntDefault(e.target.value, 0))}
                        size="small"
                      />
                </Stack>
              </Grid2>
            </Grid2>
            </>            
            }

            {(activeSelection.className === 'Rect') && <>
            <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Width:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.width}
                      onChange={(e) => handlePropChange('width', TryParseIntDefault(e.target.value, 0))}
                      size="small"
                    />
              </Stack>

            </Grid2>
            <Grid2 xs={2} />
            <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Height:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.height}
                      onChange={(e) => handlePropChange('height', TryParseIntDefault(e.target.value, 0))}
                      size="small"
                    />
              </Stack>
              
            </Grid2>

            </>}
            {activeSelection.className === 'TextPath' && <>
                      <Grid2 xs={12}>
                        <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography>Text:</Typography>
                          <Stack direction='row' spacing={0} sx={{display: 'flex', alignItems: 'center', width: '100%'}}>
                            <TextField sx={{width: '100%'}}
                                  value={activeSelection.attrs.textRaw}
                                  onChange={(e) => handlePropChange('textRaw', e.target.value)}
                                  disabled={activeSelection.attrs.dataBindType !== 'none'}
                                  size="small"
                                />
                            <DatabindingSelector dataBindValue={activeSelection.attrs.textRaw}
                                sampleData={props.sampleData}
                                noPreview
                                dataBindType={activeSelection.attrs.dataBindType}
                                dataBindTypes={['none', 'url', 'databind']}
                                onChange={handleTextDatabindChange} />
                          </Stack>
                        </Stack>
                      </Grid2>
                      <Grid2 xs={12}>
                        <FontSelectorNew returnCurrentFont={updateActiveSelectionWithCurrentFontInfo}
                        currentFont={{ fontName: activeSelection.attrs.fontFamily,
                                      fontId: activeSelection.attrs.fontId,
                                      size: activeSelection.attrs.fontSize, 
                                      style: activeSelection.attrs.fontStyle === undefined ? '' : activeSelection.attrs.fontStyle,
                                      align: activeSelection.attrs.align === undefined ? 'left' : activeSelection.attrs.align,
                                      textDecoration: activeSelection.attrs.textDecoration === undefined  ? '' : activeSelection.attrs.textDecoration,
                                      }} />
                      </Grid2>
                      </>
             }
      {activeSelection.className === 'Text' && (activeSelection && activeSelection.attrs.subType !== 'Timer') && <>
            <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Width:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.width}
                      onChange={(e) => handlePropChange('width', TryParseIntDefault(e.target.value, 0))}
                      size="small"
                    />
              </Stack>

            </Grid2>
            <Grid2 xs={2} />
            <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Height:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.height}
                      onChange={(e) => handlePropChange('height', TryParseIntDefault(e.target.value, 0))}
                      size="small"
                    />
              </Stack>        
            </Grid2>
            <Grid2 xs={12}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Line Height:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined || activeSelection.attrs.lineHeight === undefined? 1 : activeSelection.attrs.lineHeight}
                      onChange={(e) => handlePropChange('lineHeight', e.target.value)}
                      size="small"
                    />
              </Stack>              
            </Grid2>
              {activeSelection.attrs.subType === 'TimerSeparator' &&
                <Grid2 xs={12}>
                  <FormControl sx={{width: '100%'}}>
                    <InputLabel id="time-part-label">Separator</InputLabel>
                        <Select size='small' 
                                labelId='time-part-separator'
                                label='Separator'
                                value={activeSelection.attrs === undefined ? ':' : activeSelection.attrs.text}
                                onChange={(e) => handlePropChange('text', e.target.value)}
                                >
                                  <MenuItem value={':'}>:</MenuItem>
                                  <MenuItem value={'-'}>-</MenuItem>                                
                                  <MenuItem value={'.'}>.</MenuItem>
                              </Select>
                    </FormControl>
                </Grid2>
              }
              {activeSelection.attrs.subType === undefined && 
              <Grid2 xs={12}>
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Text:</Typography>
                  <Stack direction='row' spacing={0} sx={{display: 'flex', alignItems: 'center', width:'100%'}}>
                  <TextField sx={{width: '100%'}}
                        value={activeSelection.attrs.textRaw}
                        onChange={(e) => handlePropChange('textRaw', e.target.value)}
                        disabled={activeSelection.attrs.dataBindType !== 'none'}
                        size="small"
                      />
                    <DatabindingSelector dataBindValue={activeSelection.attrs.dataBindValue}
                        designTimeValue={(activeSelection.attrs.designTimeValue && activeSelection.attrs.designTimeValue.length > 0) ? activeSelection.attrs.designTimeValue : activeSelection.attrs.textRaw}
                        sampleData={props.sampleData}
                        noPreview
                        dataBindType={activeSelection.attrs.dataBindType}
                        //dataBindTypes={(snippetTypeId === 9 || snippetTypeId === 14) ? ['none', 'url'] : ['none', 'url', 'databind']}
                        dataBindTypes={getDatabindNames()}
                        weatherUnits={props.weatherUnits}
                        onChange={handleTextDatabindChange} />
                  </Stack>
                </Stack>
              </Grid2>
              }
              {activeSelection.attrs.subType === 'urlBoundBlock' && 
              <Grid2 xs={12}>
                <div className='flex flex-col gap-2 border p-2 bg-slate-100 border-gray-200 rounded-lg shadow'>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <div className='font-semibold text-ccColorTeal'>Parameter:</div>
                      <TextField sx={{width: 200}}
                          value={activeSelection.attrs.dataBindValue}
                          onChange={(e) => handleTextDatabindChange('url', e.target.value, activeSelection.attrs.textRaw)}
                          size="small"
                        />
                      <InfoToolTip 
                        placement='left'
                        headLine='URL parameter value'
                        message="Define the name of the URL parameter which contains the data for this block"
                      />

                  </Stack>
                  <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                    <div className='font-semibold text-ccColorTeal'>Preview content:</div>
                      <TextField sx={{width: 200}}
                          //value={activeSelection.attrs.textRaw.replace('param(', '').slice(0, -1)}
                          value={activeSelection.attrs.textRaw}
                          onChange={(e) => handlePropChange('textRaw', e.target.value)}
                          size="small"
                        />
                      <InfoToolTip 
                        placement='left'
                        headLine='Preview content'
                        message="This value is to be used in the design lab ONLY. It won't affect live tags"
                      />
                  </Stack>
                </div>
              </Grid2>
              }
            
              {(activeSelection.attrs.subType === undefined || activeSelection.attrs.subType !== 'TimerSeparator') && 
                <Grid2 xs={12}>
                  <TextFunctionsManager onTextFunctionsChange={handleTextFunctionsChange}
                  currentTransforms={activeSelection.attrs.textTransforms}
                    />
                </Grid2>
              }
            
            <Grid2 xs={12}>
              <FontSelectorNew returnCurrentFont={updateActiveSelectionWithCurrentFontInfo}
              showAutoSize
               currentFont={{ fontName: activeSelection.attrs.fontFamily,
                              fontId: activeSelection.attrs.fontId,
                             size: activeSelection.attrs.fontSize, 
                             style: activeSelection.attrs.fontStyle === undefined ? '' : activeSelection.attrs.fontStyle,
                             align: activeSelection.attrs.align === undefined ? 'left' : activeSelection.attrs.align,
                             textDecoration: activeSelection.attrs.textDecoration === undefined  ? '' : activeSelection.attrs.textDecoration,
                             fontIsAutoSize: activeSelection.attrs.fontIsAutoSize === undefined ? false : activeSelection.attrs.fontIsAutoSize,
                             }} />
            </Grid2>

            </>
      }
      {activeSelection.className !== 'Image' && activeSelection.className !== 'Shape' && activeSelection.attrs !== undefined && <>
      <Paper variant='outlined' sx={{width: '100%'}}>
        <Grid2 xs={12}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Select size='small'
                    value={activeSelection.attrs === undefined || activeSelection.attrs.fillMode === undefined ? 'solid' : activeSelection.attrs.fillMode}
                    onChange={(e) => handlePropChange('fillMode', e.target.value)}
                    >
                      <MenuItem value={'solid'}>Font color</MenuItem>                                
                      <MenuItem value={'gradient'}>Font gradient</MenuItem>                                
                  </Select>
                  {activeSelection.attrs !== undefined && (activeSelection.attrs.fillMode === 'solid' || activeSelection.attrs.fillMode === undefined) &&
                  <LionColorPicker color={activeSelection.attrs === undefined ? '' : activeSelection.attrs.fill}      
                  onChange={(color) => handlePropChange('fill', color)}
                  />
                  }
                  {activeSelection.attrs !== undefined && activeSelection.attrs.fillMode === 'gradient' && <>
                  <FormControl>
                    <RadioGroup row
                      value={activeSelection.attrs.gradientType}
                      onChange={(e) => {
                                        if (e.target.value === 'linear') handlePropChange('fillPriority','linear-gradient');
                                        if (e.target.value === 'radial') handlePropChange('fillPriority','radial-gradient');
                                        handlePropChange('gradientType', e.target.value);
                                       }}
                    >
                    <FormControlLabel value="linear" control={<Radio />} label="Linear" />
                    <FormControlLabel value="radial" control={<Radio />} label="Radial" />
                  </RadioGroup>
                </FormControl>
                  </>
                  }
              </Stack>
            </Grid2>
            {activeSelection.attrs !== undefined && activeSelection.attrs.fillMode === 'gradient' && activeSelection.attrs.gradientType === 'linear' && <Grid2 xs={12}>
              <LionLinearGradientPicker
              onChange={handleGradientChange}
              direction={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.gradientDirection}
              colorsStops={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.fillLinearGradientColorStops} />
              </Grid2>
              }
            {activeSelection.attrs !== undefined && activeSelection.attrs.fillMode === 'gradient' && activeSelection.attrs.gradientType === 'radial' && <Grid2 xs={12}>
              <LionRadialGradientPicker
              onChange={handleGradientChange}
              colorsStops={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.fillRadialGradientColorStops}
              startX={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.fillRadialGradientStartPointX}
              startY={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.fillRadialGradientStartPointY}
              radius={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.fillRadialGradientEndRadius}
              />
              </Grid2>
              }
      </Paper>
            <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Stroke:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.strokeWidth}
                      onChange={(e) => handlePropChange('strokeWidth', TryParseIntDefault(e.target.value, 0))}
                      size="small"
                    />
              </Stack>
            </Grid2>
            <Grid2 xs={7}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Color:</Typography>
                <LionColorPicker color={activeSelection.attrs === undefined ? '' : activeSelection.attrs.stroke} 
                                onChange={(color) => handlePropChange('stroke', color)}
                 />
              </Stack>              
            </Grid2>      
      </>}

      {activeSelection.className === 'Image' && <>
          <Grid2 xs={5}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Width:</Typography>
                <TextField sx={{width: '80px'}}
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.width}
                      onChange={(e) => handlePropChange('width', TryParseIntDefault(e.target.value, ''))}
                      size="small"
                    />
              </Stack>

            </Grid2>
          <Grid2 xs={2} />
          <Grid2 xs={5}>
            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
              <Typography>Height:</Typography>
              <TextField sx={{width: '80px'}}
                    value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.height}
                    onChange={(e) => handlePropChange('height', TryParseIntDefault(e.target.value, ''))}
                    size="small"
                  />
            </Stack>              
          </Grid2>
        <Grid2 xs={12}>
          <DatabindingSelector 
                              //dataBindValue={activeSelection.attrs.dataBindValue}
                              dataBindValue={activeSelection.attrs.imageUrl}
                              sampleData={props.sampleData}
                              dataBindType={activeSelection.attrs.dataBindType}
                            //dataBindTypes={['none', 'imgLibrary', 'databind']}
                            //dataBindTypes={snippetTypeId === 12 ? ['none'] : ['none', 'databind']}
                            dataBindTypes={getDatabindNamesImageBlock()}
                            weatherIconsCollections={props.weatherIconsCollections}
                            weatherIconsCollectionId={props.weatherIconsCollectionId}
                            onChange={handleImageDatabindChange} />
        </Grid2>
        <Grid2 xs={12}>
                  <TextFunctionsManager onTextFunctionsChange={handleTextFunctionsChange}
                  currentTransforms={activeSelection.attrs.textTransforms}
                    />
                </Grid2>
       </>}
      {activeSelection.className === 'TextPath' && <>
          <Grid2 sx={{pb:0, pt:0}} xs={12}><Button color='secondary' onClick={() => handleAddSegment(activeSelection.attrs.data)}>Add Segment</Button></Grid2>
          <Box sx={{height: '400px', overflow: 'scroll'}}>
          {
              ParseSvg(activeSelection.attrs.data).map((seg, index) => {
                // console.log(seg);
                if (seg.typeCode === 'M') return <></>
                return  <Paper key={index} elevation={6} sx={{width: 'calc(100% - 15px)', m: '10px'}} >
                          <Grid2  xs={12}>
                          <FormControl  sx={{ m: 0, minWidth: 120 }} size="small">
                                      <Stack  spacing={1} >
                                        <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                          <Typography>Segment{index}</Typography>
                                          <Select
                                            labelId={`select-segment-type${index}`}
                                            id={`select-segment-type${index}`}
                                            value={seg.typeCode}
                                            label="Type"
                                            onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'typeCode', e.target.value)}
                                            >
                                              <MenuItem value={'l'}>Line</MenuItem>                                
                                              <MenuItem value={'a'}>Arc</MenuItem>                                
                                          </Select>
                                          { index > 1 &&
                                          <Box sx={{width: '100%'}} display="flex" justifyContent="flex-end" p={0.5} >
                                            <IconButton variant="contained" onClick={() => handleDeleteSegment(activeSelection.attrs.data, seg.pos)} >
                                              <Iconify  icon={lionIcons.Icon_Actions_Delete}  />
                                            </IconButton>
                                          </Box>
                                          }
                                        </Stack>

                                          <Stack direction='row' spacing={2} sx={{display: 'flex', alignItems: 'center'}}>                                          
                                          <Typography> To:  </Typography>
                                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                              <Typography>X:</Typography>
                                              <TextField sx={{width: '70px'}}
                                                    value={seg.endX}
                                                    onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'endX', e.target.value)}
                                                    size="small"
                                                  />
                                            </Stack>
                                            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                              <Typography>Y:</Typography>
                                              <TextField sx={{width: '70px'}}
                                                    value={seg.endY}
                                                    onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'endY', e.target.value)}
                                                    size="small"
                                                  />
                                            </Stack>
                                          </Stack>

                                        {
                                          seg.typeCode === 'a' && <>
                                                  <Stack direction='row' spacing={5} sx={{display: 'flex', alignItems: 'center'}}>                                          
                                                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                                      <Typography>Rx:</Typography>
                                                      <TextField sx={{width: '80px'}}
                                                            value={seg.rx}
                                                            onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'rx', e.target.value)}
                                                            size="small"
                                                          />
                                                    </Stack>
                                                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                                      <Typography>Ry:</Typography>
                                                      <TextField sx={{width: '80px'}}
                                                            value={seg.ry}
                                                            onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'ry', e.target.value)}
                                                            size="small"
                                                          />
                                                    </Stack>
                                                  </Stack>

                                                  <Stack direction='row' spacing={5} sx={{display: 'flex', alignItems: 'center'}}>                                          
                                                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                                      <Typography>XRotation:</Typography>
                                                      <TextField sx={{width: '60px'}}
                                                            value={seg.xRotation}
                                                            onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'xRotation', e.target.value)}
                                                            size="small"
                                                          />
                                                    </Stack>
                                                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                                      <Typography>ArcFlag:</Typography>
                                                      <TextField sx={{width: '60px'}}
                                                            value={seg.arcFlag}
                                                            onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'arcFlag', e.target.value)}
                                                            size="small"
                                                          />
                                                    </Stack>
                                                  </Stack>

                                                  <Stack direction='row' spacing={5} sx={{display: 'flex', alignItems: 'center'}}>                                          
                                                    <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                                                      <Typography>SweepFlag:</Typography>
                                                      <TextField sx={{width: '60px'}}
                                                            value={seg.sweepFlag}
                                                            onChange={(e) => handleSegmentChange(activeSelection.attrs.data, seg.pos, 'sweepFlag', e.target.value)}
                                                            size="small"
                                                          />
                                                    </Stack>
                                                  </Stack>

                                          </>                                       
                                        }
                                      </Stack>
                            </FormControl>        
                          </Grid2>
                        </Paper>
              })
          }
          </Box>


      </>}
      {activeSelection.attrs !== undefined && activeSelection.attrs.subType === 'Rating' && <>
        <Grid2 xs={6}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Icons:</Typography>
                <LionNumberInput size="small"
                          value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.numIcons}
                          minValue={1}
                          // increment={5}
                          onChange={(num) => handlePropChangeRatingBlock(activeSelection.attrs.svgPath, activeSelection.attrs.gapIcon, num, activeSelection.attrs.svgScale, 'numIcons', num)}
                          label='' />
              </Stack>

            </Grid2>
        <Grid2 xs={6}>
          <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
            <Typography>Gap:</Typography>
            <LionNumberInput size="small"
                      value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.gapIcon}
                      minValue={1}
                      // increment={5}
                      onChange={(num) => handlePropChangeRatingBlock(activeSelection.attrs.svgPath, num, activeSelection.attrs.numIcons, activeSelection.attrs.svgScale, 'gapIcon', num)}
                      label='' />
          </Stack>        
        </Grid2>
        <Grid2 xs={6}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Stroke:</Typography>
                <LionNumberInput size="small"
                          value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.svgStrokeWidth}
                          minValue={1}
                          // increment={5}
                          onChange={(num) => handlePropChange('svgStrokeWidth', num)}
                          // onChange={(num) => handlePropChangeRatingBlock(activeSelection.attrs.svgPath, num, activeSelection.attrs.numIcons, activeSelection.attrs.svgScale, 'gapIcon', num)}
                          label='' />
              </Stack>
          </Grid2>
          <Grid2 xs={6}>
            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
              <LionColorPicker color={activeSelection.attrs === undefined ? '' : activeSelection.attrs.stroke} 
                              onChange={(color) => handlePropChange('stroke', color)}
                />
            </Stack>              
          </Grid2>      
            <Grid2 xs={12}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Colours:</Typography>
                <LionColorPicker color={activeSelection.attrs === undefined ? '' : activeSelection.attrs.unratedColor} 
                                onChange={(color) => handlePropChange('unratedColor', color)}
                                label="Unrated"
                 />
                <LionColorPicker color={activeSelection.attrs === undefined ? '' : activeSelection.attrs.ratedColor} 
                                onChange={(color) => handlePropChange('ratedColor', color)}
                                label="Rated"
                 />
              </Stack>              
            </Grid2>
            <Grid2 xs={6}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Min value:</Typography>
                <LionNumberInput size="small"
                          value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.minValue}
                          minValue={1}
                          // increment={5}
                          onChange={(num) => handlePropChange('minValue', num)}
                          label='' />
              </Stack>

            </Grid2>
            <Grid2 xs={6}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Max value:</Typography>
                <LionNumberInput size="small"
                          value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.maxValue}
                          minValue={1}
                          // increment={5}
                          onChange={(num) => handlePropChange('maxValue', num)}
                          label='' />
              </Stack>        
            </Grid2>
            <Grid2 xs={6}>
              <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Scale:</Typography>
                <LionNumberInput size="small"
                          value={activeSelection.attrs === undefined ? 0 : activeSelection.attrs.svgScale}
                          minValue={1}
                          increment={.1}
                          onChange={(num) => handlePropChangeRatingBlock(activeSelection.attrs.svgPath, activeSelection.attrs.gapIcon, activeSelection.attrs.numIcons, num, 'svgScale', num)}
                          label='' />
              </Stack>
            </Grid2>
            <Grid2 xs={6} />

            <Grid2 xs={12}>
            <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Typography>Value:</Typography>
                <Stack direction='row' spacing={0} sx={{display: 'flex', alignItems: 'center', width:'100%'}}>
                  <TextField sx={{width: '100%'}}
                      value={activeSelection.attrs.textRaw}
                      onChange={(e) => handlePropChange('textRaw', e.target.value)}
                      disabled={activeSelection.attrs.dataBindType !== 'none'}
                      size="small"
                    />
                  <DatabindingSelector dataBindValue={activeSelection.attrs.textRaw}
                      sampleData={props.sampleData}
                      noPreview
                      dataBindType={activeSelection.attrs.dataBindType}
                      dataBindTypes={snippetTypeId === 9 ? ['none', 'url'] : ['none', 'url', 'databind']}
                      onChange={handleTextDatabindChange} />
                </Stack>
              </Stack>          

            </Grid2>

      </>}

      {activeSelection.attrs !== undefined && activeSelection.attrs.subType === 'Timer'&& activeSelection.attrs.showLabel && <Grid2 xs={12}>
      <div className='flex flex-col gap-2 rounded-md border border-gray-300 p-1'>
          <span className=' text-gray-500 text-sm'>Label</span>
          <FontSelectorNew returnCurrentFont={updateTimerLabelWithCurrentFontInfo}
               currentFont={{ fontName: timerLabelBlock === undefined ? 'Arial' : timerLabelBlock.attrs.fontFamily,
                              fontId: timerLabelBlock === undefined ? -1 : timerLabelBlock.attrs.fontId,
                             size: timerLabelBlock === undefined ? 0 : timerLabelBlock.attrs.fontSize, 
                             style: timerLabelBlock === undefined ? 'normal' : timerLabelBlock.attrs.fontStyle,
                             align: timerLabelBlock === undefined ? 'left' : timerLabelBlock.attrs.align,
                             textDecoration: timerLabelBlock === undefined  ? '' : timerLabelBlock.attrs.textDecoration,
                             }} />
            <div className='flex flex-row gap-x-4 items-end'>
              <LionColorPicker color={timerLabelBlock === undefined ? '' : timerLabelBlock.attrs.fill}      
                    onChange={(color) => props.timerLabelChange(activeSelection.attrs.id, 'fill', color)}
                />
              <div className='flex flex-col w-40'>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                  Vertical offset
                </div>
                <InputNumber
                  value={(timerLabelBlock === undefined || timerLabelBlock.attrs.ccOffsetY === undefined) ? 0 : timerLabelBlock.attrs.ccOffsetY}
                  min={-100}
                  max={100}
                  onChange={(val) => props.timerLabelChange(activeSelection.attrs.id, 'ccOffsetY', val)}
                />
              </div>
            </div>

      </div> 
      </Grid2>
      }

      {activeSelection.attrs !== undefined && activeSelection.attrs.subType === 'Timer'&& activeSelection.attrs.showRing && <Grid2 xs={12}>
      <div className='flex flex-col gap-2 rounded-md border border-gray-300 p-1'>
          <span className=' text-gray-500 text-sm'>Ring</span>
            <div className='flex flex-row gap-x-4 items-end'>
              <div className='flex flex-col w-40'>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                  Thickness
                </div>
                <InputNumber
                  value={(timerRingBlock === undefined || timerRingBlock.attrs.ringThickness === undefined) ? 0 : timerRingBlock.attrs.ringThickness}
                  min={0}
                  max={60}
                  onChange={(val) => props.timerRingChange(activeSelection.attrs.id, 'ringThickness', val)}
                />
              </div>
              <div className='flex flex-col w-40'>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                  Background colour
                </div>
                <LionColorPicker color={timerRingBlock === undefined ? '' : timerRingBlock.attrs.fill}      
                      onChange={(color) => props.timerRingChange(activeSelection.attrs.id, 'fill', color)}
                  />
              </div>
            </div>

            {timerRingBlock !== undefined && timerRingBlock.attrs.ccFillColors.length === 0 &&
            <div className='flex flex-row gap-x-4 items-end'>
              <div className='flex flex-col w-40'>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                  Front colour
                </div>
                <LionColorPicker color={timerRingBlock === undefined ? '' : timerRingBlock.attrs.fillArc}      
                      onChange={(color) => props.timerRingChange(activeSelection.attrs.id, 'fillArc', color)}
                  />
              </div>
              <div className='flex flex-row gap-x-0.5 items-center'>
              <CcActionButtonOutlined onClick={() => props.timerRingChange(activeSelection.attrs.id, 'angularGradient', true)}>Use gradient colors</CcActionButtonOutlined>
                <InfoToolTip 
                  placement='right'
                  headLine='Gradients'
                  message="You can select multiple colours for the ring and we will apply an angular gradient"
                  />
              </div>
 
            </div>
            }
            {timerRingBlock !== undefined && timerRingBlock.attrs.ccFillColors.length > 0 &&
            <div className='bg-slate-100 rounded p-1'>
              <div className='flex flex-row'>
                <div className='text-xs mb-2'>Using gradient</div>
                <div className='flex grow'></div>
                <div className='flex flex-row gap-x-1 cursor-pointer rounded hover:bg-slate-200 items-center text-xs mb-2'
                      onClick={() => props.timerRingChange(activeSelection.attrs.id, 'angularGradient', false)}>
                  <div>Remove</div>
                  <Iconify icon={lionIcons.Icon_Actions_Cancel} width="18px" />
                </div>

              </div>
              <div className='flex flex-row gap-x-4'>
                <div className='flex flex-col grow'>
                {timerRingBlock.attrs.ccFillColors.map((c, index) =>  <div className='flex flex-col w-40'>
                              <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                                Colour {index +1}
                              </div>
                              <div className='flex flex-row'>
                                <LionColorPicker color={timerRingBlock === undefined ? '' : timerRingBlock.attrs.ccFillColors[index]}
                                      onChange={(color) => props.timerRingChange(activeSelection.attrs.id, 'ccFillColorsChange', {color: color, index: index})}
                                  />
                                {timerRingBlock.attrs.ccFillColors.length > 2 &&
                                  <IconButton variant="contained" sx={{color: ccColorDarkTeal}} onClick={() => props.timerRingChange(activeSelection.attrs.id, 'ccFillColorsRemove', index)} >
                                      <Iconify icon={lionIcons.Icon_Actions_Cancel} width="24px" />
                                  </IconButton>
                                }
                                {index === timerRingBlock.attrs.ccFillColors.length-1  &&
                                  <IconButton variant="contained" sx={{color: ccColorDarkTeal}} onClick={() => props.timerRingChange(activeSelection.attrs.id, 'ccFillColorsAdd')} >
                                      <Iconify icon={lionIcons.Icon_Actions_Add} width="24px" />
                                  </IconButton>
                                }

                              </div>
                            </div> 

                  )
                }
                </div>
                <div className='w-[160px] flex flex-col items-center justify-start'>
                  <div className='flex flex-row items-center text-ccColorDarkTeal gap-x-1 border rounded px-2 py-1 hover:bg-slate-200 cursor-pointer'
                        onClick={() => props.timerRingChange(activeSelection.attrs.id, 'angularGradientSpreadToAll')}>
                      <div>Spread to all</div>
                      <InfoToolTip 
                        placement='right'
                        headLine='Spread Gradients'
                        message="Apply these gradient settings to all the other rings of this template"
                        />
                  </div>
                  <div id="gradient-preview-container" ref={gradientPreviewCanvasRef}></div>
                </div>

              </div>
            </div>
            }

            <div className='flex flex-row gap-x-4 items-end'>
              <div className='flex flex-col w-40'>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                  Stroke width
                </div>
                <InputNumber
                  value={(timerRingBlock === undefined || timerRingBlock.attrs.strokeWidth === undefined) ? 0 : timerRingBlock.attrs.strokeWidth}
                  min={0}
                  max={60}
                  onChange={(val) => props.timerRingChange(activeSelection.attrs.id, 'strokeWidth', val)}
                />
              </div>
              <div className='flex flex-col w-40'>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                  Stroke colour
                </div>
                <LionColorPicker color={timerRingBlock === undefined ? '' : timerRingBlock.attrs.stroke}      
                      onChange={(color) => props.timerRingChange(activeSelection.attrs.id, 'stroke', color)}
                  />
              </div>
            </div>

      </div> 
      </Grid2>
      }

<BlockVisibilityManager
      availableConditions={props.availableConditions}
      visibilityConditions={activeSelection.attrs === undefined ? undefined : activeSelection.attrs.visibilityConditions}
      onConditionalPropertiesChange={handleConditionalPropertiesChange}
 />

{/*props.noDynamicProps === undefined && activeSelection.attrs !== undefined && activeSelection.attrs.subType !== 'Timer' && activeSelection.attrs.subType !== 'TimerSeparator' &&
    <Grid2 xs={12}>
              <ConditionalPropertiesBuilder availableConditions={props.availableConditions}
                                            objects={[activeSelection]}
                                            onConditionalPropertiesChange={handleConditionalPropertiesChange} />
            </Grid2>
*/}
{false && canSeeAnimationManager() &&
          <Grid2 xs={12}>
            <AnimationManager animations={activeSelection.attrs.animation} 
            onAnimationChange={handleAnimationChange}
            sampleData={props.sampleData}
            blockType={activeSelection.className}
            />
          </Grid2>
}
{false && activeSelection.attrs !== undefined && activeSelection.attrs.subType !== 'Timer' && activeSelection.attrs.subType !== 'TimerSeparator' &&
          <Grid2 xs={12}>
            <AnimationManagerOLD animations={activeSelection.attrs.animation} 
            onAnimationChange={handleAnimationChange}
            />
          </Grid2>
}
{activeSelection.attrs !== undefined &&
          <Grid2 xs={12}>
          <TwoDSelector 
            effects={{rotation: activeSelection.attrs.rotation, skewX: activeSelection.attrs.skewX, skewY: activeSelection.attrs.skewY}}
            onAddRotationViewFinder={handleAddRotationViewFinder}
            onChange={handle2dEffectsChange}
            />
        </Grid2>
}
        </Grid2>    
    </>
    }

{ /* MULTI SELECTION */ 
    props.objects.length > 1 &&
        <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
        <Typography>Multi selection to do</Typography>
      </Stack>
    }


</Stack>
  </>
}

const WeatherLocationsSelectors = (props) => {
  //props:
  // needs to take the list of all locations
  // doesn't fetch any location
  
  //onChange: returns the selected location id
  const [locations, setLocations] = useState([]) //[{id: 'GET', name: 'GET'}
  
  useEffect(() => {
    //console.log(props.locations)
    if (props.locations && props.locations.length > 0) {
      const newLocations = props.locations.map(l => {
        const itemName = l.city + ', ' + l.countryCode
        return {id: l.locationId, name: itemName}
      })
      setLocations(newLocations)
    }

  }, [props.locations])

  const handleChange = (id) => {
    if (props.onChange) props.onChange(id)
  }


  return <div className='w-40'>
              <LionListbox items={locations}
                          selectedItemId={props.selectedItemId}
                          onChange={(item) => handleChange(item.id)}
                          zIndex={10}
                          id="weatherLocationsSelector"
                          />
    
  </div>
}

export const WeatherUnitsSelector = (props) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const openDialog = Boolean(anchorEl);

  const handleOpenSrcSettings = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSrcSettings = () => {
    setAnchorEl(null);
  };
  const handleUnitsChange = (unit) => {
    setAnchorEl(null);
    if (props.onChange) props.onChange(unit);

  }

return <>
          <div className='text-ccColorDarkTeal flex flex-row items-center gap-x-2 border p-1 rounded hover:bg-slate-100 hover:cursor-pointer' onClick={handleOpenSrcSettings} >
            <div>{props.units}</div>
            <Iconify icon="carbon:temperature-inversion" />
          </div>        

<Popover      open={openDialog}
                    anchorEl={anchorEl}
                    onClose={handleCloseSrcSettings}
                    anchorOrigin={{
                      vertical: 'top',
                    }}
          >
        <div className='w-[800px] max-h-[600px] p-3'>

        <div class="inline-flex rounded-md shadow-sm font-poppins" role="group">
                <div className={`cursor-pointer px-4 py-2 w-64 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.units === 'standard' ? 'bg-gray-200' : 'bg-white'}`}
                      onClick={()=>handleUnitsChange('standard')}
                      >
                  <div>
                    Standard
                  </div>
                  <div className='text-sm mt-2 font-normal'>For temperature in Kelvin and wind speed in meter/sec</div>
                </div>
                <div className={`cursor-pointer px-4 py-2 w-64 font-medium border-t border-b border-gray-200 focus:outline-none focus:ring-0 hover:bg-gray-100 hover:text-ccColorTeal ${props.units === 'metric' ? 'bg-gray-200' : 'bg-white'}`}
                    onClick={()=>handleUnitsChange('metric')}
                    >
                  <div>
                     Metric
                  </div>
                  <div className='text-sm mt-2 font-normal'>For temperature in Celsius and wind speed in meter/sec</div>
                </div>
                <div className={`cursor-pointer px-4 py-2 w-64 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.units === 'imperial' ? 'bg-gray-200' : 'bg-white'}`}
                    onClick={()=>handleUnitsChange('imperial')}
                    >
                  <div>
                    Imperial
                  </div>
                  <div className='text-sm mt-2 font-normal'>For temperature in Fahrenheit and wind speed in miles/hour</div>
                </div>
              </div>



        </div>
    </Popover>

</>
  
}

export default function TemplateEditor(props) {
  /*
  props:
  onTemplateCreated
  embeddedInWizard: if true, it removes the border and the submit and cancel buttons. Instead 3 buttons: "Previous, Save & Exist, Next" will be added.
  onPreviousClicked: available on when embeddedInWizard
  onSaveExitClicked: available on when embeddedInWizard
  onNextClicked: available on when embeddedInWizard

  buildFromDictionary: pass a js dictionary to create a template from it instead of using a json metadata
      supported props for the dictionary:
      {canvasBackground, canvasWidth, canvasHeight, timeParts,
      canvasImageUrl, canvasDatabindType }
  */
  const DEFAULT_FONT_ID = -1
  const DEFAULT_FONTNAME = "Arial" 
  const canvasWidth = 1200;
  const canvasHeight = 900;
  const [canvasBackgroundImageShowAnimationSelector, setCanvasBackgroundImageShowAnimationSelector] = useState(false);

  const propsToInclude = ['width','height','subtype','dataBindType','fontStyle','fontFamily','fontId','align','imageUrl','animation','strokeWidth','showLabel','minTimePart','maxTimePart','timePartSeparator','digitsToWord','text','ccOffsetY'];
  // const canvasHeight = '400px';
  const [templateName, setTemplateName] = useState('')
  const [templateDescription, setTemplateDescription] = useState('')
  const [templateIsRetina, setTemplateIsRetina] = useState(false)

  const [selectedObjects, setSelectedObjects] = useState([]);
  const [timerLabelBlock, setTimerLabelBlock] = useState(undefined); 
  const [timerRingBlock, setTimerRingBlock] = useState(undefined); 
  const [canvasProps, setCanvasProps] = useState({className: 'Canvas', width: canvasWidth, height: canvasHeight, backgroundColor: '#fff', isImageAnimated: false}); // the canvasProps obj can be passed to selectedObject
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataConnection, setDataConnection] = useState(undefined);
  const [dataConnectionInfo, setDataConnectionInfo] = useState(undefined);
  const [sampleData, setSampleData] = useState({});

  const [currentTab, setCurrentTab] = useState('objInspector');
  const [tabItems, setTabItems] = useState([{id: 'objInspector', name: 'Formatting'},
                                              {id: 'layers', name: 'Layers'},
                                            ])

  // start variables to turn features on/off
  const [showDataConnection, setShowDataConnection] = useState(true);
  const [showAnswersManager, setShowAnswersManager] = useState(false);
  const [showRatingBlocks, setShowRatingBlocks] = useState(true);
  const [showTimerBlocks, setShowTimerBlocks] = useState(false);
  const [showWeatherLocationsSelector, setShowWeatherLocationsSelector] = useState(false);
  // end variables to turn features on/off
  const [weatherLocations, setWeatherLocations] = useState([]);
  const [selectedWeatherLocationId, setSelectedWeatherLocationId] = useState(1)
  const [weatherSampleDataByLocations, setWeatherSampleDataByLocations] = useState({}); // it is a dic {locId: {}} with key the location id and value the weather data. //used to avoid making multiple api calls
  const [weatherSettings, setWeatherSettings] = useState({units: 'metric', repeatCount: 0, repeatDirection: 'horizontal', weatherCollectionId: 1})
  const [weatherIconsCollections, setWeatherIconsCollections] = useState([])

  // -------
  // props.snippetTypeId : it is used to turn on/off certain features of the editor depending on the kind of snippet this template refers to
  // backward compatibility: when props.snippetTypeId is not defined, it is a "Generator" type (snippetTypeId = 1)
  // we need to use a state variable instead of the prop to set it to 1 when props is undefined
  const [snippetTypeId, setSnippetTypeId] = useState(0);

  useEffect(() => {
    if (props.snippetTypeId === undefined) setSnippetTypeId(1);
    else setSnippetTypeId(props.snippetTypeId);
    
    setUIForSnippetType(props.snippetTypeId);
    if (props.snippetTypeId.toString() === '18') getweatherIconsCollections();

  }, [props.snippetTypeId])

  const setUIForSnippetType = (_snippetTypeId) => {
    switch(_snippetTypeId) {
      case 9:
        if (props.showDataConnections === undefined) setShowDataConnection(false)
      break;
      case 5:
      case 6:
      case 7:
        setShowDataConnection(false)
        setShowAnswersManager(true)
      break;
      case 1:
        setShowDataConnection(true)
        break;
      case 12:
        setShowDataConnection(false)
        setShowRatingBlocks(false)
        setShowTimerBlocks(true)
      break;
      case 14:
        setShowDataConnection(false)
        break;
      case 18:
        setShowDataConnection(false)
        setShowWeatherLocationsSelector(true)
        if (weatherLocations.length === 0) getWeatherLocations()
        setTabItems([{id: 'objInspector', name: 'Formatting'},
                      {id: 'layers', name: 'Layers'},
                      {id: 'tabForecasts', name: 'Forecasts'},
                    ])
        break;
        default:
        // it's a Generator
        if (props.showDataConnections === undefined) setShowDataConnection(true)
      break;
    }

  }


  useEffect(() => {
    if (props.showDataConnections !== undefined) setShowDataConnection(props.showDataConnections);
  }, [props.showDataConnections])


  useEffect(() => {
    if (!Object.keys(weatherSampleDataByLocations).includes(1)) addWeatherSampleData(1)
  }, [])

// const getCanvasProps = () => {
//  return canvasProps};

    // load data for edit mode -----
    const getTemplateInfo = async (templateId) => {
      let tMetadata = null;
      try {
        let url = `${process.env.REACT_APP_LION_API_URL}/Templates/info/${templateId}`;
        let response = await axios.get(url);
        // let url = `api/Templates/info/${templateId}`;
        // let response = await fetch(url, { method: "GET", });
    
        //const data = await response.json();
        //response.data = data;

        tMetadata = response.data;
        setSnippetTypeId(response.data.productTypeId);
        setUIForSnippetType(response.data.productTypeId);
        if (response.data.productTypeId === 5 || response.data.productTypeId === 6 || response.data.productTypeId === 7) {
          // it's a vote widget
          tMetadata = response.data.templates[0];
          setVoteAllTemplates(response.data.templates);
          setVoteCurrentTemplateNum(0);
          setVoteNumTemplates(response.data.templates.length);
          setTemplateIsRetina(tMetadata.templateIsRetina ? tMetadata.templateIsRetina : false )
        }
        else {
          setTemplateIsRetina(response.data.templateIsRetina ? response.data.templateIsRetina : false )
        }

        setTemplateName(response.data.templateName);
        setTemplateDescription(response.data.templateDescription);
        //setFadeInFunction(response.data.fadeInFunction);
        
        if (tMetadata.weatherSettings) setWeatherSettings(tMetadata.weatherSettings)
        if (tMetadata.animation != null) setAnimationSettings(tMetadata.animation)
        //console.log(tMetadata.animation)
        // we get the dataConnectionInfo if present in this template
        if (tMetadata.dataConnectionId !== undefined && tMetadata.dataConnectionId !== null) {
          getDataConnectionInfo(tMetadata.dataConnectionId)

          /*
          url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${tMetadata.dataConnectionId}`;
          response = await axios.get(url);
          // url = `api/Feeds/info/${tMetadata.dataConnectionId}`;
          // response = await fetch(url, { method: "GET", });
      
          //response.data = await response.json();
  
          setDataConnectionInfo(response.data)
          setDataConnection({...response.data, id: response.data.feedId})
  
          url = `${process.env.REACT_APP_LION_API_URL}/Feeds/sample/${tMetadata.dataConnectionId}`;
          response = await axios.get(url);
          // url = `api/Feeds/sample/${tMetadata.dataConnectionId}`;
          // response = await fetch(url, { method: "GET", });
      
          //response.data = await response.json();
          setSampleData(response.data);  
          */
        }

                
      } catch (error) {
        console.log(error);
      }

      
      updateEditorFromMetadata(tMetadata);

    }
    const getDataConnectionInfo = async (dataConnectionId) => {
        let url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${dataConnectionId}`;
        let response = await axios.get(url);
        // url = `api/Feeds/info/${tMetadata.dataConnectionId}`;
        // response = await fetch(url, { method: "GET", });
    
        //response.data = await response.json();

        setDataConnectionInfo(response.data)
        setDataConnection({...response.data, id: response.data.feedId})

        url = `${process.env.REACT_APP_LION_API_URL}/Feeds/sample/${dataConnectionId}`;
        response = await axios.get(url);
        // url = `api/Feeds/sample/${tMetadata.dataConnectionId}`;
        // response = await fetch(url, { method: "GET", });
    
        //response.data = await response.json();
        setSampleData(response.data);  

    }

    const getweatherIconsCollections = async () => {
      //console.log('entrato')
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Weather/weatherCollections/mine?includeDefault=1`;
            const response = await axios.get(url);
            const data = response.data;
    
            setWeatherIconsCollections(data)
            //console.log(data);
    
        } catch (error) {
            //console.log(error);
        }
    }

    const updateEditorFromMetadata = (tMetadata, voteTemplateChange) => {
      /*
      if (voteTemplateChange) {        
        var nodes = canvasRef.current.getLayers()[0].find(node => {
          return node.getClassName() !== 'Transformer';
         });
         nodes.forEach(n => n.destroy());
      }*/
      canvasRef.current = initCanvas(tMetadata);
      // we need to update canvas' props separately
      const newCanvasProps = {...tMetadata.canvas, className:'Canvas'};
      //console.log('updateEditorFromMetadata')
      updateCanvas(newCanvasProps, voteTemplateChange, true);

      const blocks = tMetadata.model.children[0].children;
      for (let i = 0; i<blocks.length; i+=1) {
        const currentBlock = blocks[i];
        if (currentBlock.className === 'Text') {
          if (currentBlock.attrs.subType === 'Timer') handleAddTimerBlock(undefined, currentBlock);
          else if (currentBlock.attrs.subType === 'TimerLabel') handleAddTimerLabelBlock(undefined, currentBlock);
          else if (currentBlock.attrs.subType === 'TimerSeparator') handleAddTimerSeparatorBlock(undefined, currentBlock);
          else handleAddTextBlock(undefined, currentBlock);
        }
        if (currentBlock.className === 'Ring') {
          if (currentBlock.attrs.subType === 'TimerRing') handleAddTimerRingBlock(undefined, currentBlock);
        }
        if (currentBlock.className === 'Image') {
          console.log('found image')
          handleAddImage(undefined, currentBlock, undefined, i);
        }
        if (currentBlock.className === 'TextPath') {
          handleAddTextPath(undefined, currentBlock);
        }
        if (currentBlock.className === 'Circle') {
          handleAddCircle(undefined, currentBlock);
        }
        if (currentBlock.className === 'Rect') {
          handleAddRect(undefined, currentBlock);
        }
        if (currentBlock.className === 'RegularPolygon') {
          handleAddPolygon(undefined, currentBlock);
        }
        if (currentBlock.className === 'Ellipse') {
          handleAddEllipse(undefined, currentBlock);
        }
        if (currentBlock.className === 'Shape') {
          if (currentBlock.attrs.subType === 'Rating') handleAddRatingsBlock(undefined, currentBlock);
        }

      }

    }
    const createTemplateFromDictionary = () => {
      const propsDic = props.buildFromDictionary;
      const propNames = Object.keys(propsDic);
      //console.log(propsDic)
      
      //special case for Votes
      if (propsDic.isVote) {createTemplateFromDictionaryVotes(propsDic); return;}

      let canvasProps = {className:'Canvas', backgroundColor: '#fff', width: 900, height: 600}

      if (propsDic.canvasBackground) canvasProps.backgroundColor = propsDic.canvasBackground;
      if (propsDic.canvasWidth) canvasProps.width = propsDic.canvasWidth;
      if (propsDic.canvasHeight) canvasProps.height = propsDic.canvasHeight;
      if (propsDic.canvasImageUrl) canvasProps.imageUrl = propsDic.canvasImageUrl;
      if (propsDic.canvasDatabindType) canvasProps.databindType = propsDic.canvasDatabindType;

      //console.log('createTemplateFromDictionary')
      updateCanvas(canvasProps)

      if (propNames.findIndex(n => n === "timeParts") !== -1) {
        handleAddTimerBlocks(propsDic.timeParts, canvasProps, propsDic.includeTimePartsSeparator, propsDic.digitsColor)
      }
      if (propsDic.isTextImage) {
        //console.log(propsDic)
        handleAddTextImage(canvasProps, propsDic.textImageDatabind)
      }
      if (propsDic.isPersAnimation) {
        //console.log(propsDic)
        handleAddPersAnimations(canvasProps, propsDic)
      }

      if (propsDic.dataConnectionId) getDataConnectionInfo(propsDic.dataConnectionId)
    }

    const createTemplateFromDictionaryVotes = (propsDic) => {
      const templateEmpty = {"model":{"className":"Stage","children":[{"className":"Layer","children":[{"className":"Transformer","children":null,"attrs":{"id":null,"x":0,"y":0,"width":0,"height":0,"lineHeight":1,"imageWidth":0,"imageHeight":0,"fontFamily":null,"fontWeight":null,"fontSize":null,"fontStyle":"400","fontIsAutoSize":false,"textDecoration":"","align":"left","fill":null,"fillMode":"solid","fillPriority":null,"gradientType":null,"gradientDirection":null,"fillLinearGradientColorStops":null,"fillLinearGradientStartPointX":0,"fillLinearGradientStartPointY":0,"fillLinearGradientEndPointX":0,"fillLinearGradientEndPointY":0,"fillRadialGradientColorStops":null,"fillRadialGradientStartPointX":0,"fillRadialGradientStartPointY":0,"fillRadialGradientEndPointX":0,"fillRadialGradientEndPointY":0,"fillRadialGradientEndRadius":50,"stroke":null,"strokeWidth":null,"text":"","textTransforms":null,"conditionalProperties":null,"imageUrl":null,"radius":null,"radiusX":null,"radiusY":null,"sides":null,"data":null,"dataBindType":null,"dataBindValue":null,"subType":null,"minValue":null,"maxValue":null,"numIcons":null,"gapIcon":null,"unratedColor":null,"ratedColor":null,"svgPath":null,"svgStrokeWidth":null,"svgScale":1,"svgFitCanvas":false,"animation":null,"rotation":0,"skewX":0,"skewY":0,"timePart":null,"minTimePart":null,"maxTimePart":null,"timePartSeparator":null,"digitsToWord":false,"showLabel":null},"hasConditionalProperties":false},{"className":"Transformer","children":null,"attrs":{"id":null,"x":0,"y":0,"width":0,"height":0,"lineHeight":1,"imageWidth":0,"imageHeight":0,"fontFamily":null,"fontWeight":null,"fontSize":null,"fontStyle":null,"fontIsAutoSize":false,"textDecoration":"","align":"left","fill":null,"fillMode":"solid","fillPriority":null,"gradientType":null,"gradientDirection":null,"fillLinearGradientColorStops":null,"fillLinearGradientStartPointX":0,"fillLinearGradientStartPointY":0,"fillLinearGradientEndPointX":0,"fillLinearGradientEndPointY":0,"fillRadialGradientColorStops":null,"fillRadialGradientStartPointX":0,"fillRadialGradientStartPointY":0,"fillRadialGradientEndPointX":0,"fillRadialGradientEndPointY":0,"fillRadialGradientEndRadius":50,"stroke":null,"strokeWidth":null,"text":"","textTransforms":null,"conditionalProperties":null,"imageUrl":null,"radius":null,"radiusX":null,"radiusY":null,"sides":null,"data":null,"dataBindType":null,"dataBindValue":null,"subType":null,"minValue":null,"maxValue":null,"numIcons":null,"gapIcon":null,"unratedColor":null,"ratedColor":null,"svgPath":null,"svgStrokeWidth":null,"svgScale":1,"svgFitCanvas":false,"animation":null,"rotation":0,"skewX":0,"skewY":0,"timePart":null,"minTimePart":null,"maxTimePart":null,"timePartSeparator":null,"digitsToWord":false,"showLabel":null},"hasConditionalProperties":false}],"attrs":{"id":null,"x":0,"y":0,"width":0,"height":0,"lineHeight":1,"imageWidth":0,"imageHeight":0,"fontFamily":null,"fontWeight":null,"fontSize":null,"fontStyle":null,"fontIsAutoSize":false,"textDecoration":"","align":"left","fill":null,"fillMode":"solid","fillPriority":null,"gradientType":null,"gradientDirection":null,"fillLinearGradientColorStops":null,"fillLinearGradientStartPointX":0,"fillLinearGradientStartPointY":0,"fillLinearGradientEndPointX":0,"fillLinearGradientEndPointY":0,"fillRadialGradientColorStops":null,"fillRadialGradientStartPointX":0,"fillRadialGradientStartPointY":0,"fillRadialGradientEndPointX":0,"fillRadialGradientEndPointY":0,"fillRadialGradientEndRadius":50,"stroke":null,"strokeWidth":null,"text":"","textTransforms":null,"conditionalProperties":null,"imageUrl":null,"radius":null,"radiusX":null,"radiusY":null,"sides":null,"data":null,"dataBindType":null,"dataBindValue":null,"subType":null,"minValue":null,"maxValue":null,"numIcons":null,"gapIcon":null,"unratedColor":null,"ratedColor":null,"svgPath":null,"svgStrokeWidth":null,"svgScale":1,"svgFitCanvas":false,"animation":null,"rotation":0,"skewX":0,"skewY":0,"timePart":null,"minTimePart":null,"maxTimePart":null,"timePartSeparator":null,"digitsToWord":false,"showLabel":null},"hasConditionalProperties":false}],"attrs":{"id":null,"x":0,"y":0,"width":600,"height":450,"lineHeight":1,"imageWidth":0,"imageHeight":0,"fontFamily":null,"fontWeight":null,"fontSize":null,"fontStyle":null,"fontIsAutoSize":false,"textDecoration":"","align":"left","fill":null,"fillMode":"solid","fillPriority":null,"gradientType":null,"gradientDirection":null,"fillLinearGradientColorStops":null,"fillLinearGradientStartPointX":0,"fillLinearGradientStartPointY":0,"fillLinearGradientEndPointX":0,"fillLinearGradientEndPointY":0,"fillRadialGradientColorStops":null,"fillRadialGradientStartPointX":0,"fillRadialGradientStartPointY":0,"fillRadialGradientEndPointX":0,"fillRadialGradientEndPointY":0,"fillRadialGradientEndRadius":50,"stroke":null,"strokeWidth":null,"text":"","textTransforms":null,"conditionalProperties":null,"imageUrl":null,"radius":null,"radiusX":null,"radiusY":null,"sides":null,"data":null,"dataBindType":null,"dataBindValue":null,"subType":null,"minValue":null,"maxValue":null,"numIcons":null,"gapIcon":null,"unratedColor":null,"ratedColor":null,"svgPath":null,"svgStrokeWidth":null,"svgScale":1,"svgFitCanvas":false,"animation":null,"rotation":0,"skewX":0,"skewY":0,"timePart":null,"minTimePart":null,"maxTimePart":null,"timePartSeparator":null,"digitsToWord":false,"showLabel":null},"hasConditionalProperties":false},"canvas":{"width":600,"height":450,"backgroundColor":"#fff","dataBindType":null,"dataBindValue":null,"imageUrl":null,"isImageAnimated":false},"dataConnectionId":-10,"previewSampleData":null,"animation":null}
      const textBoxEmpty = {"className":"Text","children":null,"attrs":{"id":"N0md1NGqQi6kQ9a1TM7H","x":10,"y":10,"width":100,"height":40,"lineHeight":1.1,"imageWidth":0,"imageHeight":0,"fontFamily":DEFAULT_FONTNAME,"fontId":DEFAULT_FONT_ID,"fontWeight":null,"fontSize":30,"fontStyle":"400","fontIsAutoSize":false,"textDecoration":"","align":"left","fill":"#000","fillMode":"solid","fillPriority":null,"gradientType":"linear","gradientDirection":null,"fillLinearGradientColorStops":null,"fillLinearGradientStartPointX":0,"fillLinearGradientStartPointY":0,"fillLinearGradientEndPointX":0,"fillLinearGradientEndPointY":0,"fillRadialGradientColorStops":null,"fillRadialGradientStartPointX":0,"fillRadialGradientStartPointY":0,"fillRadialGradientEndPointX":0,"fillRadialGradientEndPointY":0,"fillRadialGradientEndRadius":50,"stroke":null,"strokeWidth":0,"text":"242","textTransforms":null,"conditionalProperties":null,"imageUrl":null,"radius":null,"radiusX":null,"radiusY":null,"sides":null,"data":null,"dataBindType":"databind","dataBindValue":"votesForQuestion","subType":null,"minValue":null,"maxValue":null,"numIcons":null,"gapIcon":null,"unratedColor":null,"ratedColor":null,"svgPath":null,"svgStrokeWidth":null,"svgScale":1,"svgFitCanvas":false,"animation":{"totalSeconds":5},"rotation":0,"skewX":0,"skewY":0,"timePart":null,"minTimePart":null,"maxTimePart":null,"timePartSeparator":null,"digitsToWord":false,"showLabel":null},"hasConditionalProperties":false};

      const allTemplates = [];
      const uploadedCanvasImgs = [];
      const uploadedCanvasSizes = [];
      if (propsDic.canvasImageUrl) {
          const keys = Object.keys(propsDic.canvasImageUrl);
          keys.forEach(k => {uploadedCanvasImgs.push(propsDic.canvasImageUrl[k]);
                            uploadedCanvasSizes.push(propsDic.canvasSizes[k])})
     }
     //console.log(uploadedCanvasImgs);
      for (let i = 0; i < propsDic.numAnswers; i += 1) {
        const currentTemplate = JSON.parse(JSON.stringify(templateEmpty));
        
        if (propsDic.canvasBackground) currentTemplate.canvas.backgroundColor = propsDic.canvasBackground;
        if (uploadedCanvasSizes.length > 0) {
          currentTemplate.canvas.width = uploadedCanvasSizes[i].width;
          currentTemplate.canvas.height = uploadedCanvasSizes[i].height;  
        }
        else {
          currentTemplate.canvas.width = propsDic.canvasWidth;
          currentTemplate.canvas.height = propsDic.canvasHeight;
        }
        if (propsDic.canvasDatabindType) currentTemplate.canvas.databindType = propsDic.canvasDatabindType;
        if (uploadedCanvasImgs.length > 0) {
           if (uploadedCanvasImgs.length === 1) currentTemplate.canvas.imageUrl = uploadedCanvasImgs[0];
           else if (i < uploadedCanvasImgs.length) currentTemplate.canvas.imageUrl = uploadedCanvasImgs[i];
           else currentTemplate.canvas.imageUrl = null;
        }

        let currentY = 10;
        if (propsDic.votesForQuestion) {
          const currentTextBox = JSON.parse(JSON.stringify(textBoxEmpty));
          currentTextBox.attrs.dataBindValue = 'votesForQuestion'
          currentTextBox.attrs.text = '242'
          currentTextBox.attrs.textRaw = '242'
          currentTextBox.attrs.y = currentY;
          currentY += 50
          currentTemplate.model.children[0].children.push(currentTextBox);
        }
        if (propsDic.totalVotes) {
          const currentTextBox = JSON.parse(JSON.stringify(textBoxEmpty));
          currentTextBox.attrs.dataBindValue = 'totalVotes'
          currentTextBox.attrs.text = '1536'
          currentTextBox.attrs.textRaw = '1536'
          currentTextBox.attrs.y = currentY;
          currentY += 50
          currentTemplate.model.children[0].children.push(currentTextBox);
        }
        if (propsDic.votesForQuestionPerc) {
          const currentTextBox = JSON.parse(JSON.stringify(textBoxEmpty));
          currentTextBox.attrs.dataBindValue = 'votesForQuestion%'
          currentTextBox.attrs.text = '52 %'
          currentTextBox.attrs.textRaw = '52'
          currentTextBox.attrs.y = currentY;
          currentTextBox.attrs.textTransforms = { prefix: "", suffix: " %", functions: [] }
          currentY += 50
          currentTemplate.model.children[0].children.push(currentTextBox);
        }
        allTemplates.push(currentTemplate)
        
        //console.log(allTemplates)
      }

      getDataConnectionInfo(allTemplates[0].dataConnectionId)

      setVoteAllTemplates(allTemplates);
      console.log(allTemplates)
      setVoteCurrentTemplateNum(0);
      setVoteNumTemplates(allTemplates.length);

      updateEditorFromMetadata(allTemplates[0])
    }

    useEffect(() => {
      if (props.id === null || props.id === undefined) {// new template
        canvasRef.current = initCanvas();

        // console.log(canvasRef.current);
        if (props.buildFromDictionary !== undefined) createTemplateFromDictionary()
        else canvasRef.current.container().style.backgroundColor = '#fff';

      }
      else {
        getTemplateInfo(props.id);  
      }

      return () => {
        if (canvasRef.current != null) {
          // console.log(canvasRef.current)
          // canvasRef.current.destroy();
          canvasRef.current = null;  
        }
      };

}, [props.id]);

const preloadDataConnection = async (id) => {
  let url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${id}`;
  let response = await axios.get(url);
  // let url = `api/Feeds/info/${id}`;
  // let response = await fetch(url, { method: "GET", });

  // response.data = await response.json();

  setDataConnectionInfo(response.data)
  setDataConnection({...response.data, id: response.data.feedId})

  url = `${process.env.REACT_APP_LION_API_URL}/Feeds/sample/${id}`;
  response = await axios.get(url);
  // url = `api/Feeds/sample/${id}`;
  // response = await fetch(url, { method: "GET", });

  // response.data = await response.json();
  setSampleData(response.data);  

}

useEffect(() => {
  if (props.connectToDataConnectionId !== undefined) {
    preloadDataConnection(props.connectToDataConnectionId)

  }
}, [props.connectToDataConnectionId])

    const canvasRef = useRef(null);

    const initCanvas = () => {

      const tr = new Konva.Transformer({resizeEnabled: true, shouldOverdrawWholeArea: true});
      const trNoResize = new Konva.Transformer({resizeEnabled: false, shouldOverdrawWholeArea: true});
      const layer = new Konva.Layer();

      const stage = new Konva.Stage({
        container: 'canvas',   // id of container <div>
        width: canvasWidth,
        height: canvasHeight
      });

      // IMPORTANT 
      // we can't use react state to bind the stage onClick event below (because the state var will always have its initial value)
      // so we need to create a 'state' var inside the stage object and use that
      stage.lionProps = canvasProps;

      stage.on('click', (e) => {        
        // const nodesToDelete = stage.find(n => (n.attrs.id !== undefined && n.attrs.id.includes('_delete')));
        // any custom node will contain an underscore as part of  its id
        const nodesToDelete = stage.find(n => (n.attrs.id !== undefined && n.attrs.id.includes('_')));
        nodesToDelete.forEach(n => n.destroy());
        setSelectedObjects([stage.lionProps]);
        // tr.resizeEnabled = true;
        tr.nodes([]);
        trNoResize.nodes([]);
      })
      // then create layer
      // stage.container().style.backgroundColor = '#fff';

      // for snap to grid
      layer.on('dragmove', function (e) {
        // clear all previous lines on the screen
        layer.find('.guid-line').forEach((l) => l.destroy());
  
        // find possible snapping lines
        var lineGuideStops = getLineGuideStops(e.target);
        // find snapping points of current object
        var itemBounds = getObjectSnappingEdges(e.target);
  
        // now find where can we snap current object
        var guides = getGuides(lineGuideStops, itemBounds);
  
        // do nothing of no snapping
        if (!guides.length) {
          return;
        }
  
        drawGuides(guides);
  
        var absPos = e.target.absolutePosition();
        // now force object position
        guides.forEach((lg) => {
          switch (lg.snap) {
            case 'start': {
              switch (lg.orientation) {
                case 'V': {
                  absPos.x = lg.lineGuide + lg.offset;
                  break;
                }
                case 'H': {
                  absPos.y = lg.lineGuide + lg.offset;
                  break;
                }
              }
              break;
            }
            case 'center': {
              switch (lg.orientation) {
                case 'V': {
                  absPos.x = lg.lineGuide + lg.offset;
                  break;
                }
                case 'H': {
                  absPos.y = lg.lineGuide + lg.offset;
                  break;
                }
              }
              break;
            }
            case 'end': {
              switch (lg.orientation) {
                case 'V': {
                  absPos.x = lg.lineGuide + lg.offset;
                  break;
                }
                case 'H': {
                  absPos.y = lg.lineGuide + lg.offset;
                  break;
                }
              }
              break;
            }
          }
        });
        e.target.absolutePosition(absPos);
      });
  
      layer.on('dragend', function (e) {
        // clear all previous lines on the screen
        layer.find('.guid-line').forEach((l) => l.destroy());
      });
  
    
      layer.add(tr);
      layer.add(trNoResize);
      stage.add(layer);

      return stage;
};

/*
    useEffect(() => {

      canvasRef.current = initCanvas();
  
      // canvasRef.current.setWidth(1200);
      // canvasRef.current.setHeight(900);

      // destroy fabric on unmount
      return () => {
        if (canvasRef.current != null) {
          canvasRef.current.destroy();
          canvasRef.current = null;  
        }
      };
    }, []);
*/
  const {settings, setSettings} = useContext(SettingsContext);
  const getBlockPropertyMappedValue = (blockPropertyId) => {

    if (settings.accountSettings === undefined) return undefined;
  
    const match = settings.accountSettings.blocksPropertiesMappings.find(bp => bp.blockPropertyId === blockPropertyId)
    return match !== undefined ? match.propValue : undefined;
  }
  
  /* ---------------- START QuickBlockSettings -------------------- */
  const [quickBlocksSettings, setQuickBlocksSettings] = useState([]);

  const getQuickBlocksSettings = async() => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/User/QuickBlocksSettings`;

      const response = await axios.get(url);
    const settings = response.data.map(s => {
                            if (s.metadata) return {...s, metadata: JSON.parse(s.metadata)}
                            else return s;
    })
      setQuickBlocksSettings(settings)

    } catch (error) {
    }
    finally {
    }

  }

  useEffect(() => {
    getQuickBlocksSettings()
  }, [])
  /* ---------------- END QuickBlockSettings -------------------- */


    useEffect(() => {
      setUserSettingsColumnPrettyNames(settings.feedCustomColumnsPretty);
/*
      // Prepare data to pass to the PrettyNamesMapper component via props
      async function getDataFromStore() {
        const settings = await store.getState().userSettings.feedCustomColumnsPretty;
        setUserSettingsColumnPrettyNames(settings.feedCustomColumnsPretty);
      };
      getDataFromStore();
      */
    }, [settings]);


    // const [showSubmit, setShowSubmit] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [previewImageData, setPreviewImageData] = useState(false);
    const [previewUrlParamsValues, setPreviewUrlParamsValues] = useState([]);
    const [previewItemsFilters, setPreviewItemsFilters] = useState(null);
    const [previewPos, setPreviewPos] = useState(1);
    const [itemIdLookup, setItemIdLookup] = useState(''); // used to prepare previewItemsFilters
    const [clearFilter, setClearFilter] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    // const [colPrettyNamesMappings, setColPrettyNamesMappings] = useState({});
    const [userSettingsColumnPrettyNames, setUserSettingsColumnPrettyNames] = useState({});
    const [showLoader, setShowLoader] = useState(false);

    const [voteAllTemplates, setVoteAllTemplates] = useState([{}]);
    const [voteCurrentTemplateNum, setVoteCurrentTemplateNum] = useState(0);
    const [voteNumTemplates, setVoteNumTemplates] = useState(1);
    //const [voteSwappingTemplates, setVoteSwappingTemplates] = useState(false);

    const [animationSettings, setAnimationSettings] = useState(undefined)

    const [activeErrorList, setActiveErrorList] = useState([]);
    const templateValidationSchema = yupObject({
       templateName: string().required("Required field"),
       templateDescription: string().required("Required field"),
    });

    const [zoomLevel, setZoomLevel] = useState(1)

    const deleteCustomNodes = () => {
        // function to remove any custom nodes such as "delete" (trash-icon) node
        // any custom node will contain an underscore as part of  its id
        const nodesToDelete = canvasRef.current.find(n => (n.attrs.id !== undefined && n.attrs.id.includes('_')));
        nodesToDelete.forEach(n => n.destroy());

    }
    const deleteAllNodes = () => {
      // function to remove any custom nodes such as "delete" (trash-icon) node
      // any custom node will contain an underscore as part of  its id
      // const nodesToDelete = canvasRef.current.find(n => (n.getType() === 'Node'));
      const nodesToDelete = canvasRef.current.find(n => n.attrs.id !== undefined);
      nodesToDelete.forEach(n => n.destroy());

  }

    const prepareModelToPost = (templateModel, urlParams, filters) => {
        // object to post: {
        //                    model: {this is the Konva obj}, 
        //                    templateIsRetina: bool flag
        //                   canvas: {the object canvasProps which is necessary because Konva doesn't handle the background well}
        //                    dataConnectionId, etc...
        //                    urlParameters: array with test values
        //                    previewItems: object  with rules on to filter products to preview 
        //                    fadeInFunction: optional fade id effect
        //                    animation: optional settings {duration: , loop:, pauseBetweenLoops:}
        //                    for the preview we also pass any url parameter test value inserted by users, etc...
        // }

        // if urlParams have been passed as a parameter we use those
        // otherwise we use the ones from the state (previewUrlParamsValues)
        const params = urlParams === undefined ? previewUrlParamsValues : urlParams;
        const filterParams = filters === undefined ? previewItemsFilters : filters;
        //console.log(filters)
        //console.log(templateModel)
        const result = {model: JSON.parse(templateModel),
                            templateIsRetina: templateIsRetina,
                            canvas: canvasProps,
                            dataConnectionId: dataConnection === undefined ? null : dataConnection.id,
                            previewItems: filterParams,
                            productTypeId: snippetTypeId,
                            weatherSettings: {...weatherSettings, locationId: selectedWeatherLocationId},
                            //"fadeInFunction": fadeInFunction,
                            urlParameters: params};
        if (animationSettings) result.animation = animationSettings;

        return result;
    }

    const getTemplatePreview = async (templateModel, urlParams, filters) => {
      try {
        const url = `${process.env.REACT_APP_LION_API_URL}/Templates/preview`;
        //const dataFormUrlEncoded = new URLSearchParams({templateJson: templateModelJSON});

        const requestObj = prepareModelToPost(templateModel, urlParams, filters)
        const response = await axios.post(url, requestObj);

        //const url = `api/Templates/preview`;
        //const response = await fetch(url, { method: "POST", body: JSON.stringify(requestObj) });    
        //response.data = await response.json();
        //console.log(response.data)

        setPreviewLoading(false);
        setPreviewImageData(`data:image/jpg;base64,${response.data.imageBase64}`);
        if (snippetTypeId !== 18) setSampleData(response.data.dataRow)
        // console.log(JSON.stringify(templateModel));

      } catch (error) {
        setPreviewLoading(false);
        console.log(error);
      }
    }
    const getImageInfo = async (imageUrl) => {
      if (imageUrl === undefined ||  imageUrl === null) return;

      try {
        const url = `${process.env.REACT_APP_LION_API_URL}/Utils/isAnimation`;
        //const dataFormUrlEncoded = new URLSearchParams({templateJson: templateModelJSON});

        const requestObj = {'imageUrl': imageUrl};

        const response = await axios.post(url, requestObj);

        //const url = `api/Utils/isAnimation`;
        //const response = await fetch(url, { method: "POST", body: JSON.stringify(requestObj) });    
        //response.data = await response.json();


        if (response.data.isAnimated) setCanvasBackgroundImageShowAnimationSelector(true);
        else {
          setCanvasBackgroundImageShowAnimationSelector(false);
          const newCanvasProps = {...canvasProps, isImageAnimated: false}
          console.log('getImageInfo')          
          updateCanvas(newCanvasProps);
        }
        
        //console.log(response.data);

      } catch (error) {
        setPreviewLoading(false);
        console.log(error);
      }
    }

    const getUrlParametersFromModel = (templateModel) => {
      const results = [];
      // we have 1 konva stage and 1 konva layer on top of the blocks;
      const blocks = templateModel.children[0].children;

      blocks.forEach(b => {
        if (b.attrs.dataBindType !== undefined && b.attrs.dataBindType === 'url') {
          //const paramName = b.attrs.textRaw.replace('param(', '').slice(0, -1)
          const paramName = b.attrs.dataBindValue;
          const paramDesignTimeValue = b.attrs.textRaw;

          results.push({name: paramName, value: paramDesignTimeValue});
        }
      })

      return results;
    }

    const changePreviewUrlParamValue = (index, newValue) => {
      const newParams = [...previewUrlParamsValues];
      const param = newParams[index];
      const newParam = {...param, value: newValue};

      const result = newParams.splice(index, 1, newParam)
      setPreviewUrlParamsValues(newParams);
    }
    const changePreviewPosAndRefresh = (increment) => {
      if (increment === -1 && previewPos === 1) return;
      setItemIdLookup(''); // clearing the lookup filter

      const newPos = previewPos + increment;
      setPreviewPos(newPos);
      const newPreviewItems = {...previewItemsFilters, position: newPos, lookupById_Catalogs: ''}
      setPreviewItemsFilters(newPreviewItems)

      // we trigger a new preview
      setPreviewImageData('');
      setPreviewLoading(true);
      getTemplatePreview(serializeCanvas(),undefined,newPreviewItems);
    }
    const changePreviewPosNoRefresh = (newPosition) => {
      setPreviewPos(newPosition);
      const newPreviewItems = {...previewItemsFilters, position: newPosition}
      setPreviewItemsFilters(newPreviewItems)

    }
    const handleLookupByIdChange = (newId) => {
      console.log(newId)
      setItemIdLookup(newId);
      // setClearFilter(true)
      // const newPreviewItems = {...previewItemsFilters, lookupById_Catalogs: newId, filters: []}
      const newPreviewItems = {...previewItemsFilters, lookupById_Catalogs: newId}
      setPreviewItemsFilters(newPreviewItems)

    }
    const handleFilterChange = (newFilter) => {
      setPreviewPos(1);
      //setItemIdLookup('');
      setClearFilter(false)
      const newPreviewItems = {...previewItemsFilters, lookupById_Catalogs: '', filters: newFilter}
      setPreviewItemsFilters(newPreviewItems)
      //console.log(newPreviewItems)


      if (newFilter.length > 0) {
        // we check for filter requiring url parameters
        // if found any, then we add the necessary parameters to the previewUrlParamsValues object so that the UI will allow to edit them in preview
        const filtersWithUrlParams = newFilter.filter(item => item.valueOrigin === 'url')
        const newPreviewUrlParamsValues = getUrlParametersFromModel(canvasRef.current.toObject())
        filtersWithUrlParams.forEach(f => {
          if (newPreviewUrlParamsValues.findIndex(item => item.name === f.value) === -1) {
            if (f.value !== '') newPreviewUrlParamsValues.push({name: f.value, value: ''})
          } 
        })
        setPreviewUrlParamsValues(newPreviewUrlParamsValues)
      }
    }
    const resetFilters = () => {
      setPreviewPos(1);
      setItemIdLookup('');
      setClearFilter(true)
      const newPreviewItems = {...previewItemsFilters, lookupById_Catalogs: '', filters: []}
      setPreviewItemsFilters(newPreviewItems)

    }

    const handleFindById = () => {
      setPreviewPos(1);
      setClearFilter(true)
      const newPreviewItems = {...previewItemsFilters, lookupById_Catalogs: itemIdLookup, filters: []}
      setPreviewItemsFilters(newPreviewItems)

      setPreviewImageData('');
      setPreviewLoading(true);
      getTemplatePreview(serializeCanvas());
    }

const clearSelectedBlocks = () => {
  // there are some konva issues thar are esolved if we clear the selected items
  // so we use this functions in various part as a workaround
  const stage = canvasRef.current;
  const nodesToDelete = stage.find(n => (n.attrs.id !== undefined && n.attrs.id.includes('_')));
  nodesToDelete.forEach(n => n.destroy());
  setSelectedObjects([stage.lionProps]);
  const tr = stage.getLayers()[0].find('Transformer')[0];
  tr.nodes([]);
}

const getStartTextForBlocks = () => {
  const sentences = ["Fill this text box with branded brilliance",
                    "Insert your textual masterpiece here",
                    "Add your words here, wordsmith",
  ]
  const randomIndex = Math.floor(Math.random() * sentences.length);

  return sentences[randomIndex];
}
const handleAddImage = (e, tMetadata, mappedBindValue, positionIndexOnStage) => {
  setCurrentTab('objInspector')
  const imgBlock = new Image();
  imgBlock.firstLoad = true;
  let konvaImg;
  
  imgBlock.onload = () => {
    const [newWidth, newHeight] = imageAutoResize(imgBlock.width, imgBlock.height);

    if (!imgBlock.firstLoad) {
      konvaImg.setAttrs({width: newWidth, height: newHeight, 
        imageWidth: newWidth, imageHeight: newHeight, imageUrl: imgBlock.src});
      //if (imgBlock.src !== `${process.env.REACT_APP_LION_UI_ASSETS_BASE_URL}imagePlaceholder.png`) konvaImg.setAttr('imageUrl', imgBlock.src)

      // when we change the image src we want the UI to update witbh no selected items
      // we select the canvas
      clearSelectedBlocks();

      // setSelectedObjects([konvaImg]);
      return;
    }
    
    imgBlock.firstLoad = false;
    if (tMetadata === undefined) {
      konvaImg = new Konva.Image({
        id: RandomId(20),
        x: 100,
        y: 100,
        image: imgBlock,
        width: mappedBindValue === undefined ? 284 : newWidth,
        height: mappedBindValue === undefined ? 163 : newHeight,
        imageWidth: mappedBindValue === undefined ? 284 : newWidth,
        imageHeight: mappedBindValue === undefined ? 163 : newHeight,
        draggable: true,
        dataBindType: mappedBindValue === undefined ? 'none' : 'databind',
        dataBindValue: mappedBindValue,
        imageUrl: mappedBindValue === undefined ? imgBlock.src : sampleData[mappedBindValue],
        animation: {totalSeconds: 4000},
      });
  
    }
    else {
      konvaImg = new Konva.Image({
        //id: RandomId(20),
        id: tMetadata.attrs.id, //we need to keep this id consisten among edits so that variant viewer can pick up the image blocks correctly
        x: tMetadata.attrs.x,
        y: tMetadata.attrs.y,
        image: imgBlock,
        width: tMetadata.attrs.width,
        height: tMetadata.attrs.height,
        imageWidth: tMetadata.attrs.width,
        imageHeight: tMetadata.attrs.height,
        rotation: tMetadata.attrs.rotation,
        skewX: tMetadata.attrs.skewX,
        skewY: tMetadata.attrs.skewY,
    
        draggable: true,
        dataBindType: tMetadata.attrs.dataBindType,
        dataBindValue: tMetadata.attrs.dataBindValue,
        textTransforms: tMetadata.attrs.textTransforms,
        conditionalProperties: tMetadata.attrs.conditionalProperties,
        visibilityConditions: tMetadata.attrs.visibilityConditions,
        imageUrl: imgBlock.src,
        layerName: tMetadata.attrs.layerName,
        animation: tMetadata.attrs.animation,
      });

      
    }
    canvasRef.current.getLayers()[0].add(konvaImg);

    //moving the image in the right position //image is create after the onload event and it would go always to the top
    //if (positionIndexOnStage) {
    //  konvaImg.moveToBottom();
    //  for (let i=0; i<positionIndexOnStage; i++) konvaImg.moveUp()  
    //}
    //simple logic for now we put the image at the bottom of everything
    konvaImg.moveToBottom();

    konvaImg.getLayer().draw();
    const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

    konvaImg.dragBoundFunc(function (pos) {
      // Make sure the rectangle stays within the canvas bounds
      const stageWidth = canvasRef.current.width();
      const stageHeight = canvasRef.current.height();
    
      const rectWidth = this.width() * this.scaleX();
      const rectHeight = this.height() * this.scaleY();
    
      const newX = Math.max(0, Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
      const newY = Math.max(0, Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));
    
      return {
        x: newX,
        y: newY,
      };
    },
    )

    
    konvaImg.on('click', (e) => {
      //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
      const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
      const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
      const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
      const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
      tr.nodes([]);
      trNoResize.nodes([]);
      
      deleteCustomNodes();
      addDeleteBlockButton(konvaImg.attrs.id, konvaImg.attrs.x ,konvaImg.attrs.y, konvaImg.attrs.width, konvaImg.attrs.height);
      const selectedObj = e.target.toObject();
      selectedObj.attrs.width = e.target.attrs.width;
      selectedObj.attrs.height = e.target.attrs.height;

      selectedObj.attrs.imageUrl = e.target.attrs.image.currentSrc;
      setSelectedObjects([selectedObj]);
      e.cancelBubble = true;

      tr.moveToTop();
      tr.enabledAnchors(['top-left', 'top-right', 'bottom-left', 'bottom-right']);
      tr.nodes([e.target]);
    });
    konvaImg.on('dragmove', (e) => {
      synchDeleteBlockButtonPosition(e.target);
      setSelectedObjects([e.target.toObject()]);
    });
    konvaImg.on('mouseover', (e) => {
      document.body.style.cursor = 'pointer';
    });
    konvaImg.on('mouseout', (e) => {
      document.body.style.cursor = 'default';
    });
  
    konvaImg.on('transform', () => {
      konvaImg.setAttrs({
        x: Math.round(konvaImg.x()),
        y: Math.round(konvaImg.y()),
        width: Math.round(konvaImg.width() * konvaImg.scaleX()),
        height: Math.round(konvaImg.height() * konvaImg.scaleY()),
        imageWidth: Math.round(konvaImg.width() * konvaImg.scaleX()),
        imageHeight: Math.round(konvaImg.height() * konvaImg.scaleY()),
          });
      setSelectedObjects([konvaImg.toObject()]);
    });

    
  };

  imgBlock.onerror = () => {
    console.log('error loading image')
    console.log(imgBlock.src)
    imgBlock.src = `${process.env.REACT_APP_LION_UI_ASSETS_BASE_URL}imagePlaceholder.png`
  }

  if (tMetadata === undefined) {
     if (mappedBindValue === undefined) imgBlock.src = `${process.env.REACT_APP_LION_UI_ASSETS_BASE_URL}imagePlaceholder.png`;
     else imgBlock.src = sampleData[mappedBindValue];
  }
  else {
    //console.log(tMetadata)
    imgBlock.src = tMetadata.attrs.imageUrl;

  }


}
const handleAddImageFromCustomAttrs = (customAttrs) => {
  setCurrentTab('objInspector')
  const imgBlock = new Image();
  imgBlock.firstLoad = true;
  let konvaImg;
  
  imgBlock.onload = () => {
    const [newWidth, newHeight] = imageAutoResize(imgBlock.width, imgBlock.height);

    if (!imgBlock.firstLoad) {
      konvaImg.setAttrs({width: newWidth, height: newHeight, 
        imageWidth: newWidth, imageHeight: newHeight, imageUrl: imgBlock.src});
      clearSelectedBlocks();

      return;
    }
    
    imgBlock.firstLoad = false;
    
    konvaImg = new Konva.Image({
      id: RandomId(20),
      x: 100,
      y: 100,
      image: imgBlock,
      width: customAttrs.width,
      height: customAttrs.height,
      imageWidth: customAttrs.width,
      imageHeight: customAttrs.height,
      draggable: true,
      dataBindType: customAttrs.dataBindType,
      //dataBindValue: customAttrs.dataBindValue,
      imageUrl: customAttrs.imageUrl,
    });
  


    canvasRef.current.getLayers()[0].add(konvaImg);

    //moving the image in the right position //image is create after the onload event and it would go always to the top
    //if (positionIndexOnStage) {
    //  konvaImg.moveToBottom();
    //  for (let i=0; i<positionIndexOnStage; i++) konvaImg.moveUp()  
    //}
    //simple logic for now we put the image at the bottom of everything
    konvaImg.moveToBottom();

    konvaImg.getLayer().draw();
    const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

    konvaImg.dragBoundFunc(function (pos) {
      // Make sure the rectangle stays within the canvas bounds
      const stageWidth = canvasRef.current.width();
      const stageHeight = canvasRef.current.height();
    
      const rectWidth = this.width() * this.scaleX();
      const rectHeight = this.height() * this.scaleY();
    
      const newX = Math.max(0, Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
      const newY = Math.max(0, Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));
    
      return {
        x: newX,
        y: newY,
      };
    },
    )

    
    konvaImg.on('click', (e) => {
      deleteCustomNodes();
      addDeleteBlockButton(konvaImg.attrs.id, konvaImg.attrs.x ,konvaImg.attrs.y, konvaImg.attrs.width, konvaImg.attrs.height);
      const selectedObj = e.target.toObject();
      selectedObj.attrs.width = e.target.attrs.width;
      selectedObj.attrs.height = e.target.attrs.height;

      selectedObj.attrs.imageUrl = e.target.attrs.image.currentSrc;
      setSelectedObjects([selectedObj]);
      e.cancelBubble = true;

      tr.moveToTop();
      tr.enabledAnchors(['top-left', 'top-right', 'bottom-left', 'bottom-right']);
      tr.nodes([e.target]);
    });
    konvaImg.on('dragmove', (e) => {
      synchDeleteBlockButtonPosition(e.target);
      setSelectedObjects([e.target.toObject()]);
    });
    konvaImg.on('mouseover', (e) => {
      document.body.style.cursor = 'pointer';
    });
    konvaImg.on('mouseout', (e) => {
      document.body.style.cursor = 'default';
    });
  
    konvaImg.on('transform', () => {
      konvaImg.setAttrs({
        x: Math.round(konvaImg.x()),
        y: Math.round(konvaImg.y()),
        width: Math.round(konvaImg.width() * konvaImg.scaleX()),
        height: Math.round(konvaImg.height() * konvaImg.scaleY()),
        imageWidth: Math.round(konvaImg.width() * konvaImg.scaleX()),
        imageHeight: Math.round(konvaImg.height() * konvaImg.scaleY()),
          });
      setSelectedObjects([konvaImg.toObject()]);
    });

    
  };

  imgBlock.onerror = () => {
    console.log('error loading image')
    console.log(imgBlock.src)
    imgBlock.src = `${process.env.REACT_APP_LION_UI_ASSETS_BASE_URL}imagePlaceholder.png`
  }

  
  imgBlock.src = customAttrs.imageUrl

}
const imageAutoResize = (imgWidth, imgHeight) => {
  const maxLength = 300 // max length of the longest side
  if (imgWidth < maxLength && imgHeight < maxLength) return [imgWidth, imgHeight];
  if (imgWidth >= imgHeight) {
    const ratio = imgWidth / maxLength;
    imgWidth = maxLength;
    imgHeight = Math.round(imgHeight / ratio);
  }
  else {
    const ratio = imgHeight / maxLength;
    imgHeight = maxLength;
    imgWidth = Math.round(imgWidth / ratio);
  }
  return [imgWidth, imgHeight]
}
const checkHandleConditionalPropertiesChanges = (konvaObj) => {
    // check and handle differences in the conditionalProperties
    // the props in the main obj and in the conditionalProperties models need to stay the same (if they were originally the same)

    if (konvaObj.attrs.conditionalProperties !== undefined && konvaObj.attrs.conditionalProperties.length > 0) {
      for (let i = 0; i<konvaObj.attrs.conditionalProperties.length; i+=1) {
        const currentModelAttrs =  konvaObj.attrs.conditionalProperties[i].model.attrs;
        if (currentModelAttrs.x === konvaObj.attrs.originalX) {
          currentModelAttrs.x = Math.round(konvaObj.x());
        }
        if (currentModelAttrs.y === konvaObj.attrs.originalY) {
          currentModelAttrs.y = Math.round(konvaObj.y());
        }
        if (currentModelAttrs.width === konvaObj.attrs.originalWidth) {
          currentModelAttrs.width = Math.round(konvaObj.attrs.width);
        }
        if (currentModelAttrs.height === konvaObj.attrs.originalHeight) {
          currentModelAttrs.height = Math.round(konvaObj.attrs.height);
        }
      }
    }

}
const getBlockInitialPosition = () => {
  const blockWidth = Math.min(300, canvasRef.current.lionProps.width - 20);
  const blockHeight = Math.min(40, canvasRef.current.lionProps.height);

  return [(canvasRef.current.lionProps.width - blockWidth) / 2, (canvasRef.current.lionProps.height - blockHeight) / 2, blockWidth, blockHeight]
}

const handleAddTextBlock = (e, tMetadata, mappedBindValue, blockAttrs) => {
  setCurrentTab('objInspector')
  let text = null;
  const startText = getStartTextForBlocks();
  const [initX, initY, initWidth, initHeight] = getBlockInitialPosition();
  const applyTransforms = (transforms, text) => {
    if (transforms === undefined || transforms === null) return text;
    return `${transforms.prefix}${text}${transforms.suffix}`
  }

  if (tMetadata === undefined) {
    text =  new Konva.Text({
      id: RandomId(20),
      x: (blockAttrs && blockAttrs.x) ? blockAttrs.x : initX,
      y: (blockAttrs && blockAttrs.y) ? blockAttrs.y : initY,
      width: (blockAttrs && blockAttrs.width) ? blockAttrs.width : initWidth,
      height: (blockAttrs && blockAttrs.height) ? blockAttrs.height : initHeight,
      lineHeight: 1.1,
      text: (blockAttrs && blockAttrs.text) ? blockAttrs.text : (mappedBindValue === undefined ? startText : sampleData[mappedBindValue]),
      textRaw: (blockAttrs && blockAttrs.textRaw) ? blockAttrs.textRaw : (mappedBindValue === undefined ? startText : sampleData[mappedBindValue]),
      textTransforms: (blockAttrs && blockAttrs.textTransforms) ? blockAttrs.textTransforms : undefined,
      fontSize: (blockAttrs && blockAttrs.fontSize) ? blockAttrs.fontSize : 30,
      fontId: (blockAttrs && blockAttrs.fontId) ? blockAttrs.fontId : DEFAULT_FONT_ID,
      fontFamily: (blockAttrs && blockAttrs.fontFamily) ? blockAttrs.fontFamily :  DEFAULT_FONTNAME,
      fontStyle: (blockAttrs && blockAttrs.fontStyle) ? blockAttrs.fontStyle : '400',
      fontIsAutoSize: (blockAttrs && blockAttrs.fontIsAutoSize) ? blockAttrs.fontIsAutoSize : false,
      textDecoration: '',
      align: (blockAttrs && blockAttrs.align) ? blockAttrs.align : 'left',
      verticalAlign: 'top',
      fill: (blockAttrs && blockAttrs.fill) ? blockAttrs.fill : '#000',
      fillMode: 'solid',
      gradientType: 'linear',
      strokeWidth: 0,
      draggable: true,
      dataBindType: (blockAttrs && blockAttrs.dataBindType) ? blockAttrs.dataBindType : mappedBindValue === undefined ? 'none' : 'databind',
      dataBindValue: mappedBindValue,
      animation: (blockAttrs && blockAttrs.animation) ? blockAttrs.animation : {totalSeconds: 4000},
      name: 'objectSnappable', //used for the snap to grid
    });
    if (blockAttrs && blockAttrs.subType) text.setAttr('subType', blockAttrs.subType)
    if (blockAttrs && blockAttrs.textTransforms) text.setAttr('textTransforms', blockAttrs.textTransforms)

}
else {
  text = new Konva.Text({
    // id: RandomId(20),
    id: tMetadata.attrs.id,
    x: tMetadata.attrs.x,
    y: tMetadata.attrs.y,
    width: tMetadata.attrs.width,
    height: tMetadata.attrs.height,
    lineHeight: tMetadata.attrs.lineHeight,
    textRaw: tMetadata.attrs.textRaw,
    text: applyTransforms(tMetadata.attrs.textTransforms, tMetadata.attrs.textRaw),
    visibilityConditions: tMetadata.attrs.visibilityConditions,
    fontSize: tMetadata.attrs.fontSize,
    fontFamily: tMetadata.attrs.fontFamily,
    fontId: tMetadata.attrs.fontId,
    fontStyle: tMetadata.attrs.fontStyle,
    fontIsAutoSize: tMetadata.attrs.fontIsAutoSize,
    textDecoration: tMetadata.attrs.textDecoration,
    rotation: tMetadata.attrs.rotation,
    skewX: tMetadata.attrs.skewX,
    skewY: tMetadata.attrs.skewY,

    align: tMetadata.attrs.align,
    fill: tMetadata.attrs.fill,
    fillMode: tMetadata.attrs.fillMode,
    fillPriority: tMetadata.attrs.fillPriority,
    gradientType: tMetadata.attrs.gradientType,
    gradientDirection: tMetadata.attrs.gradientDirection,
    fillLinearGradientColorStops: tMetadata.attrs.fillLinearGradientColorStops,
    fillLinearGradientStartPointX: tMetadata.attrs.fillLinearGradientStartPointX,
    fillLinearGradientStartPointY: tMetadata.attrs.fillLinearGradientStartPointY,
    fillLinearGradientEndPointX: tMetadata.attrs.fillLinearGradientEndPointX,
    fillLinearGradientEndPointY: tMetadata.attrs.fillLinearGradientEndPointY,
    fillRadialGradientColorStops: tMetadata.attrs.fillRadialGradientColorStops,
    fillRadialGradientStartPointX: tMetadata.attrs.fillRadialGradientStartPointX,
    fillRadialGradientStartPointY: tMetadata.attrs.fillRadialGradientStartPointY,
    fillRadialGradientEndPointX: tMetadata.attrs.fillRadialGradientEndPointX,
    fillRadialGradientEndPointY: tMetadata.attrs.fillRadialGradientEndPointY,
    fillRadialGradientEndRadius: tMetadata.attrs.fillRadialGradientEndRadius,
    strokeWidth: tMetadata.attrs.strokeWidth,
    stroke: tMetadata.attrs.stroke,
    draggable: true,
    dataBindType: tMetadata.attrs.dataBindType,
    dataBindValue: tMetadata.attrs.dataBindValue,
    textTransforms: tMetadata.attrs.textTransforms,
    conditionalProperties: tMetadata.attrs.conditionalProperties,
    animation: tMetadata.attrs.animation,
    name: 'objectSnappable', //used for the snap to grid
    subType: tMetadata.attrs.subType,
    layerName: tMetadata.attrs.layerName,


  });
}


text.dragBoundFunc(function (pos) {
  // Make sure the rectangle stays within the canvas bounds
  const stageWidth = canvasRef.current.width();
  const stageHeight = canvasRef.current.height();

  const rectWidth = this.width() * this.scaleX();
  const rectHeight = this.height() * this.scaleY();

  const newX = Math.max(0, Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
  const newY = Math.max(0, Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));

  return {
    x: newX,
    y: newY,
  };
},
)

  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

  text.on('click', (e) => {
    //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
    const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
    const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
    const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
    tr.nodes([]);
    trNoResize.nodes([]);
    deleteCustomNodes();
    addDeleteBlockButton(text.attrs.id, text.attrs.x ,text.attrs.y, text.attrs.width, text.attrs.height);

    //IMPORTANT: toObject() doesn't always work with custom props
    // strokeWidth doesn't work all the time so need to set it manually
    // fontFamily doesn't work all the time so need to set it manually

    // setSelectedObjects([e.target.toObject()]);
    const selectedObj = e.target.toObject();
    selectedObj.attrs.strokeWidth = e.target.attrs.strokeWidth;
    selectedObj.attrs.fontFamily = e.target.attrs.fontFamily;
    setSelectedObjects([selectedObj]);

    e.cancelBubble = true;
    tr.moveToTop();

    tr.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
    tr.nodes([e.target]);
  });
  text.on('dragmove', (e) => {
    synchDeleteBlockButtonPosition(e.target);
    setSelectedObjects([e.target.toObject()]);
  });
  text.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  text.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });
  text.on('transformstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y(),
       originalWidth: text.attrs.width, originalHeight: text.attrs.height})
  })
  text.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y()})
  })
  text.on('dragend', (e) => {
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;


    //IMPORTANT: toObject() doesn't always work with custom props
    // strokeWidth doesn't work all the time so need to set it manually
    // fontFamily doesn't work all the time so need to set it manually
    const selectedObj = e.target.toObject();
    
    selectedObj.attrs.strokeWidth = e.target.attrs.strokeWidth;
    selectedObj.attrs.fontFamily = e.target.attrs.fontFamily;

    setSelectedObjects([selectedObj]);
    //setSelectedObjects([text.toObject()]);
  })

  text.on('transformend', () => {
    // check and handle differences in the conditionalProperties
    // the props in the main obj and in the conditionalProperties models need to stay the same (if they were originally the same)

    /*
    if (text.attrs.conditionalProperties !== undefined && text.attrs.conditionalProperties.length > 0) {
      for (let i = 0; i<text.attrs.conditionalProperties.length; i+=1) {
        const currentModelAttrs =  text.attrs.conditionalProperties[i].model.attrs;
        if (currentModelAttrs.x === text.attrs.originalX) {
          currentModelAttrs.x = Math.round(text.x());
        }
        if (currentModelAttrs.y === text.attrs.originalY) {
          currentModelAttrs.y = Math.round(text.y());
        }
        if (currentModelAttrs.width === text.attrs.originalWidth) {
          currentModelAttrs.width = Math.round(text.attrs.width);
        }
        if (currentModelAttrs.height === text.attrs.originalHeight) {
          currentModelAttrs.height = Math.round(text.attrs.height);
        }
      }
    }
    */
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    text.attrs.originalWidth = undefined;
    text.attrs.originalHeight = undefined;
    setSelectedObjects([text.toObject()]);
  })
  text.on('transform', () => {        
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    text.setAttrs({
      width: Math.round(text.width() * text.scaleX()),
      height: Math.round(text.height() * text.scaleY()),
      x: Math.round(text.x()),
      y: Math.round(text.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([text.toObject()]);
  });

  canvasRef.current.getLayers()[0].add(text);
  if (tMetadata === undefined) text.fire('click')
  return text;
}
const handleAddTimerBlock = (e, tMetadata, blockAttrs) => {
  setCurrentTab('objInspector')
  let text = null;
  if (tMetadata === undefined) text =  new Konva.Text({
    id: RandomId(20),
    x: blockAttrs !== undefined ? blockAttrs.x : 200,
    y: (blockAttrs && blockAttrs.y) ? blockAttrs.y : 100,
    width: (blockAttrs !== undefined && blockAttrs.width !== undefined) ? blockAttrs.width : 160,
    height: (blockAttrs && blockAttrs.height) ? blockAttrs.height : 60,
    lineHeight: 1.1,
    subType: 'Timer',

    timePart: blockAttrs !== undefined ? blockAttrs.timePart : 'seconds', //possible values: days, hours, minutes, seconds
    showLabel: blockAttrs !== undefined ? blockAttrs.showLabel : false,
    showRing: blockAttrs !== undefined ? blockAttrs.showRing : false,
    minTimePart: blockAttrs !== undefined ? blockAttrs.minTimePart : 'seconds',
    maxTimePart: blockAttrs !== undefined ? blockAttrs.maxTimePart : 'weeks',
    timePartSeparator: blockAttrs !== undefined ? blockAttrs.timePartSeparator : ', ',
    digitsToWord: false,
    // text: mappedBindValue === undefined ? 'Lorem ipsum, Hello world Text, ciao mondo, hola mundo' : sampleData[mappedBindValue],
    text: (blockAttrs !== undefined && blockAttrs.text !== undefined) ? blockAttrs.text : '00',
    fontSize: (blockAttrs !== undefined && blockAttrs.fontSize !== undefined) ? blockAttrs.fontSize : 48,
    fontId: DEFAULT_FONT_ID,
    fontFamily: DEFAULT_FONTNAME,
    fontStyle: '400',
    textDecoration: '',
    align: (blockAttrs !== undefined && blockAttrs.align !== undefined) ? blockAttrs.align : 'center',
    verticalAlign: 'top',
    fill: (blockAttrs && blockAttrs.fill) ? blockAttrs.fill : (getBlockPropertyMappedValue(1) !== undefined) ? getBlockPropertyMappedValue(1) : '#000',
    fillMode: 'solid',
    gradientType: 'linear',
    strokeWidth: 0,
    stroke: (getBlockPropertyMappedValue(5) !== undefined) ? getBlockPropertyMappedValue(5) : '#000',
    draggable: true,
    // dataBindType: mappedBindValue === undefined ? 'none' : 'databind',
    // dataBindValue: mappedBindValue,
    dataBindType: 'none',
    dataBindValue: '',
    animation: {totalSeconds: 4000}, //not used in timers
    name: 'objectSnappable', //used for the snap to grid
  });
else {
  text = new Konva.Text({
    //id: RandomId(20),
    id: tMetadata.attrs.id,
    x: tMetadata.attrs.x,
    y: tMetadata.attrs.y,
    width: tMetadata.attrs.width,
    height: tMetadata.attrs.height,
    lineHeight: tMetadata.attrs.lineHeight,
    subType: 'Timer',
    timePart: tMetadata.attrs.timePart,
    rotation: tMetadata.attrs.rotation,
    skewX: tMetadata.attrs.skewX,
    skewY: tMetadata.attrs.skewY,
    

    minTimePart: tMetadata.attrs.minTimePart,
    maxTimePart: tMetadata.attrs.maxTimePart,
    timePartSeparator: tMetadata.attrs.timePartSeparator,
    digitsToWord: tMetadata.attrs.digitsToWord,
    showLabel: tMetadata.attrs.showLabel,
    showRing: tMetadata.attrs.showRing,
    text: tMetadata.attrs.text,
    visibilityConditions: tMetadata.attrs.visibilityConditions,
    fontSize: tMetadata.attrs.fontSize,
    fontFamily: tMetadata.attrs.fontFamily,
    fontId: tMetadata.attrs.fontId,
    fontStyle: tMetadata.attrs.fontStyle,
    textDecoration: tMetadata.attrs.textDecoration,
    align: tMetadata.attrs.align,
    fill: tMetadata.attrs.fill,
    fillMode: tMetadata.attrs.fillMode,
    fillPriority: tMetadata.attrs.fillPriority,
    gradientType: tMetadata.attrs.gradientType,
    gradientDirection: tMetadata.attrs.gradientDirection,
    fillLinearGradientColorStops: tMetadata.attrs.fillLinearGradientColorStops,
    fillLinearGradientStartPointX: tMetadata.attrs.fillLinearGradientStartPointX,
    fillLinearGradientStartPointY: tMetadata.attrs.fillLinearGradientStartPointY,
    fillLinearGradientEndPointX: tMetadata.attrs.fillLinearGradientEndPointX,
    fillLinearGradientEndPointY: tMetadata.attrs.fillLinearGradientEndPointY,
    fillRadialGradientColorStops: tMetadata.attrs.fillRadialGradientColorStops,
    fillRadialGradientStartPointX: tMetadata.attrs.fillRadialGradientStartPointX,
    fillRadialGradientStartPointY: tMetadata.attrs.fillRadialGradientStartPointY,
    fillRadialGradientEndPointX: tMetadata.attrs.fillRadialGradientEndPointX,
    fillRadialGradientEndPointY: tMetadata.attrs.fillRadialGradientEndPointY,
    fillRadialGradientEndRadius: tMetadata.attrs.fillRadialGradientEndRadius,
    strokeWidth: tMetadata.attrs.strokeWidth,
    stroke: tMetadata.attrs.stroke,
    draggable: true,
    dataBindType: tMetadata.attrs.dataBindType,
    dataBindValue: tMetadata.attrs.dataBindValue,
    textTransforms: tMetadata.attrs.textTransforms,
    conditionalProperties: tMetadata.attrs.conditionalProperties,
    animation: tMetadata.attrs.animation,
    name: 'objectSnappable', //used for the snap to grid
    layerName: tMetadata.attrs.layerName,
  });
}

  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

  text.dragBoundFunc(function (pos) {
    // Make sure the rectangle stays within the canvas bounds
    const stageWidth = canvasRef.current.width();
    const stageHeight = canvasRef.current.height();
  
    const rectWidth = this.width() * this.scaleX();
    const rectHeight = this.height() * this.scaleY();
  
    const newX = Math.max(0, Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
    const newY = Math.max(0, Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));
  
    return {
      x: newX,
      y: newY,
    };
  },
  )
  
  text.on('click', (e) => {
    //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
    const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
    const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
    const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
    tr.nodes([]);
    trNoResize.nodes([]);

    deleteCustomNodes();
    addDeleteBlockButton(text.attrs.id, text.attrs.x ,text.attrs.y, text.attrs.width, text.attrs.height, true);
    //IMPORTANT: toObject() doesn't always work with custom props
    // strokeWidth doesn't work all the time so need to set it manually
    // fontFamily doesn't work all the time so need to set it manually
    
    // setSelectedObjects([e.target.toObject()]);
    const selectedObj = e.target.toObject();
    selectedObj.attrs.strokeWidth = e.target.attrs.strokeWidth;
    selectedObj.attrs.fontFamily = e.target.attrs.fontFamily;
    //selectedObj.attrs.rotation = e.target.attrs.rotation;

    setSelectedObjects([selectedObj]);
    const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${text.attrs.id}`)[0];
    setTimerLabelBlock(labelBlock);
    const ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${text.attrs.id}`)[0];
    setTimerRingBlock(ringBlock);
    
    e.cancelBubble = true;

    tr.moveToTop();
    tr.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
    tr.nodes([e.target]);
  });
  text.on('dragmove', (e) => {
    synchDeleteBlockButtonPosition(e.target);
    synchTimerLabelBlockPosition(e.target);
    synchTimerRingBlockPosition(e.target)
    setSelectedObjects([e.target.toObject()]);
  });
  text.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  text.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });
  text.on('transformstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y(),
       originalWidth: text.attrs.width, originalHeight: text.attrs.height})
  })
  text.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y()})
  })
  text.on('dragend', () => {
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    setSelectedObjects([text.toObject()]);
  })

  text.on('transformend', () => {
    // check and handle differences in the conditionalProperties
    // the props in the main obj and in the conditionalProperties models need to stay the same (if they were originally the same)

    /*
    if (text.attrs.conditionalProperties !== undefined && text.attrs.conditionalProperties.length > 0) {
      for (let i = 0; i<text.attrs.conditionalProperties.length; i+=1) {
        const currentModelAttrs =  text.attrs.conditionalProperties[i].model.attrs;
        if (currentModelAttrs.x === text.attrs.originalX) {
          currentModelAttrs.x = Math.round(text.x());
        }
        if (currentModelAttrs.y === text.attrs.originalY) {
          currentModelAttrs.y = Math.round(text.y());
        }
        if (currentModelAttrs.width === text.attrs.originalWidth) {
          currentModelAttrs.width = Math.round(text.attrs.width);
        }
        if (currentModelAttrs.height === text.attrs.originalHeight) {
          currentModelAttrs.height = Math.round(text.attrs.height);
        }
      }
    }
    */
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    text.attrs.originalWidth = undefined;
    text.attrs.originalHeight = undefined;
    setSelectedObjects([text.toObject()]);
  })
  text.on('transform', (e) => {        
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    text.setAttrs({
      width: Math.round(text.width() * text.scaleX()),
      height: Math.round(text.height() * text.scaleY()),
      x: Math.round(text.x()),
      y: Math.round(text.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([text.toObject()]);
    synchTimerLabelBlockPosition(e.target);
    synchTimerRingBlockPosition(e.target);
  });

  canvasRef.current.getLayers()[0].add(text);
  return text;
}
const handleAddTimerBlocks = (blockTypes, canvasSize, includeTimePartsSeparator, digitsColor) => {
  //console.log(blockTypes)
  const alignmentInfo = centerFitTimeParts(blockTypes, canvasSize ? canvasSize.width : canvasProps.width, canvasSize ? canvasSize.height : canvasProps.height)
  //used by the shortcut menu
  let block = undefined;
  const blockAttrs = {x: alignmentInfo.startX, y: alignmentInfo.startY, fontSize: alignmentInfo.timerBlockFontSize,
                      width: alignmentInfo.timerBlockWidth,
                       height: alignmentInfo.timerBlockHeight,
                       fill: digitsColor,
                        showLabel: true}
  switch(blockTypes) {
    case "dd:hh:mm:ss":
      //console.log(includeTimePartsSeparator)
      blockAttrs.timePart = 'days';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Days', alignmentInfo.labelBlockFontSize)
      blockAttrs.x += alignmentInfo.timerBlockWidth;
      blockAttrs.width = alignmentInfo.separatorBlockWidth;
      if (includeTimePartsSeparator) handleAddTimerSeparatorBlock(undefined, undefined, blockAttrs);
      blockAttrs.x += alignmentInfo.separatorBlockWidth;  
      blockAttrs.width = alignmentInfo.timerBlockWidth;
      blockAttrs.timePart = 'hours';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Hours', alignmentInfo.labelBlockFontSize)
      blockAttrs.x += alignmentInfo.timerBlockWidth;
      blockAttrs.width = alignmentInfo.separatorBlockWidth;
      if (includeTimePartsSeparator) handleAddTimerSeparatorBlock(undefined, undefined, blockAttrs);
      blockAttrs.x += alignmentInfo.separatorBlockWidth;
      blockAttrs.width = alignmentInfo.timerBlockWidth;
      blockAttrs.timePart = 'minutes';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Minutes', alignmentInfo.labelBlockFontSize)
      blockAttrs.x += alignmentInfo.timerBlockWidth;
      blockAttrs.width = alignmentInfo.separatorBlockWidth;
      if (includeTimePartsSeparator) handleAddTimerSeparatorBlock(undefined, undefined, blockAttrs);
      blockAttrs.x += alignmentInfo.separatorBlockWidth;
      blockAttrs.width = alignmentInfo.timerBlockWidth;
      blockAttrs.timePart = 'seconds';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Seconds', alignmentInfo.labelBlockFontSize)
    break;
    case "hh:mm:ss":
      blockAttrs.timePart = 'hours';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Hours', alignmentInfo.labelBlockFontSize)
      blockAttrs.x += alignmentInfo.timerBlockWidth;
      blockAttrs.width = alignmentInfo.separatorBlockWidth;
      if (includeTimePartsSeparator) handleAddTimerSeparatorBlock(undefined, undefined, blockAttrs);
      blockAttrs.x += alignmentInfo.separatorBlockWidth;
      blockAttrs.width = alignmentInfo.timerBlockWidth;
      blockAttrs.timePart = 'minutes';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Minutes', alignmentInfo.labelBlockFontSize)
      blockAttrs.x += alignmentInfo.timerBlockWidth;
      blockAttrs.width = alignmentInfo.separatorBlockWidth;
      if (includeTimePartsSeparator) handleAddTimerSeparatorBlock(undefined, undefined, blockAttrs);
      blockAttrs.x += alignmentInfo.separatorBlockWidth;
      blockAttrs.width = alignmentInfo.timerBlockWidth;
      blockAttrs.timePart = 'seconds';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Seconds', alignmentInfo.labelBlockFontSize)
    break;
    case "hh:mm":
      blockAttrs.timePart = 'hours';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Hours', alignmentInfo.labelBlockFontSize)
      blockAttrs.x += alignmentInfo.timerBlockWidth;
      blockAttrs.width = alignmentInfo.separatorBlockWidth;
      if (includeTimePartsSeparator) handleAddTimerSeparatorBlock(undefined, undefined, blockAttrs);
      blockAttrs.x += alignmentInfo.separatorBlockWidth;
      blockAttrs.width = alignmentInfo.timerBlockWidth;
      blockAttrs.timePart = 'minutes';
      block = handleAddTimerBlock(undefined, undefined, blockAttrs);
      handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Minutes', alignmentInfo.labelBlockFontSize)
    break;
    case "singleBlock":
      block = handleAddTimerBlock();
      //handleAddTimerLabelBlock(undefined, undefined, block.attrs.id, 'Seconds')
    break;
    case "separatorBlock":
      block = handleAddTimerSeparatorBlock();
    break;
    case "sentence":
      block = handleAddTimerBlockAsSentence(canvasSize);
    break;
    default:
    break;
  }
}
const handleAddTextImage = (canvasSize, urlParamName) => {
  //we add one text block (large as approx 95% of the canvas with the correct url binding)
  const blockAttrs = {fontIsAutoSize: true, }
  //console.log(urlParamName)
  if (urlParamName === "I'll manually bind later") {
    blockAttrs.text = `Bind me to a url parameter`
    blockAttrs.textRaw = `Bind me to a url parameter`
  }
  else {
    //blockAttrs.dataBindType = 'url';
    blockAttrs.text = `${urlParamName}`
    blockAttrs.textRaw = `${urlParamName}`
    blockAttrs.subType = 'urlBoundBlock'
  }

  blockAttrs.width = canvasSize.width * .90;
  blockAttrs.x = (canvasSize.width - blockAttrs.width) / 2;

  blockAttrs.height = Math.min(140, canvasSize.height * .7);
  blockAttrs.y = (canvasSize.height - blockAttrs.height) / 2;

  //console.log(blockAttrs)
  const block = handleAddTextBlock(undefined, undefined, undefined, blockAttrs)
  block.setAttrs({
              dataBindType: 'url',
              dataBindValue: `${urlParamName}`,
              height: 42,
              subType: 'urlBoundBlock'})
}
const handleAddPersAnimations = (canvasSize, propsDic) => {
  const urlParamName = propsDic.textImageDatabind
  //we add one text block (large as approx 95% of the canvas with the correct url binding)
  const blockAttrs = {fontIsAutoSize: false, fontSize: 28 }
  //console.log(urlParamName)
  if (urlParamName === "I'll manually bind later") {
    blockAttrs.text = `Bind me to a url parameter`
    blockAttrs.textRaw = `Bind me to a url parameter`
  }
  else {
    //blockAttrs.dataBindType = 'url';
    blockAttrs.text = `${urlParamName}`
    blockAttrs.textRaw = `${urlParamName}`
    blockAttrs.subType = 'urlBoundBlock'
  }

  blockAttrs.width = canvasSize.width * .90;
  blockAttrs.x = (canvasSize.width - blockAttrs.width) / 2;

  //blockAttrs.height = Math.min(140, canvasSize.height * .7);
  blockAttrs.height = 42;
  blockAttrs.y = (canvasSize.height - blockAttrs.height) / 2;

  blockAttrs.fill = propsDic.fontColor

  blockAttrs.dataBindType = 'url'
  blockAttrs.subType = 'urlBoundBlock'

  //console.log(propsDic)
  //we need to map the props of the propsDic obj to the props of the block.animation obj

  const blockAnimationProps = {totalSeconds: propsDic.animationSettings.duration}
  if (propsDic.animationSettings.id === "typing") blockAnimationProps.textTyping = ["leftToRight"]
  if (propsDic.animationSettings.id === "flashing") blockAnimationProps.textFlashing = ["no params needed for now"]
  if (propsDic.animationSettings.id === "scrolling") blockAnimationProps.textScrolling = [{direction: "left"}]
  if (propsDic.animationSettings.id === "tumbling") blockAnimationProps.textTumble = ["downUp"]

  blockAttrs.animation = blockAnimationProps

  const block = handleAddTextBlock(undefined, undefined, `${urlParamName}`, blockAttrs)
  

  //console.log(blockAnimationProps)
  setAnimationSettings({duration: propsDic.animationSettings.duration, isLoop: propsDic.animationSettings.loop, pauseBetweenLoops: propsDic.animationSettings.pauseBetweenLoops})
}

const centerFitTimeParts = (blockType, canvasWidth, canvasHeight) => {
  /*result is an info object like this:
    result = {startX: , startY:
              ,timerBlockWidth:
              ,timerBlockHeight:
              ,timerBlockFontSize:
              ,separatorBlockWidth:
              ,labelBlockFontSize:
            }
  */
  const result = {startX: 10}
  let numTimerBlocks = 4;
  let numSeparatorBlocks = 3;
  const widthForTimerBlocks = 0.75;
  let fontSize = 12;
  //let separatorFontSize = 12;
  let width = 12;
  //console.log(timerBlockHeight)

  switch(blockType) {
    case "dd:hh:mm:ss":
      break;
    case "hh:mm:ss":
      numTimerBlocks = 3;
      numSeparatorBlocks = 2;
      break;
    case "hh:mm":
      numTimerBlocks = 2;
      numSeparatorBlocks = 1;
      break;
    default:
      break;
  }

  const timerBlockWidth = (canvasWidth * widthForTimerBlocks - 20) / numTimerBlocks
  const timerBlockHeight = (canvasHeight - 32 - 20); //32 space for time labels and 20 margin
  const separatorBlockWidth = (canvasWidth * (1 - widthForTimerBlocks) - 20) / numSeparatorBlocks

  for (let fSize = 12; fSize < 500; fSize += 2) {
    if (width > timerBlockWidth || fSize > timerBlockHeight) break; 
 
    width = getTextWidth('00', `${fSize}px ${DEFAULT_FONTNAME}`);
    fontSize = fSize;
  }

  const separatorWidth = getTextWidth(':', `${fontSize}px ${DEFAULT_FONTNAME}`);

  result.timerBlockWidth = width + 2; //2px safety margin
  result.timerBlockFontSize = fontSize;
  result.separatorBlockWidth = separatorWidth + 2; //2px safety margin
  result.timerBlockHeight = fontSize;

  const totalWidth = result.timerBlockWidth * numTimerBlocks + result.separatorBlockWidth * numSeparatorBlocks;
  result.startX = (canvasWidth - totalWidth) / 2;

  
  //finding fontSize for labels
  width = 12;
  for (let fSize = 8; fSize <= 32; fSize += 2) {
    if (width > result.timerBlockWidth - 8 || fSize > timerBlockHeight) break; 
 
    const widthMin = getTextWidth('Minutes000', `${fSize}px ${DEFAULT_FONTNAME}`); //we use 000 to adjust for longer words in other languages
    const widthSec = getTextWidth('Seconds000', `${fSize}px ${DEFAULT_FONTNAME}`);
    width = Math.max(widthMin, widthSec);
    fontSize = fSize;
  }
  result.labelBlockFontSize = fontSize;
  const totalHeight = result.timerBlockFontSize + result.labelBlockFontSize;
  result.startY = (canvasHeight - totalHeight) / 2;

  console.log(result)


  return result;
}
const centerFitTimeSentence = (canvasWidth, canvasHeight) => {
  /*result is an info object like this:
    result = {startX: , startY:
              ,sentenceBlockWidth:
              ,sentenceBlockHeight:
              ,sentenceBlockFontSize:
            }
  */
  const result = {startX: 10}
  let fontSize = 12;
  //let separatorFontSize = 12;
  let width = 12;
  //console.log(timerBlockHeight)


  const sentenceBlockWidth = (canvasWidth - 20)
  const sentenceBlockHeight = (canvasHeight - 20); //32 space for time labels and 20 margin

  for (let fSize = 12; fSize < 500; fSize += 2) {
    if (width > sentenceBlockWidth || fSize > sentenceBlockHeight) break; 
 
    width = getTextWidth('00 Days, 00 Hours, 00 Minutes, 00 Seconds,', `${fSize}px ${DEFAULT_FONTNAME}`);
    fontSize = fSize;
  }


  result.sentenceBlockWidth = width + 2; //2px safety margin
  result.sentenceBlockFontSize = fontSize;
  result.sentenceBlockHeight = fontSize;

  const totalWidth = result.sentenceBlockWidth;
  result.startX = (canvasWidth - totalWidth) / 2;

  
  const totalHeight = result.sentenceBlockHeight;
  result.startY = (canvasHeight - totalHeight) / 2;

  console.log(result)


  return result;
}
const getTextWidth = (text, font) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = font || getComputedStyle(document.body).font;

  return context.measureText(text).width;
}

const handleAddTimerLabelBlock = (e, tMetadata, timerBlockId, labelText, labelFontSize) => {
  const timerBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
  let text = null;
  if (tMetadata === undefined) text =  new Konva.Text({
    id: `timerLabel${timerBlockId}`,
    x: timerBlock.attrs.x,
    y: timerBlock.attrs.y + timerBlock.attrs.height,
    ccOffsetY: 0,
    width: timerBlock.attrs.width,
    height: 90,
    //height: labelFontSize ? labelFontSize : 60,
    lineHeight: 1,
    subType: 'TimerLabel',
    text: labelText !== undefined ? labelText : 'Seconds',
    fontSize: labelFontSize ? labelFontSize : 30,
    fontId: DEFAULT_FONT_ID,
    fontFamily: DEFAULT_FONTNAME,
    fontStyle: '400',
    textDecoration: '',
    align: 'center',
    fill: (getBlockPropertyMappedValue(2) !== undefined) ? getBlockPropertyMappedValue(2) : '#000',
    fillMode: 'solid',
    gradientType: 'linear',
    strokeWidth: 0,
    draggable: false,
    dataBindType: 'databind',
    dataBindValue: labelText !== undefined ? `label${labelText}` : 'labelSeconds',
    animation: {totalSeconds: 4000},
  });
else {
  text = new Konva.Text({
    // id: RandomId(20),
    id: tMetadata.attrs.id,
    x: tMetadata.attrs.x,
    y: tMetadata.attrs.y,
    ccOffsetY: tMetadata.attrs.ccOffsetY,
    width: tMetadata.attrs.width,
    height: tMetadata.attrs.height,
    lineHeight: tMetadata.attrs.lineHeight,
    subType: 'TimerLabel',
    text: tMetadata.attrs.text,
    fontSize: tMetadata.attrs.fontSize,
    fontFamily: tMetadata.attrs.fontFamily,
    fontId: tMetadata.attrs.fontId,
    fontStyle: tMetadata.attrs.fontStyle,
    textDecoration: tMetadata.attrs.textDecoration,
    align: tMetadata.attrs.align,
    fill: tMetadata.attrs.fill,
    fillMode: tMetadata.attrs.fillMode,
    fillPriority: tMetadata.attrs.fillPriority,
    gradientType: tMetadata.attrs.gradientType,
    gradientDirection: tMetadata.attrs.gradientDirection,
    fillLinearGradientColorStops: tMetadata.attrs.fillLinearGradientColorStops,
    fillLinearGradientStartPointX: tMetadata.attrs.fillLinearGradientStartPointX,
    fillLinearGradientStartPointY: tMetadata.attrs.fillLinearGradientStartPointY,
    fillLinearGradientEndPointX: tMetadata.attrs.fillLinearGradientEndPointX,
    fillLinearGradientEndPointY: tMetadata.attrs.fillLinearGradientEndPointY,
    fillRadialGradientColorStops: tMetadata.attrs.fillRadialGradientColorStops,
    fillRadialGradientStartPointX: tMetadata.attrs.fillRadialGradientStartPointX,
    fillRadialGradientStartPointY: tMetadata.attrs.fillRadialGradientStartPointY,
    fillRadialGradientEndPointX: tMetadata.attrs.fillRadialGradientEndPointX,
    fillRadialGradientEndPointY: tMetadata.attrs.fillRadialGradientEndPointY,
    fillRadialGradientEndRadius: tMetadata.attrs.fillRadialGradientEndRadius,
    strokeWidth: tMetadata.attrs.strokeWidth,
    stroke: tMetadata.attrs.stroke,
    draggable: true,
    dataBindType: tMetadata.attrs.dataBindType,
    dataBindValue: tMetadata.attrs.dataBindValue,
    textTransforms: tMetadata.attrs.textTransforms,
    conditionalProperties: tMetadata.attrs.conditionalProperties,
    animation: tMetadata.attrs.animation,
  });
}

  const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

  /*
  text.on('click', (e) => {
    deleteCustomNodes();
    addDeleteBlockButton(text.attrs.id, text.attrs.x ,text.attrs.y, text.attrs.width, text.attrs.height, true);
    //IMPORTANT: toObject() doesn't always work with custom props
    // strokeWidth doesn't work all the time so need to set it manually
    
    // setSelectedObjects([e.target.toObject()]);
    const selectedObj = e.target.toObject();
    selectedObj.attrs.strokeWidth = e.target.attrs.strokeWidth;
    setSelectedObjects([selectedObj]);
    const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${text.attrs.id}`)[0];
    setTimerLabelBlock(labelBlock);
    
    e.cancelBubble = true;
    tr.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
    tr.nodes([e.target]);
  });
  */

  canvasRef.current.getLayers()[0].add(text);
  return text;
}
const handleAddTimerBlockAsSentence = (canvasSize) => {
  const alignmentInfo = centerFitTimeSentence(canvasSize ? canvasSize.width : canvasProps.width, canvasSize ? canvasSize.height : canvasProps.height)

  const attrs = {text: "1 day, 1 hour, 1 minute, 1 second", timePart: "sentence", minTimePart: "seconds", maxTimePart: "weeks", timePartSeparator: ", ",
                x: alignmentInfo.startX, y: alignmentInfo.startY,  align:'left', fontSize: alignmentInfo.sentenceBlockFontSize,
                width: alignmentInfo.sentenceBlockWidth, height:alignmentInfo.sentenceBlockHeight,}
  handleAddTimerBlock(undefined, undefined, attrs);
}
const handleAddTimerSeparatorBlock = (e, tMetadata, blockAttrs) => {
  setCurrentTab('objInspector')
  let text = null;
  if (tMetadata === undefined) text =  new Konva.Text({
    id: RandomId(20),
    x: (blockAttrs !== undefined && blockAttrs.x !== undefined) ? blockAttrs.x : 50,
    y: (blockAttrs !== undefined && blockAttrs.y !== undefined) ? blockAttrs.y : 100,
    width: (blockAttrs && blockAttrs.width) ? blockAttrs.width : 40, 
    height: (blockAttrs && blockAttrs.height) ? blockAttrs.height : 60,
    verticalAlign: 'top',
    lineHeight: 1,
    subType: 'TimerSeparator',
    text: (blockAttrs !== undefined && blockAttrs.text !== undefined) ? blockAttrs.text : ':',
    //textRaw: (blockAttrs !== undefined && blockAttrs.textRaw !== undefined) ? blockAttrs.textRaw : ':',
    fontSize: (blockAttrs && blockAttrs.fontSize) ? blockAttrs.fontSize : 48,
    fontId: DEFAULT_FONT_ID,
    fontFamily: DEFAULT_FONTNAME,
    fontStyle: '400',
    textDecoration: '',
    align: 'center',
    fill: (getBlockPropertyMappedValue(6) !== undefined) ? getBlockPropertyMappedValue(6) : '#000',
    fillMode: 'solid',
    gradientType: 'linear',
    strokeWidth: 0,
    draggable: true,
    dataBindType: 'none',
    animation: {totalSeconds: 4000},
  });
else {
  text = new Konva.Text({
    // id: RandomId(20),
    id: tMetadata.attrs.id,
    x: tMetadata.attrs.x,
    y: tMetadata.attrs.y,
    width: tMetadata.attrs.width,
    height: tMetadata.attrs.height,
    lineHeight: tMetadata.attrs.lineHeight,
    subType: 'TimerSeparator',
    text: tMetadata.attrs.text,
    //textRaw: tMetadata.attrs.textRaw,
    visibilityConditions: tMetadata.attrs.visibilityConditions,
    fontSize: tMetadata.attrs.fontSize,
    fontFamily: tMetadata.attrs.fontFamily,
    fontId: tMetadata.attrs.fontId,
    fontStyle: tMetadata.attrs.fontStyle,
    textDecoration: tMetadata.attrs.textDecoration,
    align: tMetadata.attrs.align,
    fill: tMetadata.attrs.fill,
    fillMode: tMetadata.attrs.fillMode,
    fillPriority: tMetadata.attrs.fillPriority,
    gradientType: tMetadata.attrs.gradientType,
    gradientDirection: tMetadata.attrs.gradientDirection,
    fillLinearGradientColorStops: tMetadata.attrs.fillLinearGradientColorStops,
    fillLinearGradientStartPointX: tMetadata.attrs.fillLinearGradientStartPointX,
    fillLinearGradientStartPointY: tMetadata.attrs.fillLinearGradientStartPointY,
    fillLinearGradientEndPointX: tMetadata.attrs.fillLinearGradientEndPointX,
    fillLinearGradientEndPointY: tMetadata.attrs.fillLinearGradientEndPointY,
    fillRadialGradientColorStops: tMetadata.attrs.fillRadialGradientColorStops,
    fillRadialGradientStartPointX: tMetadata.attrs.fillRadialGradientStartPointX,
    fillRadialGradientStartPointY: tMetadata.attrs.fillRadialGradientStartPointY,
    fillRadialGradientEndPointX: tMetadata.attrs.fillRadialGradientEndPointX,
    fillRadialGradientEndPointY: tMetadata.attrs.fillRadialGradientEndPointY,
    fillRadialGradientEndRadius: tMetadata.attrs.fillRadialGradientEndRadius,
    strokeWidth: tMetadata.attrs.strokeWidth,
    stroke: tMetadata.attrs.stroke,
    draggable: true,
    dataBindType: tMetadata.attrs.dataBindType,
    dataBindValue: tMetadata.attrs.dataBindValue,
    textTransforms: tMetadata.attrs.textTransforms,
    conditionalProperties: tMetadata.attrs.conditionalProperties,
    animation: tMetadata.attrs.animation,
  });
}

  text.on('click', (e) => {
    deleteCustomNodes();
    addDeleteBlockButton(text.attrs.id, text.attrs.x ,text.attrs.y, text.attrs.width, text.attrs.height, true);
    //IMPORTANT: toObject() doesn't always work with custom props
    // strokeWidth doesn't work all the time so need to set it manually
    // fontFamily doesn't work all the time so need to set it manually
    
    // setSelectedObjects([e.target.toObject()]);
    const selectedObj = e.target.toObject();
    selectedObj.attrs.strokeWidth = e.target.attrs.strokeWidth;
    selectedObj.attrs.fontFamily = e.target.attrs.fontFamily;

    setSelectedObjects([selectedObj]);
    //const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${text.attrs.id}`)[0];
    //setTimerLabelBlock(labelBlock);
    
    e.cancelBubble = true;
    tr.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
    tr.nodes([e.target]);
  });
  text.on('dragmove', (e) => {
    synchDeleteBlockButtonPosition(e.target);
    setSelectedObjects([e.target.toObject()]);
  });
  text.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  text.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });
  text.on('transformstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y(),
      originalWidth: text.attrs.width, originalHeight: text.attrs.height})
  })
  text.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y()})
  })
  text.on('dragend', () => {
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    setSelectedObjects([text.toObject()]);
  })

  text.on('transformend', () => {
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    text.attrs.originalWidth = undefined;
    text.attrs.originalHeight = undefined;
    setSelectedObjects([text.toObject()]);
  })
  text.on('transform', (e) => {        
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    text.setAttrs({
      width: Math.round(text.width() * text.scaleX()),
      height: Math.round(text.height() * text.scaleY()),
      x: Math.round(text.x()),
      y: Math.round(text.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([text.toObject()]);
  });


  const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];


  canvasRef.current.getLayers()[0].add(text);
  return text;
}
const handleAddTimerRingBlock = (e, tMetadata, timerBlockId, labelText, labelFontSize) => {
  const timerBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
  //console.log(labelFontSize)
  const ringThickness = 6
  let text = null;
  if (tMetadata === undefined) text =  new Konva.Ring({
    id: `timerRing${timerBlockId}`,
    x: timerBlock.attrs.x + timerBlock.attrs.width/2,
    y: timerBlock.attrs.y + timerBlock.attrs.height/2,
    //width: timerBlock.attrs.width,
    ringThickness: ringThickness,
    innerRadius: Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2),
    outerRadius: Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + ringThickness,
    lineHeight: 1,
    subType: 'TimerRing',
    align: 'center',
    fill: '#ccc',
    fillMode: 'solid',
    fillArc: ccColorTeal,
    ccFillColors: [],
    strokeWidth: 0,
    stroke: '#000',
    fontSize: labelFontSize ? labelFontSize : 30,
    fontId: DEFAULT_FONT_ID,
    fontFamily: DEFAULT_FONTNAME,
    fontStyle: '400',
    textDecoration: '',
    draggable: false,
    dataBindType: 'none',
    //dataBindValue: labelText !== undefined ? `label${labelText}` : 'labelSeconds',
    animation: {totalSeconds: 4000},
  });
else {
  text = new Konva.Ring({
    // id: RandomId(20),
    id: tMetadata.attrs.id,
    x: tMetadata.attrs.x,
    y: tMetadata.attrs.y,
    ringThickness: tMetadata.attrs.ringThickness,
    innerRadius: tMetadata.attrs.innerRadius,
    outerRadius: tMetadata.attrs.outerRadius,
    lineHeight: tMetadata.attrs.lineHeight,
    subType: 'TimerRing',
    align: tMetadata.attrs.align,
    fill: tMetadata.attrs.fill,
    //fillMode: tMetadata.attrs.fillMode,
    fillArc: tMetadata.attrs.fillArc,
    ccFillColors: tMetadata.attrs.ccFillColors,
    fontSize: tMetadata.attrs.fontSize,
    fontFamily: tMetadata.attrs.fontFamily,
    fontId: tMetadata.attrs.fontId,
    fontStyle: tMetadata.attrs.fontStyle,
    textDecoration: tMetadata.attrs.textDecoration,
    strokeWidth: tMetadata.attrs.strokeWidth,
    stroke: tMetadata.attrs.stroke,
    draggable: false,
    dataBindType: tMetadata.attrs.dataBindType,
    dataBindValue: tMetadata.attrs.dataBindValue,
    animation: tMetadata.attrs.animation,
  });
}

  const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];


  canvasRef.current.getLayers()[0].add(text);
  const arcColor = text.attrs.fillArc


  handleAddTimerRingArcBlock(arcColor, text.attrs.x, text.attrs.y, text.attrs.id.replace('timerRing', ''))
  return text;
}
const handleAddTimerRingArcBlock = (color, x, y, id) => {
  //used by the handleAddTimerRingBlock method
  //used purely to show a different ring colour in the UI
  //it shouldn't be saved in the model

  const timerBlock = canvasRef.current.getLayers()[0].find(`#${id}`)[0];
  const ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${id}`)[0];
  const innerRadiusArc = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + ringBlock.attrs.strokeWidth
  const outerRadiusArc = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + ringBlock.attrs.strokeWidth + ringBlock.attrs.ringThickness

  const text =  new Konva.Arc({
    id: `timerRingArc${id}`,
    x: x,
    y: y,
    innerRadius: innerRadiusArc,
    outerRadius: outerRadiusArc,
    angle: getRandomInt(30, 360),
    //rotation: getRandomInt(-180, 180),
    rotation: -90,
    //rotation: 0,
    fillPatternRotation: 90,
    lineHeight: 1,
    subType: 'TimerRingArc',
    align: 'center',
    fill: color,
    fillMode: 'solid',
    strokeWidth: 0,
    stroke: '#000',
    draggable: false,
    dataBindType: 'databind',
    dataBindValue: timerBlock.attrs.timePart,
  });

  if (ringBlock.attrs.ccFillColors && ringBlock.attrs.ccFillColors.length > 0) {
    const colors = ringBlock.attrs.ccFillColors
    const deltaStop = 1 / (colors.length-1)
    const colorsSteps = colors.map((c,index) => {return {stop: deltaStop*index, color: c}})
    const gradientCanvas = createSweepGradient(600, colorsSteps);

    text.setAttrs({ccFillColors: colors, fill: undefined, fillPatternImage: gradientCanvas, fillPatternOffset: { x: 300, y: 300 }})

  }
  canvasRef.current.getLayers()[0].add(text);
  //return text;
}

const handleAddRatingsBlock = (e, tMetadata, path) => {
  setCurrentTab('objInspector')
  let text = null;
  path = path === undefined ? "M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" : path;
  // path = path === undefined ? "M7 12H17M8 8.5C8 8.5 9 9 10 9C11.5 9 12.5 8 14 8C15 8 16 8.5 16 8.5M8 15.5C8 15.5 9 16 10 16C11.5 16 12.5 15 14 15C15 15 16 15.5 16 15.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" : path;
  const blockSize = getRatingsBlockSize(path, 4, 5);

  if (tMetadata === undefined) text = new Konva.Shape({
    id: RandomId(20),
    x: 200,
    y: 100,
    numIcons: 5,
    minValue: 0,
    maxValue: 5,
    gapIcon: 4,
    svgPath: path,
    svgStrokeWidth: 1,
    svgScale: 1,
    width: blockSize.width,
    height: blockSize.height,
    unratedColor: '#fff',
    ratedColor: '#ff3',
    draggable: true,
    dataBindType: 'none',
    subType: 'Rating',
    animation: {totalSeconds: 4000},

    sceneFunc: (context, shape) => {
      const scale = shape.getAttr('svgScale');
      let path = shape.getAttr('svgPath');
      path = svgpath(path).scale(scale).toString();
      const gapIcon = shape.getAttr('gapIcon');
      const numIcons = shape.getAttr('numIcons');
      const [left, top, right, bottom] = getBounds(path);
      const pathWidth = right - left;

      context.lineWidth = shape.getAttr('svgStrokeWidth');
      context.strokeStyle = shape.getAttr('stroke');
      context.fillStyle = shape.getAttr('ratedColor');
      
      context.beginPath();
      for (let i = 0; i < numIcons; i +=1) {
        if (i > 0) context.fillStyle = shape.getAttr('unratedColor');
        const myPath = new Path2D(path);
        context.fill(myPath);
        context.stroke(myPath);
        path = svgpath(path).translate(pathWidth + gapIcon).toString();
        }

      // (!) Konva specific method, it is very important
      context.fillStrokeShape(shape);
    },
    
    hitFunc: (context, shape) => {
      context.beginPath();
      context.rect(0, 0, shape.getAttr('width'), shape.getAttr('height'));

      context.closePath();
      context.fillStrokeShape(shape); 
       },

    fill: '#fff',
    stroke: '#000',
    strokeWidth: 1,
  });
else {
  const blockSize = getRatingsBlockSize(tMetadata.attrs.svgPath, tMetadata.attrs.gapIcon, tMetadata.attrs.numIcons);
  text = new Konva.Shape({
    id: RandomId(20),
    x: tMetadata.attrs.x,
    y: tMetadata.attrs.y,
    numIcons: tMetadata.attrs.numIcons,
    minValue: tMetadata.attrs.minValue,
    maxValue: tMetadata.attrs.maxValue,
    gapIcon: tMetadata.attrs.gapIcon,
    svgPath: tMetadata.attrs.svgPath,
    svgStrokeWidth: tMetadata.attrs.svgStrokeWidth,
    width: blockSize.width,
    height: blockSize.height,
    unratedColor: tMetadata.attrs.unratedColor,
    ratedColor: tMetadata.attrs.ratedColor,
    subType: 'Rating',
    visibilityConditions: tMetadata.attrs.visibilityConditions,

    lineHeight: tMetadata.attrs.lineHeight,
    text: tMetadata.attrs.text,
    fontSize: tMetadata.attrs.fontSize,
    fontFamily: tMetadata.attrs.fontFamily,
    fontStyle: tMetadata.attrs.fontStyle,
    textDecoration: tMetadata.attrs.textDecoration,
    align: tMetadata.attrs.align,
    fill: tMetadata.attrs.fill,
    fillMode: tMetadata.attrs.fillMode,
    fillPriority: tMetadata.attrs.fillPriority,
    gradientType: tMetadata.attrs.gradientType,
    gradientDirection: tMetadata.attrs.gradientDirection,
    fillLinearGradientColorStops: tMetadata.attrs.fillLinearGradientColorStops,
    fillLinearGradientStartPointX: tMetadata.attrs.fillLinearGradientStartPointX,
    fillLinearGradientStartPointY: tMetadata.attrs.fillLinearGradientStartPointY,
    fillLinearGradientEndPointX: tMetadata.attrs.fillLinearGradientEndPointX,
    fillLinearGradientEndPointY: tMetadata.attrs.fillLinearGradientEndPointY,
    fillRadialGradientColorStops: tMetadata.attrs.fillRadialGradientColorStops,
    fillRadialGradientStartPointX: tMetadata.attrs.fillRadialGradientStartPointX,
    fillRadialGradientStartPointY: tMetadata.attrs.fillRadialGradientStartPointY,
    fillRadialGradientEndPointX: tMetadata.attrs.fillRadialGradientEndPointX,
    fillRadialGradientEndPointY: tMetadata.attrs.fillRadialGradientEndPointY,
    fillRadialGradientEndRadius: tMetadata.attrs.fillRadialGradientEndRadius,
    strokeWidth: tMetadata.attrs.strokeWidth,
    stroke: tMetadata.attrs.stroke,
    draggable: true,
    dataBindType: tMetadata.attrs.dataBindType,
    dataBindValue: tMetadata.attrs.dataBindValue,
    textTransforms: tMetadata.attrs.textTransforms,
    conditionalProperties: tMetadata.attrs.conditionalProperties,
    animation: tMetadata.attrs.animation,
    layerName: tMetadata.attrs.layerName,

    sceneFunc: (context, shape) => {
      let path = shape.getAttr('svgPath');
      const gapIcon = shape.getAttr('gapIcon');
      const numIcons = shape.getAttr('numIcons');
      const [left, top, right, bottom] = getBounds(path);
      const pathWidth = right - left;

      context.lineWidth = shape.getAttr('strokeWidth');
      context.strokeStyle = shape.getAttr('stroke');
      context.fillStyle = shape.getAttr('ratedColor');
      
      context.beginPath();
      for (let i = 0; i < numIcons; i +=1) {
        if (i > 0) context.fillStyle = shape.getAttr('unratedColor');
        const myPath = new Path2D(path);
        context.fill(myPath);
        context.stroke(myPath);
        path = svgpath(path).translate(pathWidth + gapIcon).toString();
        }

      // (!) Konva specific method, it is very important
      context.fillStrokeShape(shape);
    },
    
    hitFunc: (context, shape) => {
      context.beginPath();
      context.rect(0, 0, shape.getAttr('width'), shape.getAttr('height'));

      context.closePath();
      context.fillStrokeShape(shape); 
       },

  });
}

text.dragBoundFunc(function (pos) {
  // Make sure the rectangle stays within the canvas bounds
  const stageWidth = canvasRef.current.width();
  const stageHeight = canvasRef.current.height();

  const rectWidth = this.width() * this.scaleX();
  const rectHeight = this.height() * this.scaleY();

  const newX = Math.max(0, Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
  const newY = Math.max(0, Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));

  return {
    x: newX,
    y: newY,
  };
},
)

  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

  text.on('click', (e) => {
    //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
    const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
    const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
    const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
    tr.nodes([]);
    trNoResize.nodes([]);

    deleteCustomNodes();
    addDeleteBlockButton(text.attrs.id, text.attrs.x ,text.attrs.y, text.attrs.width, text.attrs.height);
    setSelectedObjects([e.target.toObject()]);
    e.cancelBubble = true;

    tr.moveToTop();
    tr.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
    tr.nodes([e.target]);
  });
  text.on('dragmove', (e) => {
    synchDeleteBlockButtonPosition(e.target);
    setSelectedObjects([e.target.toObject()]);
  });
  text.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  text.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });
  text.on('transformstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y(),
       originalWidth: text.attrs.width, originalHeight: text.attrs.height})
  })
  text.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y()})
  })
  text.on('dragend', () => {
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    setSelectedObjects([text.toObject()]);
  })

  text.on('transformend', () => {
    // check and handle differences in the conditionalProperties
    // the props in the main obj and in the conditionalProperties models need to stay the same (if they were originally the same)

    /*
    if (text.attrs.conditionalProperties !== undefined && text.attrs.conditionalProperties.length > 0) {
      for (let i = 0; i<text.attrs.conditionalProperties.length; i+=1) {
        const currentModelAttrs =  text.attrs.conditionalProperties[i].model.attrs;
        if (currentModelAttrs.x === text.attrs.originalX) {
          currentModelAttrs.x = Math.round(text.x());
        }
        if (currentModelAttrs.y === text.attrs.originalY) {
          currentModelAttrs.y = Math.round(text.y());
        }
        if (currentModelAttrs.width === text.attrs.originalWidth) {
          currentModelAttrs.width = Math.round(text.attrs.width);
        }
        if (currentModelAttrs.height === text.attrs.originalHeight) {
          currentModelAttrs.height = Math.round(text.attrs.height);
        }
      }
    }
    */
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    text.attrs.originalWidth = undefined;
    text.attrs.originalHeight = undefined;
    setSelectedObjects([text.toObject()]);
  })
  text.on('transform', () => {        
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    text.setAttrs({
      width: Math.round(text.width() * text.scaleX()),
      height: Math.round(text.height() * text.scaleY()),
      x: Math.round(text.x()),
      y: Math.round(text.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([text.toObject()]);
  });

  canvasRef.current.getLayers()[0].add(text);
  return text;
}


const handleAddUrlBuondTextBlock = (urlParamName, tMetadata) => {
  const block = handleAddTextBlock(null, undefined);
  block.setAttrs({
                      dataBindType: 'url',
                      dataBindValue: `${urlParamName}`,
                      height: 42,
                      subType: 'urlBoundBlock'})
}

const handleAddTextPath = (e, tMetadata) => {
  setCurrentTab('objInspector')
  let text = null;
  const startText = getStartTextForBlocks();

  if (tMetadata === undefined) text = new Konva.TextPath({
    id: RandomId(20),
    x: 150,
    y: 150,
    fill: '#000',
    fillMode: 'solid',
    strokeWidth: 0,
    fontSize: 22,
    fontId: DEFAULT_FONT_ID,
    fontFamily: DEFAULT_FONTNAME,
    text: startText,
    textRaw: startText,
    // data: 'M10,10 C0,0 10,150 100,100 S300,150 5.0.300',
    data: 'M0 0 a 100 60 0 0 1 250 0 a 100 60 0 0 0 250 0',
    fontStyle: 'normal',
    textDecoration: '',
    align: 'left',
    draggable: true,
    dataBindType: 'none',
  });
  else {
    text = new Konva.TextPath({
      id: RandomId(20),
      x: tMetadata.attrs.x,
      y: tMetadata.attrs.y,
      data: tMetadata.attrs.data,
      fill: tMetadata.attrs.fill,
      strokeWidth: tMetadata.attrs.strokeWidth,
      stroke: tMetadata.attrs.stroke,
      lineHeight: tMetadata.attrs.lineHeight,
      text: tMetadata.attrs.textRaw,
      textRaw: tMetadata.attrs.textRaw,
      visibilityConditions: tMetadata.attrs.visibilityConditions,
      fontSize: tMetadata.attrs.fontSize,
      fontFamily: tMetadata.attrs.fontFamily,
      fontId: tMetadata.attrs.fontId,
      fontStyle: tMetadata.attrs.fontStyle,
      textDecoration: tMetadata.attrs.textDecoration,
      align: tMetadata.attrs.align,
      draggable: true,
      dataBindType: tMetadata.attrs.dataBindType,
      dataBindValue: tMetadata.attrs.dataBindValue,
      textTransforms: tMetadata.attrs.textTransforms,
      conditionalProperties: tMetadata.attrs.conditionalProperties,
      layerName: tMetadata.attrs.layerName,
    });
  }
  
  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[1];

  text.on('click', (e) => {
    //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
    const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
    const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
    const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
    tr.nodes([]);
    trNoResize.nodes([]);

    const boundRect = text.getSelfRect();
    text.setAttrs({lionBoundWidth: boundRect.width, lionBoundHeight: boundRect.height})
    deleteCustomNodes();
    handleAddTextPathEdit(text);
    synchPathEditPosition(text)
    addDeleteBlockButton(text.attrs.id, text.attrs.x ,text.attrs.y, text.attrs.width, text.attrs.height);
    setSelectedObjects([e.target.toObject()]);
    e.cancelBubble = true;
    // tr.resizeEnabled = false;

    tr.moveToTop();
    tr.nodes([e.target]);
  });
  text.on('dragmove', (e) => {
    setSelectedObjects([e.target.toObject()]);
  });
  text.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  text.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });

  text.on('transformstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y(),
       originalWidth: text.attrs.width, originalHeight: text.attrs.height})
  })
  text.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    text.setAttrs({originalX: text.x(), originalY: text.y()})
  })
  text.on('dragend', () => {
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    setSelectedObjects([text.toObject()]);
  })

  text.on('transformend', () => {
    checkHandleConditionalPropertiesChanges(text);
    text.attrs.originalX = undefined;
    text.attrs.originalY = undefined;
    text.attrs.originalWidth = undefined;
    text.attrs.originalHeight = undefined;
    setSelectedObjects([text.toObject()]);
  })


  text.on('transform', () => {
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    text.setAttrs({
      width: Math.round(text.width() * text.scaleX()),
      height: Math.round(text.height() * text.scaleY()),
      x: Math.round(text.x()),
      y: Math.round(text.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([text.toObject()]);
  });

  canvasRef.current.getLayers()[0].add(text);
}
const handleAddTextPathEdit = (mainObj) => {
  const text = new Konva.Path({
    id: `${mainObj.attrs.id}_path`,
    x: mainObj.attrs.x,
    y: mainObj.attrs.y,
    fill: 'transparent',
    stroke: '#000',
    strokeWidth: 1,
    // data: 'M10,10 C0,0 10,150 100,100 S300,150 5.0.300',
    data: mainObj.attrs.data,
    align: 'left',
    draggable: true,
    dataBindType: 'none',
  });

  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

  text.on('click', (e) => {
    e.cancelBubble = true;
  });
  text.on('dragmove', (e) => {
    synchPathEditPosition(text)
  });
  text.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  text.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });

  text.on('transform', () => {
  });

  canvasRef.current.getLayers()[0].add(text);

  // we add circles for every editable points
  const segments = ParseSvg(mainObj.attrs.data);
  let currentX = 0;
  let currentY = 0;
  segments.forEach((s, index) => {
    if (index === 0) {
      // the first item (M0 0) is not draggable
      const circle = new Konva.Circle({
        id: `${mainObj.attrs.id}_segmentEditPos_${index}`,
        x: text.attrs.x,
        y: text.attrs.y,
        radius: 6,
        fill: '#999',
        draggable: false,
      });
      currentX = text.attrs.x
      currentY = text.attrs.y
      canvasRef.current.getLayers()[0].add(circle);  
    }
    else {
      // all other items are draggable
      const circle = new Konva.Circle({
        id: `${mainObj.attrs.id}_segmentEditPos_${index}`,
        x: currentX + parseInt(s.endX, 10),
        y: currentY + parseInt(s.endY, 10),
        radius: 6,
        fill: '#00f',
        draggable: true,
      });
      circle.on('dragmove', (e) => {
        const previousCoords = GetSegmentEndXY(mainObj.attrs.data, index - 1);
        const coords = canvasRef.current.getPointerPosition();
        // we need coords to be relative so
        coords.x -= mainObj.attrs.x;
        coords.y -= mainObj.attrs.y;

        const deltaX = coords.x - previousCoords.x;
        const deltaY = coords.y - previousCoords.y;

        const newData = ChangeEndPointSvg(mainObj.attrs.data, index, deltaX, deltaY);
        mainObj.setAttrs({data: newData});
        const textPath = canvasRef.current.getLayers()[0].find(`#${mainObj.attrs.id}_path`)[0];
        textPath.setAttrs({data: newData});
      });
      circle.on('mouseover', (e) => {
        document.body.style.cursor = 'pointer';
      });
      circle.on('mouseout', (e) => {
        document.body.style.cursor = 'default';
      });
    
      currentX += parseInt(s.endX, 10);
      currentY += parseInt(s.endY, 10);
      canvasRef.current.getLayers()[0].add(circle);  

    }
  })
}

const handleAddCircle = (e, tMetadata) => {
  setCurrentTab('objInspector')
    let circle = null;
    if (tMetadata === undefined) circle = new Konva.Circle({
      id: RandomId(20),
      x: 200,
      y: 200,
      radius: 70,
      fill: 'transparent',
      stroke: '#000',
      strokeWidth: 1,
      draggable: true,
    });
    else {
      circle = new Konva.Circle({
        id: RandomId(20),
        x: tMetadata.attrs.x,
        y: tMetadata.attrs.y,
        radius: tMetadata.attrs.radius,
        fill: tMetadata.attrs.fill,
        rotation: tMetadata.attrs.rotation,
        skewX: tMetadata.attrs.skewX,
        skewY: tMetadata.attrs.skewY,
    
        strokeWidth: tMetadata.attrs.strokeWidth,
        stroke: tMetadata.attrs.stroke,
        draggable: true,
        dataBindType: tMetadata.attrs.dataBindType,
        dataBindValue: tMetadata.attrs.dataBindValue,
        conditionalProperties: tMetadata.attrs.conditionalProperties,
        visibilityConditions: tMetadata.attrs.visibilityConditions,
        layerName: tMetadata.attrs.layerName,
      });
    }

    
    //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

    circle.dragBoundFunc(function (pos) {
      // Make sure the rectangle stays within the canvas bounds
      const stageWidth = canvasRef.current.width();
      const stageHeight = canvasRef.current.height();
    
      const rectWidth = this.radius() * this.scaleX();
      const rectHeight = this.radius() * this.scaleY();
    
      const newX = Math.max(this.radius(), Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
      const newY = Math.max(this.radius(), Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));
    
      return {
        x: newX,
        y: newY,
      };
    },
    )
    
    circle.on('click', (e) => {
      //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
      const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
      const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
      const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
      const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
      tr.nodes([]);
      trNoResize.nodes([]);

      deleteCustomNodes();
      addDeleteBlockButton(circle.attrs.id, circle.attrs.x ,circle.attrs.y, circle.attrs.radius, circle.attrs.radius);
      setSelectedObjects([e.target.toObject()]);
      e.cancelBubble = true;
      // tr.enabledAnchors([]);

      tr.moveToTop();
      tr.nodes([e.target]);
    });
    circle.on('dragmove', (e) => {
      synchDeleteBlockButtonPosition(e.target);
      setSelectedObjects([e.target.toObject()]);
    });
    circle.on('dragstart', () => {
      // transformstart and transformend are use to manage conditionalProperties changes
      circle.setAttrs({originalX: circle.x(), originalY: circle.y()})
    })
    circle.on('dragend', () => {
      checkHandleConditionalPropertiesChanges(circle);
      circle.attrs.originalX = undefined;
      circle.attrs.originalY = undefined;
      setSelectedObjects([circle.toObject()]);
    })
  
    circle.on('mouseover', (e) => {
      document.body.style.cursor = 'pointer';
    });
    circle.on('mouseout', (e) => {
      document.body.style.cursor = 'default';
    });
    circle.on('transform', () => {        
      // with enabled anchors we can only change scaleX
      // so we don't need to reset height
      // just width
      circle.setAttrs({
        width: Math.round(circle.width() * circle.scaleX()),
        height: Math.round(circle.height() * circle.scaleY()),
        x: Math.round(circle.x()),
        y: Math.round(circle.y()),
        scaleX: 1,
        scaleY: 1,
      });
      setSelectedObjects([circle.toObject()]);
    });
  
    canvasRef.current.getLayers()[0].add(circle);
}

const handleAddEllipse = (e, tMetadata) => {
  setCurrentTab('objInspector')
  let ellipse = null;
  if (tMetadata === undefined) ellipse = new Konva.Ellipse({
    id: RandomId(20),
    x: 100,
    y: 150,
    radiusX: 100,
    radiusY: 50,
    fill: 'transparent',
    stroke: '#000',
    strokeWidth: 1,
    draggable: true
  });
  else {
    ellipse = new Konva.Ellipse({
      id: RandomId(20),
      x: tMetadata.attrs.x,
      y: tMetadata.attrs.y,
      radiusX: tMetadata.attrs.radiusX,
      radiusY: tMetadata.attrs.radiusY,
      fill: tMetadata.attrs.fill,
      rotation: tMetadata.attrs.rotation,
      skewX: tMetadata.attrs.skewX,
      skewY: tMetadata.attrs.skewY,
  
      strokeWidth: tMetadata.attrs.strokeWidth,
      stroke: tMetadata.attrs.stroke,
      draggable: true,
      dataBindType: tMetadata.attrs.dataBindType,
      dataBindValue: tMetadata.attrs.dataBindValue,
      conditionalProperties: tMetadata.attrs.conditionalProperties,
      visibilityConditions: tMetadata.attrs.visibilityConditions,
      layerName: tMetadata.attrs.layerName,
    });
  }
      
  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];

  ellipse.dragBoundFunc(function (pos) {
    // Make sure the rectangle stays within the canvas bounds
    const stageWidth = canvasRef.current.width();
    const stageHeight = canvasRef.current.height();
  
    const rectWidth = this.radiusX() * this.scaleX();
    const rectHeight = this.radiusY() * this.scaleY();
  
    const newX = Math.max(this.radiusX(), Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
    const newY = Math.max(this.radiusY(), Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));
  
    return {
      x: newX,
      y: newY,
    };
  },
  )
  
  ellipse.on('click', (e) => {
    //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
    const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
    const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
    const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
    tr.nodes([]);
    trNoResize.nodes([]);

    deleteCustomNodes();
    addDeleteBlockButton(ellipse.attrs.id, ellipse.attrs.x ,ellipse.attrs.y, ellipse.attrs.radiusX, ellipse.attrs.radiusY);
    setSelectedObjects([e.target.toObject()]);
    e.cancelBubble = true;
    // tr.resizeEnabled = true;

    tr.moveToTop();
    tr.nodes([e.target]);
  });
  ellipse.on('dragmove', (e) => {
    synchDeleteBlockButtonPosition(e.target);
    setSelectedObjects([e.target.toObject()]);
  });
  ellipse.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    ellipse.setAttrs({originalX: ellipse.x(), originalY: ellipse.y()})
  })
  ellipse.on('dragend', () => {
    checkHandleConditionalPropertiesChanges(ellipse);
    ellipse.attrs.originalX = undefined;
    ellipse.attrs.originalY = undefined;
    setSelectedObjects([ellipse.toObject()]);
  })

  ellipse.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  ellipse.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });
  ellipse.on('transform', () => {        
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    ellipse.setAttrs({
      width: Math.round(ellipse.width() * ellipse.scaleX()),
      height: Math.round(ellipse.height() * ellipse.scaleY()),
      x: Math.round(ellipse.x()),
      y: Math.round(ellipse.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([ellipse.toObject()]);
  });

  canvasRef.current.getLayers()[0].add(ellipse);


}

const handleAddPolygon = (numSides, tMetadata) => {
  setCurrentTab('objInspector')
  let polygon = null;
  if (tMetadata === undefined) polygon = new Konva.RegularPolygon({
    id: RandomId(20),
    x: 100,
    y: 150,
    sides: numSides,
    radius: 100,
    fill: 'transparent',
    stroke: '#000',
    strokeWidth: 1,
    draggable: true
  });
  else {
    polygon = new Konva.RegularPolygon({
      id: RandomId(20),
      x: tMetadata.attrs.x,
      y: tMetadata.attrs.y,
      sides: tMetadata.attrs.sides,
      radius: tMetadata.attrs.radius,
      fill: tMetadata.attrs.fill,
      rotation: tMetadata.attrs.rotation,
      skewX: tMetadata.attrs.skewX,
      skewY: tMetadata.attrs.skewY,
  
      strokeWidth: tMetadata.attrs.strokeWidth,
      stroke: tMetadata.attrs.stroke,
      draggable: true,
      dataBindType: tMetadata.attrs.dataBindType,
      dataBindValue: tMetadata.attrs.dataBindValue,
      conditionalProperties: tMetadata.attrs.conditionalProperties,
      visibilityConditions: tMetadata.attrs.visibilityConditions,
      layerName: tMetadata.attrs.layerName,
    });
  }
    
  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];


  polygon.dragBoundFunc(function (pos) {
    // Make sure the rectangle stays within the canvas bounds
    const stageWidth = canvasRef.current.width();
    const stageHeight = canvasRef.current.height();
  
    const rectWidth = this.radius() * this.scaleX();
    const rectHeight = this.radius() * this.scaleY();
  
    const newX = Math.max(this.radius(), Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
    const newY = Math.max(this.radius(), Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));
  
    return {
      x: newX,
      y: newY,
    };
  },
  )

  
  polygon.on('click', (e) => {
    deleteCustomNodes();
    addDeleteBlockButton(polygon.attrs.id, polygon.attrs.x ,polygon.attrs.y, polygon.attrs.radius, polygon.attrs.radius);
    setSelectedObjects([e.target.toObject()]);
    e.cancelBubble = true;
    // tr.resizeEnabled = true;
    //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
    const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
    const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
    const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
    tr.nodes([]);
    trNoResize.nodes([]);

    tr.moveToTop();
    tr.nodes([e.target]);
  });
  polygon.on('dragmove', (e) => {
    synchDeleteBlockButtonPosition(e.target);
    setSelectedObjects([e.target.toObject()]);
  });
  polygon.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    polygon.setAttrs({originalX: polygon.x(), originalY: polygon.y()})
  })
  polygon.on('dragend', () => {
    checkHandleConditionalPropertiesChanges(polygon);
    polygon.attrs.originalX = undefined;
    polygon.attrs.originalY = undefined;
    setSelectedObjects([polygon.toObject()]);
  })

  polygon.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  polygon.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });

  polygon.on('transform', () => {        
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    polygon.setAttrs({
      width: Math.round(polygon.width() * polygon.scaleX()),
      height: Math.round(polygon.height() * polygon.scaleY()),
      x: Math.round(polygon.x()),
      y: Math.round(polygon.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([polygon.toObject()]);
  });

  canvasRef.current.getLayers()[0].add(polygon);
}

const handleAddRect = (isSquare, tMetadata) => {
  setCurrentTab('objInspector')
  let rectHeight = 100;
  if (isSquare) rectHeight = 150;

  let rect = null;
  if (tMetadata === undefined) rect = new Konva.Rect({
    id: RandomId(20),
    x: 50,
    y: 50,
    width: 150,
    height: rectHeight,
    fill: 'transparent',
    stroke: '#000',
    strokeWidth: 1,
    draggable: true
  });
  else {
    rect = new Konva.Rect({
      id: RandomId(20),
      x: tMetadata.attrs.x,
      y: tMetadata.attrs.y,
      width: tMetadata.attrs.width,
      height: tMetadata.attrs.height,
      fill: tMetadata.attrs.fill,
      rotation: tMetadata.attrs.rotation,
      skewX: tMetadata.attrs.skewX,
      skewY: tMetadata.attrs.skewY,
  
      strokeWidth: tMetadata.attrs.strokeWidth,
      stroke: tMetadata.attrs.stroke,
      draggable: true,
      dataBindType: tMetadata.attrs.dataBindType,
      dataBindValue: tMetadata.attrs.dataBindValue,
      conditionalProperties: tMetadata.attrs.conditionalProperties,
      visibilityConditions: tMetadata.attrs.visibilityConditions,
      layerName: tMetadata.attrs.layerName,
    });
  }
    
  //const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];


  rect.dragBoundFunc(function (pos) {
    // Make sure the rectangle stays within the canvas bounds
    const stageWidth = canvasRef.current.width();
    const stageHeight = canvasRef.current.height();
  
    const rectWidth = this.width() * this.scaleX();
    const rectHeight = this.height() * this.scaleY();
  
    const newX = Math.max(0, Math.min(pos.x, (stageWidth - rectWidth) * canvasRef.current.scaleX()));
    const newY = Math.max(0, Math.min(pos.y, (stageHeight - rectHeight) * canvasRef.current.scaleY()));
  
    return {
      x: newX,
      y: newY,
    };
  },
  )

  
  rect.on('click', (e) => {
    addDeleteBlockButton(rect.attrs.id, rect.attrs.x ,rect.attrs.y, rect.attrs.width, rect.attrs.height);
    setSelectedObjects([e.target.toObject()]);
    e.cancelBubble = true;
    // tr.resizeEnabled = true;

    //we have 2 transformers, one can resize and the other can't - they both need to be cleaned
    const tr0 = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];
    const tr = tr0.attrs.resizeEnabled ? tr0 : tr1
    const trNoResize = tr0.attrs.resizeEnabled ? tr1 : tr0
    tr.nodes([]);
    trNoResize.nodes([]);

    tr.moveToTop();
    tr.nodes([e.target]);
  });
  rect.on('dragmove', (e) => {
    synchDeleteBlockButtonPosition(e.target);
    setSelectedObjects([e.target.toObject()]);
  });
  rect.on('dragstart', () => {
    // transformstart and transformend are use to manage conditionalProperties changes
    rect.setAttrs({originalX: rect.x(), originalY: rect.y()})
  })
  rect.on('dragend', () => {
    checkHandleConditionalPropertiesChanges(rect);
    rect.attrs.originalX = undefined;
    rect.attrs.originalY = undefined;
    setSelectedObjects([rect.toObject()]);
  })

  rect.on('mouseover', (e) => {
    document.body.style.cursor = 'pointer';
  });
  rect.on('mouseout', (e) => {
    document.body.style.cursor = 'default';
  });
  rect.on('transform', () => {        
    // with enabled anchors we can only change scaleX
    // so we don't need to reset height
    // just width
    rect.setAttrs({
      width: Math.round(rect.width() * rect.scaleX()),
      height: Math.round(rect.height() * rect.scaleY()),
      x: Math.round(rect.x()),
      y: Math.round(rect.y()),
      scaleX: 1,
      scaleY: 1,
    });
    setSelectedObjects([rect.toObject()]);
  });

  canvasRef.current.getLayers()[0].add(rect);

}        

const handleAddShape = (shape) => {
  switch (shape) {
    case 'circle':
      handleAddCircle();
    break;
    case 'ellipse':
      handleAddEllipse();
    break;
    case 'triangle':
      handleAddPolygon(3);
    break;
    case 'polygon':
      handleAddPolygon(6);
    break;
    case 'rect':
      handleAddRect();
    break;
    case 'square':
      handleAddRect(true);
    break;
    default:
      break;
  }
}
const handleAddViewFinder = (startX, startY) => {
  const lineV = new Konva.Line({points: [0, -20, 0, 20], stroke: 'cyan', strokeWidth: 1})
  const lineH = new Konva.Line({points: [-20, 0,  20, 0], stroke: 'cyan', strokeWidth: 1})
  const circle = new Konva.Circle({x: 0, y: 0, radius: 10, fill: 'transparent', stroke: 'cyan', strokeWidth: 1})
  const cross = new Konva.Group({draggable: true, x: startX, y: startY})

// Add the elements to the cross-hair group
cross.add(lineV, lineH, circle);

cross.on('dragmove', (e) => {
  console.log(e.target.attrs);
  updateSingleProp('rotationOriginX', e.target.attrs.x)
  updateSingleProp('rotationOriginY', e.target.attrs.y)
  const idSelectedObject = selectedObjects[0].attrs.id;

  const activeObject = canvasRef.current.getLayers()[0].find(`#${idSelectedObject}`)[0];

  setSelectedObjects([activeObject]);
});


canvasRef.current.getLayers()[0].add(cross);


}

const handleAddMappedBlock = (bindValue, prettyName) => {
  if (prettyName === 'Image') {
    handleAddImage(undefined, undefined, bindValue);
  }
  else {
    let customAttrs = undefined;
    try {
      const match = quickBlocksSettings.find(qb => qb.colName === prettyName);
      if (match) {
        console.log(match.metadata)
        if (match.metadata) {
          customAttrs = {}
          customAttrs.fill = match.metadata.textColor
          customAttrs.fontFamily = match.metadata.textFont.fontName
          customAttrs.fontId = match.metadata.textFont.fontId
          customAttrs.fontSize = match.metadata.textFont.size
          customAttrs.align = match.metadata.textFont.align
          customAttrs.fontStyle = match.metadata.textFont.style
          //customAttrs.fontIsAutoSize = match.metadata.textFont.isAutoSize
        }
      }
    }
    catch(e){}

    handleAddTextBlock(undefined, undefined, bindValue, customAttrs);
  }
}
const handleAddWeatherBlock = (name) => {
  let customAttrs = {align: 'center', dataBindType: 'forecasts'};
  
  switch(name) {
    case "minTemp":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '19'
      customAttrs.text = '19° C'
      customAttrs.textTransforms = {prefix:"", suffix:"° C", functions: []}
      handleAddTextBlock(undefined, undefined, 'temperature||min', customAttrs);
    break;
    case "minTemp-imperial":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '19'
      customAttrs.text = '45° F'
      customAttrs.textTransforms = {prefix:"", suffix:"° F", functions: [{functionName: "celsiusToFahrenheit", id:"7VckL9tQIk", parameters: [""]}]}
      handleAddTextBlock(undefined, undefined, 'temperature||min', customAttrs);
    break;
    case "maxTemp":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '24'
      customAttrs.text = '24° C'
      customAttrs.textTransforms = {prefix:"", suffix:"° C", functions: []}
      handleAddTextBlock(undefined, undefined, 'temperature||max', customAttrs);
    break;
    case "maxTemp-imperial":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '75'
      customAttrs.text = '75° C'
      customAttrs.textTransforms = {prefix:"", suffix:"° F", functions: [{functionName: "celsiusToFahrenheit", id:"8VckL9tQIk", parameters: [""]}]}
      handleAddTextBlock(undefined, undefined, 'temperature||max', customAttrs);
    break;
    case "dayTemp":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '21'
      customAttrs.text = '21° C'
      customAttrs.textTransforms = {prefix:"", suffix:"° C", functions: []}
      handleAddTextBlock(undefined, undefined, 'temperature||day', customAttrs);
    break;
    case "dayTemp-imperial":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '21'
      customAttrs.text = '70° F'
      customAttrs.textTransforms = {prefix:"", suffix:"° F", functions: [{functionName: "celsiusToFahrenheit", id:"9VckL9tQIk", parameters: [""]}]}
      handleAddTextBlock(undefined, undefined, 'temperature||day', customAttrs);
    break;
    case "dayFeelsLike":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '22'
      customAttrs.text = '22° C'
      customAttrs.textTransforms = {prefix:"", suffix:"° C", functions: []}
      handleAddTextBlock(undefined, undefined, 'feelsLike||day', customAttrs);
    break;
    case "dayFeelsLike-imperial":
      customAttrs.fontSize = 24
      customAttrs.textRaw = '22'
      customAttrs.text = '71° F'
      customAttrs.textTransforms = {prefix:"", suffix:"° F", functions: [{functionName: "celsiusToFahrenheit", id:"0VckL9tQIk", parameters: [""]}]}
      handleAddTextBlock(undefined, undefined, 'feelsLike||day', customAttrs);
    break;
    case "dayOfWeek":
      customAttrs.fontSize = 24
      customAttrs.textRaw = getDayOfWeek()
      customAttrs.textTransforms = {prefix:"", suffix:"", functions: [{functionName: "formatDatetime", id:"6VckL9tQIk", parameters: ["unix","dddd","en-GB"]}]}
      handleAddTextBlock(undefined, undefined, 'general||dt', customAttrs);
    break;
    case "weatherIcon":
      //console.log(weatherIconsCollections[0].collection[0].iconDayDataURL)
      customAttrs.imageWidth = 100
      customAttrs.imageHeght = 100
      customAttrs.width = 100
      customAttrs.height = 100
      customAttrs.dataBindType = 'weatherIcon'
      customAttrs.imageUrl = weatherIconsCollections[0].collection[0].iconDayDataURL
      //customAttrs.dataBindValue

      handleAddImageFromCustomAttrs(customAttrs);
      break;
    default:
      break;
  }
}

const addDeleteBlockButton = (boxId, boxLeft, boxTop, boxWidth, boxHeight, isTimer) => {
  if (boxWidth === undefined) boxWidth = -36;
  const imageObjDelete = new Image();
  let konvaImageDelete;
  imageObjDelete.onload = () => {
    konvaImageDelete = new Konva.Image({
      id: `${boxId}_delete`,
      x: boxLeft + boxWidth + 8,
      y: boxTop,
      image: imageObjDelete,
      width: 28,
      height: 28,
      draggable: true,
    });

    const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];
    const tr1 = canvasRef.current.getLayers()[0].find('Transformer')[1];

    konvaImageDelete.on('click', (e) => {
      // tr.resizeEnabled = true;
      tr.nodes([]);
      tr1.nodes([]);
      setSelectedObjects([]);
      const boxToDelete = canvasRef.current.getLayers()[0].find(`#${boxId}`)[0];
      boxToDelete.destroy();
      konvaImageDelete.destroy();
      if (isTimer !== undefined && isTimer) {
        const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${boxId}`)[0];
        if (labelBlock !== undefined) labelBlock.destroy();
      }
      document.body.style.cursor = 'default';
      e.cancelBubble = true;
    });
    konvaImageDelete.on('dragmove', (e) => {
      setSelectedObjects([e.target.toObject()]);
    });
    konvaImageDelete.on('mouseover', (e) => {
      document.body.style.cursor = 'pointer';
    });
    konvaImageDelete.on('mouseout', (e) => {
      document.body.style.cursor = 'default';
    });

    canvasRef.current.getLayers()[0].add(konvaImageDelete);
    };
    imageObjDelete.src = `/assets/bin.png`

  
  
}
const synchDeleteBlockButtonPosition = (konvaObj) => {
  const mainObjId = konvaObj.attrs.id;
  const objToSync = canvasRef.current.getLayers()[0].find(`#${mainObjId}_delete`)[0];

  if (objToSync === undefined) return;

  const konvaObjClass = konvaObj.getClassName();
  switch (konvaObjClass) {
    case "Circle":
    case "RegularPolygon":
      objToSync.setAttrs({
        x: konvaObj.attrs.x + konvaObj.attrs.radius + 8,
        y: konvaObj.attrs.y
      });
    break;
    case "Ellipse":
      objToSync.setAttrs({
        x: konvaObj.attrs.x + konvaObj.attrs.radiusX + 8,
        y: konvaObj.attrs.y
      });
    break;
    default:
      objToSync.setAttrs({
        x: konvaObj.attrs.x + konvaObj.attrs.width + 8,
        y: konvaObj.attrs.y
      });
      break;
  }
}

const synchPathEditPosition = (konvaObj) => {
  let id = '';
  let idBase = ''; // handy var to store the first 20 chars of the id
  let objToSync = {};
  // kanvaObj can be the text block or the path-only block
  if (konvaObj.attrs.id.includes('_path')) {
    // path-only block -> we need to synch the text block
    id = konvaObj.attrs.id.replace('_path', '');
    idBase = id;
    objToSync = canvasRef.current.getLayers()[0].find(`#${id}`)[0];
  }
  else {
    idBase = id;
    id = `${konvaObj.attrs.id}_path`;
    objToSync = canvasRef.current.getLayers()[0].find(`#${id}`)[0];
  }

  const deltaX = konvaObj.attrs.x - objToSync.attrs.x;
  const deltaY = konvaObj.attrs.y - objToSync.attrs.y;

  objToSync.setAttrs({
    x: konvaObj.attrs.x,
    y: konvaObj.attrs.y
  });

  // we want to update the position of all the "editing circles"
  // const circles = canvasRef.current.getLayers()[0].find(node => node.attrs.id.startsWith(id) && node.attrs.id.includes('_circle'))[0];
  const circles = canvasRef.current.getLayers()[0].find(node => {if (node.attrs === undefined || node.attrs.id === undefined) return false;
                                                                   return node.attrs.id.startsWith(idBase) && (node.attrs.id.includes('_segmentEditPos'))});
  circles.forEach(c => {
    c.setAttrs({
      x: c.attrs.x + deltaX,
      y: c.attrs.y + deltaY
    });  
  })
}


const updateSingleProp = async (propName, propValue) => {
  const idSelectedObject = selectedObjects[0].attrs.id;

  const activeObject = canvasRef.current.getLayers()[0].find(`#${idSelectedObject}`)[0];
  activeObject.setAttr(propName, propValue);

  //handling special properties textRaw and textTransforms
  if (propName === 'textRaw') {
    // we change the text and apply any text function
    const textAfterTransformFunctions = propValue; //for now we don't apply text transforms
    if (selectedObjects[0].attrs.textTransforms)
      activeObject.setAttr('text', `${selectedObjects[0].attrs.textTransforms.prefix}${textAfterTransformFunctions}${selectedObjects[0].attrs.textTransforms.suffix}`)
    else
      activeObject.setAttr('text', propValue)
  }
  if (propName === 'textTransforms') {
    if (activeObject.getClassName() === 'Text') {
      // we change the text and apply any text function
      const textAfterTransformFunctions = selectedObjects[0].attrs.textRaw; //for now we don't apply text transforms
      activeObject.setAttr('text', `${propValue.prefix}${textAfterTransformFunctions}${propValue.suffix}`)
    }
    if (activeObject.getClassName() === 'Image') {

      const url = `${propValue.prefix}${sampleData[selectedObjects[0].attrs.dataBindValue]}${propValue.suffix}`
      const urlValid = await CheckImageUrlExists(url)
      console.log(selectedObjects[0].attrs.dataBindValue)
    
      if (urlValid) activeObject.attrs.image.src = url;
  }

  
  }

  // konva img doesn't carry custom props so we need to update them here

  if (activeObject.getClassName() === 'Image') {
    if (propName === 'width') activeObject.setAttr('imageWidth', propValue);
    if (propName === 'height') activeObject.setAttr('imageHeight', propValue);
  }
  if (propName === 'fillMode') { // we need to manually refresh the konva colors
    if (propValue === 'solid') {
      // activeObject.setAttr('fill', '#000')
      activeObject.fillPriority('color')  
    }
    else if (propValue === 'gradient') {
      if (activeObject.getAttr('gradientType') === undefined || activeObject.getAttr('gradientType') === 'linear') {
        activeObject.fillPriority('linear-gradient')  
      }
      else       activeObject.fillPriority('radial-gradient');
    }

    console.log(propValue)
    console.log(activeObject.attrs)
  }
}
const updateMultipleProps = async (newProps) => {
  const idSelectedObject = selectedObjects[0].attrs.id;

  const activeObject = canvasRef.current.getLayers()[0].find(`#${idSelectedObject}`)[0];
  activeObject.setAttrs(newProps)

}

const updateImageBindings = async (databindType, newUrl, dataBindValue) => {
  const idSelectedObject = selectedObjects[0].attrs.id;

  const activeObject = canvasRef.current.getLayers()[0].find(`#${idSelectedObject}`)[0];
  activeObject.setAttr('dataBindType', databindType);
  if (dataBindValue) activeObject.setAttr('dataBindValue', dataBindValue);
  let url = newUrl;
  if (activeObject.attrs.textTransforms) {
    const t = activeObject.attrs.textTransforms;
    url = `${t.prefix}${newUrl}${t.suffix}`;
  }
  const urlValid = await CheckImageUrlExists(url)
  //console.log(urlValid)
  if (databindType === 'weatherIcon')  updateWeatherSettings('weatherCollectionId', parseInt(dataBindValue)) //this is the weatherCollectionId
  setSelectedObjects([activeObject]) //IMPORTANT THIS ALLOW TO REFRESH THE OBJECT INSPECTOR INSTANTLY (it might be used in other places too)
  if (urlValid) activeObject.attrs.image.src = url;


}

const updateTextPath = (id, newPathData) => {
  const objToSync = canvasRef.current.getLayers()[0].find(`#${id}_path`)[0];
  objToSync.setAttr('data', newPathData);
}

const updateCanvas = (newValues, voteTemplateChange, keepCanvasSize) => {
  //keepCanvasSize: we don't need to re-size the canvas every time there is an image background
  // e.g. if we edit a template we want to keep the canvas size as it was last saved (and not necesarrily as the size of the background image)
  //console.log(voteSwappingTemplates)
  //if (voteSwappingTemplates) return;

  //console.log(newValues)
  //console.log(voteTemplateChange)
  
  //special handling for Vote
  if (voteTemplateChange) {
    if (newValues.imageUrl !== null && newValues.imageUrl !== '') {
      // MOD: check if image is animated:
      //getImageInfo(newValues.imageUrl); ----- NEVER USE THIS LINE!!!! -----
      // if active the canvas background image won't update properly. it would fire updatCanvas again once img src is loaded in unpredictable order
      // -------------------------------- !!!!!!!!!!!!!!!!!!!!!!!!!!!  ----
      
      // it's an image background
      const img = new Image();
      if (newValues.dataBindType === 'databind') {
        img.src = sampleData[newValues.imageUrl]
      }
      else img.src = newValues.imageUrl;
  
      img.onerror = () => {console.log('error img load');}
      img.onload = () => {
        //setVoteSwappingTemplates(false)

        canvasRef.current.container().style.backgroundSize = `${img.width}px ${img.height}px`;
        canvasRef.current.container().style.backgroundRepeat = 'no-repeat'
        canvasRef.current.container().style.backgroundImage = newValues.dataBindType === 'databind' ? `url(${sampleData[newValues.imageUrl]})` : `url(${newValues.imageUrl})`;
        newValues = {...newValues, width: img.width, height: img.height }
  
        setCanvasProps(newValues);
        //console.log(newValues)
        canvasRef.current.lionProps = newValues;
      
        canvasRef.current.width(newValues.width);
        canvasRef.current.height(newValues.height);
        canvasRef.current.container().style.width = `${newValues.width}px`;
        canvasRef.current.container().style.height = `${newValues.height}px`;
      
      
        canvasRef.current.container().style.backgroundColor = newValues.backgroundColor;
      
        document.getElementById('canvas-outline').style.width = `min(${newValues.width}px, calc(100%))`;
        document.getElementById('canvas-outline').style.height = `min(${newValues.height}px, 400px)`;
  
        const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];
        const trNoResize = canvasRef.current.getLayers()[0].find('Transformer')[1];
  
        const nodesToDelete = canvasRef.current.find(n => (n.attrs.id !== undefined && n.attrs.id.includes('_')));
        nodesToDelete.forEach(n => n.destroy());

        setSelectedObjects([canvasRef.current.lionProps]);
        // tr.resizeEnabled = true;
        tr.nodes([]);
        trNoResize.nodes([]);
  
      }  
    }
    else {
      // it's a colour (or size) change
      canvasRef.current.container().style.backgroundImage = `none`;
      canvasRef.current.container().style.backgroundColor = newValues.backgroundColor;  
  
      setCanvasProps(newValues);
      canvasRef.current.lionProps = newValues;
    
      canvasRef.current.width(newValues.width);
      canvasRef.current.height(newValues.height);
      canvasRef.current.container().style.width = `${newValues.width}px`;
      canvasRef.current.container().style.height = `${newValues.height}px`;
      canvasRef.current.container().style.backgroundSize = `${newValues.width}px ${newValues.height}px`;
  
    
      document.getElementById('canvas-outline').style.width = `min(${newValues.width}px, calc(100%))`;
      document.getElementById('canvas-outline').style.height = `min(${newValues.height}px, 400px)`;
    
    
    }

    return;
  }

  if (newValues.imageUrl !== null && newValues.imageUrl !== '' && newValues.imageUrl !== canvasRef.current.lionProps.imageUrl) {
    // MOD: check if image is animated:
    console.log(newValues.imageUrl)
    getImageInfo(newValues.imageUrl);

    // it's an image background
    const img = new Image();
    if (newValues.dataBindType === 'databind') {
      img.src = sampleData[newValues.imageUrl]
    }
    else img.src = newValues.imageUrl;

    img.onerror = () => {console.log('error img load');}
    img.onload = () => {
      if (keepCanvasSize) {
        canvasRef.current.container().style.backgroundSize = `${newValues.width}px ${newValues.height}px`;
        canvasRef.current.container().style.backgroundImage = newValues.dataBindType === 'databind' ? `url(${sampleData[newValues.imageUrl]})` : `url(${newValues.imageUrl})`;
      }
      else {
        const normWidth = img.width;
        const normHeight = img.height;
        console.log(normWidth)
        console.log(normHeight)
        canvasRef.current.container().style.backgroundSize = `${img.width}px ${img.height}px`;
        canvasRef.current.container().style.backgroundImage = newValues.dataBindType === 'databind' ? `url(${sampleData[newValues.imageUrl]})` : `url(${newValues.imageUrl})`;
        newValues = {...newValues, width: img.width, height: img.height }  
      }

      setCanvasProps(newValues);
      canvasRef.current.lionProps = newValues;
    
      canvasRef.current.width(newValues.width);
      canvasRef.current.height(newValues.height);
      canvasRef.current.container().style.width = `${newValues.width}px`;
      canvasRef.current.container().style.height = `${newValues.height}px`;
    
    
      canvasRef.current.container().style.backgroundColor = newValues.backgroundColor;
    
      document.getElementById('canvas-outline').style.width = `min(${newValues.width}px, calc(100%))`;
      document.getElementById('canvas-outline').style.height = `min(${newValues.height}px, 400px)`;

      const tr = canvasRef.current.getLayers()[0].find('Transformer')[0];
      const trNoResize = canvasRef.current.getLayers()[0].find('Transformer')[1];

      const nodesToDelete = canvasRef.current.find(n => (n.attrs.id !== undefined && n.attrs.id.includes('_')));
      nodesToDelete.forEach(n => n.destroy());
      setSelectedObjects([canvasRef.current.lionProps]);
      // tr.resizeEnabled = true;
      tr.nodes([]);
      trNoResize.nodes([]);

    }  
  }
  else {
    // it's a colour (or size) change
  if ((newValues.backgroundColor !== canvasRef.current.lionProps.backgroundColor) || newValues.imageUrl === '') {
      // it's a colour change so we remove any possible background image
      canvasRef.current.container().style.backgroundImage = `none`;
      canvasRef.current.container().style.backgroundColor = newValues.backgroundColor;  
    }

    setCanvasProps(newValues);
    canvasRef.current.lionProps = newValues;
  
    canvasRef.current.width(newValues.width);
    canvasRef.current.height(newValues.height);
    canvasRef.current.container().style.width = `${newValues.width}px`;
    canvasRef.current.container().style.height = `${newValues.height}px`;
    canvasRef.current.container().style.backgroundSize = `${newValues.width}px ${newValues.height}px`;

  
    document.getElementById('canvas-outline').style.width = `min(${newValues.width}px, calc(100%))`;
    document.getElementById('canvas-outline').style.height = `min(${newValues.height}px, 400px)`;
  
  
  }

}

const validateTemplate = (template) => {
  const templateToValidate = template ? template : {templateName: templateName, templateDescription: templateDescription}
  try {
    templateValidationSchema.validateSync(templateToValidate, {abortEarly: false});
    setActiveErrorList([])
    return true;
  }
  catch (e) {
    const errorList = getErrorListFromYupError(e)
    setActiveErrorList(errorList)
    return false;
  }

}
const validateTemplateOnChange = (template) => {
  //console.log(activeErrorList)
  if (activeErrorList.length === 0) return;

  validateTemplate(template)
}

  const submitData = async () => {
    //it returns an array: [success, templateId, templateData]
    if (!validateTemplate()) return [false, undefinedType, undefinedType];

    // returns the new template id and its json metadata
    setShowLoader(true);
    setSubmitLoading(true);
    let response = {};
    let requestObj = {};

    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/Templates/create`;
      // let url = `${process.env.NEXT_PUBLIC_NEXT_API_URL}/Templates/create`;
      if (props.id !== undefined && props.id !== null) url = `${process.env.REACT_APP_LION_API_URL}/Templates/update/${props.id}`;

      requestObj = prepareModelToPost(serializeCanvas(),undefined,undefined);
      let data = {...requestObj, 'templateName': templateName, 'templateDescription': templateDescription,
                  templateIsRetina: templateIsRetina,
                  }
      if (snippetTypeId === 5 || snippetTypeId === 6 || snippetTypeId === 7) {
        // we need to save any existing changes in the current template before saving
        const voteAllTemplatesNew = [...voteAllTemplates];
        //voteAllTemplatesNew.splice(voteCurrentTemplateNum, 1, prepareModelToPost(canvasRef.current.toJSON(propsToInclude)));
        voteAllTemplatesNew.splice(voteCurrentTemplateNum, 1, prepareModelToPost(serializeCanvas()));
  
        requestObj = voteAllTemplatesNew;
        url = `${process.env.REACT_APP_LION_API_URL}/Templates/create-polling?productTypeId=${snippetTypeId}`;
        //url = `api/Templates/create-polling`;
        if (props.id !== null) url = `${process.env.REACT_APP_LION_API_URL}/Templates/update-polling/${props.id}`;

        data = {templates: requestObj, 'templateName': templateName, 'templateDescription': templateDescription}
      }

      response = await axios.post(url, data);

      // const response = await fetch(url, { method: "POST", body: JSON.stringify(data) });    
      // response.data = await response.json();

// console.log(response.data)
      if (response.data === 0) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
      }
      else {
        setShowSuccessMsg(true);
        setShowErrorMsg(false);
        if (props.onTemplateCreated !== undefined) props.onTemplateCreated(response.data)

      }
    } catch (error) {
      setShowSuccessMsg(false);
      setShowErrorMsg(true);
      console.log(error);
    }
  setShowLoader(false);
  setSubmitLoading(false);
    if (response.data && response.data !== 0) return [true, (props.id !== null && props.id !== undefined) ? props.id : response.data, requestObj]
  }

  const openPreview = (event) => {
    clearSelectedBlocks();
    //setPreviewItemsFilters(null)
    const urlParams = getUrlParametersFromModel(canvasRef.current.toObject());
    //console.log(urlParams)
    setPreviewUrlParamsValues(urlParams);

    setAnchorEl(event.currentTarget);

    getTemplatePreview(serializeCanvas(), urlParams);
    // getTemplatePreview(JSON.stringify(canvasRef.current.toObject(propsToInclude)));
    setPreviewImageData('');
    setPreviewLoading(true);
    setShowPreview(true);
  }

  const serializeCanvas = (returnJson) => {
    if (canvasRef.current === undefined || canvasRef.current === null) return undefined

    // konva toJSON doesn't always work with custom props
    // se we wrap it in this method where we manually set our custom props
    deleteCustomNodes(); //remove a ny custom nodes before submitting data

    const result = JSON.parse(canvasRef.current.toJSON(propsToInclude));
    //console.log(result)

    for (let i=0; i<canvasRef.current.children[0].children.length; i +=1) {
      propsToInclude.forEach(p => {
        result.children[0].children[i].attrs[p] = canvasRef.current.children[0].children[i].attrs[p]
      })
    }
    //return canvasRef.current.toJSON(propsToInclude);
    if (returnJson) return result;
    else return JSON.stringify(result);
  }

  const closePreview = () => {
    setAnchorEl(null);
    // canvasRef.current.loadFromJSON(templateModel);
    setShowPreview(false);
    setPreviewItemsFilters(null);
  }

  const handleDataConnectionChange = (dataCon) => {
    //console.log(dataCon)
    if (typeof dataCon === 'number') return //fix: dataCon is a number if you exited from the popup with ESC (not by clicking the connect or disconnet buttons)

    setDataConnection(dataCon)
    if (dataCon !== undefined) getDataConnectionInfoAndSampleData(dataCon.id);
    else {
      setDataConnectionInfo(undefined)
      setSampleData({});
    }
  }
  const getDataConnectionInfoAndSampleData = async (dataConnectionId) => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${dataConnectionId}`;
      let response = await axios.get(url);
      // let url = `api/Feeds/info/${dataConnectionId}`;
      // let response = await fetch(url, { method: "GET", });
      let data = response.data;

      //let data = await response.json();
      setDataConnectionInfo(data)

      // TODO ADD LOGIC TO FETCH SAMPLE DATA
      url = `${process.env.REACT_APP_LION_API_URL}/Feeds/sample/${dataConnectionId}`;
      response = await axios.get(url);
      // url = `api/Feeds/sample/${dataConnectionId}`;
      // response = await fetch(url, { method: "GET", });
      data = response.data;
  
      // data = await response.json();
      setSampleData(data);
      // console.log(response.data);  

    } catch (error) {
      console.log(error);
    }
  }
  const addWeatherSampleData = async (locId) => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/Weather/sampleLocations/data/${locId}`;
      const response = await axios.get(url);
  
      //const data = JSON.parse(response.data)
      const data = response.data
      data.metric = JSON.parse(data.metric)
      //data.imperial = JSON.parse(data.imperial)
      //data.standard = JSON.parse(data.standard)
      setSampleData(data);
      //console.log(data);

      //add this data to the weather dic
      const newWeatherSampleDataByLocations = {...weatherSampleDataByLocations, [locId]: data}
      setWeatherSampleDataByLocations(newWeatherSampleDataByLocations)

    } catch (error) {
      console.log(error);
    }
  }

  const getCatalogKeyFieldName = () => {
    if (dataConnectionInfo === undefined || dataConnectionInfo === null) return '';
    if (dataConnectionInfo.feedType !== 'CATALOG') return '';
    const metadata = JSON.parse(dataConnectionInfo.metadata);
    const colNames = Object.keys(metadata.columns);
    for (let i=0; i<colNames.length; i+=1) {
      const currentColName = colNames[i];
      if (metadata.columns[currentColName].isKey) return currentColName
    }

    return '';
  }
  const getCatalogAvailableConditions = () => {
    if (dataConnectionInfo === undefined || dataConnectionInfo === null) return [];
    // if (dataConnectionInfo.feedType !== 'CATALOG') return [];
    const results = [];
    const metadata = JSON.parse(dataConnectionInfo.metadata);
    const colNames = Object.keys(metadata.columns);
    for (let i=0; i<colNames.length; i+=1) {
      const currentColName = colNames[i];
      if (metadata.columns[currentColName].visible) {
        const currentCondition = {
          conditionName: currentColName,
          dataType: dataConnectionInfo.feedType === 'CATALOG' ? metadata.columns[currentColName].dataType : 'unknown', 
          conditionSymbol: currentColName
        }
        results.push(currentCondition);  
      }

    }

    return results;
  }
  const handleBlockPositionChange = (direction) => {
    const idSelectedObject = selectedObjects[0].attrs.id;

    const activeObject = canvasRef.current.getLayers()[0].find(`#${idSelectedObject}`)[0];
    switch(direction) {
      case "top":
        activeObject.moveToTop();
        break;
      case "bottom":
        activeObject.moveToBottom();
        break;
      case "up":
        activeObject.moveUp();
        break;
      case "down":
        activeObject.moveDown();
        break;
      default:
        break;
    }
  
  }
  const handleAddRotationViewFinder = (startX, startY) => {
    console.log(startX)
    console.log(startY)
    handleAddViewFinder(startX, startY)
  }


    // ------------------- Methods to handle the Vote widget

    const voteTemplateChange = (templateNum) => {
      // we need to save the current template in the allTemplates array
      // then we switch the current template
      const voteAllTemplatesNew = [...voteAllTemplates];
      //voteAllTemplatesNew.splice(voteCurrentTemplateNum, 1, prepareModelToPost(canvasRef.current.toJSON(propsToInclude)));
      voteAllTemplatesNew.splice(voteCurrentTemplateNum, 1, prepareModelToPost(serializeCanvas()));
      setVoteAllTemplates(voteAllTemplatesNew);

      setVoteCurrentTemplateNum(templateNum);

      const newLionProps = {...canvasRef.current.lionProps, imageUrl: voteAllTemplatesNew[templateNum].canvas.imageUrl}
      //setSelectedObjects([canvasRef.current.lionProps]);
      //setSelectedObjects([newLionProps]);

      updateEditorFromMetadata(voteAllTemplatesNew[templateNum], true)

    }
  
    const voteTemplateAdded = () => {
      // we need to save the current template in the allTemplates array
      // then we switch the current template
      const voteAllTemplatesNew = [...voteAllTemplates, {}];
      voteAllTemplatesNew.splice(voteCurrentTemplateNum, 1, prepareModelToPost(serializeCanvas()));

      // console.log(voteAllTemplatesNew)
      setVoteNumTemplates(voteAllTemplatesNew.length)

      setVoteAllTemplates(voteAllTemplatesNew)
      setVoteCurrentTemplateNum(voteAllTemplates.length);

      // canvasRef.current.destroyChildren()
      deleteAllNodes();
      setSelectedObjects([])
      setSelectedObjects([canvasRef.current.lionProps]);

    }

    const voteTemplateRemoved = (index) => {
      
      // we need to save the current template in the allTemplates array
      // then we switch the current template
      const voteAllTemplatesNew = [...voteAllTemplates];
      voteAllTemplatesNew.splice(index, 1);
      setVoteAllTemplates(voteAllTemplatesNew);
      setVoteNumTemplates(voteNumTemplates -1);
      setVoteCurrentTemplateNum(0);

      updateEditorFromMetadata(voteAllTemplatesNew[0])
    }

    // ------------------- Methods to handle timer blocks
    const handleTimerLabelChange = (timerBlockId, propName, propValue) => {
      //special case when propName = 'show'
      if (propName === 'showAll' && propValue) { //SHOW ALL
        const timerBlocks = canvasRef.current.getLayers()[0].find(node => {
          return node.getAttr('subType') === 'Timer'
         });

        if (timerBlocks) timerBlocks.forEach(lb => {
          //console.log(thisBlock.attrs.timePart)
          const labelText = lb.attrs.timePart[0].toUpperCase() + lb.attrs.timePart.slice(1);
          handleAddTimerLabelBlock(undefined, undefined, lb.id(), labelText);
          lb.setAttr('showLabel', true);
        });


  
        updateSingleProp('showLabel', true);
        const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${timerBlockId}`)[0];
        setTimerLabelBlock(labelBlock);
        return;
      }

      if (propName === 'show' && propValue) {
        const thisBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
        //console.log(thisBlock.attrs.timePart)
        const labelText = thisBlock.attrs.timePart[0].toUpperCase() + thisBlock.attrs.timePart.slice(1);
        handleAddTimerLabelBlock(undefined, undefined, timerBlockId, labelText);
  
        updateSingleProp('showLabel', true);
        const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${timerBlockId}`)[0];
        setTimerLabelBlock(labelBlock);
        return;
      }
      if (propName === 'show' && !propValue) {
        // we need to remove the label block
        const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${timerBlockId}`)[0];
        if (labelBlock !== undefined) labelBlock.destroy();
        updateSingleProp('showLabel', false);
        return;
      }
      if (propName === 'showAll' && !propValue) { //HIDE ALL
        // we need to remove all the label blocks
        const labelBlocks = canvasRef.current.getLayers()[0].find(node => {
          return node.id().startsWith('timerLabel') 
         });

        if (labelBlocks) labelBlocks.forEach(lb => {
          const parentBlockId = lb.id().replace('timerLabel', '');
          const parentBlock = canvasRef.current.getLayers()[0].find(`#${parentBlockId}`)[0];
          parentBlock.setAttr('showLabel', false);
          lb.destroy()
        });
        updateSingleProp('showLabel', false);
        return;
      }

      if (propName === 'timePart') {
        // we need to remove the label block
        const labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${timerBlockId}`)[0];
        if (labelBlock !== undefined) labelBlock.setAttr('text', propValue[0].toUpperCase() + propValue.slice(1));
        return;
      }

      if (propName === 'width' || propName === 'height') {
        //console.log(propName);
        // updateSingleProp(propName, propValue);
        const thisBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
        synchTimerLabelBlockPosition(thisBlock)
        synchTimerRingBlockPosition(thisBlock)
        return;
      }

      if (propName === 'ccOffsetY') {
        const thisBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
        synchTimerLabelBlockPosition(thisBlock)
      }

      //generic prop
      var labelBlock = canvasRef.current.getLayers()[0].find(`#timerLabel${timerBlockId}`)[0];
      //console.log(labelBlock)
      //console.log(propName)
      //console.log(propValue)
      if (labelBlock !== undefined) labelBlock = labelBlock.setAttr(propName, propValue);

      const updatedAttrs = {...labelBlock.attrs, [propName]: propValue};

      setTimerLabelBlock({...labelBlock, attrs: updatedAttrs});

    }

    const synchTimerLabelBlockPosition = (konvaObj) => {
      const mainObjId = konvaObj.attrs.id;
      const objToSync = canvasRef.current.getLayers()[0].find(`#timerLabel${mainObjId}`)[0];
      if (objToSync === undefined) return;

      objToSync.setAttrs({
        x: konvaObj.attrs.x,
        y: konvaObj.attrs.y + konvaObj.attrs.height + (objToSync.attrs.ccOffsetY ? objToSync.attrs.ccOffsetY : 0),
        width: konvaObj.attrs.width,
      });

    }
    const handleTimerRingChange = (timerBlockId, propName, propValue) => {
      if (propName === 'show' && propValue) {
        //const thisBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
        //console.log(thisBlock.attrs.timePart)
        //const labelText = thisBlock.attrs.timePart[0].toUpperCase() + thisBlock.attrs.timePart.slice(1);
        handleAddTimerRingBlock(undefined, undefined, timerBlockId);
  
        updateSingleProp('showRing', true);
        const ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        setTimerRingBlock(ringBlock);
        return;
      }
      if (propName === 'show' && !propValue) {
        // we need to remove the label block
        const ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        if (ringBlock !== undefined) ringBlock.destroy();
        if (ringArcBlock !== undefined) ringArcBlock.destroy();
        updateSingleProp('showRing', false);
        return;
      }
      if (propName === 'showAll' && !propValue) { //HIDE ALL
        // we need to remove all the label blocks
        const ringBlocks = canvasRef.current.getLayers()[0].find(node => {
          return node.id().startsWith('timerRing') 
         });

        if (ringBlocks) ringBlocks.forEach(lb => {
          const parentBlockId = lb.id().replace('timerRingArc', '').replace('timerRing', '');
          const parentBlock = canvasRef.current.getLayers()[0].find(`#${parentBlockId}`)[0];
          parentBlock.setAttr('showRing', false);
          lb.destroy()
        });
        updateSingleProp('showRing', false);
        return;
      }
      if (propName === 'showAll' && propValue) { //SHOW ALL
        const timerBlocks = canvasRef.current.getLayers()[0].find(node => {
          return node.getAttr('subType') === 'Timer'
         });

         console.log(timerBlocks)
        if (timerBlocks) timerBlocks.forEach(lb => {
          handleAddTimerRingBlock(undefined, undefined, lb.id());
          lb.setAttr('showRing', true);
        });


  
        updateSingleProp('showRing', true);
        const ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        setTimerRingBlock(ringBlock);
        return;
      }



      if (propName === 'fillArc') {
        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        ringArcBlock.setAttr('fill', propValue)
      }
      if (propName === 'strokeWidth') {
        const timerBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];

        if (ringBlock === undefined) return 
        ringBlock = ringBlock.setAttr(propName, propValue);
        const innerRadius = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + propValue / 2
        const outerRadius = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + propValue*1.5 + ringBlock.attrs.ringThickness
        ringBlock = ringBlock.setAttr('innerRadius', innerRadius);
        ringBlock = ringBlock.setAttr('outerRadius', outerRadius);

        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        const innerRadiusArc = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + propValue
        const outerRadiusArc = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + propValue + ringBlock.attrs.ringThickness
        ringArcBlock.setAttrs({innerRadius: innerRadiusArc, outerRadius: outerRadiusArc})

        const updatedAttrs = {...ringBlock.attrs, [propName]: propValue, innerRadius: innerRadius, outerRadius: outerRadius};

        setTimerRingBlock({...ringBlock, attrs: updatedAttrs});
        return
      }
      if (propName === 'ringThickness') {
        const timerBlock = canvasRef.current.getLayers()[0].find(`#${timerBlockId}`)[0];
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];

        if (ringBlock === undefined) return 
        ringBlock = ringBlock.setAttr(propName, propValue);
        const innerRadius = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + ringBlock.attrs.strokeWidth / 2
        const outerRadius = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + ringBlock.attrs.strokeWidth*1.5 + propValue
        ringBlock = ringBlock.setAttr('innerRadius', innerRadius);
        ringBlock = ringBlock.setAttr('outerRadius', outerRadius);

        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        const innerRadiusArc = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + ringBlock.attrs.strokeWidth
        const outerRadiusArc = Math.max(timerBlock.attrs.width/2, timerBlock.attrs.height/2) + ringBlock.attrs.strokeWidth + propValue
        ringArcBlock.setAttrs({innerRadius: innerRadiusArc, outerRadius: outerRadiusArc})

        const updatedAttrs = {...ringBlock.attrs, [propName]: propValue, innerRadius: innerRadius, outerRadius: outerRadius};

        setTimerRingBlock({...ringBlock, attrs: updatedAttrs});
        return
      }
      if (propName === 'angularGradient' && propValue) {
        //activate angular gradient.... we need to fill the ccFillColors array with two colors
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        //we use the current fill color as the first color
        //const newColors = [ringBlock.attrs.fillArc, ccColorOrange]
        //we use some default nice colors
        const newColors = ['#357e86', '#9240BE', '#357e86', '#9240BE']

        ringBlock = ringBlock.setAttr('ccFillColors', newColors);

        const updatedAttrs = {...ringBlock.attrs, ccFillColors: newColors};

        const deltaStop = 1 / (newColors.length-1)
        const colorsSteps = newColors.map((c,index) => {return {stop: deltaStop*index, color: c}})
        const gradientCanvas = createSweepGradient(600, colorsSteps);

        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        ringArcBlock.setAttrs({ccFillColors: newColors, fill: undefined, fillPatternImage: gradientCanvas, fillPatternOffset: { x: 300, y: 300 }})

        setTimerRingBlock({...ringBlock, attrs: updatedAttrs});
        return
      }
      if (propName === 'angularGradient' && !propValue) {
        //deactivate angular gradient.... we need to empty the ccFillColors array and assign a fill color
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        //we use the current fill color as the first color
        const firstColor = ringBlock.attrs.ccFillColors[0]
        ringBlock = ringBlock.setAttrs({ccFillColors: [], fillArc: firstColor});

        const updatedAttrs = {...ringBlock.attrs, ccFillColors: [], fillArc: firstColor};

        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        ringArcBlock.setAttrs({ccFillColors: [], fill: firstColor, fillPatternImage: undefined, fillPatternOffset: undefined})

        setTimerRingBlock({...ringBlock, attrs: updatedAttrs});
        return
      }
      if (propName === 'angularGradientSpreadToAll') {
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        
        const newColors = [...ringBlock.attrs.ccFillColors]

        const deltaStop = 1 / (newColors.length-1)
        const colorsSteps = newColors.map((c,index) => {return {stop: deltaStop*index, color: c}})
        const gradientCanvas = createSweepGradient(600, colorsSteps);

        //const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        //ringArcBlock.setAttrs({ccFillColors: newColors, fill: undefined, fillPatternImage: gradientCanvas, fillPatternOffset: { x: 300, y: 300 }})
        const otherRingBlocks = canvasRef.current.getLayers()[0].find(block => block.attrs.id && block.attrs.id.startsWith('timerRing') && !block.attrs.id.startsWith('timerRingArc') && block.attrs.id !== `timerRing${timerBlockId}`);
        const otherRingArcBlocks = canvasRef.current.getLayers()[0].find(block => block.attrs.id && block.attrs.id.startsWith('timerRingArc') && block.attrs.id !== `timerRingArc${timerBlockId}`);
        otherRingBlocks.forEach(b => {b.setAttr('ccFillColors', newColors);})
        otherRingArcBlocks.forEach(b => {b.setAttrs({ccFillColors: newColors, fill: undefined, fillPatternImage: gradientCanvas, fillPatternOffset: { x: 300, y: 300 }})})

        return
      }
      if (propName === 'ccFillColorsAdd') {
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        //we add 1 new color
        const newColors = [...ringBlock.attrs.ccFillColors, ccColorOrange]
        ringBlock = ringBlock.setAttr('ccFillColors', newColors);

        const updatedAttrs = {...ringBlock.attrs, ccFillColors: newColors};

        const deltaStop = 1 / (newColors.length-1)
        const colorsSteps = newColors.map((c,index) => {return {stop: deltaStop*index, color: c}})
        const gradientCanvas = createSweepGradient(600, colorsSteps);



        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        ringArcBlock.setAttrs({ccFillColors: newColors, fill: undefined, fillPatternImage: gradientCanvas, fillPatternOffset: { x: 300, y: 300 }})
        setTimerRingBlock({...ringBlock, attrs: updatedAttrs});

        return
      }
      if (propName === 'ccFillColorsRemove') {
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        
        const newColors = [...ringBlock.attrs.ccFillColors]
        newColors.splice(propValue, 1)
        ringBlock = ringBlock.setAttr('ccFillColors', newColors);

        const updatedAttrs = {...ringBlock.attrs, ccFillColors: newColors};

        const deltaStop = 1 / (newColors.length-1)
        const colorsSteps = newColors.map((c,index) => {return {stop: deltaStop*index, color: c}})
        const gradientCanvas = createSweepGradient(600, colorsSteps);

        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        ringArcBlock.setAttrs({ccFillColors: newColors, fill: undefined, fillPatternImage: gradientCanvas, fillPatternOffset: { x: 300, y: 300 }})

        setTimerRingBlock({...ringBlock, attrs: updatedAttrs});
        return
      }
      if (propName === 'ccFillColorsChange') {
        var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
        
        const newColors = [...ringBlock.attrs.ccFillColors]
        newColors[propValue.index] = propValue.color
        ringBlock = ringBlock.setAttr('ccFillColors', newColors);

        const updatedAttrs = {...ringBlock.attrs, ccFillColors: newColors};

        const deltaStop = 1 / (newColors.length-1)
        const colorsSteps = newColors.map((c,index) => {return {stop: deltaStop*index, color: c}})
        const gradientCanvas = createSweepGradient(600, colorsSteps);

        const ringArcBlock = canvasRef.current.getLayers()[0].find(`#timerRingArc${timerBlockId}`)[0];
        ringArcBlock.setAttrs({ccFillColors: newColors, fill: undefined, fillPatternImage: gradientCanvas, fillPatternOffset: { x: 300, y: 300 }})

        setTimerRingBlock({...ringBlock, attrs: updatedAttrs});
        return

      }

       //generic prop
      var ringBlock = canvasRef.current.getLayers()[0].find(`#timerRing${timerBlockId}`)[0];
      //console.log(labelBlock)
      //console.log(propName)
      //console.log(propValue)
      if (ringBlock !== undefined) ringBlock = ringBlock.setAttr(propName, propValue);

      const updatedAttrs = {...ringBlock.attrs, [propName]: propValue};

      setTimerRingBlock({...ringBlock, attrs: updatedAttrs});

    }
    const synchTimerRingBlockPosition = (konvaObj) => {
      const mainObjId = konvaObj.attrs.id;
      const objToSync = canvasRef.current.getLayers()[0].find(`#timerRing${mainObjId}`)[0];
      const objToSync2 = canvasRef.current.getLayers()[0].find(`#timerRingArc${mainObjId}`)[0];
      if (objToSync === undefined) return;

      objToSync.setAttrs({
        x: konvaObj.attrs.x + konvaObj.attrs.width/2,
        y: konvaObj.attrs.y + konvaObj.attrs.height/2,
      });
      objToSync2.setAttrs({
        x: konvaObj.attrs.x + konvaObj.attrs.width/2,
        y: konvaObj.attrs.y + konvaObj.attrs.height/2,
      });

    }


    // -------------------- Methods used when embeddedInWizard
    const handlePreviousClicked = () => {
      if (props.onPreviousClicked !== undefinedType) props.onPreviousClicked()

    }
    const handleSaveExitClicked = async() => {
      const [success, templateId, templateJson] = await submitData();
      if (!success) return;
      if (props.onSaveExitClicked !== undefinedType) props.onSaveExitClicked()

    }
    const handleNextClicked = async() => {
      const [success, templateId, templateJson] = await submitData();

      if (!success) return;
      if (props.onNextClicked !== undefinedType) props.onNextClicked(templateId, templateJson)

    }

    //#region SNAP TO GRID FUNCTIONS
    const GUIDELINE_OFFSET = 10;

    // were can we snap our objects?
    function getLineGuideStops(skipShape) {
      const stage = canvasRef.current;

      // we can snap to stage borders and the center of the stage
      var vertical = [0, stage.width() / 2, stage.width()];
      var horizontal = [0, stage.height() / 2, stage.height()];

      // and we snap over edges and center of each object on the canvas
      stage.find('.objectSnappable').forEach((guideItem) => {
        if (guideItem === skipShape) {
          return;
        }
        var box = guideItem.getClientRect();
        // and we can snap to all edges of shapes
        vertical.push([box.x, box.x + box.width, box.x + box.width / 2]);
        horizontal.push([box.y, box.y + box.height, box.y + box.height / 2]);
      });
      return {
        vertical: vertical.flat(),
        horizontal: horizontal.flat(),
      };
    }

    // what points of the object will trigger to snapping?
    // it can be just center of the object
    // but we will enable all edges and center
    function getObjectSnappingEdges(node) {
      var box = node.getClientRect();
      var absPos = node.absolutePosition();

      return {
        vertical: [
          {
            guide: Math.round(box.x),
            offset: Math.round(absPos.x - box.x),
            snap: 'start',
          },
          {
            guide: Math.round(box.x + box.width / 2),
            offset: Math.round(absPos.x - box.x - box.width / 2),
            snap: 'center',
          },
          {
            guide: Math.round(box.x + box.width),
            offset: Math.round(absPos.x - box.x - box.width),
            snap: 'end',
          },
        ],
        horizontal: [
          {
            guide: Math.round(box.y),
            offset: Math.round(absPos.y - box.y),
            snap: 'start',
          },
          {
            guide: Math.round(box.y + box.height / 2),
            offset: Math.round(absPos.y - box.y - box.height / 2),
            snap: 'center',
          },
          {
            guide: Math.round(box.y + box.height),
            offset: Math.round(absPos.y - box.y - box.height),
            snap: 'end',
          },
        ],
      };
    }

    // find all snapping possibilities
    function getGuides(lineGuideStops, itemBounds) {
      var resultV = [];
      var resultH = [];

      lineGuideStops.vertical.forEach((lineGuide) => {
        itemBounds.vertical.forEach((itemBound) => {
          var diff = Math.abs(lineGuide - itemBound.guide);
          // if the distance between guild line and object snap point is close we can consider this for snapping
          if (diff < GUIDELINE_OFFSET) {
            resultV.push({
              lineGuide: lineGuide,
              diff: diff,
              snap: itemBound.snap,
              offset: itemBound.offset,
            });
          }
        });
      });

      lineGuideStops.horizontal.forEach((lineGuide) => {
        itemBounds.horizontal.forEach((itemBound) => {
          var diff = Math.abs(lineGuide - itemBound.guide);
          if (diff < GUIDELINE_OFFSET) {
            resultH.push({
              lineGuide: lineGuide,
              diff: diff,
              snap: itemBound.snap,
              offset: itemBound.offset,
            });
          }
        });
      });

      var guides = [];

      // find closest snap
      var minV = resultV.sort((a, b) => a.diff - b.diff)[0];
      var minH = resultH.sort((a, b) => a.diff - b.diff)[0];
      if (minV) {
        guides.push({
          lineGuide: minV.lineGuide,
          offset: minV.offset,
          orientation: 'V',
          snap: minV.snap,
        });
      }
      if (minH) {
        guides.push({
          lineGuide: minH.lineGuide,
          offset: minH.offset,
          orientation: 'H',
          snap: minH.snap,
        });
      }
      return guides;
    }

    function drawGuides(guides) {
      const layer = canvasRef.current.getLayers()[0];

      guides.forEach((lg) => {
        if (lg.orientation === 'H') {
          var line = new Konva.Line({
            points: [-6000, 0, 6000, 0],
            stroke: 'rgb(0, 161, 255)',
            strokeWidth: 1,
            name: 'guid-line',
            dash: [4, 6],
          });
          layer.add(line);
          line.absolutePosition({
            x: 0,
            y: lg.lineGuide,
          });
        } else if (lg.orientation === 'V') {
          var line = new Konva.Line({
            points: [0, -6000, 0, 6000],
            stroke: 'rgb(0, 161, 255)',
            strokeWidth: 1,
            name: 'guid-line',
            dash: [4, 6],
          });
          layer.add(line);
          line.absolutePosition({
            x: lg.lineGuide,
            y: 0,
          });
        }
      });
    }



    //#endregion
    
    const handleTemplateIsRetinaChange = (value) => {
      if (snippetTypeId === 5 || snippetTypeId === 6 || snippetTypeId === 7) {
        
        //we update all the templates
        const voteAllTemplatesNew = [...voteAllTemplates];
        voteAllTemplatesNew.forEach(t => t.templateIsRetina = value);
        console.log(voteAllTemplatesNew)
        setVoteAllTemplates(voteAllTemplatesNew)
      }
      
      setTemplateIsRetina(value)

    }

    const templateContainsAnimatedBlocks = () => {
      if (canvasRef.current === undefined || canvasRef.current === null) return false;
      if (canvasRef.current.children[0] === undefined) return false

      let animationFound = false;

      //loop thorugh all the blocks
      canvasRef.current.children[0].children.forEach(b => {
        if (b.attrs.animation !== undefined) {
          //check if the animation obj has props other than totalSeconds to make sure there is an animation
          if (Object.keys(b.attrs.animation).length > 1) {
            animationFound = true
          }
        }
      })
      return animationFound
  
      //return Object.keys(animations).filter(k => k !== "totalSeconds" && k !== "textTransitionFunction");
  
    }
    const handleAnimationLoopSettingsChange = (settings) => {
      //console.log(settings)
      setAnimationSettings(settings)
    }
    const handleZoomChange = (zoom) => {
      const originalWidth = canvasRef.current.width();
      const originalHeight = canvasRef.current.height();
      console.log(originalWidth)
      console.log(originalHeight)
      //canvasRef.current.width(originalWidth * zoom);
      //canvasRef.current.height(originalHeight * zoom);

      canvasRef.current.scale({ x: zoom, y: zoom });

      canvasRef.current.container().style.width = `${originalWidth * zoom}px`
      canvasRef.current.container().style.height = `${originalHeight * zoom}px`
      canvasRef.current.container().style.backgroundSize = `${originalWidth * zoom}px ${originalHeight * zoom}px`;
      canvasRef.current.container().style.backgroundRepeat = 'no-repeat'

      canvasRef.current.position({x:0, y:0})
      canvasRef.current.batchDraw();

      setZoomLevel(zoom)
    }

    const getWeatherLocations = async () => {
      try {
        let url = `${process.env.REACT_APP_LION_API_URL}/Weather/sampleLocations/`;
        let response = await axios.get(url);

        setWeatherLocations(response.data)
        setSelectedWeatherLocationId(response.data[0].locationId)
                
      } catch (error) {
        console.log(error);
      }
    }
    const handleWeatherLocationChange = (locId) => {
      setSelectedWeatherLocationId(locId)
      if (!Object.keys(weatherSampleDataByLocations).includes(locId.toString())) addWeatherSampleData(locId)
    }
  const handleWeatherUnitsChange = (units) => {
    const newWeatherSettings = {...weatherSettings, units: units}
    setWeatherSettings(newWeatherSettings)

    //we want to update the text of any block thatn is bound to a weather data
    canvasRef.current.getLayers()[0].children.forEach((node) => {
      if (node.getType() === 'Shape' && node.attrs.dataBindType === 'forecasts') {

        const [section, forecastsDatabindValue] = node.attrs.dataBindValue.split('||')
        //console.log(section)
        //console.log(props.sampleData)
        let txt = ''
        if (section === 'general') {
          txt = sampleData[units].daily[0][forecastsDatabindValue]
        }
        if (section === 'temperature') {
          txt = sampleData[units].daily[0].temp[forecastsDatabindValue]
        }
        if (section === 'feelsLike') {
          txt = sampleData[units].daily[0].feels_like[forecastsDatabindValue]
        }
        if (section === 'weather') {
          txt = sampleData[units].daily[0].weather[0][forecastsDatabindValue]
        }
        node.setAttrs({textRaw: txt, text: txt})

      }
    });
  }
  const updateWeatherSettings = (propName, propValue) => {
    const newWeatherSettings = {...weatherSettings, [propName]: propValue}
    setWeatherSettings(newWeatherSettings)

  }
  const getWeatherForecastsPreviewSize = () => {
    if (weatherSettings.repeatCount === 0) return [canvasProps.width, canvasProps.height]

    if (weatherSettings.repeatDirection === 'horizontal') return [canvasProps.width * (weatherSettings.repeatCount +1), canvasProps.height]
    if (weatherSettings.repeatDirection === 'vertical') return [canvasProps.width, canvasProps.height * (weatherSettings.repeatCount +1)]
  }

  const numDefinedAnimations = () => {
    const result = {Image: 0, Others: 0, isOneToOne: false}
    if (selectedObjects == undefined || selectedObjects.length === 0) return result

    const model = serializeCanvas(true);
    if (model === undefined) return result

    const blocks = model.children[0].children

    blocks.forEach(b => {
      if (b.attrs.animation) {
        if (Object.keys(b.attrs.animation).length === 2) {
          //there is an animation for this block
          if (b.className === "Image") result.Image +=1;
          else result.Others +=1;
        }
      }
    })
    if (dataConnectionInfo && dataConnectionInfo.oneToOneParameters) result.isOneToOne = dataConnectionInfo.oneToOneParameters.length > 0
    return result;
  }
  function getRandomInt(min, max) {
    const minCeil = Math.ceil(min);
    const maxFloor = Math.floor(max);
    return Math.floor(Math.random() * (maxFloor - minCeil + 1)) + minCeil;
  }


    return <>
    <CcFontLoader />
    <div className={props.embeddedInWizard ? `p-1` : `border border-gray-200 rounded-md p-1 shadow-md`}>
      {!showLoader && !showErrorMsg && !showSuccessMsg && <>    
      <Grid2 container alignItems='center'>
        <Grid2 xs={11}>
          <Stack direction='row' spacing={6} sx={{display: 'flex', alignItems: 'center', }} pl={1}>
            <div className='flex flex-row items-center gap-x-1'>
              <Typography>Name</Typography>
              <div className='w-64'>
                <InputText
                        value={templateName}
                        onChange={(val) => {setTemplateName(val); validateTemplateOnChange({templateName: val, templateDescription: templateDescription})}}
                        error={getErrorMessage(activeErrorList, 'templateName')}          
                />
              </div>
            </div>
            <div className='flex flex-row items-center gap-x-1'>
              <Typography>Description</Typography>
              <div className='w-64'>
                <InputText
                        value={templateDescription}
                        onChange={(val) => {setTemplateDescription(val); validateTemplateOnChange({templateName: templateName, templateDescription: val})}}
                        error={getErrorMessage(activeErrorList, 'templateDescription')}          
                />
              </div>
            </div>

            {templateContainsAnimatedBlocks() &&
              <AnimationLoopSelector
                settings={animationSettings}
                onChange={handleAnimationLoopSettingsChange}
              />
            }


          </Stack>
        </Grid2>
        <Grid2 xs={1}>
          {!props.embeddedInWizard && 
                <Box display="flex" justifyContent="flex-end" p={0.5} >
                  <IconButton variant="contained" sx={{color: ccColorDarkTeal}} onClick={props.closingCall} >
                      <Iconify icon="material-symbols:cancel-outline" width="48px" />
                  </IconButton>
                </Box>
          }
        </Grid2>
      </Grid2>

        <Grid2 container spacing={2} >
            <Grid2 xs={8}>
                <Stack>
                <Box  sx={{m:1}} >
                  <Stack divider={<Divider orientation="vertical" flexItem />} direction='row' alignItems='center' justifyContent='left' spacing={0.5} >
                    {snippetTypeId === 1 &&
                    <MenuAddMappedBlocks allNames={userSettingsColumnPrettyNames} 
                            mappings={dataConnectionInfo === undefined ? undefined : JSON.parse(dataConnectionInfo.metadata).colPrettyNames} 
                            feedConnected={dataConnection !== undefined}
                            onClick={(name, prettyName) => handleAddMappedBlock(name, prettyName)}
                             />
                    }
                    {snippetTypeId === 18 &&
                    <MenuQuickAddWeatherBlocks 
                            onClick={handleAddWeatherBlock}
                             />
                    }
                    {snippetTypeId === 9 && <MenuUrlBoundBlocks
                                              onClick={handleAddUrlBuondTextBlock} />}

                    <Button sx={{p: 1, m:1, minWidth: 40, maxWidth:40 }} color='inherit' onClick={handleAddTextBlock}><Iconify icon={lionIcons.Icon_TextInsert} width={24} /></Button>
                    {/*<Button sx={{p: 1, m:1, minWidth: 40, maxWidth:40}} color='inherit' onClick={handleAddTextPath}><Iconify icon={lionIcons.Icon_Shapes_Path} width={24} /></Button>*/}
                    <Button sx={{p: 1, m:1, minWidth: 40, maxWidth:40}} color='inherit' onClick={handleAddImage}><Iconify icon={lionIcons.Icon_ImageInsert} width={24} /></Button>
                    <MenuAddShapes onClick={handleAddShape} />
                    {showRatingBlocks && <MenuAddRatings onClick={(path) => handleAddRatingsBlock(undefined, undefined, path)} />}
                    {showTimerBlocks && <MenuAddTimerBlocks onClick={handleAddTimerBlocks} />}
                    {showDataConnection && <DatafeedPicker onDataConnectionChange={handleDataConnectionChange}
                                    selectedDataconnectionId={dataConnection === undefined ? undefined : dataConnection.id}
                    />}
                    {showAnswersManager && <AnswersManager 
                                              allTemplates={voteAllTemplates}
                                              currentTemplateNum={voteCurrentTemplateNum}
                                              numTemplates={voteNumTemplates}
                                              onTemplateChange={voteTemplateChange}
                                              onTemplateAdded={voteTemplateAdded}
                                              onTemplateRemoved={voteTemplateRemoved}
                    />}
                    <Button sx={{minWidth: 40, maxWidth:40}} color='inherit' onClick={openPreview}><Iconify icon="icon-park-outline:preview-open" width={24} /></Button>
                    <MenuZoom zoomLevel={zoomLevel}
                      onChange={handleZoomChange}
                     />

                    <FormGroup>
                    <FormControlLabel control={<Switch
                                                checked={templateIsRetina}
                                                onChange={(e) => handleTemplateIsRetinaChange(e.target.checked)}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                sx={{'& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                            />} label="Retina"
                    />
                    </FormGroup>

                    {showWeatherLocationsSelector && <div className='flex flex-row items-center gap-x-2'>
                      <WeatherLocationsSelectors locations={weatherLocations}
                        selectedItemId={selectedWeatherLocationId}
                        onChange={handleWeatherLocationChange}
                      />
                      {/*
                        <WeatherUnitsSelector units={weatherSettings.units}
                          onChange={(units) => handleWeatherUnitsChange(units)}
                        />                      
                      */}
                    </div>

                    }
                  </Stack>
                </Box>
                <div className={`m-1 p-6 bg-slate-300 flex ${weatherSettings.repeatDirection === 'horizontal' ? 'flex-row' : 'flex-col'}`} /*sx={{m:1, p:4, backgroundColor: '#ddd'}}*/>
                  <div id="canvas-outline"  style={{width: 'calc(100%)', height: '400px', overflow: 'scroll', outlineWidth: 2, outlineStyle: 'solid', outlineColor: '#aaa' }} >
                    <div id='ruler-div'>
                      <div id="canvas" ref={canvasRef} style={{width: `${canvasWidth}px`, height: `${canvasHeight}px`, backgroundColor: '#fff'}}  />
                    </div>
                  </div>
                  {weatherSettings.repeatCount > 0 && <>
                      {[...Array(weatherSettings.repeatCount)].map((_,index) => <div className={`flex items-center justify-center ${index % 2 ? 'bg-zinc-100' : 'bg-zinc-300'}`} style={{width: `${canvasProps.width}px`, height: `${canvasProps.height}px`}}>
                        <div className='font-poppins text-lg text-ccColorTeal font-bold'>Day +{index+1}</div>
                      </div>)

                      }
                    </>
                    }

                </div>
                </Stack>
            </Grid2>
            <Grid2 xs={4}>
              <div className='mr-4 mb-2'>
                <TabSelector 
                  items={tabItems}
                  selectedItemId={currentTab}
                  onChange={setCurrentTab}
                />
              </div>

              {currentTab === 'objInspector' &&
             <ObjectInspector objects={selectedObjects} returnUpdateSingle={updateSingleProp}
                              sampleData={sampleData}
                              snippetTypeId={snippetTypeId}
                              returnUpdateCanvas={updateCanvas}
                              returnUpdateTextPath={updateTextPath}
                              returnUpdateImageBindings={updateImageBindings}
                              returnUpdateMultipleProps={updateMultipleProps}
                              availableConditions={getCatalogAvailableConditions()}
                              onBlockPositionChange={handleBlockPositionChange}
                              canvasBackgroundImageShowAnimationSelector={canvasBackgroundImageShowAnimationSelector}
                              onAddRotationViewFinder={handleAddRotationViewFinder}
                              timerLabelChange={handleTimerLabelChange}
                              timerRingChange={handleTimerRingChange}
                              timerLabelBlock={timerLabelBlock}
                              timerRingBlock={timerRingBlock}
                              weatherUnits={weatherSettings.units}
                              weatherIconsCollections={weatherIconsCollections}
                              weatherIconsCollectionId={weatherSettings.weatherCollectionId}
                              numDefinedAnimations={numDefinedAnimations()}
                               />
              }

              {currentTab === 'layers' && 
                <LayersManager konvaLayer={canvasRef.current ? canvasRef.current.getLayers()[0] : undefined}
                              selectedObjects={selectedObjects}
                />
              }
              {currentTab === 'tabForecasts' && <div>
                <div className='flex flex-row gap-x-6 items-center'>
                  <div className=' w-36'>
                    <InputNumber displayName="Add days"
                      value={weatherSettings.repeatCount}
                      min={0}
                      max={6}
                      onChange={(val) => updateWeatherSettings('repeatCount', val)}
                    />
                  </div>
                  <div className='flex flex-col w-40'>
                    <div className='block text-sm font-medium leading-6 text-gray-900'>Direction</div>
                    <LionListbox items={[{id: 'horizontal', name: 'Horizontal'}, {id: 'vertical', name: 'Vertical'}]}
                      zIndex={10}
                      selectedItemId={weatherSettings.repeatDirection}
                      onChange={(val) => updateWeatherSettings('repeatDirection', val.id)}
                  />
                  </div>
                </div>
              </div>
              }

            </Grid2>
      </Grid2>

      <Popover      open={showPreview}
                    anchorEl={anchorEl}
                    onClose={closePreview}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}

          >
        <Stack alignItems='center' sx={{minWidth: '900px', pt:1}}>
          <CcActionButtonOutlined sx={{mt:1}} color='primary'
                  onClick={() => {setPreviewImageData(''); setPreviewLoading(true); getTemplatePreview(serializeCanvas())}}>Refresh Preview</CcActionButtonOutlined>
          <Box sx={{ padding: '10px', width: '95%', height: '440px'}} >
            <Box display="flex" alignItems='center' justifyContent='center' >
              {previewLoading && <CircularProgress size={64} />}
              {!previewLoading && 
              <Stack direction='row' spacing={1}>
                <Box sx={{m:1, height:400}}>
                  <div style={{width: '850px', height: '400px', overflow: 'scroll', outlineWidth: 2, outlineStyle: 'solid', outlineColor: 'black' }} >
                    {snippetTypeId === 18 && weatherSettings.repeatCount > 0 ?
                      <img style={{width: getWeatherForecastsPreviewSize()[0], maxWidth: getWeatherForecastsPreviewSize()[0], height: getWeatherForecastsPreviewSize()[1]}} src={previewImageData} alt='Preview' />
                      :
                      <img style={{width: canvasProps.width, maxWidth: canvasProps.width, height: canvasProps.height}} src={previewImageData} alt='Preview' />
                  }
                  </div>
                </Box>
                {dataConnectionInfo !== undefined && <Stack sx={{maxWidth: 200}} spacing={1} >
                    <Chip label="Item Info" />
                      <Stack sx={{overflow: 'scroll', maxHeight: 400}} >
                        {sampleData !== null && <>
                              {Object.keys(sampleData).map(propName => <Stack key={propName} direction='row' spacing={1}>
                                                                  <Typography><strong>{propName}</strong></Typography>
                                                                  <Tooltip title={JSON.stringify(sampleData[propName])} placement='right' >
                                                                    <Typography noWrap>{JSON.stringify(sampleData[propName])}</Typography>
                                                                  </Tooltip>
                                                                </Stack> )

                              }
                      </>}
                    </Stack>
                  </Stack>}
              </Stack>}
            </Box>
          </Box>
          {dataConnectionInfo !== undefined && <Box sx={{width:'100%', marginLeft:'50px'}} display="flex" justifyContent="center">
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <IconButton variant="contained" 
                            onClick={() => changePreviewPosAndRefresh(-1)}
                             >
                    <Iconify width='32' icon='material-symbols:arrow-circle-left-outline' />
                  </IconButton>
                  <TextField sx={{width: '120px'}}
                            value={previewPos}
                            onChange={(e) => changePreviewPosNoRefresh(TryParseIntDefault(e.target.value,1))}
                            size="small"
                          />
                  <IconButton variant="contained" 
                            onClick={() => changePreviewPosAndRefresh(+1)}
                            >
                    <Iconify width='32' icon='material-symbols:arrow-circle-right-outline' />
                  </IconButton>
                </Stack>
              </Box>
              }
          {dataConnectionInfo !== undefined && dataConnectionInfo.feedType === 'CATALOG' && <Box sx={{width:'100%', marginLeft:'50px'}} display="flex" justifyContent="flex-start">
                <Stack direction='row' spacing={1} sx={{display: 'flex', alignItems: 'center'}}>
                  <Typography>Look up product by <strong>{getCatalogKeyFieldName()}</strong></Typography>
                  <TextField sx={{width: '120px'}}
                            value={itemIdLookup}
                            onChange={(e) => handleLookupByIdChange(e.target.value)}
                            size="small"
                          />
                    <Button sx={{mt:1}} color='primary'
                            onClick={handleFindById}>Find</Button>
                </Stack>
              </Box>
              }
          {dataConnectionInfo !== undefined && <div className='w-full ml-[50px] mt-4 flex flex-col'>
                <div className='flex flex-row items-center gap-x-2'>
                  <div className='text-ccColorTeal font-semibold'>Preview conditions & filters</div>
                  <InfoToolTip 
                        placement='right'
                        headLine='Preview conditions & filters'
                        message="Add your conditions here to preview the products that will be displayed by your element."
                      />
                </div>
                <Box sx={{width:'100%'}} display="flex" justifyContent="flex-start">
                  <Paper sx={{mt:1, p:1}} elevation={3}>
                    <Stack>
                      <Stack sx={{display:'flex', justifyContent: 'flex-end'}} direction='row'>
                        <Button onClick={() => resetFilters()}>Reset filters</Button>
                        <Button onClick={() => {setPreviewImageData(''); setPreviewLoading(true); getTemplatePreview(serializeCanvas())}}>Apply filters</Button>
                      </Stack>
                      <ConditionsManager availableConditions={getCatalogAvailableConditions()}
                                        onConditionChange={handleFilterChange}
                                        clearFilter={clearFilter}
                                        urlParameters
                          />
                    </Stack>
                  </Paper>
                </Box>
              </div>
          }
          {previewUrlParamsValues.length > 0 && <Box sx={{width:'100%', marginLeft:'50px'}} display="flex" justifyContent="flex-start">
                <Stack spacing={1}>
                  <div className='flex flex-row items-center gap-2'>
                    <Typography>Test values for your parameters</Typography>
                    <CcActionButtonOutlined sx={{mt:1}} color='primary'
                          onClick={() => {setPreviewImageData(''); setPreviewLoading(true); getTemplatePreview(serializeCanvas())}}>Refresh Preview</CcActionButtonOutlined>
                  </div>
                  {previewUrlParamsValues.map((p, index) => <Stack key={p.name} direction='row' alignItems='center' spacing={1}>
                                              <Typography>Parameter: {p.name}</Typography>
                                              <TextField sx={{width: '120px'}}
                                                value={p.value}
                                                onChange={(e) => changePreviewUrlParamValue(index, e.target.value)}
                                                size="small"
                                              />
                                              </Stack>)}
                </Stack>
              </Box>
              }

          <Box display="flex" justifyContent="flex-end" sx={{m:1, width:'100%'}} >
                <Button variant='outlined' color='secondary'  sx={{mr:1}} onClick={closePreview}>Close</Button>
          </Box>
        </Stack>
      </Popover>
      </>
    }

    {showErrorMsg &&
                   <Box  sx={{ml: 1, pb:1, display: 'flex', justifyContent: 'center'}}  >
                    <Alert sx={{marginTop: '50px'}} severity="error">
                      <AlertTitle>Error</AlertTitle>
                      Something went wrong while saving your template
                    </Alert>
                   </Box>     
     }

    {showSuccessMsg && 
                  <Box  sx={{ml: 1, pb:1, display: 'flex', justifyContent: 'center'}}  >
                    <Alert sx={{marginTop: '50px'}} severity="success">
                      <AlertTitle>Success</AlertTitle>
                      Template saved
                    </Alert>
                  </Box>
    }
    {showLoader && 
              <Box  sx={{pb:1, display: 'flex', justifyContent: 'center'}}  >
              <CircularProgress sx={{marginTop: '50px'}} size={64} />
              </Box>
    }

{!showSuccessMsg && !showErrorMsg && !props.embeddedInWizard &&
      <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
          <LoadingButton sx={{backgroundColor: ccColorDarkTeal, ":hover":{backgroundColor: ccColorTeal}}} variant="contained" onClick={submitData} loading={submitLoading} >Submit</LoadingButton>
      </Box>
}
{!showSuccessMsg && !showErrorMsg && props.embeddedInWizard &&
      <Box display="flex" gap={1} justifyContent="flex-end" sx={{m:1}} >
          <CcActionButton onClick={handlePreviousClicked} >Previous</CcActionButton>
          <CcActionButton onClick={handleSaveExitClicked} >Save & Exit</CcActionButton>
          <CcActionButton onClick={handleNextClicked} >Next</CcActionButton>
      </Box>
}

{showSuccessMsg &&
      <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
          <LoadingButton variant="contained" onClick={props.closingCall} loading={submitLoading} >Close</LoadingButton>
      </Box>
}
{showErrorMsg &&
      <Box display="flex" justifyContent="flex-end" sx={{m:1}} >
          <LoadingButton variant="contained" onClick={() => setShowErrorMsg(false)} loading={submitLoading} >Close</LoadingButton>
      </Box>
}

    </div>

    </>
}

